import gql from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: number; output: number; }
  date: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** columns and relationships of "Anime" */
export type Anime = {
  __typename?: 'Anime';
  /** An array relationship */
  Genres: Array<Anime_Genre>;
  /** An aggregate relationship */
  Genres_aggregate: Anime_Genre_Aggregate;
  /** An object relationship */
  Video?: Maybe<Video>;
  chapters?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  score: Scalars['numeric']['output'];
  status?: Maybe<Scalars['String']['output']>;
  studio?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "Anime" */
export type AnimeGenresArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


/** columns and relationships of "Anime" */
export type AnimeGenres_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};

/** aggregated selection of "Anime" */
export type Anime_Aggregate = {
  __typename?: 'Anime_aggregate';
  aggregate?: Maybe<Anime_Aggregate_Fields>;
  nodes: Array<Anime>;
};

/** aggregate fields of "Anime" */
export type Anime_Aggregate_Fields = {
  __typename?: 'Anime_aggregate_fields';
  avg?: Maybe<Anime_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anime_Max_Fields>;
  min?: Maybe<Anime_Min_Fields>;
  stddev?: Maybe<Anime_Stddev_Fields>;
  stddev_pop?: Maybe<Anime_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anime_Stddev_Samp_Fields>;
  sum?: Maybe<Anime_Sum_Fields>;
  var_pop?: Maybe<Anime_Var_Pop_Fields>;
  var_samp?: Maybe<Anime_Var_Samp_Fields>;
  variance?: Maybe<Anime_Variance_Fields>;
};


/** aggregate fields of "Anime" */
export type Anime_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anime_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Anime_Avg_Fields = {
  __typename?: 'Anime_avg_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "Anime". All fields are combined with a logical 'AND'. */
export type Anime_Bool_Exp = {
  Genres?: InputMaybe<Anime_Genre_Bool_Exp>;
  Genres_aggregate?: InputMaybe<Anime_Genre_Aggregate_Bool_Exp>;
  Video?: InputMaybe<Video_Bool_Exp>;
  _and?: InputMaybe<Array<Anime_Bool_Exp>>;
  _not?: InputMaybe<Anime_Bool_Exp>;
  _or?: InputMaybe<Array<Anime_Bool_Exp>>;
  chapters?: InputMaybe<Int_Comparison_Exp>;
  cover?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  score?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  studio?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "Anime" */
export enum Anime_Constraint {
  /** unique or primary key constraint on columns "uuid" */
  AnimeIdKey = 'Anime__id_key',
  /** unique or primary key constraint on columns "id" */
  AnimePkey = 'anime_pkey'
}

/** input type for incrementing numeric columns in table "Anime" */
export type Anime_Inc_Input = {
  chapters?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Anime" */
export type Anime_Insert_Input = {
  Genres?: InputMaybe<Anime_Genre_Arr_Rel_Insert_Input>;
  Video?: InputMaybe<Video_Obj_Rel_Insert_Input>;
  chapters?: InputMaybe<Scalars['Int']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Anime_Max_Fields = {
  __typename?: 'Anime_max_fields';
  chapters?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studio?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Anime_Min_Fields = {
  __typename?: 'Anime_min_fields';
  chapters?: Maybe<Scalars['Int']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studio?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "Anime" */
export type Anime_Mutation_Response = {
  __typename?: 'Anime_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anime>;
};

/** input type for inserting object relation for remote table "Anime" */
export type Anime_Obj_Rel_Insert_Input = {
  data: Anime_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Anime_On_Conflict>;
};

/** on_conflict condition type for table "Anime" */
export type Anime_On_Conflict = {
  constraint: Anime_Constraint;
  update_columns?: Array<Anime_Update_Column>;
  where?: InputMaybe<Anime_Bool_Exp>;
};

/** Ordering options when selecting data from "Anime". */
export type Anime_Order_By = {
  Genres_aggregate?: InputMaybe<Anime_Genre_Aggregate_Order_By>;
  Video?: InputMaybe<Video_Order_By>;
  chapters?: InputMaybe<Order_By>;
  cover?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  studio?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Anime */
export type Anime_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "Anime" */
export enum Anime_Select_Column {
  /** column name */
  Chapters = 'chapters',
  /** column name */
  Cover = 'cover',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  Studio = 'studio',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "Anime" */
export type Anime_Set_Input = {
  chapters?: InputMaybe<Scalars['Int']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Anime_Stddev_Fields = {
  __typename?: 'Anime_stddev_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Anime_Stddev_Pop_Fields = {
  __typename?: 'Anime_stddev_pop_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Anime_Stddev_Samp_Fields = {
  __typename?: 'Anime_stddev_samp_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "Anime" */
export type Anime_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anime_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anime_Stream_Cursor_Value_Input = {
  chapters?: InputMaybe<Scalars['Int']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studio?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Anime_Sum_Fields = {
  __typename?: 'Anime_sum_fields';
  chapters?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['numeric']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "Anime" */
export enum Anime_Update_Column {
  /** column name */
  Chapters = 'chapters',
  /** column name */
  Cover = 'cover',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  Studio = 'studio',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url',
  /** column name */
  Uuid = 'uuid',
  /** column name */
  Year = 'year'
}

export type Anime_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anime_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anime_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anime_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anime_Var_Pop_Fields = {
  __typename?: 'Anime_var_pop_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Anime_Var_Samp_Fields = {
  __typename?: 'Anime_var_samp_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Anime_Variance_Fields = {
  __typename?: 'Anime_variance_fields';
  chapters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** columns and relationships of "Genre" */
export type Genre = {
  __typename?: 'Genre';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** aggregated selection of "Genre" */
export type Genre_Aggregate = {
  __typename?: 'Genre_aggregate';
  aggregate?: Maybe<Genre_Aggregate_Fields>;
  nodes: Array<Genre>;
};

/** aggregate fields of "Genre" */
export type Genre_Aggregate_Fields = {
  __typename?: 'Genre_aggregate_fields';
  avg?: Maybe<Genre_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Genre_Max_Fields>;
  min?: Maybe<Genre_Min_Fields>;
  stddev?: Maybe<Genre_Stddev_Fields>;
  stddev_pop?: Maybe<Genre_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Genre_Stddev_Samp_Fields>;
  sum?: Maybe<Genre_Sum_Fields>;
  var_pop?: Maybe<Genre_Var_Pop_Fields>;
  var_samp?: Maybe<Genre_Var_Samp_Fields>;
  variance?: Maybe<Genre_Variance_Fields>;
};


/** aggregate fields of "Genre" */
export type Genre_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Genre_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Genre_Avg_Fields = {
  __typename?: 'Genre_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "Genre". All fields are combined with a logical 'AND'. */
export type Genre_Bool_Exp = {
  _and?: InputMaybe<Array<Genre_Bool_Exp>>;
  _not?: InputMaybe<Genre_Bool_Exp>;
  _or?: InputMaybe<Array<Genre_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Genre" */
export enum Genre_Constraint {
  /** unique or primary key constraint on columns "id" */
  GenrePkey = 'Genre_pkey',
  /** unique or primary key constraint on columns "title" */
  GenreTitleKey = 'Genre_title_key'
}

/** input type for incrementing numeric columns in table "Genre" */
export type Genre_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Genre" */
export type Genre_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Genre_Max_Fields = {
  __typename?: 'Genre_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Genre_Min_Fields = {
  __typename?: 'Genre_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "Genre" */
export type Genre_Mutation_Response = {
  __typename?: 'Genre_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Genre>;
};

/** input type for inserting object relation for remote table "Genre" */
export type Genre_Obj_Rel_Insert_Input = {
  data: Genre_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Genre_On_Conflict>;
};

/** on_conflict condition type for table "Genre" */
export type Genre_On_Conflict = {
  constraint: Genre_Constraint;
  update_columns?: Array<Genre_Update_Column>;
  where?: InputMaybe<Genre_Bool_Exp>;
};

/** Ordering options when selecting data from "Genre". */
export type Genre_Order_By = {
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Genre */
export type Genre_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "Genre" */
export enum Genre_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "Genre" */
export type Genre_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Genre_Stddev_Fields = {
  __typename?: 'Genre_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Genre_Stddev_Pop_Fields = {
  __typename?: 'Genre_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Genre_Stddev_Samp_Fields = {
  __typename?: 'Genre_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "Genre" */
export type Genre_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Genre_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Genre_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Genre_Sum_Fields = {
  __typename?: 'Genre_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "Genre" */
export enum Genre_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

export type Genre_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Genre_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Genre_Set_Input>;
  /** filter the rows which have to be updated */
  where: Genre_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Genre_Var_Pop_Fields = {
  __typename?: 'Genre_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Genre_Var_Samp_Fields = {
  __typename?: 'Genre_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Genre_Variance_Fields = {
  __typename?: 'Genre_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Video" */
export type Video = {
  __typename?: 'Video';
  created_at: Scalars['timestamptz']['output'];
  entity_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "Video" */
export type Video_Aggregate = {
  __typename?: 'Video_aggregate';
  aggregate?: Maybe<Video_Aggregate_Fields>;
  nodes: Array<Video>;
};

/** aggregate fields of "Video" */
export type Video_Aggregate_Fields = {
  __typename?: 'Video_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Video_Max_Fields>;
  min?: Maybe<Video_Min_Fields>;
};


/** aggregate fields of "Video" */
export type Video_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Video_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Video". All fields are combined with a logical 'AND'. */
export type Video_Bool_Exp = {
  _and?: InputMaybe<Array<Video_Bool_Exp>>;
  _not?: InputMaybe<Video_Bool_Exp>;
  _or?: InputMaybe<Array<Video_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "Video" */
export enum Video_Constraint {
  /** unique or primary key constraint on columns "entity_id" */
  VideoEntityIdKey = 'Video_entity_id_key',
  /** unique or primary key constraint on columns "id" */
  VideoPkey = 'Video_pkey'
}

/** input type for inserting data into table "Video" */
export type Video_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Video_Max_Fields = {
  __typename?: 'Video_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Video_Min_Fields = {
  __typename?: 'Video_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "Video" */
export type Video_Mutation_Response = {
  __typename?: 'Video_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Video>;
};

/** input type for inserting object relation for remote table "Video" */
export type Video_Obj_Rel_Insert_Input = {
  data: Video_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Video_On_Conflict>;
};

/** on_conflict condition type for table "Video" */
export type Video_On_Conflict = {
  constraint: Video_Constraint;
  update_columns?: Array<Video_Update_Column>;
  where?: InputMaybe<Video_Bool_Exp>;
};

/** Ordering options when selecting data from "Video". */
export type Video_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: Video */
export type Video_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Video" */
export enum Video_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "Video" */
export type Video_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Video" */
export type Video_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Video_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Video_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Video" */
export enum Video_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  Url = 'url'
}

export type Video_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Video_Set_Input>;
  /** filter the rows which have to be updated */
  where: Video_Bool_Exp;
};

/** columns and relationships of "anime_genre" */
export type Anime_Genre = {
  __typename?: 'anime_genre';
  /** An object relationship */
  Anime: Anime;
  /** An object relationship */
  Genre: Genre;
  anime_id: Scalars['Int']['output'];
  genre_id: Scalars['Int']['output'];
};

/** aggregated selection of "anime_genre" */
export type Anime_Genre_Aggregate = {
  __typename?: 'anime_genre_aggregate';
  aggregate?: Maybe<Anime_Genre_Aggregate_Fields>;
  nodes: Array<Anime_Genre>;
};

export type Anime_Genre_Aggregate_Bool_Exp = {
  count?: InputMaybe<Anime_Genre_Aggregate_Bool_Exp_Count>;
};

export type Anime_Genre_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Anime_Genre_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "anime_genre" */
export type Anime_Genre_Aggregate_Fields = {
  __typename?: 'anime_genre_aggregate_fields';
  avg?: Maybe<Anime_Genre_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Anime_Genre_Max_Fields>;
  min?: Maybe<Anime_Genre_Min_Fields>;
  stddev?: Maybe<Anime_Genre_Stddev_Fields>;
  stddev_pop?: Maybe<Anime_Genre_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Anime_Genre_Stddev_Samp_Fields>;
  sum?: Maybe<Anime_Genre_Sum_Fields>;
  var_pop?: Maybe<Anime_Genre_Var_Pop_Fields>;
  var_samp?: Maybe<Anime_Genre_Var_Samp_Fields>;
  variance?: Maybe<Anime_Genre_Variance_Fields>;
};


/** aggregate fields of "anime_genre" */
export type Anime_Genre_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "anime_genre" */
export type Anime_Genre_Aggregate_Order_By = {
  avg?: InputMaybe<Anime_Genre_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Anime_Genre_Max_Order_By>;
  min?: InputMaybe<Anime_Genre_Min_Order_By>;
  stddev?: InputMaybe<Anime_Genre_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Anime_Genre_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Anime_Genre_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Anime_Genre_Sum_Order_By>;
  var_pop?: InputMaybe<Anime_Genre_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Anime_Genre_Var_Samp_Order_By>;
  variance?: InputMaybe<Anime_Genre_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "anime_genre" */
export type Anime_Genre_Arr_Rel_Insert_Input = {
  data: Array<Anime_Genre_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Anime_Genre_On_Conflict>;
};

/** aggregate avg on columns */
export type Anime_Genre_Avg_Fields = {
  __typename?: 'anime_genre_avg_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "anime_genre" */
export type Anime_Genre_Avg_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "anime_genre". All fields are combined with a logical 'AND'. */
export type Anime_Genre_Bool_Exp = {
  Anime?: InputMaybe<Anime_Bool_Exp>;
  Genre?: InputMaybe<Genre_Bool_Exp>;
  _and?: InputMaybe<Array<Anime_Genre_Bool_Exp>>;
  _not?: InputMaybe<Anime_Genre_Bool_Exp>;
  _or?: InputMaybe<Array<Anime_Genre_Bool_Exp>>;
  anime_id?: InputMaybe<Int_Comparison_Exp>;
  genre_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "anime_genre" */
export enum Anime_Genre_Constraint {
  /** unique or primary key constraint on columns "anime_id", "genre_id" */
  AnimeGenrePkey = 'anime_genre_pkey'
}

/** input type for incrementing numeric columns in table "anime_genre" */
export type Anime_Genre_Inc_Input = {
  anime_id?: InputMaybe<Scalars['Int']['input']>;
  genre_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "anime_genre" */
export type Anime_Genre_Insert_Input = {
  Anime?: InputMaybe<Anime_Obj_Rel_Insert_Input>;
  Genre?: InputMaybe<Genre_Obj_Rel_Insert_Input>;
  anime_id?: InputMaybe<Scalars['Int']['input']>;
  genre_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Anime_Genre_Max_Fields = {
  __typename?: 'anime_genre_max_fields';
  anime_id?: Maybe<Scalars['Int']['output']>;
  genre_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "anime_genre" */
export type Anime_Genre_Max_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Anime_Genre_Min_Fields = {
  __typename?: 'anime_genre_min_fields';
  anime_id?: Maybe<Scalars['Int']['output']>;
  genre_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "anime_genre" */
export type Anime_Genre_Min_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "anime_genre" */
export type Anime_Genre_Mutation_Response = {
  __typename?: 'anime_genre_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Anime_Genre>;
};

/** on_conflict condition type for table "anime_genre" */
export type Anime_Genre_On_Conflict = {
  constraint: Anime_Genre_Constraint;
  update_columns?: Array<Anime_Genre_Update_Column>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};

/** Ordering options when selecting data from "anime_genre". */
export type Anime_Genre_Order_By = {
  Anime?: InputMaybe<Anime_Order_By>;
  Genre?: InputMaybe<Genre_Order_By>;
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: anime_genre */
export type Anime_Genre_Pk_Columns_Input = {
  anime_id: Scalars['Int']['input'];
  genre_id: Scalars['Int']['input'];
};

/** select columns of table "anime_genre" */
export enum Anime_Genre_Select_Column {
  /** column name */
  AnimeId = 'anime_id',
  /** column name */
  GenreId = 'genre_id'
}

/** input type for updating data in table "anime_genre" */
export type Anime_Genre_Set_Input = {
  anime_id?: InputMaybe<Scalars['Int']['input']>;
  genre_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Anime_Genre_Stddev_Fields = {
  __typename?: 'anime_genre_stddev_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "anime_genre" */
export type Anime_Genre_Stddev_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Anime_Genre_Stddev_Pop_Fields = {
  __typename?: 'anime_genre_stddev_pop_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "anime_genre" */
export type Anime_Genre_Stddev_Pop_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Anime_Genre_Stddev_Samp_Fields = {
  __typename?: 'anime_genre_stddev_samp_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "anime_genre" */
export type Anime_Genre_Stddev_Samp_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "anime_genre" */
export type Anime_Genre_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Anime_Genre_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Anime_Genre_Stream_Cursor_Value_Input = {
  anime_id?: InputMaybe<Scalars['Int']['input']>;
  genre_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Anime_Genre_Sum_Fields = {
  __typename?: 'anime_genre_sum_fields';
  anime_id?: Maybe<Scalars['Int']['output']>;
  genre_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "anime_genre" */
export type Anime_Genre_Sum_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** update columns of table "anime_genre" */
export enum Anime_Genre_Update_Column {
  /** column name */
  AnimeId = 'anime_id',
  /** column name */
  GenreId = 'genre_id'
}

export type Anime_Genre_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Anime_Genre_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Anime_Genre_Set_Input>;
  /** filter the rows which have to be updated */
  where: Anime_Genre_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Anime_Genre_Var_Pop_Fields = {
  __typename?: 'anime_genre_var_pop_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "anime_genre" */
export type Anime_Genre_Var_Pop_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Anime_Genre_Var_Samp_Fields = {
  __typename?: 'anime_genre_var_samp_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "anime_genre" */
export type Anime_Genre_Var_Samp_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Anime_Genre_Variance_Fields = {
  __typename?: 'anime_genre_variance_fields';
  anime_id?: Maybe<Scalars['Float']['output']>;
  genre_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "anime_genre" */
export type Anime_Genre_Variance_Order_By = {
  anime_id?: InputMaybe<Order_By>;
  genre_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  post_id: Scalars['Int']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int']['output'];
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

export type Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Comments_Aggregate_Bool_Exp_Count>;
};

export type Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  avg?: Maybe<Comments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
  stddev?: Maybe<Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Comments_Sum_Fields>;
  var_pop?: Maybe<Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Comments_Var_Samp_Fields>;
  variance?: Maybe<Comments_Variance_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
  stddev?: InputMaybe<Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Comments_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Comments_Avg_Fields = {
  __typename?: 'comments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "comments" */
export type Comments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  post_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  PostId = 'post_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Comments_Stddev_Fields = {
  __typename?: 'comments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "comments" */
export type Comments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Comments_Stddev_Pop_Fields = {
  __typename?: 'comments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "comments" */
export type Comments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Comments_Stddev_Samp_Fields = {
  __typename?: 'comments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "comments" */
export type Comments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "comments" */
export type Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Comments_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  post_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Comments_Sum_Fields = {
  __typename?: 'comments_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "comments" */
export type Comments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Comments_Var_Pop_Fields = {
  __typename?: 'comments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "comments" */
export type Comments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Comments_Var_Samp_Fields = {
  __typename?: 'comments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "comments" */
export type Comments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Comments_Variance_Fields = {
  __typename?: 'comments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "comments" */
export type Comments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type Dialog = {
  __typename?: 'dialog';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  is_new?: Maybe<Scalars['Boolean']['output']>;
  owner_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['jsonb']['output']>;
};


export type DialogUserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "dialog". All fields are combined with a logical 'AND'. */
export type Dialog_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Dialog_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Dialog_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Dialog_Bool_Exp_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_new?: InputMaybe<Boolean_Comparison_Exp>;
  owner_id?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Jsonb_Comparison_Exp>;
};

export enum Dialog_Enum_Name {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsNew = 'is_new',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Text = 'text',
  /** column name */
  User = 'user'
}

/** Ordering options when selecting data from "dialog". */
export type Dialog_Order_By = {
  created_at?: InputMaybe<Order_By>;
  is_new?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
};

/** dialogsNative Query Arguments */
export type Dialogs_Arguments = {
  owner_id: Scalars['Int']['input'];
};

/** columns and relationships of "followers" */
export type Followers = {
  __typename?: 'followers';
  followed_user: Scalars['Int']['output'];
  follower_id: Scalars['Int']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByFollowerId: Users;
};

/** aggregated selection of "followers" */
export type Followers_Aggregate = {
  __typename?: 'followers_aggregate';
  aggregate?: Maybe<Followers_Aggregate_Fields>;
  nodes: Array<Followers>;
};

export type Followers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Followers_Aggregate_Bool_Exp_Count>;
};

export type Followers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Followers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Followers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "followers" */
export type Followers_Aggregate_Fields = {
  __typename?: 'followers_aggregate_fields';
  avg?: Maybe<Followers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Followers_Max_Fields>;
  min?: Maybe<Followers_Min_Fields>;
  stddev?: Maybe<Followers_Stddev_Fields>;
  stddev_pop?: Maybe<Followers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Followers_Stddev_Samp_Fields>;
  sum?: Maybe<Followers_Sum_Fields>;
  var_pop?: Maybe<Followers_Var_Pop_Fields>;
  var_samp?: Maybe<Followers_Var_Samp_Fields>;
  variance?: Maybe<Followers_Variance_Fields>;
};


/** aggregate fields of "followers" */
export type Followers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Followers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "followers" */
export type Followers_Aggregate_Order_By = {
  avg?: InputMaybe<Followers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Followers_Max_Order_By>;
  min?: InputMaybe<Followers_Min_Order_By>;
  stddev?: InputMaybe<Followers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Followers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Followers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Followers_Sum_Order_By>;
  var_pop?: InputMaybe<Followers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Followers_Var_Samp_Order_By>;
  variance?: InputMaybe<Followers_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Followers_Avg_Fields = {
  __typename?: 'followers_avg_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "followers" */
export type Followers_Avg_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "followers". All fields are combined with a logical 'AND'. */
export type Followers_Bool_Exp = {
  _and?: InputMaybe<Array<Followers_Bool_Exp>>;
  _not?: InputMaybe<Followers_Bool_Exp>;
  _or?: InputMaybe<Array<Followers_Bool_Exp>>;
  followed_user?: InputMaybe<Int_Comparison_Exp>;
  follower_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByFollowerId?: InputMaybe<Users_Bool_Exp>;
};

/** aggregate max on columns */
export type Followers_Max_Fields = {
  __typename?: 'followers_max_fields';
  followed_user?: Maybe<Scalars['Int']['output']>;
  follower_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "followers" */
export type Followers_Max_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Followers_Min_Fields = {
  __typename?: 'followers_min_fields';
  followed_user?: Maybe<Scalars['Int']['output']>;
  follower_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "followers" */
export type Followers_Min_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "followers". */
export type Followers_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByFollowerId?: InputMaybe<Users_Order_By>;
};

/** select columns of table "followers" */
export enum Followers_Select_Column {
  /** column name */
  FollowedUser = 'followed_user',
  /** column name */
  FollowerId = 'follower_id'
}

/** aggregate stddev on columns */
export type Followers_Stddev_Fields = {
  __typename?: 'followers_stddev_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "followers" */
export type Followers_Stddev_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Followers_Stddev_Pop_Fields = {
  __typename?: 'followers_stddev_pop_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "followers" */
export type Followers_Stddev_Pop_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Followers_Stddev_Samp_Fields = {
  __typename?: 'followers_stddev_samp_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "followers" */
export type Followers_Stddev_Samp_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "followers" */
export type Followers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Followers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Followers_Stream_Cursor_Value_Input = {
  followed_user?: InputMaybe<Scalars['Int']['input']>;
  follower_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Followers_Sum_Fields = {
  __typename?: 'followers_sum_fields';
  followed_user?: Maybe<Scalars['Int']['output']>;
  follower_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "followers" */
export type Followers_Sum_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Followers_Var_Pop_Fields = {
  __typename?: 'followers_var_pop_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "followers" */
export type Followers_Var_Pop_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Followers_Var_Samp_Fields = {
  __typename?: 'followers_var_samp_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "followers" */
export type Followers_Var_Samp_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Followers_Variance_Fields = {
  __typename?: 'followers_variance_fields';
  followed_user?: Maybe<Scalars['Float']['output']>;
  follower_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "followers" */
export type Followers_Variance_Order_By = {
  followed_user?: InputMaybe<Order_By>;
  follower_id?: InputMaybe<Order_By>;
};

export type Is_Liked_Uogorod_Comments_Args = {
  entity?: InputMaybe<Scalars['String']['input']>;
};

export type Is_Liked_Uogorod_Images_Args = {
  entity?: InputMaybe<Scalars['String']['input']>;
};

export type Is_Liked_Uogorod_Posts_Args = {
  entity?: InputMaybe<Scalars['String']['input']>;
};

export type Is_Liked_Uogorod_Reviews_Args = {
  entity?: InputMaybe<Scalars['String']['input']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "Anime" */
  delete_Anime?: Maybe<Anime_Mutation_Response>;
  /** delete single row from the table: "Anime" */
  delete_Anime_by_pk?: Maybe<Anime>;
  /** delete data from the table: "Genre" */
  delete_Genre?: Maybe<Genre_Mutation_Response>;
  /** delete single row from the table: "Genre" */
  delete_Genre_by_pk?: Maybe<Genre>;
  /** delete data from the table: "Video" */
  delete_Video?: Maybe<Video_Mutation_Response>;
  /** delete single row from the table: "Video" */
  delete_Video_by_pk?: Maybe<Video>;
  /** delete data from the table: "anime_genre" */
  delete_anime_genre?: Maybe<Anime_Genre_Mutation_Response>;
  /** delete single row from the table: "anime_genre" */
  delete_anime_genre_by_pk?: Maybe<Anime_Genre>;
  /** delete data from the table: "uogorod.achivments" */
  delete_uogorod_achivments?: Maybe<Uogorod_Achivments_Mutation_Response>;
  /** delete single row from the table: "uogorod.achivments" */
  delete_uogorod_achivments_by_pk?: Maybe<Uogorod_Achivments>;
  /** delete data from the table: "uogorod.brands" */
  delete_uogorod_brands?: Maybe<Uogorod_Brands_Mutation_Response>;
  /** delete single row from the table: "uogorod.brands" */
  delete_uogorod_brands_by_pk?: Maybe<Uogorod_Brands>;
  /** delete data from the table: "uogorod.brands_contacts" */
  delete_uogorod_brands_contacts?: Maybe<Uogorod_Brands_Contacts_Mutation_Response>;
  /** delete single row from the table: "uogorod.brands_contacts" */
  delete_uogorod_brands_contacts_by_pk?: Maybe<Uogorod_Brands_Contacts>;
  /** delete data from the table: "uogorod.comments" */
  delete_uogorod_comments?: Maybe<Uogorod_Comments_Mutation_Response>;
  /** delete single row from the table: "uogorod.comments" */
  delete_uogorod_comments_by_pk?: Maybe<Uogorod_Comments>;
  /** delete data from the table: "uogorod.emails" */
  delete_uogorod_emails?: Maybe<Uogorod_Emails_Mutation_Response>;
  /** delete data from the table: "uogorod.experiments" */
  delete_uogorod_experiments?: Maybe<Uogorod_Experiments_Mutation_Response>;
  /** delete single row from the table: "uogorod.experiments" */
  delete_uogorod_experiments_by_pk?: Maybe<Uogorod_Experiments>;
  /** delete data from the table: "uogorod.experiments_seeds" */
  delete_uogorod_experiments_seeds?: Maybe<Uogorod_Experiments_Seeds_Mutation_Response>;
  /** delete single row from the table: "uogorod.experiments_seeds" */
  delete_uogorod_experiments_seeds_by_pk?: Maybe<Uogorod_Experiments_Seeds>;
  /** delete data from the table: "uogorod.experiments_steps" */
  delete_uogorod_experiments_steps?: Maybe<Uogorod_Experiments_Steps_Mutation_Response>;
  /** delete single row from the table: "uogorod.experiments_steps" */
  delete_uogorod_experiments_steps_by_pk?: Maybe<Uogorod_Experiments_Steps>;
  /** delete data from the table: "uogorod.experiments_views" */
  delete_uogorod_experiments_views?: Maybe<Uogorod_Experiments_Views_Mutation_Response>;
  /** delete single row from the table: "uogorod.experiments_views" */
  delete_uogorod_experiments_views_by_pk?: Maybe<Uogorod_Experiments_Views>;
  /** delete data from the table: "uogorod.garden_beds" */
  delete_uogorod_garden_beds?: Maybe<Uogorod_Garden_Beds_Mutation_Response>;
  /** delete single row from the table: "uogorod.garden_beds" */
  delete_uogorod_garden_beds_by_pk?: Maybe<Uogorod_Garden_Beds>;
  /** delete data from the table: "uogorod.garden_beds_seeds" */
  delete_uogorod_garden_beds_seeds?: Maybe<Uogorod_Garden_Beds_Seeds_Mutation_Response>;
  /** delete single row from the table: "uogorod.garden_beds_seeds" */
  delete_uogorod_garden_beds_seeds_by_pk?: Maybe<Uogorod_Garden_Beds_Seeds>;
  /** delete data from the table: "uogorod.garden_seasons" */
  delete_uogorod_garden_seasons?: Maybe<Uogorod_Garden_Seasons_Mutation_Response>;
  /** delete single row from the table: "uogorod.garden_seasons" */
  delete_uogorod_garden_seasons_by_pk?: Maybe<Uogorod_Garden_Seasons>;
  /** delete data from the table: "uogorod.garden_seeds" */
  delete_uogorod_garden_seeds?: Maybe<Uogorod_Garden_Seeds_Mutation_Response>;
  /** delete single row from the table: "uogorod.garden_seeds" */
  delete_uogorod_garden_seeds_by_pk?: Maybe<Uogorod_Garden_Seeds>;
  /** delete data from the table: "uogorod.gardens" */
  delete_uogorod_gardens?: Maybe<Uogorod_Gardens_Mutation_Response>;
  /** delete single row from the table: "uogorod.gardens" */
  delete_uogorod_gardens_by_pk?: Maybe<Uogorod_Gardens>;
  /** delete data from the table: "uogorod.geo_city" */
  delete_uogorod_geo_city?: Maybe<Uogorod_Geo_City_Mutation_Response>;
  /** delete single row from the table: "uogorod.geo_city" */
  delete_uogorod_geo_city_by_pk?: Maybe<Uogorod_Geo_City>;
  /** delete data from the table: "uogorod.geo_country" */
  delete_uogorod_geo_country?: Maybe<Uogorod_Geo_Country_Mutation_Response>;
  /** delete single row from the table: "uogorod.geo_country" */
  delete_uogorod_geo_country_by_pk?: Maybe<Uogorod_Geo_Country>;
  /** delete data from the table: "uogorod.geo_region" */
  delete_uogorod_geo_region?: Maybe<Uogorod_Geo_Region_Mutation_Response>;
  /** delete single row from the table: "uogorod.geo_region" */
  delete_uogorod_geo_region_by_pk?: Maybe<Uogorod_Geo_Region>;
  /** delete data from the table: "uogorod.groups" */
  delete_uogorod_groups?: Maybe<Uogorod_Groups_Mutation_Response>;
  /** delete single row from the table: "uogorod.groups" */
  delete_uogorod_groups_by_pk?: Maybe<Uogorod_Groups>;
  /** delete data from the table: "uogorod.groups_category" */
  delete_uogorod_groups_category?: Maybe<Uogorod_Groups_Category_Mutation_Response>;
  /** delete single row from the table: "uogorod.groups_category" */
  delete_uogorod_groups_category_by_pk?: Maybe<Uogorod_Groups_Category>;
  /** delete data from the table: "uogorod.groups_users" */
  delete_uogorod_groups_users?: Maybe<Uogorod_Groups_Users_Mutation_Response>;
  /** delete single row from the table: "uogorod.groups_users" */
  delete_uogorod_groups_users_by_pk?: Maybe<Uogorod_Groups_Users>;
  /** delete data from the table: "uogorod.images" */
  delete_uogorod_images?: Maybe<Uogorod_Images_Mutation_Response>;
  /** delete single row from the table: "uogorod.images" */
  delete_uogorod_images_by_pk?: Maybe<Uogorod_Images>;
  /** delete data from the table: "uogorod.likes" */
  delete_uogorod_likes?: Maybe<Uogorod_Likes_Mutation_Response>;
  /** delete single row from the table: "uogorod.likes" */
  delete_uogorod_likes_by_pk?: Maybe<Uogorod_Likes>;
  /** delete data from the table: "uogorod.manual" */
  delete_uogorod_manual?: Maybe<Uogorod_Manual_Mutation_Response>;
  /** delete single row from the table: "uogorod.manual" */
  delete_uogorod_manual_by_pk?: Maybe<Uogorod_Manual>;
  /** delete data from the table: "uogorod.messages" */
  delete_uogorod_messages?: Maybe<Uogorod_Messages_Mutation_Response>;
  /** delete single row from the table: "uogorod.messages" */
  delete_uogorod_messages_by_pk?: Maybe<Uogorod_Messages>;
  /** delete data from the table: "uogorod.notifications" */
  delete_uogorod_notifications?: Maybe<Uogorod_Notifications_Mutation_Response>;
  /** delete single row from the table: "uogorod.notifications" */
  delete_uogorod_notifications_by_pk?: Maybe<Uogorod_Notifications>;
  /** delete data from the table: "uogorod.pages" */
  delete_uogorod_pages?: Maybe<Uogorod_Pages_Mutation_Response>;
  /** delete single row from the table: "uogorod.pages" */
  delete_uogorod_pages_by_pk?: Maybe<Uogorod_Pages>;
  /** delete data from the table: "uogorod.posts" */
  delete_uogorod_posts?: Maybe<Uogorod_Posts_Mutation_Response>;
  /** delete single row from the table: "uogorod.posts" */
  delete_uogorod_posts_by_pk?: Maybe<Uogorod_Posts>;
  /** delete data from the table: "uogorod.reports" */
  delete_uogorod_reports?: Maybe<Uogorod_Reports_Mutation_Response>;
  /** delete single row from the table: "uogorod.reports" */
  delete_uogorod_reports_by_pk?: Maybe<Uogorod_Reports>;
  /** delete data from the table: "uogorod.reviews" */
  delete_uogorod_reviews?: Maybe<Uogorod_Reviews_Mutation_Response>;
  /** delete single row from the table: "uogorod.reviews" */
  delete_uogorod_reviews_by_pk?: Maybe<Uogorod_Reviews>;
  /** delete data from the table: "uogorod.seed_categories" */
  delete_uogorod_seed_categories?: Maybe<Uogorod_Seed_Categories_Mutation_Response>;
  /** delete single row from the table: "uogorod.seed_categories" */
  delete_uogorod_seed_categories_by_pk?: Maybe<Uogorod_Seed_Categories>;
  /** delete data from the table: "uogorod.seed_params" */
  delete_uogorod_seed_params?: Maybe<Uogorod_Seed_Params_Mutation_Response>;
  /** delete single row from the table: "uogorod.seed_params" */
  delete_uogorod_seed_params_by_pk?: Maybe<Uogorod_Seed_Params>;
  /** delete data from the table: "uogorod.seed_similar" */
  delete_uogorod_seed_similar?: Maybe<Uogorod_Seed_Similar_Mutation_Response>;
  /** delete single row from the table: "uogorod.seed_similar" */
  delete_uogorod_seed_similar_by_pk?: Maybe<Uogorod_Seed_Similar>;
  /** delete data from the table: "uogorod.seed_specs" */
  delete_uogorod_seed_specs?: Maybe<Uogorod_Seed_Specs_Mutation_Response>;
  /** delete single row from the table: "uogorod.seed_specs" */
  delete_uogorod_seed_specs_by_pk?: Maybe<Uogorod_Seed_Specs>;
  /** delete data from the table: "uogorod.seed_votes" */
  delete_uogorod_seed_votes?: Maybe<Uogorod_Seed_Votes_Mutation_Response>;
  /** delete single row from the table: "uogorod.seed_votes" */
  delete_uogorod_seed_votes_by_pk?: Maybe<Uogorod_Seed_Votes>;
  /** delete data from the table: "uogorod.seeds" */
  delete_uogorod_seeds?: Maybe<Uogorod_Seeds_Mutation_Response>;
  /** delete data from the table: "uogorod.seeds_brands" */
  delete_uogorod_seeds_brands?: Maybe<Uogorod_Seeds_Brands_Mutation_Response>;
  /** delete single row from the table: "uogorod.seeds_brands" */
  delete_uogorod_seeds_brands_by_pk?: Maybe<Uogorod_Seeds_Brands>;
  /** delete single row from the table: "uogorod.seeds" */
  delete_uogorod_seeds_by_pk?: Maybe<Uogorod_Seeds>;
  /** delete data from the table: "uogorod.seeds_images" */
  delete_uogorod_seeds_images?: Maybe<Uogorod_Seeds_Images_Mutation_Response>;
  /** delete single row from the table: "uogorod.seeds_images" */
  delete_uogorod_seeds_images_by_pk?: Maybe<Uogorod_Seeds_Images>;
  /** delete data from the table: "uogorod.seeds_records" */
  delete_uogorod_seeds_records?: Maybe<Uogorod_Seeds_Records_Mutation_Response>;
  /** delete single row from the table: "uogorod.seeds_records" */
  delete_uogorod_seeds_records_by_pk?: Maybe<Uogorod_Seeds_Records>;
  /** delete data from the table: "uogorod.subscribes" */
  delete_uogorod_subscribes?: Maybe<Uogorod_Subscribes_Mutation_Response>;
  /** delete single row from the table: "uogorod.subscribes" */
  delete_uogorod_subscribes_by_pk?: Maybe<Uogorod_Subscribes>;
  /** delete data from the table: "uogorod.type_comments" */
  delete_uogorod_type_comments?: Maybe<Uogorod_Type_Comments_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_comments" */
  delete_uogorod_type_comments_by_pk?: Maybe<Uogorod_Type_Comments>;
  /** delete data from the table: "uogorod.type_contacts" */
  delete_uogorod_type_contacts?: Maybe<Uogorod_Type_Contacts_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_contacts" */
  delete_uogorod_type_contacts_by_pk?: Maybe<Uogorod_Type_Contacts>;
  /** delete data from the table: "uogorod.type_likes" */
  delete_uogorod_type_likes?: Maybe<Uogorod_Type_Likes_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_likes" */
  delete_uogorod_type_likes_by_pk?: Maybe<Uogorod_Type_Likes>;
  /** delete data from the table: "uogorod.type_posts" */
  delete_uogorod_type_posts?: Maybe<Uogorod_Type_Posts_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_posts" */
  delete_uogorod_type_posts_by_pk?: Maybe<Uogorod_Type_Posts>;
  /** delete data from the table: "uogorod.type_seed_actions" */
  delete_uogorod_type_seed_actions?: Maybe<Uogorod_Type_Seed_Actions_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_seed_actions" */
  delete_uogorod_type_seed_actions_by_pk?: Maybe<Uogorod_Type_Seed_Actions>;
  /** delete data from the table: "uogorod.type_seeds_status" */
  delete_uogorod_type_seeds_status?: Maybe<Uogorod_Type_Seeds_Status_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_seeds_status" */
  delete_uogorod_type_seeds_status_by_pk?: Maybe<Uogorod_Type_Seeds_Status>;
  /** delete data from the table: "uogorod.type_users" */
  delete_uogorod_type_users?: Maybe<Uogorod_Type_Users_Mutation_Response>;
  /** delete single row from the table: "uogorod.type_users" */
  delete_uogorod_type_users_by_pk?: Maybe<Uogorod_Type_Users>;
  /** delete data from the table: "uogorod.user_achivments" */
  delete_uogorod_user_achivments?: Maybe<Uogorod_User_Achivments_Mutation_Response>;
  /** delete single row from the table: "uogorod.user_achivments" */
  delete_uogorod_user_achivments_by_pk?: Maybe<Uogorod_User_Achivments>;
  /** delete data from the table: "uogorod.user_contacts" */
  delete_uogorod_user_contacts?: Maybe<Uogorod_User_Contacts_Mutation_Response>;
  /** delete single row from the table: "uogorod.user_contacts" */
  delete_uogorod_user_contacts_by_pk?: Maybe<Uogorod_User_Contacts>;
  /** delete data from the table: "uogorod.users" */
  delete_uogorod_users?: Maybe<Uogorod_Users_Mutation_Response>;
  /** delete single row from the table: "uogorod.users" */
  delete_uogorod_users_by_pk?: Maybe<Uogorod_Users>;
  /** delete data from the table: "uogorod.users_calendar" */
  delete_uogorod_users_calendar?: Maybe<Uogorod_Users_Calendar_Mutation_Response>;
  /** delete single row from the table: "uogorod.users_calendar" */
  delete_uogorod_users_calendar_by_pk?: Maybe<Uogorod_Users_Calendar>;
  /** delete data from the table: "uogorod.users_not_activated" */
  delete_uogorod_users_not_activated?: Maybe<Uogorod_Users_Not_Activated_Mutation_Response>;
  /** delete data from the table: "uogorod.users_seed_actions" */
  delete_uogorod_users_seed_actions?: Maybe<Uogorod_Users_Seed_Actions_Mutation_Response>;
  /** delete single row from the table: "uogorod.users_seed_actions" */
  delete_uogorod_users_seed_actions_by_pk?: Maybe<Uogorod_Users_Seed_Actions>;
  /** insert data into the table: "Anime" */
  insert_Anime?: Maybe<Anime_Mutation_Response>;
  /** insert a single row into the table: "Anime" */
  insert_Anime_one?: Maybe<Anime>;
  /** insert data into the table: "Genre" */
  insert_Genre?: Maybe<Genre_Mutation_Response>;
  /** insert a single row into the table: "Genre" */
  insert_Genre_one?: Maybe<Genre>;
  /** insert data into the table: "Video" */
  insert_Video?: Maybe<Video_Mutation_Response>;
  /** insert a single row into the table: "Video" */
  insert_Video_one?: Maybe<Video>;
  /** insert data into the table: "anime_genre" */
  insert_anime_genre?: Maybe<Anime_Genre_Mutation_Response>;
  /** insert a single row into the table: "anime_genre" */
  insert_anime_genre_one?: Maybe<Anime_Genre>;
  /** insert data into the table: "uogorod.achivments" */
  insert_uogorod_achivments?: Maybe<Uogorod_Achivments_Mutation_Response>;
  /** insert a single row into the table: "uogorod.achivments" */
  insert_uogorod_achivments_one?: Maybe<Uogorod_Achivments>;
  /** insert data into the table: "uogorod.brands" */
  insert_uogorod_brands?: Maybe<Uogorod_Brands_Mutation_Response>;
  /** insert data into the table: "uogorod.brands_contacts" */
  insert_uogorod_brands_contacts?: Maybe<Uogorod_Brands_Contacts_Mutation_Response>;
  /** insert a single row into the table: "uogorod.brands_contacts" */
  insert_uogorod_brands_contacts_one?: Maybe<Uogorod_Brands_Contacts>;
  /** insert a single row into the table: "uogorod.brands" */
  insert_uogorod_brands_one?: Maybe<Uogorod_Brands>;
  /** insert data into the table: "uogorod.comments" */
  insert_uogorod_comments?: Maybe<Uogorod_Comments_Mutation_Response>;
  /** insert a single row into the table: "uogorod.comments" */
  insert_uogorod_comments_one?: Maybe<Uogorod_Comments>;
  /** insert data into the table: "uogorod.emails" */
  insert_uogorod_emails?: Maybe<Uogorod_Emails_Mutation_Response>;
  /** insert a single row into the table: "uogorod.emails" */
  insert_uogorod_emails_one?: Maybe<Uogorod_Emails>;
  /** insert data into the table: "uogorod.experiments" */
  insert_uogorod_experiments?: Maybe<Uogorod_Experiments_Mutation_Response>;
  /** insert a single row into the table: "uogorod.experiments" */
  insert_uogorod_experiments_one?: Maybe<Uogorod_Experiments>;
  /** insert data into the table: "uogorod.experiments_seeds" */
  insert_uogorod_experiments_seeds?: Maybe<Uogorod_Experiments_Seeds_Mutation_Response>;
  /** insert a single row into the table: "uogorod.experiments_seeds" */
  insert_uogorod_experiments_seeds_one?: Maybe<Uogorod_Experiments_Seeds>;
  /** insert data into the table: "uogorod.experiments_steps" */
  insert_uogorod_experiments_steps?: Maybe<Uogorod_Experiments_Steps_Mutation_Response>;
  /** insert a single row into the table: "uogorod.experiments_steps" */
  insert_uogorod_experiments_steps_one?: Maybe<Uogorod_Experiments_Steps>;
  /** insert data into the table: "uogorod.experiments_views" */
  insert_uogorod_experiments_views?: Maybe<Uogorod_Experiments_Views_Mutation_Response>;
  /** insert a single row into the table: "uogorod.experiments_views" */
  insert_uogorod_experiments_views_one?: Maybe<Uogorod_Experiments_Views>;
  /** insert data into the table: "uogorod.garden_beds" */
  insert_uogorod_garden_beds?: Maybe<Uogorod_Garden_Beds_Mutation_Response>;
  /** insert a single row into the table: "uogorod.garden_beds" */
  insert_uogorod_garden_beds_one?: Maybe<Uogorod_Garden_Beds>;
  /** insert data into the table: "uogorod.garden_beds_seeds" */
  insert_uogorod_garden_beds_seeds?: Maybe<Uogorod_Garden_Beds_Seeds_Mutation_Response>;
  /** insert a single row into the table: "uogorod.garden_beds_seeds" */
  insert_uogorod_garden_beds_seeds_one?: Maybe<Uogorod_Garden_Beds_Seeds>;
  /** insert data into the table: "uogorod.garden_seasons" */
  insert_uogorod_garden_seasons?: Maybe<Uogorod_Garden_Seasons_Mutation_Response>;
  /** insert a single row into the table: "uogorod.garden_seasons" */
  insert_uogorod_garden_seasons_one?: Maybe<Uogorod_Garden_Seasons>;
  /** insert data into the table: "uogorod.garden_seeds" */
  insert_uogorod_garden_seeds?: Maybe<Uogorod_Garden_Seeds_Mutation_Response>;
  /** insert a single row into the table: "uogorod.garden_seeds" */
  insert_uogorod_garden_seeds_one?: Maybe<Uogorod_Garden_Seeds>;
  /** insert data into the table: "uogorod.gardens" */
  insert_uogorod_gardens?: Maybe<Uogorod_Gardens_Mutation_Response>;
  /** insert a single row into the table: "uogorod.gardens" */
  insert_uogorod_gardens_one?: Maybe<Uogorod_Gardens>;
  /** insert data into the table: "uogorod.geo_city" */
  insert_uogorod_geo_city?: Maybe<Uogorod_Geo_City_Mutation_Response>;
  /** insert a single row into the table: "uogorod.geo_city" */
  insert_uogorod_geo_city_one?: Maybe<Uogorod_Geo_City>;
  /** insert data into the table: "uogorod.geo_country" */
  insert_uogorod_geo_country?: Maybe<Uogorod_Geo_Country_Mutation_Response>;
  /** insert a single row into the table: "uogorod.geo_country" */
  insert_uogorod_geo_country_one?: Maybe<Uogorod_Geo_Country>;
  /** insert data into the table: "uogorod.geo_region" */
  insert_uogorod_geo_region?: Maybe<Uogorod_Geo_Region_Mutation_Response>;
  /** insert a single row into the table: "uogorod.geo_region" */
  insert_uogorod_geo_region_one?: Maybe<Uogorod_Geo_Region>;
  /** insert data into the table: "uogorod.groups" */
  insert_uogorod_groups?: Maybe<Uogorod_Groups_Mutation_Response>;
  /** insert data into the table: "uogorod.groups_category" */
  insert_uogorod_groups_category?: Maybe<Uogorod_Groups_Category_Mutation_Response>;
  /** insert a single row into the table: "uogorod.groups_category" */
  insert_uogorod_groups_category_one?: Maybe<Uogorod_Groups_Category>;
  /** insert a single row into the table: "uogorod.groups" */
  insert_uogorod_groups_one?: Maybe<Uogorod_Groups>;
  /** insert data into the table: "uogorod.groups_users" */
  insert_uogorod_groups_users?: Maybe<Uogorod_Groups_Users_Mutation_Response>;
  /** insert a single row into the table: "uogorod.groups_users" */
  insert_uogorod_groups_users_one?: Maybe<Uogorod_Groups_Users>;
  /** insert data into the table: "uogorod.images" */
  insert_uogorod_images?: Maybe<Uogorod_Images_Mutation_Response>;
  /** insert a single row into the table: "uogorod.images" */
  insert_uogorod_images_one?: Maybe<Uogorod_Images>;
  /** insert data into the table: "uogorod.likes" */
  insert_uogorod_likes?: Maybe<Uogorod_Likes_Mutation_Response>;
  /** insert a single row into the table: "uogorod.likes" */
  insert_uogorod_likes_one?: Maybe<Uogorod_Likes>;
  /** insert data into the table: "uogorod.manual" */
  insert_uogorod_manual?: Maybe<Uogorod_Manual_Mutation_Response>;
  /** insert a single row into the table: "uogorod.manual" */
  insert_uogorod_manual_one?: Maybe<Uogorod_Manual>;
  /** insert data into the table: "uogorod.messages" */
  insert_uogorod_messages?: Maybe<Uogorod_Messages_Mutation_Response>;
  /** insert a single row into the table: "uogorod.messages" */
  insert_uogorod_messages_one?: Maybe<Uogorod_Messages>;
  /** insert data into the table: "uogorod.notifications" */
  insert_uogorod_notifications?: Maybe<Uogorod_Notifications_Mutation_Response>;
  /** insert a single row into the table: "uogorod.notifications" */
  insert_uogorod_notifications_one?: Maybe<Uogorod_Notifications>;
  /** insert data into the table: "uogorod.pages" */
  insert_uogorod_pages?: Maybe<Uogorod_Pages_Mutation_Response>;
  /** insert a single row into the table: "uogorod.pages" */
  insert_uogorod_pages_one?: Maybe<Uogorod_Pages>;
  /** insert data into the table: "uogorod.posts" */
  insert_uogorod_posts?: Maybe<Uogorod_Posts_Mutation_Response>;
  /** insert a single row into the table: "uogorod.posts" */
  insert_uogorod_posts_one?: Maybe<Uogorod_Posts>;
  /** insert data into the table: "uogorod.reports" */
  insert_uogorod_reports?: Maybe<Uogorod_Reports_Mutation_Response>;
  /** insert a single row into the table: "uogorod.reports" */
  insert_uogorod_reports_one?: Maybe<Uogorod_Reports>;
  /** insert data into the table: "uogorod.reviews" */
  insert_uogorod_reviews?: Maybe<Uogorod_Reviews_Mutation_Response>;
  /** insert a single row into the table: "uogorod.reviews" */
  insert_uogorod_reviews_one?: Maybe<Uogorod_Reviews>;
  /** insert data into the table: "uogorod.seed_categories" */
  insert_uogorod_seed_categories?: Maybe<Uogorod_Seed_Categories_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seed_categories" */
  insert_uogorod_seed_categories_one?: Maybe<Uogorod_Seed_Categories>;
  /** insert data into the table: "uogorod.seed_params" */
  insert_uogorod_seed_params?: Maybe<Uogorod_Seed_Params_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seed_params" */
  insert_uogorod_seed_params_one?: Maybe<Uogorod_Seed_Params>;
  /** insert data into the table: "uogorod.seed_similar" */
  insert_uogorod_seed_similar?: Maybe<Uogorod_Seed_Similar_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seed_similar" */
  insert_uogorod_seed_similar_one?: Maybe<Uogorod_Seed_Similar>;
  /** insert data into the table: "uogorod.seed_specs" */
  insert_uogorod_seed_specs?: Maybe<Uogorod_Seed_Specs_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seed_specs" */
  insert_uogorod_seed_specs_one?: Maybe<Uogorod_Seed_Specs>;
  /** insert data into the table: "uogorod.seed_votes" */
  insert_uogorod_seed_votes?: Maybe<Uogorod_Seed_Votes_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seed_votes" */
  insert_uogorod_seed_votes_one?: Maybe<Uogorod_Seed_Votes>;
  /** insert data into the table: "uogorod.seeds" */
  insert_uogorod_seeds?: Maybe<Uogorod_Seeds_Mutation_Response>;
  /** insert data into the table: "uogorod.seeds_brands" */
  insert_uogorod_seeds_brands?: Maybe<Uogorod_Seeds_Brands_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seeds_brands" */
  insert_uogorod_seeds_brands_one?: Maybe<Uogorod_Seeds_Brands>;
  /** insert data into the table: "uogorod.seeds_images" */
  insert_uogorod_seeds_images?: Maybe<Uogorod_Seeds_Images_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seeds_images" */
  insert_uogorod_seeds_images_one?: Maybe<Uogorod_Seeds_Images>;
  /** insert a single row into the table: "uogorod.seeds" */
  insert_uogorod_seeds_one?: Maybe<Uogorod_Seeds>;
  /** insert data into the table: "uogorod.seeds_records" */
  insert_uogorod_seeds_records?: Maybe<Uogorod_Seeds_Records_Mutation_Response>;
  /** insert a single row into the table: "uogorod.seeds_records" */
  insert_uogorod_seeds_records_one?: Maybe<Uogorod_Seeds_Records>;
  /** insert data into the table: "uogorod.subscribes" */
  insert_uogorod_subscribes?: Maybe<Uogorod_Subscribes_Mutation_Response>;
  /** insert a single row into the table: "uogorod.subscribes" */
  insert_uogorod_subscribes_one?: Maybe<Uogorod_Subscribes>;
  /** insert data into the table: "uogorod.type_comments" */
  insert_uogorod_type_comments?: Maybe<Uogorod_Type_Comments_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_comments" */
  insert_uogorod_type_comments_one?: Maybe<Uogorod_Type_Comments>;
  /** insert data into the table: "uogorod.type_contacts" */
  insert_uogorod_type_contacts?: Maybe<Uogorod_Type_Contacts_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_contacts" */
  insert_uogorod_type_contacts_one?: Maybe<Uogorod_Type_Contacts>;
  /** insert data into the table: "uogorod.type_likes" */
  insert_uogorod_type_likes?: Maybe<Uogorod_Type_Likes_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_likes" */
  insert_uogorod_type_likes_one?: Maybe<Uogorod_Type_Likes>;
  /** insert data into the table: "uogorod.type_posts" */
  insert_uogorod_type_posts?: Maybe<Uogorod_Type_Posts_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_posts" */
  insert_uogorod_type_posts_one?: Maybe<Uogorod_Type_Posts>;
  /** insert data into the table: "uogorod.type_seed_actions" */
  insert_uogorod_type_seed_actions?: Maybe<Uogorod_Type_Seed_Actions_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_seed_actions" */
  insert_uogorod_type_seed_actions_one?: Maybe<Uogorod_Type_Seed_Actions>;
  /** insert data into the table: "uogorod.type_seeds_status" */
  insert_uogorod_type_seeds_status?: Maybe<Uogorod_Type_Seeds_Status_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_seeds_status" */
  insert_uogorod_type_seeds_status_one?: Maybe<Uogorod_Type_Seeds_Status>;
  /** insert data into the table: "uogorod.type_users" */
  insert_uogorod_type_users?: Maybe<Uogorod_Type_Users_Mutation_Response>;
  /** insert a single row into the table: "uogorod.type_users" */
  insert_uogorod_type_users_one?: Maybe<Uogorod_Type_Users>;
  /** insert data into the table: "uogorod.user_achivments" */
  insert_uogorod_user_achivments?: Maybe<Uogorod_User_Achivments_Mutation_Response>;
  /** insert a single row into the table: "uogorod.user_achivments" */
  insert_uogorod_user_achivments_one?: Maybe<Uogorod_User_Achivments>;
  /** insert data into the table: "uogorod.user_contacts" */
  insert_uogorod_user_contacts?: Maybe<Uogorod_User_Contacts_Mutation_Response>;
  /** insert a single row into the table: "uogorod.user_contacts" */
  insert_uogorod_user_contacts_one?: Maybe<Uogorod_User_Contacts>;
  /** insert data into the table: "uogorod.users" */
  insert_uogorod_users?: Maybe<Uogorod_Users_Mutation_Response>;
  /** insert data into the table: "uogorod.users_calendar" */
  insert_uogorod_users_calendar?: Maybe<Uogorod_Users_Calendar_Mutation_Response>;
  /** insert a single row into the table: "uogorod.users_calendar" */
  insert_uogorod_users_calendar_one?: Maybe<Uogorod_Users_Calendar>;
  /** insert data into the table: "uogorod.users_not_activated" */
  insert_uogorod_users_not_activated?: Maybe<Uogorod_Users_Not_Activated_Mutation_Response>;
  /** insert a single row into the table: "uogorod.users_not_activated" */
  insert_uogorod_users_not_activated_one?: Maybe<Uogorod_Users_Not_Activated>;
  /** insert a single row into the table: "uogorod.users" */
  insert_uogorod_users_one?: Maybe<Uogorod_Users>;
  /** insert data into the table: "uogorod.users_seed_actions" */
  insert_uogorod_users_seed_actions?: Maybe<Uogorod_Users_Seed_Actions_Mutation_Response>;
  /** insert a single row into the table: "uogorod.users_seed_actions" */
  insert_uogorod_users_seed_actions_one?: Maybe<Uogorod_Users_Seed_Actions>;
  /** update data of the table: "Anime" */
  update_Anime?: Maybe<Anime_Mutation_Response>;
  /** update single row of the table: "Anime" */
  update_Anime_by_pk?: Maybe<Anime>;
  /** update multiples rows of table: "Anime" */
  update_Anime_many?: Maybe<Array<Maybe<Anime_Mutation_Response>>>;
  /** update data of the table: "Genre" */
  update_Genre?: Maybe<Genre_Mutation_Response>;
  /** update single row of the table: "Genre" */
  update_Genre_by_pk?: Maybe<Genre>;
  /** update multiples rows of table: "Genre" */
  update_Genre_many?: Maybe<Array<Maybe<Genre_Mutation_Response>>>;
  /** update data of the table: "Video" */
  update_Video?: Maybe<Video_Mutation_Response>;
  /** update single row of the table: "Video" */
  update_Video_by_pk?: Maybe<Video>;
  /** update multiples rows of table: "Video" */
  update_Video_many?: Maybe<Array<Maybe<Video_Mutation_Response>>>;
  /** update data of the table: "anime_genre" */
  update_anime_genre?: Maybe<Anime_Genre_Mutation_Response>;
  /** update single row of the table: "anime_genre" */
  update_anime_genre_by_pk?: Maybe<Anime_Genre>;
  /** update multiples rows of table: "anime_genre" */
  update_anime_genre_many?: Maybe<Array<Maybe<Anime_Genre_Mutation_Response>>>;
  /** update data of the table: "uogorod.achivments" */
  update_uogorod_achivments?: Maybe<Uogorod_Achivments_Mutation_Response>;
  /** update single row of the table: "uogorod.achivments" */
  update_uogorod_achivments_by_pk?: Maybe<Uogorod_Achivments>;
  /** update multiples rows of table: "uogorod.achivments" */
  update_uogorod_achivments_many?: Maybe<Array<Maybe<Uogorod_Achivments_Mutation_Response>>>;
  /** update data of the table: "uogorod.brands" */
  update_uogorod_brands?: Maybe<Uogorod_Brands_Mutation_Response>;
  /** update single row of the table: "uogorod.brands" */
  update_uogorod_brands_by_pk?: Maybe<Uogorod_Brands>;
  /** update data of the table: "uogorod.brands_contacts" */
  update_uogorod_brands_contacts?: Maybe<Uogorod_Brands_Contacts_Mutation_Response>;
  /** update single row of the table: "uogorod.brands_contacts" */
  update_uogorod_brands_contacts_by_pk?: Maybe<Uogorod_Brands_Contacts>;
  /** update multiples rows of table: "uogorod.brands_contacts" */
  update_uogorod_brands_contacts_many?: Maybe<Array<Maybe<Uogorod_Brands_Contacts_Mutation_Response>>>;
  /** update multiples rows of table: "uogorod.brands" */
  update_uogorod_brands_many?: Maybe<Array<Maybe<Uogorod_Brands_Mutation_Response>>>;
  /** update data of the table: "uogorod.comments" */
  update_uogorod_comments?: Maybe<Uogorod_Comments_Mutation_Response>;
  /** update single row of the table: "uogorod.comments" */
  update_uogorod_comments_by_pk?: Maybe<Uogorod_Comments>;
  /** update multiples rows of table: "uogorod.comments" */
  update_uogorod_comments_many?: Maybe<Array<Maybe<Uogorod_Comments_Mutation_Response>>>;
  /** update data of the table: "uogorod.emails" */
  update_uogorod_emails?: Maybe<Uogorod_Emails_Mutation_Response>;
  /** update multiples rows of table: "uogorod.emails" */
  update_uogorod_emails_many?: Maybe<Array<Maybe<Uogorod_Emails_Mutation_Response>>>;
  /** update data of the table: "uogorod.experiments" */
  update_uogorod_experiments?: Maybe<Uogorod_Experiments_Mutation_Response>;
  /** update single row of the table: "uogorod.experiments" */
  update_uogorod_experiments_by_pk?: Maybe<Uogorod_Experiments>;
  /** update multiples rows of table: "uogorod.experiments" */
  update_uogorod_experiments_many?: Maybe<Array<Maybe<Uogorod_Experiments_Mutation_Response>>>;
  /** update data of the table: "uogorod.experiments_seeds" */
  update_uogorod_experiments_seeds?: Maybe<Uogorod_Experiments_Seeds_Mutation_Response>;
  /** update single row of the table: "uogorod.experiments_seeds" */
  update_uogorod_experiments_seeds_by_pk?: Maybe<Uogorod_Experiments_Seeds>;
  /** update multiples rows of table: "uogorod.experiments_seeds" */
  update_uogorod_experiments_seeds_many?: Maybe<Array<Maybe<Uogorod_Experiments_Seeds_Mutation_Response>>>;
  /** update data of the table: "uogorod.experiments_steps" */
  update_uogorod_experiments_steps?: Maybe<Uogorod_Experiments_Steps_Mutation_Response>;
  /** update single row of the table: "uogorod.experiments_steps" */
  update_uogorod_experiments_steps_by_pk?: Maybe<Uogorod_Experiments_Steps>;
  /** update multiples rows of table: "uogorod.experiments_steps" */
  update_uogorod_experiments_steps_many?: Maybe<Array<Maybe<Uogorod_Experiments_Steps_Mutation_Response>>>;
  /** update data of the table: "uogorod.experiments_views" */
  update_uogorod_experiments_views?: Maybe<Uogorod_Experiments_Views_Mutation_Response>;
  /** update single row of the table: "uogorod.experiments_views" */
  update_uogorod_experiments_views_by_pk?: Maybe<Uogorod_Experiments_Views>;
  /** update multiples rows of table: "uogorod.experiments_views" */
  update_uogorod_experiments_views_many?: Maybe<Array<Maybe<Uogorod_Experiments_Views_Mutation_Response>>>;
  /** update data of the table: "uogorod.garden_beds" */
  update_uogorod_garden_beds?: Maybe<Uogorod_Garden_Beds_Mutation_Response>;
  /** update single row of the table: "uogorod.garden_beds" */
  update_uogorod_garden_beds_by_pk?: Maybe<Uogorod_Garden_Beds>;
  /** update multiples rows of table: "uogorod.garden_beds" */
  update_uogorod_garden_beds_many?: Maybe<Array<Maybe<Uogorod_Garden_Beds_Mutation_Response>>>;
  /** update data of the table: "uogorod.garden_beds_seeds" */
  update_uogorod_garden_beds_seeds?: Maybe<Uogorod_Garden_Beds_Seeds_Mutation_Response>;
  /** update single row of the table: "uogorod.garden_beds_seeds" */
  update_uogorod_garden_beds_seeds_by_pk?: Maybe<Uogorod_Garden_Beds_Seeds>;
  /** update multiples rows of table: "uogorod.garden_beds_seeds" */
  update_uogorod_garden_beds_seeds_many?: Maybe<Array<Maybe<Uogorod_Garden_Beds_Seeds_Mutation_Response>>>;
  /** update data of the table: "uogorod.garden_seasons" */
  update_uogorod_garden_seasons?: Maybe<Uogorod_Garden_Seasons_Mutation_Response>;
  /** update single row of the table: "uogorod.garden_seasons" */
  update_uogorod_garden_seasons_by_pk?: Maybe<Uogorod_Garden_Seasons>;
  /** update multiples rows of table: "uogorod.garden_seasons" */
  update_uogorod_garden_seasons_many?: Maybe<Array<Maybe<Uogorod_Garden_Seasons_Mutation_Response>>>;
  /** update data of the table: "uogorod.garden_seeds" */
  update_uogorod_garden_seeds?: Maybe<Uogorod_Garden_Seeds_Mutation_Response>;
  /** update single row of the table: "uogorod.garden_seeds" */
  update_uogorod_garden_seeds_by_pk?: Maybe<Uogorod_Garden_Seeds>;
  /** update multiples rows of table: "uogorod.garden_seeds" */
  update_uogorod_garden_seeds_many?: Maybe<Array<Maybe<Uogorod_Garden_Seeds_Mutation_Response>>>;
  /** update data of the table: "uogorod.gardens" */
  update_uogorod_gardens?: Maybe<Uogorod_Gardens_Mutation_Response>;
  /** update single row of the table: "uogorod.gardens" */
  update_uogorod_gardens_by_pk?: Maybe<Uogorod_Gardens>;
  /** update multiples rows of table: "uogorod.gardens" */
  update_uogorod_gardens_many?: Maybe<Array<Maybe<Uogorod_Gardens_Mutation_Response>>>;
  /** update data of the table: "uogorod.geo_city" */
  update_uogorod_geo_city?: Maybe<Uogorod_Geo_City_Mutation_Response>;
  /** update single row of the table: "uogorod.geo_city" */
  update_uogorod_geo_city_by_pk?: Maybe<Uogorod_Geo_City>;
  /** update multiples rows of table: "uogorod.geo_city" */
  update_uogorod_geo_city_many?: Maybe<Array<Maybe<Uogorod_Geo_City_Mutation_Response>>>;
  /** update data of the table: "uogorod.geo_country" */
  update_uogorod_geo_country?: Maybe<Uogorod_Geo_Country_Mutation_Response>;
  /** update single row of the table: "uogorod.geo_country" */
  update_uogorod_geo_country_by_pk?: Maybe<Uogorod_Geo_Country>;
  /** update multiples rows of table: "uogorod.geo_country" */
  update_uogorod_geo_country_many?: Maybe<Array<Maybe<Uogorod_Geo_Country_Mutation_Response>>>;
  /** update data of the table: "uogorod.geo_region" */
  update_uogorod_geo_region?: Maybe<Uogorod_Geo_Region_Mutation_Response>;
  /** update single row of the table: "uogorod.geo_region" */
  update_uogorod_geo_region_by_pk?: Maybe<Uogorod_Geo_Region>;
  /** update multiples rows of table: "uogorod.geo_region" */
  update_uogorod_geo_region_many?: Maybe<Array<Maybe<Uogorod_Geo_Region_Mutation_Response>>>;
  /** update data of the table: "uogorod.groups" */
  update_uogorod_groups?: Maybe<Uogorod_Groups_Mutation_Response>;
  /** update single row of the table: "uogorod.groups" */
  update_uogorod_groups_by_pk?: Maybe<Uogorod_Groups>;
  /** update data of the table: "uogorod.groups_category" */
  update_uogorod_groups_category?: Maybe<Uogorod_Groups_Category_Mutation_Response>;
  /** update single row of the table: "uogorod.groups_category" */
  update_uogorod_groups_category_by_pk?: Maybe<Uogorod_Groups_Category>;
  /** update multiples rows of table: "uogorod.groups_category" */
  update_uogorod_groups_category_many?: Maybe<Array<Maybe<Uogorod_Groups_Category_Mutation_Response>>>;
  /** update multiples rows of table: "uogorod.groups" */
  update_uogorod_groups_many?: Maybe<Array<Maybe<Uogorod_Groups_Mutation_Response>>>;
  /** update data of the table: "uogorod.groups_users" */
  update_uogorod_groups_users?: Maybe<Uogorod_Groups_Users_Mutation_Response>;
  /** update single row of the table: "uogorod.groups_users" */
  update_uogorod_groups_users_by_pk?: Maybe<Uogorod_Groups_Users>;
  /** update multiples rows of table: "uogorod.groups_users" */
  update_uogorod_groups_users_many?: Maybe<Array<Maybe<Uogorod_Groups_Users_Mutation_Response>>>;
  /** update data of the table: "uogorod.images" */
  update_uogorod_images?: Maybe<Uogorod_Images_Mutation_Response>;
  /** update single row of the table: "uogorod.images" */
  update_uogorod_images_by_pk?: Maybe<Uogorod_Images>;
  /** update multiples rows of table: "uogorod.images" */
  update_uogorod_images_many?: Maybe<Array<Maybe<Uogorod_Images_Mutation_Response>>>;
  /** update data of the table: "uogorod.likes" */
  update_uogorod_likes?: Maybe<Uogorod_Likes_Mutation_Response>;
  /** update single row of the table: "uogorod.likes" */
  update_uogorod_likes_by_pk?: Maybe<Uogorod_Likes>;
  /** update multiples rows of table: "uogorod.likes" */
  update_uogorod_likes_many?: Maybe<Array<Maybe<Uogorod_Likes_Mutation_Response>>>;
  /** update data of the table: "uogorod.manual" */
  update_uogorod_manual?: Maybe<Uogorod_Manual_Mutation_Response>;
  /** update single row of the table: "uogorod.manual" */
  update_uogorod_manual_by_pk?: Maybe<Uogorod_Manual>;
  /** update multiples rows of table: "uogorod.manual" */
  update_uogorod_manual_many?: Maybe<Array<Maybe<Uogorod_Manual_Mutation_Response>>>;
  /** update data of the table: "uogorod.messages" */
  update_uogorod_messages?: Maybe<Uogorod_Messages_Mutation_Response>;
  /** update single row of the table: "uogorod.messages" */
  update_uogorod_messages_by_pk?: Maybe<Uogorod_Messages>;
  /** update multiples rows of table: "uogorod.messages" */
  update_uogorod_messages_many?: Maybe<Array<Maybe<Uogorod_Messages_Mutation_Response>>>;
  /** update data of the table: "uogorod.notifications" */
  update_uogorod_notifications?: Maybe<Uogorod_Notifications_Mutation_Response>;
  /** update single row of the table: "uogorod.notifications" */
  update_uogorod_notifications_by_pk?: Maybe<Uogorod_Notifications>;
  /** update multiples rows of table: "uogorod.notifications" */
  update_uogorod_notifications_many?: Maybe<Array<Maybe<Uogorod_Notifications_Mutation_Response>>>;
  /** update data of the table: "uogorod.pages" */
  update_uogorod_pages?: Maybe<Uogorod_Pages_Mutation_Response>;
  /** update single row of the table: "uogorod.pages" */
  update_uogorod_pages_by_pk?: Maybe<Uogorod_Pages>;
  /** update multiples rows of table: "uogorod.pages" */
  update_uogorod_pages_many?: Maybe<Array<Maybe<Uogorod_Pages_Mutation_Response>>>;
  /** update data of the table: "uogorod.posts" */
  update_uogorod_posts?: Maybe<Uogorod_Posts_Mutation_Response>;
  /** update single row of the table: "uogorod.posts" */
  update_uogorod_posts_by_pk?: Maybe<Uogorod_Posts>;
  /** update multiples rows of table: "uogorod.posts" */
  update_uogorod_posts_many?: Maybe<Array<Maybe<Uogorod_Posts_Mutation_Response>>>;
  /** update data of the table: "uogorod.reports" */
  update_uogorod_reports?: Maybe<Uogorod_Reports_Mutation_Response>;
  /** update single row of the table: "uogorod.reports" */
  update_uogorod_reports_by_pk?: Maybe<Uogorod_Reports>;
  /** update multiples rows of table: "uogorod.reports" */
  update_uogorod_reports_many?: Maybe<Array<Maybe<Uogorod_Reports_Mutation_Response>>>;
  /** update data of the table: "uogorod.reviews" */
  update_uogorod_reviews?: Maybe<Uogorod_Reviews_Mutation_Response>;
  /** update single row of the table: "uogorod.reviews" */
  update_uogorod_reviews_by_pk?: Maybe<Uogorod_Reviews>;
  /** update multiples rows of table: "uogorod.reviews" */
  update_uogorod_reviews_many?: Maybe<Array<Maybe<Uogorod_Reviews_Mutation_Response>>>;
  /** update data of the table: "uogorod.seed_categories" */
  update_uogorod_seed_categories?: Maybe<Uogorod_Seed_Categories_Mutation_Response>;
  /** update single row of the table: "uogorod.seed_categories" */
  update_uogorod_seed_categories_by_pk?: Maybe<Uogorod_Seed_Categories>;
  /** update multiples rows of table: "uogorod.seed_categories" */
  update_uogorod_seed_categories_many?: Maybe<Array<Maybe<Uogorod_Seed_Categories_Mutation_Response>>>;
  /** update data of the table: "uogorod.seed_params" */
  update_uogorod_seed_params?: Maybe<Uogorod_Seed_Params_Mutation_Response>;
  /** update single row of the table: "uogorod.seed_params" */
  update_uogorod_seed_params_by_pk?: Maybe<Uogorod_Seed_Params>;
  /** update multiples rows of table: "uogorod.seed_params" */
  update_uogorod_seed_params_many?: Maybe<Array<Maybe<Uogorod_Seed_Params_Mutation_Response>>>;
  /** update data of the table: "uogorod.seed_similar" */
  update_uogorod_seed_similar?: Maybe<Uogorod_Seed_Similar_Mutation_Response>;
  /** update single row of the table: "uogorod.seed_similar" */
  update_uogorod_seed_similar_by_pk?: Maybe<Uogorod_Seed_Similar>;
  /** update multiples rows of table: "uogorod.seed_similar" */
  update_uogorod_seed_similar_many?: Maybe<Array<Maybe<Uogorod_Seed_Similar_Mutation_Response>>>;
  /** update data of the table: "uogorod.seed_specs" */
  update_uogorod_seed_specs?: Maybe<Uogorod_Seed_Specs_Mutation_Response>;
  /** update single row of the table: "uogorod.seed_specs" */
  update_uogorod_seed_specs_by_pk?: Maybe<Uogorod_Seed_Specs>;
  /** update multiples rows of table: "uogorod.seed_specs" */
  update_uogorod_seed_specs_many?: Maybe<Array<Maybe<Uogorod_Seed_Specs_Mutation_Response>>>;
  /** update data of the table: "uogorod.seed_votes" */
  update_uogorod_seed_votes?: Maybe<Uogorod_Seed_Votes_Mutation_Response>;
  /** update single row of the table: "uogorod.seed_votes" */
  update_uogorod_seed_votes_by_pk?: Maybe<Uogorod_Seed_Votes>;
  /** update multiples rows of table: "uogorod.seed_votes" */
  update_uogorod_seed_votes_many?: Maybe<Array<Maybe<Uogorod_Seed_Votes_Mutation_Response>>>;
  /** update data of the table: "uogorod.seeds" */
  update_uogorod_seeds?: Maybe<Uogorod_Seeds_Mutation_Response>;
  /** update data of the table: "uogorod.seeds_brands" */
  update_uogorod_seeds_brands?: Maybe<Uogorod_Seeds_Brands_Mutation_Response>;
  /** update single row of the table: "uogorod.seeds_brands" */
  update_uogorod_seeds_brands_by_pk?: Maybe<Uogorod_Seeds_Brands>;
  /** update multiples rows of table: "uogorod.seeds_brands" */
  update_uogorod_seeds_brands_many?: Maybe<Array<Maybe<Uogorod_Seeds_Brands_Mutation_Response>>>;
  /** update single row of the table: "uogorod.seeds" */
  update_uogorod_seeds_by_pk?: Maybe<Uogorod_Seeds>;
  /** update data of the table: "uogorod.seeds_images" */
  update_uogorod_seeds_images?: Maybe<Uogorod_Seeds_Images_Mutation_Response>;
  /** update single row of the table: "uogorod.seeds_images" */
  update_uogorod_seeds_images_by_pk?: Maybe<Uogorod_Seeds_Images>;
  /** update multiples rows of table: "uogorod.seeds_images" */
  update_uogorod_seeds_images_many?: Maybe<Array<Maybe<Uogorod_Seeds_Images_Mutation_Response>>>;
  /** update multiples rows of table: "uogorod.seeds" */
  update_uogorod_seeds_many?: Maybe<Array<Maybe<Uogorod_Seeds_Mutation_Response>>>;
  /** update data of the table: "uogorod.seeds_records" */
  update_uogorod_seeds_records?: Maybe<Uogorod_Seeds_Records_Mutation_Response>;
  /** update single row of the table: "uogorod.seeds_records" */
  update_uogorod_seeds_records_by_pk?: Maybe<Uogorod_Seeds_Records>;
  /** update multiples rows of table: "uogorod.seeds_records" */
  update_uogorod_seeds_records_many?: Maybe<Array<Maybe<Uogorod_Seeds_Records_Mutation_Response>>>;
  /** update data of the table: "uogorod.subscribes" */
  update_uogorod_subscribes?: Maybe<Uogorod_Subscribes_Mutation_Response>;
  /** update single row of the table: "uogorod.subscribes" */
  update_uogorod_subscribes_by_pk?: Maybe<Uogorod_Subscribes>;
  /** update multiples rows of table: "uogorod.subscribes" */
  update_uogorod_subscribes_many?: Maybe<Array<Maybe<Uogorod_Subscribes_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_comments" */
  update_uogorod_type_comments?: Maybe<Uogorod_Type_Comments_Mutation_Response>;
  /** update single row of the table: "uogorod.type_comments" */
  update_uogorod_type_comments_by_pk?: Maybe<Uogorod_Type_Comments>;
  /** update multiples rows of table: "uogorod.type_comments" */
  update_uogorod_type_comments_many?: Maybe<Array<Maybe<Uogorod_Type_Comments_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_contacts" */
  update_uogorod_type_contacts?: Maybe<Uogorod_Type_Contacts_Mutation_Response>;
  /** update single row of the table: "uogorod.type_contacts" */
  update_uogorod_type_contacts_by_pk?: Maybe<Uogorod_Type_Contacts>;
  /** update multiples rows of table: "uogorod.type_contacts" */
  update_uogorod_type_contacts_many?: Maybe<Array<Maybe<Uogorod_Type_Contacts_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_likes" */
  update_uogorod_type_likes?: Maybe<Uogorod_Type_Likes_Mutation_Response>;
  /** update single row of the table: "uogorod.type_likes" */
  update_uogorod_type_likes_by_pk?: Maybe<Uogorod_Type_Likes>;
  /** update multiples rows of table: "uogorod.type_likes" */
  update_uogorod_type_likes_many?: Maybe<Array<Maybe<Uogorod_Type_Likes_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_posts" */
  update_uogorod_type_posts?: Maybe<Uogorod_Type_Posts_Mutation_Response>;
  /** update single row of the table: "uogorod.type_posts" */
  update_uogorod_type_posts_by_pk?: Maybe<Uogorod_Type_Posts>;
  /** update multiples rows of table: "uogorod.type_posts" */
  update_uogorod_type_posts_many?: Maybe<Array<Maybe<Uogorod_Type_Posts_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_seed_actions" */
  update_uogorod_type_seed_actions?: Maybe<Uogorod_Type_Seed_Actions_Mutation_Response>;
  /** update single row of the table: "uogorod.type_seed_actions" */
  update_uogorod_type_seed_actions_by_pk?: Maybe<Uogorod_Type_Seed_Actions>;
  /** update multiples rows of table: "uogorod.type_seed_actions" */
  update_uogorod_type_seed_actions_many?: Maybe<Array<Maybe<Uogorod_Type_Seed_Actions_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_seeds_status" */
  update_uogorod_type_seeds_status?: Maybe<Uogorod_Type_Seeds_Status_Mutation_Response>;
  /** update single row of the table: "uogorod.type_seeds_status" */
  update_uogorod_type_seeds_status_by_pk?: Maybe<Uogorod_Type_Seeds_Status>;
  /** update multiples rows of table: "uogorod.type_seeds_status" */
  update_uogorod_type_seeds_status_many?: Maybe<Array<Maybe<Uogorod_Type_Seeds_Status_Mutation_Response>>>;
  /** update data of the table: "uogorod.type_users" */
  update_uogorod_type_users?: Maybe<Uogorod_Type_Users_Mutation_Response>;
  /** update single row of the table: "uogorod.type_users" */
  update_uogorod_type_users_by_pk?: Maybe<Uogorod_Type_Users>;
  /** update multiples rows of table: "uogorod.type_users" */
  update_uogorod_type_users_many?: Maybe<Array<Maybe<Uogorod_Type_Users_Mutation_Response>>>;
  /** update data of the table: "uogorod.user_achivments" */
  update_uogorod_user_achivments?: Maybe<Uogorod_User_Achivments_Mutation_Response>;
  /** update single row of the table: "uogorod.user_achivments" */
  update_uogorod_user_achivments_by_pk?: Maybe<Uogorod_User_Achivments>;
  /** update multiples rows of table: "uogorod.user_achivments" */
  update_uogorod_user_achivments_many?: Maybe<Array<Maybe<Uogorod_User_Achivments_Mutation_Response>>>;
  /** update data of the table: "uogorod.user_contacts" */
  update_uogorod_user_contacts?: Maybe<Uogorod_User_Contacts_Mutation_Response>;
  /** update single row of the table: "uogorod.user_contacts" */
  update_uogorod_user_contacts_by_pk?: Maybe<Uogorod_User_Contacts>;
  /** update multiples rows of table: "uogorod.user_contacts" */
  update_uogorod_user_contacts_many?: Maybe<Array<Maybe<Uogorod_User_Contacts_Mutation_Response>>>;
  /** update data of the table: "uogorod.users" */
  update_uogorod_users?: Maybe<Uogorod_Users_Mutation_Response>;
  /** update single row of the table: "uogorod.users" */
  update_uogorod_users_by_pk?: Maybe<Uogorod_Users>;
  /** update data of the table: "uogorod.users_calendar" */
  update_uogorod_users_calendar?: Maybe<Uogorod_Users_Calendar_Mutation_Response>;
  /** update single row of the table: "uogorod.users_calendar" */
  update_uogorod_users_calendar_by_pk?: Maybe<Uogorod_Users_Calendar>;
  /** update multiples rows of table: "uogorod.users_calendar" */
  update_uogorod_users_calendar_many?: Maybe<Array<Maybe<Uogorod_Users_Calendar_Mutation_Response>>>;
  /** update multiples rows of table: "uogorod.users" */
  update_uogorod_users_many?: Maybe<Array<Maybe<Uogorod_Users_Mutation_Response>>>;
  /** update data of the table: "uogorod.users_not_activated" */
  update_uogorod_users_not_activated?: Maybe<Uogorod_Users_Not_Activated_Mutation_Response>;
  /** update multiples rows of table: "uogorod.users_not_activated" */
  update_uogorod_users_not_activated_many?: Maybe<Array<Maybe<Uogorod_Users_Not_Activated_Mutation_Response>>>;
  /** update data of the table: "uogorod.users_seed_actions" */
  update_uogorod_users_seed_actions?: Maybe<Uogorod_Users_Seed_Actions_Mutation_Response>;
  /** update single row of the table: "uogorod.users_seed_actions" */
  update_uogorod_users_seed_actions_by_pk?: Maybe<Uogorod_Users_Seed_Actions>;
  /** update multiples rows of table: "uogorod.users_seed_actions" */
  update_uogorod_users_seed_actions_many?: Maybe<Array<Maybe<Uogorod_Users_Seed_Actions_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AnimeArgs = {
  where: Anime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anime_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GenreArgs = {
  where: Genre_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Genre_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_VideoArgs = {
  where: Video_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Video_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Anime_GenreArgs = {
  where: Anime_Genre_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Anime_Genre_By_PkArgs = {
  anime_id: Scalars['Int']['input'];
  genre_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_AchivmentsArgs = {
  where: Uogorod_Achivments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Achivments_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_BrandsArgs = {
  where: Uogorod_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Brands_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Brands_ContactsArgs = {
  where: Uogorod_Brands_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Brands_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_CommentsArgs = {
  where: Uogorod_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_EmailsArgs = {
  where: Uogorod_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_ExperimentsArgs = {
  where: Uogorod_Experiments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_SeedsArgs = {
  where: Uogorod_Experiments_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_StepsArgs = {
  where: Uogorod_Experiments_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_Steps_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_ViewsArgs = {
  where: Uogorod_Experiments_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Experiments_Views_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_BedsArgs = {
  where: Uogorod_Garden_Beds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_Beds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_Beds_SeedsArgs = {
  where: Uogorod_Garden_Beds_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_Beds_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_SeasonsArgs = {
  where: Uogorod_Garden_Seasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_Seasons_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_SeedsArgs = {
  where: Uogorod_Garden_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Garden_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_GardensArgs = {
  where: Uogorod_Gardens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Gardens_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_CityArgs = {
  where: Uogorod_Geo_City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_City_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_CountryArgs = {
  where: Uogorod_Geo_Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_Country_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_RegionArgs = {
  where: Uogorod_Geo_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Geo_Region_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_GroupsArgs = {
  where: Uogorod_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Groups_CategoryArgs = {
  where: Uogorod_Groups_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Groups_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Groups_UsersArgs = {
  where: Uogorod_Groups_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Groups_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_ImagesArgs = {
  where: Uogorod_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_LikesArgs = {
  where: Uogorod_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_ManualArgs = {
  where: Uogorod_Manual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Manual_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_MessagesArgs = {
  where: Uogorod_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Messages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_NotificationsArgs = {
  where: Uogorod_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Notifications_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_PagesArgs = {
  where: Uogorod_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Pages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_PostsArgs = {
  where: Uogorod_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Posts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_ReportsArgs = {
  where: Uogorod_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_ReviewsArgs = {
  where: Uogorod_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Reviews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_CategoriesArgs = {
  where: Uogorod_Seed_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_Categories_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_ParamsArgs = {
  where: Uogorod_Seed_Params_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_Params_By_PkArgs = {
  name: Scalars['String']['input'];
  seed_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_SimilarArgs = {
  where: Uogorod_Seed_Similar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_Similar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_SpecsArgs = {
  where: Uogorod_Seed_Specs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_Specs_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_VotesArgs = {
  where: Uogorod_Seed_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seed_Votes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_SeedsArgs = {
  where: Uogorod_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_BrandsArgs = {
  where: Uogorod_Seeds_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_Brands_By_PkArgs = {
  brand_id: Scalars['bigint']['input'];
  seed_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_ImagesArgs = {
  where: Uogorod_Seeds_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_RecordsArgs = {
  where: Uogorod_Seeds_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Seeds_Records_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_SubscribesArgs = {
  where: Uogorod_Subscribes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Subscribes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_CommentsArgs = {
  where: Uogorod_Type_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Comments_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_ContactsArgs = {
  where: Uogorod_Type_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Contacts_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_LikesArgs = {
  where: Uogorod_Type_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Likes_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_PostsArgs = {
  where: Uogorod_Type_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Posts_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Seed_ActionsArgs = {
  where: Uogorod_Type_Seed_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Seed_Actions_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Seeds_StatusArgs = {
  where: Uogorod_Type_Seeds_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Seeds_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_UsersArgs = {
  where: Uogorod_Type_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Type_Users_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_User_AchivmentsArgs = {
  where: Uogorod_User_Achivments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_User_Achivments_By_PkArgs = {
  achivment_id: Scalars['String']['input'];
  user_id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_User_ContactsArgs = {
  where: Uogorod_User_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_User_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_UsersArgs = {
  where: Uogorod_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_CalendarArgs = {
  where: Uogorod_Users_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_Calendar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_Not_ActivatedArgs = {
  where: Uogorod_Users_Not_Activated_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_Seed_ActionsArgs = {
  where: Uogorod_Users_Seed_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uogorod_Users_Seed_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AnimeArgs = {
  objects: Array<Anime_Insert_Input>;
  on_conflict?: InputMaybe<Anime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anime_OneArgs = {
  object: Anime_Insert_Input;
  on_conflict?: InputMaybe<Anime_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GenreArgs = {
  objects: Array<Genre_Insert_Input>;
  on_conflict?: InputMaybe<Genre_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Genre_OneArgs = {
  object: Genre_Insert_Input;
  on_conflict?: InputMaybe<Genre_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VideoArgs = {
  objects: Array<Video_Insert_Input>;
  on_conflict?: InputMaybe<Video_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Video_OneArgs = {
  object: Video_Insert_Input;
  on_conflict?: InputMaybe<Video_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anime_GenreArgs = {
  objects: Array<Anime_Genre_Insert_Input>;
  on_conflict?: InputMaybe<Anime_Genre_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Anime_Genre_OneArgs = {
  object: Anime_Genre_Insert_Input;
  on_conflict?: InputMaybe<Anime_Genre_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_AchivmentsArgs = {
  objects: Array<Uogorod_Achivments_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Achivments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Achivments_OneArgs = {
  object: Uogorod_Achivments_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Achivments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_BrandsArgs = {
  objects: Array<Uogorod_Brands_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Brands_ContactsArgs = {
  objects: Array<Uogorod_Brands_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Brands_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Brands_Contacts_OneArgs = {
  object: Uogorod_Brands_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Brands_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Brands_OneArgs = {
  object: Uogorod_Brands_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_CommentsArgs = {
  objects: Array<Uogorod_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Comments_OneArgs = {
  object: Uogorod_Comments_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_EmailsArgs = {
  objects: Array<Uogorod_Emails_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Emails_OneArgs = {
  object: Uogorod_Emails_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_ExperimentsArgs = {
  objects: Array<Uogorod_Experiments_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Experiments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_OneArgs = {
  object: Uogorod_Experiments_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Experiments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_SeedsArgs = {
  objects: Array<Uogorod_Experiments_Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Experiments_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_Seeds_OneArgs = {
  object: Uogorod_Experiments_Seeds_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Experiments_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_StepsArgs = {
  objects: Array<Uogorod_Experiments_Steps_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Experiments_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_Steps_OneArgs = {
  object: Uogorod_Experiments_Steps_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Experiments_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_ViewsArgs = {
  objects: Array<Uogorod_Experiments_Views_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Experiments_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Experiments_Views_OneArgs = {
  object: Uogorod_Experiments_Views_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Experiments_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_BedsArgs = {
  objects: Array<Uogorod_Garden_Beds_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Garden_Beds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_Beds_OneArgs = {
  object: Uogorod_Garden_Beds_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Garden_Beds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_Beds_SeedsArgs = {
  objects: Array<Uogorod_Garden_Beds_Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Garden_Beds_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_Beds_Seeds_OneArgs = {
  object: Uogorod_Garden_Beds_Seeds_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Garden_Beds_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_SeasonsArgs = {
  objects: Array<Uogorod_Garden_Seasons_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Garden_Seasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_Seasons_OneArgs = {
  object: Uogorod_Garden_Seasons_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Garden_Seasons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_SeedsArgs = {
  objects: Array<Uogorod_Garden_Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Garden_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Garden_Seeds_OneArgs = {
  object: Uogorod_Garden_Seeds_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Garden_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_GardensArgs = {
  objects: Array<Uogorod_Gardens_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Gardens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Gardens_OneArgs = {
  object: Uogorod_Gardens_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Gardens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_CityArgs = {
  objects: Array<Uogorod_Geo_City_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Geo_City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_City_OneArgs = {
  object: Uogorod_Geo_City_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Geo_City_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_CountryArgs = {
  objects: Array<Uogorod_Geo_Country_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Geo_Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_Country_OneArgs = {
  object: Uogorod_Geo_Country_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Geo_Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_RegionArgs = {
  objects: Array<Uogorod_Geo_Region_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Geo_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Geo_Region_OneArgs = {
  object: Uogorod_Geo_Region_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Geo_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_GroupsArgs = {
  objects: Array<Uogorod_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Groups_CategoryArgs = {
  objects: Array<Uogorod_Groups_Category_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Groups_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Groups_Category_OneArgs = {
  object: Uogorod_Groups_Category_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Groups_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Groups_OneArgs = {
  object: Uogorod_Groups_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Groups_UsersArgs = {
  objects: Array<Uogorod_Groups_Users_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Groups_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Groups_Users_OneArgs = {
  object: Uogorod_Groups_Users_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Groups_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_ImagesArgs = {
  objects: Array<Uogorod_Images_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Images_OneArgs = {
  object: Uogorod_Images_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_LikesArgs = {
  objects: Array<Uogorod_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Likes_OneArgs = {
  object: Uogorod_Likes_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_ManualArgs = {
  objects: Array<Uogorod_Manual_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Manual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Manual_OneArgs = {
  object: Uogorod_Manual_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Manual_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_MessagesArgs = {
  objects: Array<Uogorod_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Messages_OneArgs = {
  object: Uogorod_Messages_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_NotificationsArgs = {
  objects: Array<Uogorod_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Notifications_OneArgs = {
  object: Uogorod_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_PagesArgs = {
  objects: Array<Uogorod_Pages_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Pages_OneArgs = {
  object: Uogorod_Pages_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_PostsArgs = {
  objects: Array<Uogorod_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Posts_OneArgs = {
  object: Uogorod_Posts_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_ReportsArgs = {
  objects: Array<Uogorod_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Reports_OneArgs = {
  object: Uogorod_Reports_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_ReviewsArgs = {
  objects: Array<Uogorod_Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Reviews_OneArgs = {
  object: Uogorod_Reviews_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_CategoriesArgs = {
  objects: Array<Uogorod_Seed_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seed_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_Categories_OneArgs = {
  object: Uogorod_Seed_Categories_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seed_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_ParamsArgs = {
  objects: Array<Uogorod_Seed_Params_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seed_Params_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_Params_OneArgs = {
  object: Uogorod_Seed_Params_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seed_Params_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_SimilarArgs = {
  objects: Array<Uogorod_Seed_Similar_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seed_Similar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_Similar_OneArgs = {
  object: Uogorod_Seed_Similar_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seed_Similar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_SpecsArgs = {
  objects: Array<Uogorod_Seed_Specs_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seed_Specs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_Specs_OneArgs = {
  object: Uogorod_Seed_Specs_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seed_Specs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_VotesArgs = {
  objects: Array<Uogorod_Seed_Votes_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seed_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seed_Votes_OneArgs = {
  object: Uogorod_Seed_Votes_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seed_Votes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_SeedsArgs = {
  objects: Array<Uogorod_Seeds_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_BrandsArgs = {
  objects: Array<Uogorod_Seeds_Brands_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seeds_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_Brands_OneArgs = {
  object: Uogorod_Seeds_Brands_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seeds_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_ImagesArgs = {
  objects: Array<Uogorod_Seeds_Images_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seeds_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_Images_OneArgs = {
  object: Uogorod_Seeds_Images_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seeds_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_OneArgs = {
  object: Uogorod_Seeds_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seeds_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_RecordsArgs = {
  objects: Array<Uogorod_Seeds_Records_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Seeds_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Seeds_Records_OneArgs = {
  object: Uogorod_Seeds_Records_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Seeds_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_SubscribesArgs = {
  objects: Array<Uogorod_Subscribes_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Subscribes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Subscribes_OneArgs = {
  object: Uogorod_Subscribes_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Subscribes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_CommentsArgs = {
  objects: Array<Uogorod_Type_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Comments_OneArgs = {
  object: Uogorod_Type_Comments_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_ContactsArgs = {
  objects: Array<Uogorod_Type_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Contacts_OneArgs = {
  object: Uogorod_Type_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_LikesArgs = {
  objects: Array<Uogorod_Type_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Likes_OneArgs = {
  object: Uogorod_Type_Likes_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_PostsArgs = {
  objects: Array<Uogorod_Type_Posts_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Posts_OneArgs = {
  object: Uogorod_Type_Posts_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Posts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Seed_ActionsArgs = {
  objects: Array<Uogorod_Type_Seed_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Seed_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Seed_Actions_OneArgs = {
  object: Uogorod_Type_Seed_Actions_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Seed_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Seeds_StatusArgs = {
  objects: Array<Uogorod_Type_Seeds_Status_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Seeds_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Seeds_Status_OneArgs = {
  object: Uogorod_Type_Seeds_Status_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Seeds_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_UsersArgs = {
  objects: Array<Uogorod_Type_Users_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Type_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Type_Users_OneArgs = {
  object: Uogorod_Type_Users_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Type_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_User_AchivmentsArgs = {
  objects: Array<Uogorod_User_Achivments_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_User_Achivments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_User_Achivments_OneArgs = {
  object: Uogorod_User_Achivments_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_User_Achivments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_User_ContactsArgs = {
  objects: Array<Uogorod_User_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_User_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_User_Contacts_OneArgs = {
  object: Uogorod_User_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_User_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_UsersArgs = {
  objects: Array<Uogorod_Users_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_CalendarArgs = {
  objects: Array<Uogorod_Users_Calendar_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Users_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_Calendar_OneArgs = {
  object: Uogorod_Users_Calendar_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Users_Calendar_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_Not_ActivatedArgs = {
  objects: Array<Uogorod_Users_Not_Activated_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_Not_Activated_OneArgs = {
  object: Uogorod_Users_Not_Activated_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_OneArgs = {
  object: Uogorod_Users_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_Seed_ActionsArgs = {
  objects: Array<Uogorod_Users_Seed_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Uogorod_Users_Seed_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uogorod_Users_Seed_Actions_OneArgs = {
  object: Uogorod_Users_Seed_Actions_Insert_Input;
  on_conflict?: InputMaybe<Uogorod_Users_Seed_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AnimeArgs = {
  _inc?: InputMaybe<Anime_Inc_Input>;
  _set?: InputMaybe<Anime_Set_Input>;
  where: Anime_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anime_By_PkArgs = {
  _inc?: InputMaybe<Anime_Inc_Input>;
  _set?: InputMaybe<Anime_Set_Input>;
  pk_columns: Anime_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anime_ManyArgs = {
  updates: Array<Anime_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GenreArgs = {
  _inc?: InputMaybe<Genre_Inc_Input>;
  _set?: InputMaybe<Genre_Set_Input>;
  where: Genre_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Genre_By_PkArgs = {
  _inc?: InputMaybe<Genre_Inc_Input>;
  _set?: InputMaybe<Genre_Set_Input>;
  pk_columns: Genre_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Genre_ManyArgs = {
  updates: Array<Genre_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VideoArgs = {
  _set?: InputMaybe<Video_Set_Input>;
  where: Video_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Video_By_PkArgs = {
  _set?: InputMaybe<Video_Set_Input>;
  pk_columns: Video_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Video_ManyArgs = {
  updates: Array<Video_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Anime_GenreArgs = {
  _inc?: InputMaybe<Anime_Genre_Inc_Input>;
  _set?: InputMaybe<Anime_Genre_Set_Input>;
  where: Anime_Genre_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Anime_Genre_By_PkArgs = {
  _inc?: InputMaybe<Anime_Genre_Inc_Input>;
  _set?: InputMaybe<Anime_Genre_Set_Input>;
  pk_columns: Anime_Genre_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Anime_Genre_ManyArgs = {
  updates: Array<Anime_Genre_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_AchivmentsArgs = {
  _set?: InputMaybe<Uogorod_Achivments_Set_Input>;
  where: Uogorod_Achivments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Achivments_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Achivments_Set_Input>;
  pk_columns: Uogorod_Achivments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Achivments_ManyArgs = {
  updates: Array<Uogorod_Achivments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_BrandsArgs = {
  _append?: InputMaybe<Uogorod_Brands_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Brands_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Brands_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Brands_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Brands_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Brands_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Brands_Set_Input>;
  where: Uogorod_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Brands_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Brands_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Brands_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Brands_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Brands_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Brands_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Brands_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Brands_Set_Input>;
  pk_columns: Uogorod_Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Brands_ContactsArgs = {
  _inc?: InputMaybe<Uogorod_Brands_Contacts_Inc_Input>;
  _set?: InputMaybe<Uogorod_Brands_Contacts_Set_Input>;
  where: Uogorod_Brands_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Brands_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Brands_Contacts_Inc_Input>;
  _set?: InputMaybe<Uogorod_Brands_Contacts_Set_Input>;
  pk_columns: Uogorod_Brands_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Brands_Contacts_ManyArgs = {
  updates: Array<Uogorod_Brands_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Brands_ManyArgs = {
  updates: Array<Uogorod_Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_CommentsArgs = {
  _inc?: InputMaybe<Uogorod_Comments_Inc_Input>;
  _set?: InputMaybe<Uogorod_Comments_Set_Input>;
  where: Uogorod_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Comments_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Comments_Inc_Input>;
  _set?: InputMaybe<Uogorod_Comments_Set_Input>;
  pk_columns: Uogorod_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Comments_ManyArgs = {
  updates: Array<Uogorod_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_EmailsArgs = {
  _inc?: InputMaybe<Uogorod_Emails_Inc_Input>;
  _set?: InputMaybe<Uogorod_Emails_Set_Input>;
  where: Uogorod_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Emails_ManyArgs = {
  updates: Array<Uogorod_Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_ExperimentsArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Set_Input>;
  where: Uogorod_Experiments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Set_Input>;
  pk_columns: Uogorod_Experiments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_ManyArgs = {
  updates: Array<Uogorod_Experiments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_SeedsArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Seeds_Set_Input>;
  where: Uogorod_Experiments_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Seeds_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Seeds_Set_Input>;
  pk_columns: Uogorod_Experiments_Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Seeds_ManyArgs = {
  updates: Array<Uogorod_Experiments_Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_StepsArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Steps_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Steps_Set_Input>;
  where: Uogorod_Experiments_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Steps_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Steps_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Steps_Set_Input>;
  pk_columns: Uogorod_Experiments_Steps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Steps_ManyArgs = {
  updates: Array<Uogorod_Experiments_Steps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_ViewsArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Views_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Views_Set_Input>;
  where: Uogorod_Experiments_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Views_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Experiments_Views_Inc_Input>;
  _set?: InputMaybe<Uogorod_Experiments_Views_Set_Input>;
  pk_columns: Uogorod_Experiments_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Experiments_Views_ManyArgs = {
  updates: Array<Uogorod_Experiments_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_BedsArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Beds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Beds_Set_Input>;
  where: Uogorod_Garden_Beds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Beds_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Beds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Beds_Set_Input>;
  pk_columns: Uogorod_Garden_Beds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Beds_ManyArgs = {
  updates: Array<Uogorod_Garden_Beds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Beds_SeedsArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Beds_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Beds_Seeds_Set_Input>;
  where: Uogorod_Garden_Beds_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Beds_Seeds_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Beds_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Beds_Seeds_Set_Input>;
  pk_columns: Uogorod_Garden_Beds_Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Beds_Seeds_ManyArgs = {
  updates: Array<Uogorod_Garden_Beds_Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_SeasonsArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Seasons_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Seasons_Set_Input>;
  where: Uogorod_Garden_Seasons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Seasons_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Garden_Seasons_Inc_Input>;
  _set?: InputMaybe<Uogorod_Garden_Seasons_Set_Input>;
  pk_columns: Uogorod_Garden_Seasons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Seasons_ManyArgs = {
  updates: Array<Uogorod_Garden_Seasons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_SeedsArgs = {
  _append?: InputMaybe<Uogorod_Garden_Seeds_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Garden_Seeds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Garden_Seeds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Garden_Seeds_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Garden_Seeds_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Garden_Seeds_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Garden_Seeds_Set_Input>;
  where: Uogorod_Garden_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Seeds_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Garden_Seeds_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Garden_Seeds_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Garden_Seeds_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Garden_Seeds_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Garden_Seeds_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Garden_Seeds_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Garden_Seeds_Set_Input>;
  pk_columns: Uogorod_Garden_Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Garden_Seeds_ManyArgs = {
  updates: Array<Uogorod_Garden_Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_GardensArgs = {
  _append?: InputMaybe<Uogorod_Gardens_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Gardens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Gardens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Gardens_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Gardens_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Gardens_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Gardens_Set_Input>;
  where: Uogorod_Gardens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Gardens_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Gardens_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Gardens_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Gardens_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Gardens_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Gardens_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Gardens_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Gardens_Set_Input>;
  pk_columns: Uogorod_Gardens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Gardens_ManyArgs = {
  updates: Array<Uogorod_Gardens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_CityArgs = {
  _inc?: InputMaybe<Uogorod_Geo_City_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_City_Set_Input>;
  where: Uogorod_Geo_City_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_City_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Geo_City_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_City_Set_Input>;
  pk_columns: Uogorod_Geo_City_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_City_ManyArgs = {
  updates: Array<Uogorod_Geo_City_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_CountryArgs = {
  _inc?: InputMaybe<Uogorod_Geo_Country_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_Country_Set_Input>;
  where: Uogorod_Geo_Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_Country_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Geo_Country_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_Country_Set_Input>;
  pk_columns: Uogorod_Geo_Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_Country_ManyArgs = {
  updates: Array<Uogorod_Geo_Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_RegionArgs = {
  _inc?: InputMaybe<Uogorod_Geo_Region_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_Region_Set_Input>;
  where: Uogorod_Geo_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_Region_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Geo_Region_Inc_Input>;
  _set?: InputMaybe<Uogorod_Geo_Region_Set_Input>;
  pk_columns: Uogorod_Geo_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Geo_Region_ManyArgs = {
  updates: Array<Uogorod_Geo_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_GroupsArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Set_Input>;
  where: Uogorod_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Set_Input>;
  pk_columns: Uogorod_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_CategoryArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Category_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Category_Set_Input>;
  where: Uogorod_Groups_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_Category_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Category_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Category_Set_Input>;
  pk_columns: Uogorod_Groups_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_Category_ManyArgs = {
  updates: Array<Uogorod_Groups_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_ManyArgs = {
  updates: Array<Uogorod_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_UsersArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Users_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Users_Set_Input>;
  where: Uogorod_Groups_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_Users_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Groups_Users_Inc_Input>;
  _set?: InputMaybe<Uogorod_Groups_Users_Set_Input>;
  pk_columns: Uogorod_Groups_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Groups_Users_ManyArgs = {
  updates: Array<Uogorod_Groups_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_ImagesArgs = {
  _inc?: InputMaybe<Uogorod_Images_Inc_Input>;
  _set?: InputMaybe<Uogorod_Images_Set_Input>;
  where: Uogorod_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Images_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Images_Inc_Input>;
  _set?: InputMaybe<Uogorod_Images_Set_Input>;
  pk_columns: Uogorod_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Images_ManyArgs = {
  updates: Array<Uogorod_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_LikesArgs = {
  _inc?: InputMaybe<Uogorod_Likes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Likes_Set_Input>;
  where: Uogorod_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Likes_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Likes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Likes_Set_Input>;
  pk_columns: Uogorod_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Likes_ManyArgs = {
  updates: Array<Uogorod_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_ManualArgs = {
  _append?: InputMaybe<Uogorod_Manual_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Manual_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Manual_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Manual_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Manual_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Manual_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Manual_Set_Input>;
  where: Uogorod_Manual_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Manual_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Manual_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Manual_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Manual_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Manual_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Manual_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Manual_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Manual_Set_Input>;
  pk_columns: Uogorod_Manual_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Manual_ManyArgs = {
  updates: Array<Uogorod_Manual_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_MessagesArgs = {
  _append?: InputMaybe<Uogorod_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Messages_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Messages_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Messages_Set_Input>;
  where: Uogorod_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Messages_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Messages_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Messages_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Messages_Set_Input>;
  pk_columns: Uogorod_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Messages_ManyArgs = {
  updates: Array<Uogorod_Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_NotificationsArgs = {
  _inc?: InputMaybe<Uogorod_Notifications_Inc_Input>;
  _set?: InputMaybe<Uogorod_Notifications_Set_Input>;
  where: Uogorod_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Notifications_Inc_Input>;
  _set?: InputMaybe<Uogorod_Notifications_Set_Input>;
  pk_columns: Uogorod_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Notifications_ManyArgs = {
  updates: Array<Uogorod_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_PagesArgs = {
  _inc?: InputMaybe<Uogorod_Pages_Inc_Input>;
  _set?: InputMaybe<Uogorod_Pages_Set_Input>;
  where: Uogorod_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Pages_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Pages_Inc_Input>;
  _set?: InputMaybe<Uogorod_Pages_Set_Input>;
  pk_columns: Uogorod_Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Pages_ManyArgs = {
  updates: Array<Uogorod_Pages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_PostsArgs = {
  _append?: InputMaybe<Uogorod_Posts_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Posts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Posts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Posts_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Posts_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Posts_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Posts_Set_Input>;
  where: Uogorod_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Posts_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Posts_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Posts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Posts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Posts_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Posts_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Posts_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Posts_Set_Input>;
  pk_columns: Uogorod_Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Posts_ManyArgs = {
  updates: Array<Uogorod_Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_ReportsArgs = {
  _inc?: InputMaybe<Uogorod_Reports_Inc_Input>;
  _set?: InputMaybe<Uogorod_Reports_Set_Input>;
  where: Uogorod_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Reports_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Reports_Inc_Input>;
  _set?: InputMaybe<Uogorod_Reports_Set_Input>;
  pk_columns: Uogorod_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Reports_ManyArgs = {
  updates: Array<Uogorod_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_ReviewsArgs = {
  _append?: InputMaybe<Uogorod_Reviews_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Reviews_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Reviews_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Reviews_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Reviews_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Reviews_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Reviews_Set_Input>;
  where: Uogorod_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Reviews_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Reviews_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Reviews_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Reviews_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Reviews_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Reviews_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Reviews_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Reviews_Set_Input>;
  pk_columns: Uogorod_Reviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Reviews_ManyArgs = {
  updates: Array<Uogorod_Reviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_CategoriesArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Categories_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Categories_Set_Input>;
  where: Uogorod_Seed_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Categories_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Categories_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Categories_Set_Input>;
  pk_columns: Uogorod_Seed_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Categories_ManyArgs = {
  updates: Array<Uogorod_Seed_Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_ParamsArgs = {
  _append?: InputMaybe<Uogorod_Seed_Params_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seed_Params_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seed_Params_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seed_Params_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Seed_Params_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Seed_Params_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seed_Params_Set_Input>;
  where: Uogorod_Seed_Params_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Params_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Seed_Params_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seed_Params_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seed_Params_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seed_Params_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Seed_Params_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Seed_Params_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seed_Params_Set_Input>;
  pk_columns: Uogorod_Seed_Params_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Params_ManyArgs = {
  updates: Array<Uogorod_Seed_Params_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_SimilarArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Similar_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Similar_Set_Input>;
  where: Uogorod_Seed_Similar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Similar_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Similar_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Similar_Set_Input>;
  pk_columns: Uogorod_Seed_Similar_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Similar_ManyArgs = {
  updates: Array<Uogorod_Seed_Similar_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_SpecsArgs = {
  _append?: InputMaybe<Uogorod_Seed_Specs_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seed_Specs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seed_Specs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seed_Specs_Delete_Key_Input>;
  _prepend?: InputMaybe<Uogorod_Seed_Specs_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seed_Specs_Set_Input>;
  where: Uogorod_Seed_Specs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Specs_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Seed_Specs_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seed_Specs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seed_Specs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seed_Specs_Delete_Key_Input>;
  _prepend?: InputMaybe<Uogorod_Seed_Specs_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seed_Specs_Set_Input>;
  pk_columns: Uogorod_Seed_Specs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Specs_ManyArgs = {
  updates: Array<Uogorod_Seed_Specs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_VotesArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Votes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Votes_Set_Input>;
  where: Uogorod_Seed_Votes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Votes_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seed_Votes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seed_Votes_Set_Input>;
  pk_columns: Uogorod_Seed_Votes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seed_Votes_ManyArgs = {
  updates: Array<Uogorod_Seed_Votes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_SeedsArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Set_Input>;
  where: Uogorod_Seeds_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_BrandsArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Brands_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Brands_Set_Input>;
  where: Uogorod_Seeds_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Brands_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Brands_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Brands_Set_Input>;
  pk_columns: Uogorod_Seeds_Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Brands_ManyArgs = {
  updates: Array<Uogorod_Seeds_Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Set_Input>;
  pk_columns: Uogorod_Seeds_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_ImagesArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Images_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Images_Set_Input>;
  where: Uogorod_Seeds_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Images_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Seeds_Images_Inc_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Images_Set_Input>;
  pk_columns: Uogorod_Seeds_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Images_ManyArgs = {
  updates: Array<Uogorod_Seeds_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_ManyArgs = {
  updates: Array<Uogorod_Seeds_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_RecordsArgs = {
  _append?: InputMaybe<Uogorod_Seeds_Records_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seeds_Records_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seeds_Records_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seeds_Records_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Seeds_Records_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Seeds_Records_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Records_Set_Input>;
  where: Uogorod_Seeds_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Records_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Seeds_Records_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Seeds_Records_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Seeds_Records_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Seeds_Records_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Seeds_Records_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Seeds_Records_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Seeds_Records_Set_Input>;
  pk_columns: Uogorod_Seeds_Records_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Seeds_Records_ManyArgs = {
  updates: Array<Uogorod_Seeds_Records_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_SubscribesArgs = {
  _inc?: InputMaybe<Uogorod_Subscribes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Subscribes_Set_Input>;
  where: Uogorod_Subscribes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Subscribes_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Subscribes_Inc_Input>;
  _set?: InputMaybe<Uogorod_Subscribes_Set_Input>;
  pk_columns: Uogorod_Subscribes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Subscribes_ManyArgs = {
  updates: Array<Uogorod_Subscribes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_CommentsArgs = {
  _set?: InputMaybe<Uogorod_Type_Comments_Set_Input>;
  where: Uogorod_Type_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Comments_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Comments_Set_Input>;
  pk_columns: Uogorod_Type_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Comments_ManyArgs = {
  updates: Array<Uogorod_Type_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_ContactsArgs = {
  _set?: InputMaybe<Uogorod_Type_Contacts_Set_Input>;
  where: Uogorod_Type_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Contacts_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Contacts_Set_Input>;
  pk_columns: Uogorod_Type_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Contacts_ManyArgs = {
  updates: Array<Uogorod_Type_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_LikesArgs = {
  _set?: InputMaybe<Uogorod_Type_Likes_Set_Input>;
  where: Uogorod_Type_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Likes_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Likes_Set_Input>;
  pk_columns: Uogorod_Type_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Likes_ManyArgs = {
  updates: Array<Uogorod_Type_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_PostsArgs = {
  _set?: InputMaybe<Uogorod_Type_Posts_Set_Input>;
  where: Uogorod_Type_Posts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Posts_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Posts_Set_Input>;
  pk_columns: Uogorod_Type_Posts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Posts_ManyArgs = {
  updates: Array<Uogorod_Type_Posts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seed_ActionsArgs = {
  _set?: InputMaybe<Uogorod_Type_Seed_Actions_Set_Input>;
  where: Uogorod_Type_Seed_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seed_Actions_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Seed_Actions_Set_Input>;
  pk_columns: Uogorod_Type_Seed_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seed_Actions_ManyArgs = {
  updates: Array<Uogorod_Type_Seed_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seeds_StatusArgs = {
  _set?: InputMaybe<Uogorod_Type_Seeds_Status_Set_Input>;
  where: Uogorod_Type_Seeds_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seeds_Status_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Seeds_Status_Set_Input>;
  pk_columns: Uogorod_Type_Seeds_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Seeds_Status_ManyArgs = {
  updates: Array<Uogorod_Type_Seeds_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_UsersArgs = {
  _set?: InputMaybe<Uogorod_Type_Users_Set_Input>;
  where: Uogorod_Type_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Users_By_PkArgs = {
  _set?: InputMaybe<Uogorod_Type_Users_Set_Input>;
  pk_columns: Uogorod_Type_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Type_Users_ManyArgs = {
  updates: Array<Uogorod_Type_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_AchivmentsArgs = {
  _inc?: InputMaybe<Uogorod_User_Achivments_Inc_Input>;
  _set?: InputMaybe<Uogorod_User_Achivments_Set_Input>;
  where: Uogorod_User_Achivments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_Achivments_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_User_Achivments_Inc_Input>;
  _set?: InputMaybe<Uogorod_User_Achivments_Set_Input>;
  pk_columns: Uogorod_User_Achivments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_Achivments_ManyArgs = {
  updates: Array<Uogorod_User_Achivments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_ContactsArgs = {
  _inc?: InputMaybe<Uogorod_User_Contacts_Inc_Input>;
  _set?: InputMaybe<Uogorod_User_Contacts_Set_Input>;
  where: Uogorod_User_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_User_Contacts_Inc_Input>;
  _set?: InputMaybe<Uogorod_User_Contacts_Set_Input>;
  pk_columns: Uogorod_User_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_User_Contacts_ManyArgs = {
  updates: Array<Uogorod_User_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_UsersArgs = {
  _append?: InputMaybe<Uogorod_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Users_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Users_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Users_Set_Input>;
  where: Uogorod_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_By_PkArgs = {
  _append?: InputMaybe<Uogorod_Users_Append_Input>;
  _delete_at_path?: InputMaybe<Uogorod_Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Uogorod_Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Uogorod_Users_Delete_Key_Input>;
  _inc?: InputMaybe<Uogorod_Users_Inc_Input>;
  _prepend?: InputMaybe<Uogorod_Users_Prepend_Input>;
  _set?: InputMaybe<Uogorod_Users_Set_Input>;
  pk_columns: Uogorod_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_CalendarArgs = {
  _inc?: InputMaybe<Uogorod_Users_Calendar_Inc_Input>;
  _set?: InputMaybe<Uogorod_Users_Calendar_Set_Input>;
  where: Uogorod_Users_Calendar_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Calendar_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Users_Calendar_Inc_Input>;
  _set?: InputMaybe<Uogorod_Users_Calendar_Set_Input>;
  pk_columns: Uogorod_Users_Calendar_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Calendar_ManyArgs = {
  updates: Array<Uogorod_Users_Calendar_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_ManyArgs = {
  updates: Array<Uogorod_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Not_ActivatedArgs = {
  _inc?: InputMaybe<Uogorod_Users_Not_Activated_Inc_Input>;
  _set?: InputMaybe<Uogorod_Users_Not_Activated_Set_Input>;
  where: Uogorod_Users_Not_Activated_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Not_Activated_ManyArgs = {
  updates: Array<Uogorod_Users_Not_Activated_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Seed_ActionsArgs = {
  _inc?: InputMaybe<Uogorod_Users_Seed_Actions_Inc_Input>;
  _set?: InputMaybe<Uogorod_Users_Seed_Actions_Set_Input>;
  where: Uogorod_Users_Seed_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Seed_Actions_By_PkArgs = {
  _inc?: InputMaybe<Uogorod_Users_Seed_Actions_Inc_Input>;
  _set?: InputMaybe<Uogorod_Users_Seed_Actions_Set_Input>;
  pk_columns: Uogorod_Users_Seed_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uogorod_Users_Seed_Actions_ManyArgs = {
  updates: Array<Uogorod_Users_Seed_Actions_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "orders" */
export type Orders = {
  __typename?: 'orders';
  customer_email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  order_date: Scalars['date']['output'];
  /** An object relationship */
  price: Prices;
  price_id: Scalars['Int']['output'];
  /** An object relationship */
  product: Products;
  product_id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate?: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

export type Orders_Aggregate_Bool_Exp = {
  count?: InputMaybe<Orders_Aggregate_Bool_Exp_Count>;
};

export type Orders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Orders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  avg?: Maybe<Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Orders_Max_Fields>;
  min?: Maybe<Orders_Min_Fields>;
  stddev?: Maybe<Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_Sum_Fields>;
  var_pop?: Maybe<Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_Var_Samp_Fields>;
  variance?: Maybe<Orders_Variance_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "orders" */
export type Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Max_Order_By>;
  min?: InputMaybe<Orders_Min_Order_By>;
  stddev?: InputMaybe<Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Orders_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Orders_Avg_Fields = {
  __typename?: 'orders_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "orders" */
export type Orders_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  customer_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order_date?: InputMaybe<Date_Comparison_Exp>;
  price?: InputMaybe<Prices_Bool_Exp>;
  price_id?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  customer_email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order_date?: Maybe<Scalars['date']['output']>;
  price_id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "orders" */
export type Orders_Max_Order_By = {
  customer_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  customer_email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  order_date?: Maybe<Scalars['date']['output']>;
  price_id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "orders" */
export type Orders_Min_Order_By = {
  customer_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  customer_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_date?: InputMaybe<Order_By>;
  price?: InputMaybe<Prices_Order_By>;
  price_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  Id = 'id',
  /** column name */
  OrderDate = 'order_date',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity'
}

/** aggregate stddev on columns */
export type Orders_Stddev_Fields = {
  __typename?: 'orders_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "orders" */
export type Orders_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Orders_Stddev_Pop_Fields = {
  __typename?: 'orders_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "orders" */
export type Orders_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Orders_Stddev_Samp_Fields = {
  __typename?: 'orders_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "orders" */
export type Orders_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "orders" */
export type Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_Stream_Cursor_Value_Input = {
  customer_email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order_date?: InputMaybe<Scalars['date']['input']>;
  price_id?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Orders_Sum_Fields = {
  __typename?: 'orders_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  price_id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "orders" */
export type Orders_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Orders_Var_Pop_Fields = {
  __typename?: 'orders_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "orders" */
export type Orders_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Orders_Var_Samp_Fields = {
  __typename?: 'orders_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "orders" */
export type Orders_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Orders_Variance_Fields = {
  __typename?: 'orders_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price_id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "orders" */
export type Orders_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "posts" */
export type Posts = {
  __typename?: 'posts';
  content: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id: Scalars['Int']['output'];
};

/** aggregated selection of "posts" */
export type Posts_Aggregate = {
  __typename?: 'posts_aggregate';
  aggregate?: Maybe<Posts_Aggregate_Fields>;
  nodes: Array<Posts>;
};

/** aggregate fields of "posts" */
export type Posts_Aggregate_Fields = {
  __typename?: 'posts_aggregate_fields';
  avg?: Maybe<Posts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Posts_Max_Fields>;
  min?: Maybe<Posts_Min_Fields>;
  stddev?: Maybe<Posts_Stddev_Fields>;
  stddev_pop?: Maybe<Posts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Posts_Stddev_Samp_Fields>;
  sum?: Maybe<Posts_Sum_Fields>;
  var_pop?: Maybe<Posts_Var_Pop_Fields>;
  var_samp?: Maybe<Posts_Var_Samp_Fields>;
  variance?: Maybe<Posts_Variance_Fields>;
};


/** aggregate fields of "posts" */
export type Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Posts_Avg_Fields = {
  __typename?: 'posts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "posts". All fields are combined with a logical 'AND'. */
export type Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Posts_Bool_Exp>>;
  _not?: InputMaybe<Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Posts_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Posts_Max_Fields = {
  __typename?: 'posts_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Posts_Min_Fields = {
  __typename?: 'posts_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "posts". */
export type Posts_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "posts" */
export enum Posts_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Posts_Stddev_Fields = {
  __typename?: 'posts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Posts_Stddev_Pop_Fields = {
  __typename?: 'posts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Posts_Stddev_Samp_Fields = {
  __typename?: 'posts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "posts" */
export type Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posts_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Posts_Sum_Fields = {
  __typename?: 'posts_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Posts_Var_Pop_Fields = {
  __typename?: 'posts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Posts_Var_Samp_Fields = {
  __typename?: 'posts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Posts_Variance_Fields = {
  __typename?: 'posts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "prices" */
export type Prices = {
  __typename?: 'prices';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** An object relationship */
  product: Products;
  product_id: Scalars['Int']['output'];
};


/** columns and relationships of "prices" */
export type PricesOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "prices" */
export type PricesOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** aggregated selection of "prices" */
export type Prices_Aggregate = {
  __typename?: 'prices_aggregate';
  aggregate?: Maybe<Prices_Aggregate_Fields>;
  nodes: Array<Prices>;
};

export type Prices_Aggregate_Bool_Exp = {
  count?: InputMaybe<Prices_Aggregate_Bool_Exp_Count>;
};

export type Prices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Prices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Prices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "prices" */
export type Prices_Aggregate_Fields = {
  __typename?: 'prices_aggregate_fields';
  avg?: Maybe<Prices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Prices_Max_Fields>;
  min?: Maybe<Prices_Min_Fields>;
  stddev?: Maybe<Prices_Stddev_Fields>;
  stddev_pop?: Maybe<Prices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Prices_Stddev_Samp_Fields>;
  sum?: Maybe<Prices_Sum_Fields>;
  var_pop?: Maybe<Prices_Var_Pop_Fields>;
  var_samp?: Maybe<Prices_Var_Samp_Fields>;
  variance?: Maybe<Prices_Variance_Fields>;
};


/** aggregate fields of "prices" */
export type Prices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "prices" */
export type Prices_Aggregate_Order_By = {
  avg?: InputMaybe<Prices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Prices_Max_Order_By>;
  min?: InputMaybe<Prices_Min_Order_By>;
  stddev?: InputMaybe<Prices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Prices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Prices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Prices_Sum_Order_By>;
  var_pop?: InputMaybe<Prices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Prices_Var_Samp_Order_By>;
  variance?: InputMaybe<Prices_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Prices_Avg_Fields = {
  __typename?: 'prices_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "prices" */
export type Prices_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "prices". All fields are combined with a logical 'AND'. */
export type Prices_Bool_Exp = {
  _and?: InputMaybe<Array<Prices_Bool_Exp>>;
  _not?: InputMaybe<Prices_Bool_Exp>;
  _or?: InputMaybe<Array<Prices_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Bool_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  product_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Prices_Max_Fields = {
  __typename?: 'prices_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "prices" */
export type Prices_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Prices_Min_Fields = {
  __typename?: 'prices_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "prices" */
export type Prices_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "prices". */
export type Prices_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  product?: InputMaybe<Products_Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** select columns of table "prices" */
export enum Prices_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  ProductId = 'product_id'
}

/** aggregate stddev on columns */
export type Prices_Stddev_Fields = {
  __typename?: 'prices_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "prices" */
export type Prices_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Prices_Stddev_Pop_Fields = {
  __typename?: 'prices_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "prices" */
export type Prices_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Prices_Stddev_Samp_Fields = {
  __typename?: 'prices_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "prices" */
export type Prices_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "prices" */
export type Prices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prices_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Prices_Sum_Fields = {
  __typename?: 'prices_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "prices" */
export type Prices_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Prices_Var_Pop_Fields = {
  __typename?: 'prices_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "prices" */
export type Prices_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Prices_Var_Samp_Fields = {
  __typename?: 'prices_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "prices" */
export type Prices_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Prices_Variance_Fields = {
  __typename?: 'prices_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "prices" */
export type Prices_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
};


/** columns and relationships of "products" */
export type ProductsOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Bool_Exp>;
  prices?: InputMaybe<Prices_Bool_Exp>;
  prices_aggregate?: InputMaybe<Prices_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  prices_aggregate?: InputMaybe<Prices_Aggregate_Order_By>;
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Name = 'name'
}

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "Anime" */
  Anime: Array<Anime>;
  /** fetch aggregated fields from the table: "Anime" */
  Anime_aggregate: Anime_Aggregate;
  /** fetch data from the table: "Anime" using primary key columns */
  Anime_by_pk?: Maybe<Anime>;
  /** fetch data from the table: "Genre" */
  Genre: Array<Genre>;
  /** fetch aggregated fields from the table: "Genre" */
  Genre_aggregate: Genre_Aggregate;
  /** fetch data from the table: "Genre" using primary key columns */
  Genre_by_pk?: Maybe<Genre>;
  /** fetch data from the table: "Video" */
  Video: Array<Video>;
  /** fetch aggregated fields from the table: "Video" */
  Video_aggregate: Video_Aggregate;
  /** fetch data from the table: "Video" using primary key columns */
  Video_by_pk?: Maybe<Video>;
  /** fetch data from the table: "anime_genre" */
  anime_genre: Array<Anime_Genre>;
  /** fetch aggregated fields from the table: "anime_genre" */
  anime_genre_aggregate: Anime_Genre_Aggregate;
  /** fetch data from the table: "anime_genre" using primary key columns */
  anime_genre_by_pk?: Maybe<Anime_Genre>;
  dialogs: Array<Dialog>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table: "posts" */
  posts: Array<Posts>;
  /** fetch aggregated fields from the table: "posts" */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
  /** fetch data from the table: "prices" using primary key columns */
  prices_by_pk?: Maybe<Prices>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  socials?: Maybe<Socialsquery_Root>;
  /** fetch data from the table: "uogorod.achivments" */
  uogorod_achivments: Array<Uogorod_Achivments>;
  /** fetch aggregated fields from the table: "uogorod.achivments" */
  uogorod_achivments_aggregate: Uogorod_Achivments_Aggregate;
  /** fetch data from the table: "uogorod.achivments" using primary key columns */
  uogorod_achivments_by_pk?: Maybe<Uogorod_Achivments>;
  /** fetch data from the table: "uogorod.brands" */
  uogorod_brands: Array<Uogorod_Brands>;
  /** fetch aggregated fields from the table: "uogorod.brands" */
  uogorod_brands_aggregate: Uogorod_Brands_Aggregate;
  /** fetch data from the table: "uogorod.brands" using primary key columns */
  uogorod_brands_by_pk?: Maybe<Uogorod_Brands>;
  /** fetch data from the table: "uogorod.brands_contacts" */
  uogorod_brands_contacts: Array<Uogorod_Brands_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.brands_contacts" */
  uogorod_brands_contacts_aggregate: Uogorod_Brands_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.brands_contacts" using primary key columns */
  uogorod_brands_contacts_by_pk?: Maybe<Uogorod_Brands_Contacts>;
  /** fetch data from the table: "uogorod.comments" */
  uogorod_comments: Array<Uogorod_Comments>;
  /** fetch aggregated fields from the table: "uogorod.comments" */
  uogorod_comments_aggregate: Uogorod_Comments_Aggregate;
  /** fetch data from the table: "uogorod.comments" using primary key columns */
  uogorod_comments_by_pk?: Maybe<Uogorod_Comments>;
  /** fetch data from the table: "uogorod.emails" */
  uogorod_emails: Array<Uogorod_Emails>;
  /** fetch aggregated fields from the table: "uogorod.emails" */
  uogorod_emails_aggregate: Uogorod_Emails_Aggregate;
  /** fetch data from the table: "uogorod.experiments" */
  uogorod_experiments: Array<Uogorod_Experiments>;
  /** fetch aggregated fields from the table: "uogorod.experiments" */
  uogorod_experiments_aggregate: Uogorod_Experiments_Aggregate;
  /** fetch data from the table: "uogorod.experiments" using primary key columns */
  uogorod_experiments_by_pk?: Maybe<Uogorod_Experiments>;
  /** fetch data from the table: "uogorod.experiments_seeds" */
  uogorod_experiments_seeds: Array<Uogorod_Experiments_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.experiments_seeds" */
  uogorod_experiments_seeds_aggregate: Uogorod_Experiments_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.experiments_seeds" using primary key columns */
  uogorod_experiments_seeds_by_pk?: Maybe<Uogorod_Experiments_Seeds>;
  /** fetch data from the table: "uogorod.experiments_steps" */
  uogorod_experiments_steps: Array<Uogorod_Experiments_Steps>;
  /** fetch aggregated fields from the table: "uogorod.experiments_steps" */
  uogorod_experiments_steps_aggregate: Uogorod_Experiments_Steps_Aggregate;
  /** fetch data from the table: "uogorod.experiments_steps" using primary key columns */
  uogorod_experiments_steps_by_pk?: Maybe<Uogorod_Experiments_Steps>;
  /** fetch data from the table: "uogorod.experiments_views" */
  uogorod_experiments_views: Array<Uogorod_Experiments_Views>;
  /** fetch aggregated fields from the table: "uogorod.experiments_views" */
  uogorod_experiments_views_aggregate: Uogorod_Experiments_Views_Aggregate;
  /** fetch data from the table: "uogorod.experiments_views" using primary key columns */
  uogorod_experiments_views_by_pk?: Maybe<Uogorod_Experiments_Views>;
  /** fetch data from the table: "uogorod.garden_beds" */
  uogorod_garden_beds: Array<Uogorod_Garden_Beds>;
  /** fetch aggregated fields from the table: "uogorod.garden_beds" */
  uogorod_garden_beds_aggregate: Uogorod_Garden_Beds_Aggregate;
  /** fetch data from the table: "uogorod.garden_beds" using primary key columns */
  uogorod_garden_beds_by_pk?: Maybe<Uogorod_Garden_Beds>;
  /** fetch data from the table: "uogorod.garden_beds_seeds" */
  uogorod_garden_beds_seeds: Array<Uogorod_Garden_Beds_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.garden_beds_seeds" */
  uogorod_garden_beds_seeds_aggregate: Uogorod_Garden_Beds_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.garden_beds_seeds" using primary key columns */
  uogorod_garden_beds_seeds_by_pk?: Maybe<Uogorod_Garden_Beds_Seeds>;
  /** fetch data from the table: "uogorod.garden_seasons" */
  uogorod_garden_seasons: Array<Uogorod_Garden_Seasons>;
  /** fetch aggregated fields from the table: "uogorod.garden_seasons" */
  uogorod_garden_seasons_aggregate: Uogorod_Garden_Seasons_Aggregate;
  /** fetch data from the table: "uogorod.garden_seasons" using primary key columns */
  uogorod_garden_seasons_by_pk?: Maybe<Uogorod_Garden_Seasons>;
  /** fetch data from the table: "uogorod.garden_seeds" */
  uogorod_garden_seeds: Array<Uogorod_Garden_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.garden_seeds" */
  uogorod_garden_seeds_aggregate: Uogorod_Garden_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.garden_seeds" using primary key columns */
  uogorod_garden_seeds_by_pk?: Maybe<Uogorod_Garden_Seeds>;
  /** fetch data from the table: "uogorod.gardens" */
  uogorod_gardens: Array<Uogorod_Gardens>;
  /** fetch aggregated fields from the table: "uogorod.gardens" */
  uogorod_gardens_aggregate: Uogorod_Gardens_Aggregate;
  /** fetch data from the table: "uogorod.gardens" using primary key columns */
  uogorod_gardens_by_pk?: Maybe<Uogorod_Gardens>;
  /** fetch data from the table: "uogorod.geo_city" */
  uogorod_geo_city: Array<Uogorod_Geo_City>;
  /** fetch aggregated fields from the table: "uogorod.geo_city" */
  uogorod_geo_city_aggregate: Uogorod_Geo_City_Aggregate;
  /** fetch data from the table: "uogorod.geo_city" using primary key columns */
  uogorod_geo_city_by_pk?: Maybe<Uogorod_Geo_City>;
  /** fetch data from the table: "uogorod.geo_country" */
  uogorod_geo_country: Array<Uogorod_Geo_Country>;
  /** fetch aggregated fields from the table: "uogorod.geo_country" */
  uogorod_geo_country_aggregate: Uogorod_Geo_Country_Aggregate;
  /** fetch data from the table: "uogorod.geo_country" using primary key columns */
  uogorod_geo_country_by_pk?: Maybe<Uogorod_Geo_Country>;
  /** fetch data from the table: "uogorod.geo_region" */
  uogorod_geo_region: Array<Uogorod_Geo_Region>;
  /** fetch aggregated fields from the table: "uogorod.geo_region" */
  uogorod_geo_region_aggregate: Uogorod_Geo_Region_Aggregate;
  /** fetch data from the table: "uogorod.geo_region" using primary key columns */
  uogorod_geo_region_by_pk?: Maybe<Uogorod_Geo_Region>;
  /** fetch data from the table: "uogorod.groups" */
  uogorod_groups: Array<Uogorod_Groups>;
  /** fetch aggregated fields from the table: "uogorod.groups" */
  uogorod_groups_aggregate: Uogorod_Groups_Aggregate;
  /** fetch data from the table: "uogorod.groups" using primary key columns */
  uogorod_groups_by_pk?: Maybe<Uogorod_Groups>;
  /** fetch data from the table: "uogorod.groups_category" */
  uogorod_groups_category: Array<Uogorod_Groups_Category>;
  /** fetch aggregated fields from the table: "uogorod.groups_category" */
  uogorod_groups_category_aggregate: Uogorod_Groups_Category_Aggregate;
  /** fetch data from the table: "uogorod.groups_category" using primary key columns */
  uogorod_groups_category_by_pk?: Maybe<Uogorod_Groups_Category>;
  /** fetch data from the table: "uogorod.groups_users" */
  uogorod_groups_users: Array<Uogorod_Groups_Users>;
  /** fetch aggregated fields from the table: "uogorod.groups_users" */
  uogorod_groups_users_aggregate: Uogorod_Groups_Users_Aggregate;
  /** fetch data from the table: "uogorod.groups_users" using primary key columns */
  uogorod_groups_users_by_pk?: Maybe<Uogorod_Groups_Users>;
  /** fetch data from the table: "uogorod.images" */
  uogorod_images: Array<Uogorod_Images>;
  /** fetch aggregated fields from the table: "uogorod.images" */
  uogorod_images_aggregate: Uogorod_Images_Aggregate;
  /** fetch data from the table: "uogorod.images" using primary key columns */
  uogorod_images_by_pk?: Maybe<Uogorod_Images>;
  /** fetch data from the table: "uogorod.likes" */
  uogorod_likes: Array<Uogorod_Likes>;
  /** fetch aggregated fields from the table: "uogorod.likes" */
  uogorod_likes_aggregate: Uogorod_Likes_Aggregate;
  /** fetch data from the table: "uogorod.likes" using primary key columns */
  uogorod_likes_by_pk?: Maybe<Uogorod_Likes>;
  /** fetch data from the table: "uogorod.manual" */
  uogorod_manual: Array<Uogorod_Manual>;
  /** fetch aggregated fields from the table: "uogorod.manual" */
  uogorod_manual_aggregate: Uogorod_Manual_Aggregate;
  /** fetch data from the table: "uogorod.manual" using primary key columns */
  uogorod_manual_by_pk?: Maybe<Uogorod_Manual>;
  /** fetch data from the table: "uogorod.messages" */
  uogorod_messages: Array<Uogorod_Messages>;
  /** fetch aggregated fields from the table: "uogorod.messages" */
  uogorod_messages_aggregate: Uogorod_Messages_Aggregate;
  /** fetch data from the table: "uogorod.messages" using primary key columns */
  uogorod_messages_by_pk?: Maybe<Uogorod_Messages>;
  /** fetch data from the table: "uogorod.notifications" */
  uogorod_notifications: Array<Uogorod_Notifications>;
  /** fetch aggregated fields from the table: "uogorod.notifications" */
  uogorod_notifications_aggregate: Uogorod_Notifications_Aggregate;
  /** fetch data from the table: "uogorod.notifications" using primary key columns */
  uogorod_notifications_by_pk?: Maybe<Uogorod_Notifications>;
  /** fetch data from the table: "uogorod.onboarding" */
  uogorod_onboarding: Array<Uogorod_Onboarding>;
  /** fetch aggregated fields from the table: "uogorod.onboarding" */
  uogorod_onboarding_aggregate: Uogorod_Onboarding_Aggregate;
  /** fetch data from the table: "uogorod.pages" */
  uogorod_pages: Array<Uogorod_Pages>;
  /** fetch aggregated fields from the table: "uogorod.pages" */
  uogorod_pages_aggregate: Uogorod_Pages_Aggregate;
  /** fetch data from the table: "uogorod.pages" using primary key columns */
  uogorod_pages_by_pk?: Maybe<Uogorod_Pages>;
  /** fetch data from the table: "uogorod.posts" */
  uogorod_posts: Array<Uogorod_Posts>;
  /** fetch aggregated fields from the table: "uogorod.posts" */
  uogorod_posts_aggregate: Uogorod_Posts_Aggregate;
  /** fetch data from the table: "uogorod.posts" using primary key columns */
  uogorod_posts_by_pk?: Maybe<Uogorod_Posts>;
  /** fetch data from the table: "uogorod.reports" */
  uogorod_reports: Array<Uogorod_Reports>;
  /** fetch aggregated fields from the table: "uogorod.reports" */
  uogorod_reports_aggregate: Uogorod_Reports_Aggregate;
  /** fetch data from the table: "uogorod.reports" using primary key columns */
  uogorod_reports_by_pk?: Maybe<Uogorod_Reports>;
  /** fetch data from the table: "uogorod.reviews" */
  uogorod_reviews: Array<Uogorod_Reviews>;
  /** fetch aggregated fields from the table: "uogorod.reviews" */
  uogorod_reviews_aggregate: Uogorod_Reviews_Aggregate;
  /** fetch data from the table: "uogorod.reviews" using primary key columns */
  uogorod_reviews_by_pk?: Maybe<Uogorod_Reviews>;
  /** fetch data from the table: "uogorod.seed_categories" */
  uogorod_seed_categories: Array<Uogorod_Seed_Categories>;
  /** fetch aggregated fields from the table: "uogorod.seed_categories" */
  uogorod_seed_categories_aggregate: Uogorod_Seed_Categories_Aggregate;
  /** fetch data from the table: "uogorod.seed_categories" using primary key columns */
  uogorod_seed_categories_by_pk?: Maybe<Uogorod_Seed_Categories>;
  /** fetch data from the table: "uogorod.seed_params" */
  uogorod_seed_params: Array<Uogorod_Seed_Params>;
  /** fetch aggregated fields from the table: "uogorod.seed_params" */
  uogorod_seed_params_aggregate: Uogorod_Seed_Params_Aggregate;
  /** fetch data from the table: "uogorod.seed_params" using primary key columns */
  uogorod_seed_params_by_pk?: Maybe<Uogorod_Seed_Params>;
  /** fetch data from the table: "uogorod.seed_similar" */
  uogorod_seed_similar: Array<Uogorod_Seed_Similar>;
  /** fetch aggregated fields from the table: "uogorod.seed_similar" */
  uogorod_seed_similar_aggregate: Uogorod_Seed_Similar_Aggregate;
  /** fetch data from the table: "uogorod.seed_similar" using primary key columns */
  uogorod_seed_similar_by_pk?: Maybe<Uogorod_Seed_Similar>;
  /** fetch data from the table: "uogorod.seed_specs" */
  uogorod_seed_specs: Array<Uogorod_Seed_Specs>;
  /** fetch aggregated fields from the table: "uogorod.seed_specs" */
  uogorod_seed_specs_aggregate: Uogorod_Seed_Specs_Aggregate;
  /** fetch data from the table: "uogorod.seed_specs" using primary key columns */
  uogorod_seed_specs_by_pk?: Maybe<Uogorod_Seed_Specs>;
  /** fetch data from the table: "uogorod.seed_votes" */
  uogorod_seed_votes: Array<Uogorod_Seed_Votes>;
  /** fetch aggregated fields from the table: "uogorod.seed_votes" */
  uogorod_seed_votes_aggregate: Uogorod_Seed_Votes_Aggregate;
  /** fetch data from the table: "uogorod.seed_votes" using primary key columns */
  uogorod_seed_votes_by_pk?: Maybe<Uogorod_Seed_Votes>;
  /** fetch data from the table: "uogorod.seeds" */
  uogorod_seeds: Array<Uogorod_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.seeds" */
  uogorod_seeds_aggregate: Uogorod_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.seeds_brands" */
  uogorod_seeds_brands: Array<Uogorod_Seeds_Brands>;
  /** fetch aggregated fields from the table: "uogorod.seeds_brands" */
  uogorod_seeds_brands_aggregate: Uogorod_Seeds_Brands_Aggregate;
  /** fetch data from the table: "uogorod.seeds_brands" using primary key columns */
  uogorod_seeds_brands_by_pk?: Maybe<Uogorod_Seeds_Brands>;
  /** fetch data from the table: "uogorod.seeds" using primary key columns */
  uogorod_seeds_by_pk?: Maybe<Uogorod_Seeds>;
  /** fetch data from the table: "uogorod.seeds_images" */
  uogorod_seeds_images: Array<Uogorod_Seeds_Images>;
  /** fetch aggregated fields from the table: "uogorod.seeds_images" */
  uogorod_seeds_images_aggregate: Uogorod_Seeds_Images_Aggregate;
  /** fetch data from the table: "uogorod.seeds_images" using primary key columns */
  uogorod_seeds_images_by_pk?: Maybe<Uogorod_Seeds_Images>;
  /** fetch data from the table: "uogorod.seeds_records" */
  uogorod_seeds_records: Array<Uogorod_Seeds_Records>;
  /** fetch aggregated fields from the table: "uogorod.seeds_records" */
  uogorod_seeds_records_aggregate: Uogorod_Seeds_Records_Aggregate;
  /** fetch data from the table: "uogorod.seeds_records" using primary key columns */
  uogorod_seeds_records_by_pk?: Maybe<Uogorod_Seeds_Records>;
  /** fetch data from the table: "uogorod.subscribes" */
  uogorod_subscribes: Array<Uogorod_Subscribes>;
  /** fetch aggregated fields from the table: "uogorod.subscribes" */
  uogorod_subscribes_aggregate: Uogorod_Subscribes_Aggregate;
  /** fetch data from the table: "uogorod.subscribes" using primary key columns */
  uogorod_subscribes_by_pk?: Maybe<Uogorod_Subscribes>;
  /** fetch data from the table: "uogorod.top_reviewers" */
  uogorod_top_reviewers: Array<Uogorod_Top_Reviewers>;
  /** fetch aggregated fields from the table: "uogorod.top_reviewers" */
  uogorod_top_reviewers_aggregate: Uogorod_Top_Reviewers_Aggregate;
  /** fetch data from the table: "uogorod.type_comments" */
  uogorod_type_comments: Array<Uogorod_Type_Comments>;
  /** fetch aggregated fields from the table: "uogorod.type_comments" */
  uogorod_type_comments_aggregate: Uogorod_Type_Comments_Aggregate;
  /** fetch data from the table: "uogorod.type_comments" using primary key columns */
  uogorod_type_comments_by_pk?: Maybe<Uogorod_Type_Comments>;
  /** fetch data from the table: "uogorod.type_contacts" */
  uogorod_type_contacts: Array<Uogorod_Type_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.type_contacts" */
  uogorod_type_contacts_aggregate: Uogorod_Type_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.type_contacts" using primary key columns */
  uogorod_type_contacts_by_pk?: Maybe<Uogorod_Type_Contacts>;
  /** fetch data from the table: "uogorod.type_likes" */
  uogorod_type_likes: Array<Uogorod_Type_Likes>;
  /** fetch aggregated fields from the table: "uogorod.type_likes" */
  uogorod_type_likes_aggregate: Uogorod_Type_Likes_Aggregate;
  /** fetch data from the table: "uogorod.type_likes" using primary key columns */
  uogorod_type_likes_by_pk?: Maybe<Uogorod_Type_Likes>;
  /** fetch data from the table: "uogorod.type_posts" */
  uogorod_type_posts: Array<Uogorod_Type_Posts>;
  /** fetch aggregated fields from the table: "uogorod.type_posts" */
  uogorod_type_posts_aggregate: Uogorod_Type_Posts_Aggregate;
  /** fetch data from the table: "uogorod.type_posts" using primary key columns */
  uogorod_type_posts_by_pk?: Maybe<Uogorod_Type_Posts>;
  /** fetch data from the table: "uogorod.type_seed_actions" */
  uogorod_type_seed_actions: Array<Uogorod_Type_Seed_Actions>;
  /** fetch aggregated fields from the table: "uogorod.type_seed_actions" */
  uogorod_type_seed_actions_aggregate: Uogorod_Type_Seed_Actions_Aggregate;
  /** fetch data from the table: "uogorod.type_seed_actions" using primary key columns */
  uogorod_type_seed_actions_by_pk?: Maybe<Uogorod_Type_Seed_Actions>;
  /** fetch data from the table: "uogorod.type_seeds_status" */
  uogorod_type_seeds_status: Array<Uogorod_Type_Seeds_Status>;
  /** fetch aggregated fields from the table: "uogorod.type_seeds_status" */
  uogorod_type_seeds_status_aggregate: Uogorod_Type_Seeds_Status_Aggregate;
  /** fetch data from the table: "uogorod.type_seeds_status" using primary key columns */
  uogorod_type_seeds_status_by_pk?: Maybe<Uogorod_Type_Seeds_Status>;
  /** fetch data from the table: "uogorod.type_users" */
  uogorod_type_users: Array<Uogorod_Type_Users>;
  /** fetch aggregated fields from the table: "uogorod.type_users" */
  uogorod_type_users_aggregate: Uogorod_Type_Users_Aggregate;
  /** fetch data from the table: "uogorod.type_users" using primary key columns */
  uogorod_type_users_by_pk?: Maybe<Uogorod_Type_Users>;
  /** fetch data from the table: "uogorod.user_achivments" */
  uogorod_user_achivments: Array<Uogorod_User_Achivments>;
  /** fetch aggregated fields from the table: "uogorod.user_achivments" */
  uogorod_user_achivments_aggregate: Uogorod_User_Achivments_Aggregate;
  /** fetch data from the table: "uogorod.user_achivments" using primary key columns */
  uogorod_user_achivments_by_pk?: Maybe<Uogorod_User_Achivments>;
  /** fetch data from the table: "uogorod.user_contacts" */
  uogorod_user_contacts: Array<Uogorod_User_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.user_contacts" */
  uogorod_user_contacts_aggregate: Uogorod_User_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.user_contacts" using primary key columns */
  uogorod_user_contacts_by_pk?: Maybe<Uogorod_User_Contacts>;
  /** fetch data from the table: "uogorod.users" */
  uogorod_users: Array<Uogorod_Users>;
  /** fetch aggregated fields from the table: "uogorod.users" */
  uogorod_users_aggregate: Uogorod_Users_Aggregate;
  /** fetch data from the table: "uogorod.users" using primary key columns */
  uogorod_users_by_pk?: Maybe<Uogorod_Users>;
  /** fetch data from the table: "uogorod.users_calendar" */
  uogorod_users_calendar: Array<Uogorod_Users_Calendar>;
  /** fetch aggregated fields from the table: "uogorod.users_calendar" */
  uogorod_users_calendar_aggregate: Uogorod_Users_Calendar_Aggregate;
  /** fetch data from the table: "uogorod.users_calendar" using primary key columns */
  uogorod_users_calendar_by_pk?: Maybe<Uogorod_Users_Calendar>;
  /** fetch data from the table: "uogorod.users_not_activated" */
  uogorod_users_not_activated: Array<Uogorod_Users_Not_Activated>;
  /** fetch aggregated fields from the table: "uogorod.users_not_activated" */
  uogorod_users_not_activated_aggregate: Uogorod_Users_Not_Activated_Aggregate;
  /** fetch data from the table: "uogorod.users_seed_actions" */
  uogorod_users_seed_actions: Array<Uogorod_Users_Seed_Actions>;
  /** fetch aggregated fields from the table: "uogorod.users_seed_actions" */
  uogorod_users_seed_actions_aggregate: Uogorod_Users_Seed_Actions_Aggregate;
  /** fetch data from the table: "uogorod.users_seed_actions" using primary key columns */
  uogorod_users_seed_actions_by_pk?: Maybe<Uogorod_Users_Seed_Actions>;
  /** fetch data from the table: "uogorod.view_manual" */
  uogorod_view_manual: Array<Uogorod_View_Manual>;
  /** fetch aggregated fields from the table: "uogorod.view_manual" */
  uogorod_view_manual_aggregate: Uogorod_View_Manual_Aggregate;
};


export type Query_RootAnimeArgs = {
  distinct_on?: InputMaybe<Array<Anime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Order_By>>;
  where?: InputMaybe<Anime_Bool_Exp>;
};


export type Query_RootAnime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Order_By>>;
  where?: InputMaybe<Anime_Bool_Exp>;
};


export type Query_RootAnime_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGenreArgs = {
  distinct_on?: InputMaybe<Array<Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genre_Order_By>>;
  where?: InputMaybe<Genre_Bool_Exp>;
};


export type Query_RootGenre_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genre_Order_By>>;
  where?: InputMaybe<Genre_Bool_Exp>;
};


export type Query_RootGenre_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootVideoArgs = {
  distinct_on?: InputMaybe<Array<Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Order_By>>;
  where?: InputMaybe<Video_Bool_Exp>;
};


export type Query_RootVideo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Order_By>>;
  where?: InputMaybe<Video_Bool_Exp>;
};


export type Query_RootVideo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAnime_GenreArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


export type Query_RootAnime_Genre_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


export type Query_RootAnime_Genre_By_PkArgs = {
  anime_id: Scalars['Int']['input'];
  genre_id: Scalars['Int']['input'];
};


export type Query_RootDialogsArgs = {
  args: Dialogs_Arguments;
  distinct_on?: InputMaybe<Array<Dialog_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dialog_Order_By>>;
  where?: InputMaybe<Dialog_Bool_Exp_Bool_Exp>;
};


export type Query_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Query_RootPosts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Query_RootPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Query_RootPrices_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUogorod_AchivmentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};


export type Query_RootUogorod_Achivments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};


export type Query_RootUogorod_Achivments_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootUogorod_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};


export type Query_RootUogorod_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};


export type Query_RootUogorod_Brands_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Brands_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_Brands_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_Brands_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


export type Query_RootUogorod_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


export type Query_RootUogorod_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Emails_Order_By>>;
  where?: InputMaybe<Uogorod_Emails_Bool_Exp>;
};


export type Query_RootUogorod_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Emails_Order_By>>;
  where?: InputMaybe<Uogorod_Emails_Bool_Exp>;
};


export type Query_RootUogorod_ExperimentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Experiments_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Experiments_StepsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Steps_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Steps_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Steps_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Experiments_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Views_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Views_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};


export type Query_RootUogorod_Experiments_Views_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Garden_BedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Beds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Beds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Garden_Beds_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Beds_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Beds_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Garden_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Seasons_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Garden_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Garden_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_GardensArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


export type Query_RootUogorod_Gardens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


export type Query_RootUogorod_Gardens_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUogorod_Geo_CityArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


export type Query_RootUogorod_Geo_City_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


export type Query_RootUogorod_Geo_City_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Geo_CountryArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Country_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};


export type Query_RootUogorod_Geo_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Country_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};


export type Query_RootUogorod_Geo_Country_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Geo_RegionArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


export type Query_RootUogorod_Geo_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


export type Query_RootUogorod_Geo_Region_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};


export type Query_RootUogorod_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};


export type Query_RootUogorod_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Groups_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Category_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};


export type Query_RootUogorod_Groups_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Category_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};


export type Query_RootUogorod_Groups_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Groups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};


export type Query_RootUogorod_Groups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};


export type Query_RootUogorod_Groups_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


export type Query_RootUogorod_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


export type Query_RootUogorod_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_LikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


export type Query_RootUogorod_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


export type Query_RootUogorod_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_ManualArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};


export type Query_RootUogorod_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};


export type Query_RootUogorod_Manual_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


export type Query_RootUogorod_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


export type Query_RootUogorod_Messages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUogorod_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Notifications_Order_By>>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};


export type Query_RootUogorod_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Notifications_Order_By>>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};


export type Query_RootUogorod_Notifications_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_OnboardingArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Onboarding_Order_By>>;
  where?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
};


export type Query_RootUogorod_Onboarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Onboarding_Order_By>>;
  where?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
};


export type Query_RootUogorod_PagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Pages_Order_By>>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};


export type Query_RootUogorod_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Pages_Order_By>>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};


export type Query_RootUogorod_Pages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_PostsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


export type Query_RootUogorod_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


export type Query_RootUogorod_Posts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reports_Order_By>>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};


export type Query_RootUogorod_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reports_Order_By>>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};


export type Query_RootUogorod_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


export type Query_RootUogorod_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


export type Query_RootUogorod_Reviews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seed_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Categories_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUogorod_Seed_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Params_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Params_By_PkArgs = {
  name: Scalars['String']['input'];
  seed_id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seed_SimilarArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Similar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Similar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seed_SpecsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Specs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Specs_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Specs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Specs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Specs_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Specs_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootUogorod_Seed_VotesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Votes_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Votes_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};


export type Query_RootUogorod_Seed_Votes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Brands_By_PkArgs = {
  brand_id: Scalars['bigint']['input'];
  seed_id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seeds_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Seeds_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


export type Query_RootUogorod_Seeds_Records_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_SubscribesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


export type Query_RootUogorod_Subscribes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


export type Query_RootUogorod_Subscribes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Top_ReviewersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Top_Reviewers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Top_Reviewers_Order_By>>;
  where?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
};


export type Query_RootUogorod_Top_Reviewers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Top_Reviewers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Top_Reviewers_Order_By>>;
  where?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
};


export type Query_RootUogorod_Type_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};


export type Query_RootUogorod_Type_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};


export type Query_RootUogorod_Type_Comments_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_Type_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_Type_Contacts_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_LikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};


export type Query_RootUogorod_Type_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};


export type Query_RootUogorod_Type_Likes_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_PostsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};


export type Query_RootUogorod_Type_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};


export type Query_RootUogorod_Type_Posts_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_Seed_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};


export type Query_RootUogorod_Type_Seed_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};


export type Query_RootUogorod_Type_Seed_Actions_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_Seeds_StatusArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};


export type Query_RootUogorod_Type_Seeds_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};


export type Query_RootUogorod_Type_Seeds_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootUogorod_Type_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};


export type Query_RootUogorod_Type_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};


export type Query_RootUogorod_Type_Users_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootUogorod_User_AchivmentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


export type Query_RootUogorod_User_Achivments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


export type Query_RootUogorod_User_Achivments_By_PkArgs = {
  achivment_id: Scalars['String']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_User_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_User_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


export type Query_RootUogorod_User_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


export type Query_RootUogorod_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


export type Query_RootUogorod_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Users_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Calendar_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};


export type Query_RootUogorod_Users_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Calendar_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};


export type Query_RootUogorod_Users_Calendar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_Users_Not_ActivatedArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Not_Activated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Not_Activated_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
};


export type Query_RootUogorod_Users_Not_Activated_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Not_Activated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Not_Activated_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
};


export type Query_RootUogorod_Users_Seed_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


export type Query_RootUogorod_Users_Seed_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


export type Query_RootUogorod_Users_Seed_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUogorod_View_ManualArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_View_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_View_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
};


export type Query_RootUogorod_View_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_View_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_View_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
};

export type Socialsquery_Root = {
  __typename?: 'socialsquery_root';
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** An array relationship */
  followers: Array<Followers>;
  /** An aggregate relationship */
  followers_aggregate: Followers_Aggregate;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Socialsquery_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Socialsquery_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Socialsquery_RootComments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Socialsquery_RootFollowersArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


export type Socialsquery_RootFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


export type Socialsquery_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Socialsquery_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Socialsquery_RootUsers_By_PkArgs = {
  id: Scalars['Int']['input'];
};

export type Socialssubscription_Root = {
  __typename?: 'socialssubscription_root';
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table in a streaming manner: "comments" */
  comments_stream: Array<Comments>;
  /** An array relationship */
  followers: Array<Followers>;
  /** An aggregate relationship */
  followers_aggregate: Followers_Aggregate;
  /** fetch data from the table in a streaming manner: "followers" */
  followers_stream: Array<Followers>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Socialssubscription_RootCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Socialssubscription_RootComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Socialssubscription_RootComments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Socialssubscription_RootComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type Socialssubscription_RootFollowersArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


export type Socialssubscription_RootFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


export type Socialssubscription_RootFollowers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Followers_Stream_Cursor_Input>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


export type Socialssubscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Socialssubscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Socialssubscription_RootUsers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Socialssubscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "Anime" */
  Anime: Array<Anime>;
  /** fetch aggregated fields from the table: "Anime" */
  Anime_aggregate: Anime_Aggregate;
  /** fetch data from the table: "Anime" using primary key columns */
  Anime_by_pk?: Maybe<Anime>;
  /** fetch data from the table in a streaming manner: "Anime" */
  Anime_stream: Array<Anime>;
  /** fetch data from the table: "Genre" */
  Genre: Array<Genre>;
  /** fetch aggregated fields from the table: "Genre" */
  Genre_aggregate: Genre_Aggregate;
  /** fetch data from the table: "Genre" using primary key columns */
  Genre_by_pk?: Maybe<Genre>;
  /** fetch data from the table in a streaming manner: "Genre" */
  Genre_stream: Array<Genre>;
  /** fetch data from the table: "Video" */
  Video: Array<Video>;
  /** fetch aggregated fields from the table: "Video" */
  Video_aggregate: Video_Aggregate;
  /** fetch data from the table: "Video" using primary key columns */
  Video_by_pk?: Maybe<Video>;
  /** fetch data from the table in a streaming manner: "Video" */
  Video_stream: Array<Video>;
  /** fetch data from the table: "anime_genre" */
  anime_genre: Array<Anime_Genre>;
  /** fetch aggregated fields from the table: "anime_genre" */
  anime_genre_aggregate: Anime_Genre_Aggregate;
  /** fetch data from the table: "anime_genre" using primary key columns */
  anime_genre_by_pk?: Maybe<Anime_Genre>;
  /** fetch data from the table in a streaming manner: "anime_genre" */
  anime_genre_stream: Array<Anime_Genre>;
  dialogs: Array<Dialog>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table in a streaming manner: "orders" */
  orders_stream: Array<Orders>;
  /** fetch data from the table: "posts" */
  posts: Array<Posts>;
  /** fetch aggregated fields from the table: "posts" */
  posts_aggregate: Posts_Aggregate;
  /** fetch data from the table: "posts" using primary key columns */
  posts_by_pk?: Maybe<Posts>;
  /** fetch data from the table in a streaming manner: "posts" */
  posts_stream: Array<Posts>;
  /** An array relationship */
  prices: Array<Prices>;
  /** An aggregate relationship */
  prices_aggregate: Prices_Aggregate;
  /** fetch data from the table: "prices" using primary key columns */
  prices_by_pk?: Maybe<Prices>;
  /** fetch data from the table in a streaming manner: "prices" */
  prices_stream: Array<Prices>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  products_stream: Array<Products>;
  socials?: Maybe<Socialssubscription_Root>;
  /** fetch data from the table: "uogorod.achivments" */
  uogorod_achivments: Array<Uogorod_Achivments>;
  /** fetch aggregated fields from the table: "uogorod.achivments" */
  uogorod_achivments_aggregate: Uogorod_Achivments_Aggregate;
  /** fetch data from the table: "uogorod.achivments" using primary key columns */
  uogorod_achivments_by_pk?: Maybe<Uogorod_Achivments>;
  /** fetch data from the table in a streaming manner: "uogorod.achivments" */
  uogorod_achivments_stream: Array<Uogorod_Achivments>;
  /** fetch data from the table: "uogorod.brands" */
  uogorod_brands: Array<Uogorod_Brands>;
  /** fetch aggregated fields from the table: "uogorod.brands" */
  uogorod_brands_aggregate: Uogorod_Brands_Aggregate;
  /** fetch data from the table: "uogorod.brands" using primary key columns */
  uogorod_brands_by_pk?: Maybe<Uogorod_Brands>;
  /** fetch data from the table: "uogorod.brands_contacts" */
  uogorod_brands_contacts: Array<Uogorod_Brands_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.brands_contacts" */
  uogorod_brands_contacts_aggregate: Uogorod_Brands_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.brands_contacts" using primary key columns */
  uogorod_brands_contacts_by_pk?: Maybe<Uogorod_Brands_Contacts>;
  /** fetch data from the table in a streaming manner: "uogorod.brands_contacts" */
  uogorod_brands_contacts_stream: Array<Uogorod_Brands_Contacts>;
  /** fetch data from the table in a streaming manner: "uogorod.brands" */
  uogorod_brands_stream: Array<Uogorod_Brands>;
  /** fetch data from the table: "uogorod.comments" */
  uogorod_comments: Array<Uogorod_Comments>;
  /** fetch aggregated fields from the table: "uogorod.comments" */
  uogorod_comments_aggregate: Uogorod_Comments_Aggregate;
  /** fetch data from the table: "uogorod.comments" using primary key columns */
  uogorod_comments_by_pk?: Maybe<Uogorod_Comments>;
  /** fetch data from the table in a streaming manner: "uogorod.comments" */
  uogorod_comments_stream: Array<Uogorod_Comments>;
  /** fetch data from the table: "uogorod.emails" */
  uogorod_emails: Array<Uogorod_Emails>;
  /** fetch aggregated fields from the table: "uogorod.emails" */
  uogorod_emails_aggregate: Uogorod_Emails_Aggregate;
  /** fetch data from the table in a streaming manner: "uogorod.emails" */
  uogorod_emails_stream: Array<Uogorod_Emails>;
  /** fetch data from the table: "uogorod.experiments" */
  uogorod_experiments: Array<Uogorod_Experiments>;
  /** fetch aggregated fields from the table: "uogorod.experiments" */
  uogorod_experiments_aggregate: Uogorod_Experiments_Aggregate;
  /** fetch data from the table: "uogorod.experiments" using primary key columns */
  uogorod_experiments_by_pk?: Maybe<Uogorod_Experiments>;
  /** fetch data from the table: "uogorod.experiments_seeds" */
  uogorod_experiments_seeds: Array<Uogorod_Experiments_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.experiments_seeds" */
  uogorod_experiments_seeds_aggregate: Uogorod_Experiments_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.experiments_seeds" using primary key columns */
  uogorod_experiments_seeds_by_pk?: Maybe<Uogorod_Experiments_Seeds>;
  /** fetch data from the table in a streaming manner: "uogorod.experiments_seeds" */
  uogorod_experiments_seeds_stream: Array<Uogorod_Experiments_Seeds>;
  /** fetch data from the table: "uogorod.experiments_steps" */
  uogorod_experiments_steps: Array<Uogorod_Experiments_Steps>;
  /** fetch aggregated fields from the table: "uogorod.experiments_steps" */
  uogorod_experiments_steps_aggregate: Uogorod_Experiments_Steps_Aggregate;
  /** fetch data from the table: "uogorod.experiments_steps" using primary key columns */
  uogorod_experiments_steps_by_pk?: Maybe<Uogorod_Experiments_Steps>;
  /** fetch data from the table in a streaming manner: "uogorod.experiments_steps" */
  uogorod_experiments_steps_stream: Array<Uogorod_Experiments_Steps>;
  /** fetch data from the table in a streaming manner: "uogorod.experiments" */
  uogorod_experiments_stream: Array<Uogorod_Experiments>;
  /** fetch data from the table: "uogorod.experiments_views" */
  uogorod_experiments_views: Array<Uogorod_Experiments_Views>;
  /** fetch aggregated fields from the table: "uogorod.experiments_views" */
  uogorod_experiments_views_aggregate: Uogorod_Experiments_Views_Aggregate;
  /** fetch data from the table: "uogorod.experiments_views" using primary key columns */
  uogorod_experiments_views_by_pk?: Maybe<Uogorod_Experiments_Views>;
  /** fetch data from the table in a streaming manner: "uogorod.experiments_views" */
  uogorod_experiments_views_stream: Array<Uogorod_Experiments_Views>;
  /** fetch data from the table: "uogorod.garden_beds" */
  uogorod_garden_beds: Array<Uogorod_Garden_Beds>;
  /** fetch aggregated fields from the table: "uogorod.garden_beds" */
  uogorod_garden_beds_aggregate: Uogorod_Garden_Beds_Aggregate;
  /** fetch data from the table: "uogorod.garden_beds" using primary key columns */
  uogorod_garden_beds_by_pk?: Maybe<Uogorod_Garden_Beds>;
  /** fetch data from the table: "uogorod.garden_beds_seeds" */
  uogorod_garden_beds_seeds: Array<Uogorod_Garden_Beds_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.garden_beds_seeds" */
  uogorod_garden_beds_seeds_aggregate: Uogorod_Garden_Beds_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.garden_beds_seeds" using primary key columns */
  uogorod_garden_beds_seeds_by_pk?: Maybe<Uogorod_Garden_Beds_Seeds>;
  /** fetch data from the table in a streaming manner: "uogorod.garden_beds_seeds" */
  uogorod_garden_beds_seeds_stream: Array<Uogorod_Garden_Beds_Seeds>;
  /** fetch data from the table in a streaming manner: "uogorod.garden_beds" */
  uogorod_garden_beds_stream: Array<Uogorod_Garden_Beds>;
  /** fetch data from the table: "uogorod.garden_seasons" */
  uogorod_garden_seasons: Array<Uogorod_Garden_Seasons>;
  /** fetch aggregated fields from the table: "uogorod.garden_seasons" */
  uogorod_garden_seasons_aggregate: Uogorod_Garden_Seasons_Aggregate;
  /** fetch data from the table: "uogorod.garden_seasons" using primary key columns */
  uogorod_garden_seasons_by_pk?: Maybe<Uogorod_Garden_Seasons>;
  /** fetch data from the table in a streaming manner: "uogorod.garden_seasons" */
  uogorod_garden_seasons_stream: Array<Uogorod_Garden_Seasons>;
  /** fetch data from the table: "uogorod.garden_seeds" */
  uogorod_garden_seeds: Array<Uogorod_Garden_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.garden_seeds" */
  uogorod_garden_seeds_aggregate: Uogorod_Garden_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.garden_seeds" using primary key columns */
  uogorod_garden_seeds_by_pk?: Maybe<Uogorod_Garden_Seeds>;
  /** fetch data from the table in a streaming manner: "uogorod.garden_seeds" */
  uogorod_garden_seeds_stream: Array<Uogorod_Garden_Seeds>;
  /** fetch data from the table: "uogorod.gardens" */
  uogorod_gardens: Array<Uogorod_Gardens>;
  /** fetch aggregated fields from the table: "uogorod.gardens" */
  uogorod_gardens_aggregate: Uogorod_Gardens_Aggregate;
  /** fetch data from the table: "uogorod.gardens" using primary key columns */
  uogorod_gardens_by_pk?: Maybe<Uogorod_Gardens>;
  /** fetch data from the table in a streaming manner: "uogorod.gardens" */
  uogorod_gardens_stream: Array<Uogorod_Gardens>;
  /** fetch data from the table: "uogorod.geo_city" */
  uogorod_geo_city: Array<Uogorod_Geo_City>;
  /** fetch aggregated fields from the table: "uogorod.geo_city" */
  uogorod_geo_city_aggregate: Uogorod_Geo_City_Aggregate;
  /** fetch data from the table: "uogorod.geo_city" using primary key columns */
  uogorod_geo_city_by_pk?: Maybe<Uogorod_Geo_City>;
  /** fetch data from the table in a streaming manner: "uogorod.geo_city" */
  uogorod_geo_city_stream: Array<Uogorod_Geo_City>;
  /** fetch data from the table: "uogorod.geo_country" */
  uogorod_geo_country: Array<Uogorod_Geo_Country>;
  /** fetch aggregated fields from the table: "uogorod.geo_country" */
  uogorod_geo_country_aggregate: Uogorod_Geo_Country_Aggregate;
  /** fetch data from the table: "uogorod.geo_country" using primary key columns */
  uogorod_geo_country_by_pk?: Maybe<Uogorod_Geo_Country>;
  /** fetch data from the table in a streaming manner: "uogorod.geo_country" */
  uogorod_geo_country_stream: Array<Uogorod_Geo_Country>;
  /** fetch data from the table: "uogorod.geo_region" */
  uogorod_geo_region: Array<Uogorod_Geo_Region>;
  /** fetch aggregated fields from the table: "uogorod.geo_region" */
  uogorod_geo_region_aggregate: Uogorod_Geo_Region_Aggregate;
  /** fetch data from the table: "uogorod.geo_region" using primary key columns */
  uogorod_geo_region_by_pk?: Maybe<Uogorod_Geo_Region>;
  /** fetch data from the table in a streaming manner: "uogorod.geo_region" */
  uogorod_geo_region_stream: Array<Uogorod_Geo_Region>;
  /** fetch data from the table: "uogorod.groups" */
  uogorod_groups: Array<Uogorod_Groups>;
  /** fetch aggregated fields from the table: "uogorod.groups" */
  uogorod_groups_aggregate: Uogorod_Groups_Aggregate;
  /** fetch data from the table: "uogorod.groups" using primary key columns */
  uogorod_groups_by_pk?: Maybe<Uogorod_Groups>;
  /** fetch data from the table: "uogorod.groups_category" */
  uogorod_groups_category: Array<Uogorod_Groups_Category>;
  /** fetch aggregated fields from the table: "uogorod.groups_category" */
  uogorod_groups_category_aggregate: Uogorod_Groups_Category_Aggregate;
  /** fetch data from the table: "uogorod.groups_category" using primary key columns */
  uogorod_groups_category_by_pk?: Maybe<Uogorod_Groups_Category>;
  /** fetch data from the table in a streaming manner: "uogorod.groups_category" */
  uogorod_groups_category_stream: Array<Uogorod_Groups_Category>;
  /** fetch data from the table in a streaming manner: "uogorod.groups" */
  uogorod_groups_stream: Array<Uogorod_Groups>;
  /** fetch data from the table: "uogorod.groups_users" */
  uogorod_groups_users: Array<Uogorod_Groups_Users>;
  /** fetch aggregated fields from the table: "uogorod.groups_users" */
  uogorod_groups_users_aggregate: Uogorod_Groups_Users_Aggregate;
  /** fetch data from the table: "uogorod.groups_users" using primary key columns */
  uogorod_groups_users_by_pk?: Maybe<Uogorod_Groups_Users>;
  /** fetch data from the table in a streaming manner: "uogorod.groups_users" */
  uogorod_groups_users_stream: Array<Uogorod_Groups_Users>;
  /** fetch data from the table: "uogorod.images" */
  uogorod_images: Array<Uogorod_Images>;
  /** fetch aggregated fields from the table: "uogorod.images" */
  uogorod_images_aggregate: Uogorod_Images_Aggregate;
  /** fetch data from the table: "uogorod.images" using primary key columns */
  uogorod_images_by_pk?: Maybe<Uogorod_Images>;
  /** fetch data from the table in a streaming manner: "uogorod.images" */
  uogorod_images_stream: Array<Uogorod_Images>;
  /** fetch data from the table: "uogorod.likes" */
  uogorod_likes: Array<Uogorod_Likes>;
  /** fetch aggregated fields from the table: "uogorod.likes" */
  uogorod_likes_aggregate: Uogorod_Likes_Aggregate;
  /** fetch data from the table: "uogorod.likes" using primary key columns */
  uogorod_likes_by_pk?: Maybe<Uogorod_Likes>;
  /** fetch data from the table in a streaming manner: "uogorod.likes" */
  uogorod_likes_stream: Array<Uogorod_Likes>;
  /** fetch data from the table: "uogorod.manual" */
  uogorod_manual: Array<Uogorod_Manual>;
  /** fetch aggregated fields from the table: "uogorod.manual" */
  uogorod_manual_aggregate: Uogorod_Manual_Aggregate;
  /** fetch data from the table: "uogorod.manual" using primary key columns */
  uogorod_manual_by_pk?: Maybe<Uogorod_Manual>;
  /** fetch data from the table in a streaming manner: "uogorod.manual" */
  uogorod_manual_stream: Array<Uogorod_Manual>;
  /** fetch data from the table: "uogorod.messages" */
  uogorod_messages: Array<Uogorod_Messages>;
  /** fetch aggregated fields from the table: "uogorod.messages" */
  uogorod_messages_aggregate: Uogorod_Messages_Aggregate;
  /** fetch data from the table: "uogorod.messages" using primary key columns */
  uogorod_messages_by_pk?: Maybe<Uogorod_Messages>;
  /** fetch data from the table in a streaming manner: "uogorod.messages" */
  uogorod_messages_stream: Array<Uogorod_Messages>;
  /** fetch data from the table: "uogorod.notifications" */
  uogorod_notifications: Array<Uogorod_Notifications>;
  /** fetch aggregated fields from the table: "uogorod.notifications" */
  uogorod_notifications_aggregate: Uogorod_Notifications_Aggregate;
  /** fetch data from the table: "uogorod.notifications" using primary key columns */
  uogorod_notifications_by_pk?: Maybe<Uogorod_Notifications>;
  /** fetch data from the table in a streaming manner: "uogorod.notifications" */
  uogorod_notifications_stream: Array<Uogorod_Notifications>;
  /** fetch data from the table: "uogorod.onboarding" */
  uogorod_onboarding: Array<Uogorod_Onboarding>;
  /** fetch aggregated fields from the table: "uogorod.onboarding" */
  uogorod_onboarding_aggregate: Uogorod_Onboarding_Aggregate;
  /** fetch data from the table in a streaming manner: "uogorod.onboarding" */
  uogorod_onboarding_stream: Array<Uogorod_Onboarding>;
  /** fetch data from the table: "uogorod.pages" */
  uogorod_pages: Array<Uogorod_Pages>;
  /** fetch aggregated fields from the table: "uogorod.pages" */
  uogorod_pages_aggregate: Uogorod_Pages_Aggregate;
  /** fetch data from the table: "uogorod.pages" using primary key columns */
  uogorod_pages_by_pk?: Maybe<Uogorod_Pages>;
  /** fetch data from the table in a streaming manner: "uogorod.pages" */
  uogorod_pages_stream: Array<Uogorod_Pages>;
  /** fetch data from the table: "uogorod.posts" */
  uogorod_posts: Array<Uogorod_Posts>;
  /** fetch aggregated fields from the table: "uogorod.posts" */
  uogorod_posts_aggregate: Uogorod_Posts_Aggregate;
  /** fetch data from the table: "uogorod.posts" using primary key columns */
  uogorod_posts_by_pk?: Maybe<Uogorod_Posts>;
  /** fetch data from the table in a streaming manner: "uogorod.posts" */
  uogorod_posts_stream: Array<Uogorod_Posts>;
  /** fetch data from the table: "uogorod.reports" */
  uogorod_reports: Array<Uogorod_Reports>;
  /** fetch aggregated fields from the table: "uogorod.reports" */
  uogorod_reports_aggregate: Uogorod_Reports_Aggregate;
  /** fetch data from the table: "uogorod.reports" using primary key columns */
  uogorod_reports_by_pk?: Maybe<Uogorod_Reports>;
  /** fetch data from the table in a streaming manner: "uogorod.reports" */
  uogorod_reports_stream: Array<Uogorod_Reports>;
  /** fetch data from the table: "uogorod.reviews" */
  uogorod_reviews: Array<Uogorod_Reviews>;
  /** fetch aggregated fields from the table: "uogorod.reviews" */
  uogorod_reviews_aggregate: Uogorod_Reviews_Aggregate;
  /** fetch data from the table: "uogorod.reviews" using primary key columns */
  uogorod_reviews_by_pk?: Maybe<Uogorod_Reviews>;
  /** fetch data from the table in a streaming manner: "uogorod.reviews" */
  uogorod_reviews_stream: Array<Uogorod_Reviews>;
  /** fetch data from the table: "uogorod.seed_categories" */
  uogorod_seed_categories: Array<Uogorod_Seed_Categories>;
  /** fetch aggregated fields from the table: "uogorod.seed_categories" */
  uogorod_seed_categories_aggregate: Uogorod_Seed_Categories_Aggregate;
  /** fetch data from the table: "uogorod.seed_categories" using primary key columns */
  uogorod_seed_categories_by_pk?: Maybe<Uogorod_Seed_Categories>;
  /** fetch data from the table in a streaming manner: "uogorod.seed_categories" */
  uogorod_seed_categories_stream: Array<Uogorod_Seed_Categories>;
  /** fetch data from the table: "uogorod.seed_params" */
  uogorod_seed_params: Array<Uogorod_Seed_Params>;
  /** fetch aggregated fields from the table: "uogorod.seed_params" */
  uogorod_seed_params_aggregate: Uogorod_Seed_Params_Aggregate;
  /** fetch data from the table: "uogorod.seed_params" using primary key columns */
  uogorod_seed_params_by_pk?: Maybe<Uogorod_Seed_Params>;
  /** fetch data from the table in a streaming manner: "uogorod.seed_params" */
  uogorod_seed_params_stream: Array<Uogorod_Seed_Params>;
  /** fetch data from the table: "uogorod.seed_similar" */
  uogorod_seed_similar: Array<Uogorod_Seed_Similar>;
  /** fetch aggregated fields from the table: "uogorod.seed_similar" */
  uogorod_seed_similar_aggregate: Uogorod_Seed_Similar_Aggregate;
  /** fetch data from the table: "uogorod.seed_similar" using primary key columns */
  uogorod_seed_similar_by_pk?: Maybe<Uogorod_Seed_Similar>;
  /** fetch data from the table in a streaming manner: "uogorod.seed_similar" */
  uogorod_seed_similar_stream: Array<Uogorod_Seed_Similar>;
  /** fetch data from the table: "uogorod.seed_specs" */
  uogorod_seed_specs: Array<Uogorod_Seed_Specs>;
  /** fetch aggregated fields from the table: "uogorod.seed_specs" */
  uogorod_seed_specs_aggregate: Uogorod_Seed_Specs_Aggregate;
  /** fetch data from the table: "uogorod.seed_specs" using primary key columns */
  uogorod_seed_specs_by_pk?: Maybe<Uogorod_Seed_Specs>;
  /** fetch data from the table in a streaming manner: "uogorod.seed_specs" */
  uogorod_seed_specs_stream: Array<Uogorod_Seed_Specs>;
  /** fetch data from the table: "uogorod.seed_votes" */
  uogorod_seed_votes: Array<Uogorod_Seed_Votes>;
  /** fetch aggregated fields from the table: "uogorod.seed_votes" */
  uogorod_seed_votes_aggregate: Uogorod_Seed_Votes_Aggregate;
  /** fetch data from the table: "uogorod.seed_votes" using primary key columns */
  uogorod_seed_votes_by_pk?: Maybe<Uogorod_Seed_Votes>;
  /** fetch data from the table in a streaming manner: "uogorod.seed_votes" */
  uogorod_seed_votes_stream: Array<Uogorod_Seed_Votes>;
  /** fetch data from the table: "uogorod.seeds" */
  uogorod_seeds: Array<Uogorod_Seeds>;
  /** fetch aggregated fields from the table: "uogorod.seeds" */
  uogorod_seeds_aggregate: Uogorod_Seeds_Aggregate;
  /** fetch data from the table: "uogorod.seeds_brands" */
  uogorod_seeds_brands: Array<Uogorod_Seeds_Brands>;
  /** fetch aggregated fields from the table: "uogorod.seeds_brands" */
  uogorod_seeds_brands_aggregate: Uogorod_Seeds_Brands_Aggregate;
  /** fetch data from the table: "uogorod.seeds_brands" using primary key columns */
  uogorod_seeds_brands_by_pk?: Maybe<Uogorod_Seeds_Brands>;
  /** fetch data from the table in a streaming manner: "uogorod.seeds_brands" */
  uogorod_seeds_brands_stream: Array<Uogorod_Seeds_Brands>;
  /** fetch data from the table: "uogorod.seeds" using primary key columns */
  uogorod_seeds_by_pk?: Maybe<Uogorod_Seeds>;
  /** fetch data from the table: "uogorod.seeds_images" */
  uogorod_seeds_images: Array<Uogorod_Seeds_Images>;
  /** fetch aggregated fields from the table: "uogorod.seeds_images" */
  uogorod_seeds_images_aggregate: Uogorod_Seeds_Images_Aggregate;
  /** fetch data from the table: "uogorod.seeds_images" using primary key columns */
  uogorod_seeds_images_by_pk?: Maybe<Uogorod_Seeds_Images>;
  /** fetch data from the table in a streaming manner: "uogorod.seeds_images" */
  uogorod_seeds_images_stream: Array<Uogorod_Seeds_Images>;
  /** fetch data from the table: "uogorod.seeds_records" */
  uogorod_seeds_records: Array<Uogorod_Seeds_Records>;
  /** fetch aggregated fields from the table: "uogorod.seeds_records" */
  uogorod_seeds_records_aggregate: Uogorod_Seeds_Records_Aggregate;
  /** fetch data from the table: "uogorod.seeds_records" using primary key columns */
  uogorod_seeds_records_by_pk?: Maybe<Uogorod_Seeds_Records>;
  /** fetch data from the table in a streaming manner: "uogorod.seeds_records" */
  uogorod_seeds_records_stream: Array<Uogorod_Seeds_Records>;
  /** fetch data from the table in a streaming manner: "uogorod.seeds" */
  uogorod_seeds_stream: Array<Uogorod_Seeds>;
  /** fetch data from the table: "uogorod.subscribes" */
  uogorod_subscribes: Array<Uogorod_Subscribes>;
  /** fetch aggregated fields from the table: "uogorod.subscribes" */
  uogorod_subscribes_aggregate: Uogorod_Subscribes_Aggregate;
  /** fetch data from the table: "uogorod.subscribes" using primary key columns */
  uogorod_subscribes_by_pk?: Maybe<Uogorod_Subscribes>;
  /** fetch data from the table in a streaming manner: "uogorod.subscribes" */
  uogorod_subscribes_stream: Array<Uogorod_Subscribes>;
  /** fetch data from the table: "uogorod.top_reviewers" */
  uogorod_top_reviewers: Array<Uogorod_Top_Reviewers>;
  /** fetch aggregated fields from the table: "uogorod.top_reviewers" */
  uogorod_top_reviewers_aggregate: Uogorod_Top_Reviewers_Aggregate;
  /** fetch data from the table in a streaming manner: "uogorod.top_reviewers" */
  uogorod_top_reviewers_stream: Array<Uogorod_Top_Reviewers>;
  /** fetch data from the table: "uogorod.type_comments" */
  uogorod_type_comments: Array<Uogorod_Type_Comments>;
  /** fetch aggregated fields from the table: "uogorod.type_comments" */
  uogorod_type_comments_aggregate: Uogorod_Type_Comments_Aggregate;
  /** fetch data from the table: "uogorod.type_comments" using primary key columns */
  uogorod_type_comments_by_pk?: Maybe<Uogorod_Type_Comments>;
  /** fetch data from the table in a streaming manner: "uogorod.type_comments" */
  uogorod_type_comments_stream: Array<Uogorod_Type_Comments>;
  /** fetch data from the table: "uogorod.type_contacts" */
  uogorod_type_contacts: Array<Uogorod_Type_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.type_contacts" */
  uogorod_type_contacts_aggregate: Uogorod_Type_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.type_contacts" using primary key columns */
  uogorod_type_contacts_by_pk?: Maybe<Uogorod_Type_Contacts>;
  /** fetch data from the table in a streaming manner: "uogorod.type_contacts" */
  uogorod_type_contacts_stream: Array<Uogorod_Type_Contacts>;
  /** fetch data from the table: "uogorod.type_likes" */
  uogorod_type_likes: Array<Uogorod_Type_Likes>;
  /** fetch aggregated fields from the table: "uogorod.type_likes" */
  uogorod_type_likes_aggregate: Uogorod_Type_Likes_Aggregate;
  /** fetch data from the table: "uogorod.type_likes" using primary key columns */
  uogorod_type_likes_by_pk?: Maybe<Uogorod_Type_Likes>;
  /** fetch data from the table in a streaming manner: "uogorod.type_likes" */
  uogorod_type_likes_stream: Array<Uogorod_Type_Likes>;
  /** fetch data from the table: "uogorod.type_posts" */
  uogorod_type_posts: Array<Uogorod_Type_Posts>;
  /** fetch aggregated fields from the table: "uogorod.type_posts" */
  uogorod_type_posts_aggregate: Uogorod_Type_Posts_Aggregate;
  /** fetch data from the table: "uogorod.type_posts" using primary key columns */
  uogorod_type_posts_by_pk?: Maybe<Uogorod_Type_Posts>;
  /** fetch data from the table in a streaming manner: "uogorod.type_posts" */
  uogorod_type_posts_stream: Array<Uogorod_Type_Posts>;
  /** fetch data from the table: "uogorod.type_seed_actions" */
  uogorod_type_seed_actions: Array<Uogorod_Type_Seed_Actions>;
  /** fetch aggregated fields from the table: "uogorod.type_seed_actions" */
  uogorod_type_seed_actions_aggregate: Uogorod_Type_Seed_Actions_Aggregate;
  /** fetch data from the table: "uogorod.type_seed_actions" using primary key columns */
  uogorod_type_seed_actions_by_pk?: Maybe<Uogorod_Type_Seed_Actions>;
  /** fetch data from the table in a streaming manner: "uogorod.type_seed_actions" */
  uogorod_type_seed_actions_stream: Array<Uogorod_Type_Seed_Actions>;
  /** fetch data from the table: "uogorod.type_seeds_status" */
  uogorod_type_seeds_status: Array<Uogorod_Type_Seeds_Status>;
  /** fetch aggregated fields from the table: "uogorod.type_seeds_status" */
  uogorod_type_seeds_status_aggregate: Uogorod_Type_Seeds_Status_Aggregate;
  /** fetch data from the table: "uogorod.type_seeds_status" using primary key columns */
  uogorod_type_seeds_status_by_pk?: Maybe<Uogorod_Type_Seeds_Status>;
  /** fetch data from the table in a streaming manner: "uogorod.type_seeds_status" */
  uogorod_type_seeds_status_stream: Array<Uogorod_Type_Seeds_Status>;
  /** fetch data from the table: "uogorod.type_users" */
  uogorod_type_users: Array<Uogorod_Type_Users>;
  /** fetch aggregated fields from the table: "uogorod.type_users" */
  uogorod_type_users_aggregate: Uogorod_Type_Users_Aggregate;
  /** fetch data from the table: "uogorod.type_users" using primary key columns */
  uogorod_type_users_by_pk?: Maybe<Uogorod_Type_Users>;
  /** fetch data from the table in a streaming manner: "uogorod.type_users" */
  uogorod_type_users_stream: Array<Uogorod_Type_Users>;
  /** fetch data from the table: "uogorod.user_achivments" */
  uogorod_user_achivments: Array<Uogorod_User_Achivments>;
  /** fetch aggregated fields from the table: "uogorod.user_achivments" */
  uogorod_user_achivments_aggregate: Uogorod_User_Achivments_Aggregate;
  /** fetch data from the table: "uogorod.user_achivments" using primary key columns */
  uogorod_user_achivments_by_pk?: Maybe<Uogorod_User_Achivments>;
  /** fetch data from the table in a streaming manner: "uogorod.user_achivments" */
  uogorod_user_achivments_stream: Array<Uogorod_User_Achivments>;
  /** fetch data from the table: "uogorod.user_contacts" */
  uogorod_user_contacts: Array<Uogorod_User_Contacts>;
  /** fetch aggregated fields from the table: "uogorod.user_contacts" */
  uogorod_user_contacts_aggregate: Uogorod_User_Contacts_Aggregate;
  /** fetch data from the table: "uogorod.user_contacts" using primary key columns */
  uogorod_user_contacts_by_pk?: Maybe<Uogorod_User_Contacts>;
  /** fetch data from the table in a streaming manner: "uogorod.user_contacts" */
  uogorod_user_contacts_stream: Array<Uogorod_User_Contacts>;
  /** fetch data from the table: "uogorod.users" */
  uogorod_users: Array<Uogorod_Users>;
  /** fetch aggregated fields from the table: "uogorod.users" */
  uogorod_users_aggregate: Uogorod_Users_Aggregate;
  /** fetch data from the table: "uogorod.users" using primary key columns */
  uogorod_users_by_pk?: Maybe<Uogorod_Users>;
  /** fetch data from the table: "uogorod.users_calendar" */
  uogorod_users_calendar: Array<Uogorod_Users_Calendar>;
  /** fetch aggregated fields from the table: "uogorod.users_calendar" */
  uogorod_users_calendar_aggregate: Uogorod_Users_Calendar_Aggregate;
  /** fetch data from the table: "uogorod.users_calendar" using primary key columns */
  uogorod_users_calendar_by_pk?: Maybe<Uogorod_Users_Calendar>;
  /** fetch data from the table in a streaming manner: "uogorod.users_calendar" */
  uogorod_users_calendar_stream: Array<Uogorod_Users_Calendar>;
  /** fetch data from the table: "uogorod.users_not_activated" */
  uogorod_users_not_activated: Array<Uogorod_Users_Not_Activated>;
  /** fetch aggregated fields from the table: "uogorod.users_not_activated" */
  uogorod_users_not_activated_aggregate: Uogorod_Users_Not_Activated_Aggregate;
  /** fetch data from the table in a streaming manner: "uogorod.users_not_activated" */
  uogorod_users_not_activated_stream: Array<Uogorod_Users_Not_Activated>;
  /** fetch data from the table: "uogorod.users_seed_actions" */
  uogorod_users_seed_actions: Array<Uogorod_Users_Seed_Actions>;
  /** fetch aggregated fields from the table: "uogorod.users_seed_actions" */
  uogorod_users_seed_actions_aggregate: Uogorod_Users_Seed_Actions_Aggregate;
  /** fetch data from the table: "uogorod.users_seed_actions" using primary key columns */
  uogorod_users_seed_actions_by_pk?: Maybe<Uogorod_Users_Seed_Actions>;
  /** fetch data from the table in a streaming manner: "uogorod.users_seed_actions" */
  uogorod_users_seed_actions_stream: Array<Uogorod_Users_Seed_Actions>;
  /** fetch data from the table in a streaming manner: "uogorod.users" */
  uogorod_users_stream: Array<Uogorod_Users>;
  /** fetch data from the table: "uogorod.view_manual" */
  uogorod_view_manual: Array<Uogorod_View_Manual>;
  /** fetch aggregated fields from the table: "uogorod.view_manual" */
  uogorod_view_manual_aggregate: Uogorod_View_Manual_Aggregate;
  /** fetch data from the table in a streaming manner: "uogorod.view_manual" */
  uogorod_view_manual_stream: Array<Uogorod_View_Manual>;
};


export type Subscription_RootAnimeArgs = {
  distinct_on?: InputMaybe<Array<Anime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Order_By>>;
  where?: InputMaybe<Anime_Bool_Exp>;
};


export type Subscription_RootAnime_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anime_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Order_By>>;
  where?: InputMaybe<Anime_Bool_Exp>;
};


export type Subscription_RootAnime_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAnime_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anime_Stream_Cursor_Input>>;
  where?: InputMaybe<Anime_Bool_Exp>;
};


export type Subscription_RootGenreArgs = {
  distinct_on?: InputMaybe<Array<Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genre_Order_By>>;
  where?: InputMaybe<Genre_Bool_Exp>;
};


export type Subscription_RootGenre_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Genre_Order_By>>;
  where?: InputMaybe<Genre_Bool_Exp>;
};


export type Subscription_RootGenre_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGenre_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Genre_Stream_Cursor_Input>>;
  where?: InputMaybe<Genre_Bool_Exp>;
};


export type Subscription_RootVideoArgs = {
  distinct_on?: InputMaybe<Array<Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Order_By>>;
  where?: InputMaybe<Video_Bool_Exp>;
};


export type Subscription_RootVideo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Video_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Video_Order_By>>;
  where?: InputMaybe<Video_Bool_Exp>;
};


export type Subscription_RootVideo_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVideo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Video_Stream_Cursor_Input>>;
  where?: InputMaybe<Video_Bool_Exp>;
};


export type Subscription_RootAnime_GenreArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


export type Subscription_RootAnime_Genre_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Anime_Genre_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Anime_Genre_Order_By>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


export type Subscription_RootAnime_Genre_By_PkArgs = {
  anime_id: Scalars['Int']['input'];
  genre_id: Scalars['Int']['input'];
};


export type Subscription_RootAnime_Genre_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Anime_Genre_Stream_Cursor_Input>>;
  where?: InputMaybe<Anime_Genre_Bool_Exp>;
};


export type Subscription_RootDialogsArgs = {
  args: Dialogs_Arguments;
  distinct_on?: InputMaybe<Array<Dialog_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dialog_Order_By>>;
  where?: InputMaybe<Dialog_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootPostsArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Posts_Order_By>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPosts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPosts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Posts_Bool_Exp>;
};


export type Subscription_RootPricesArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootPrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prices_Order_By>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootPrices_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPrices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prices_Stream_Cursor_Input>>;
  where?: InputMaybe<Prices_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootUogorod_AchivmentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_Achivments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_Achivments_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Achivments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Achivments_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_Brands_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Brands_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Brands_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Brands_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Brands_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Brands_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Brands_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_Comments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Emails_Order_By>>;
  where?: InputMaybe<Uogorod_Emails_Bool_Exp>;
};


export type Subscription_RootUogorod_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Emails_Order_By>>;
  where?: InputMaybe<Uogorod_Emails_Bool_Exp>;
};


export type Subscription_RootUogorod_Emails_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Emails_Bool_Exp>;
};


export type Subscription_RootUogorod_ExperimentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Experiments_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Experiments_Seeds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Experiments_Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_StepsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Steps_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Steps_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Steps_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Experiments_Steps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Experiments_Steps_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Experiments_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Views_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Experiments_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Experiments_Views_Order_By>>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};


export type Subscription_RootUogorod_Experiments_Views_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Experiments_Views_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Experiments_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_BedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Beds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Beds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Garden_Beds_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Beds_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Beds_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Garden_Beds_Seeds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Garden_Beds_Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Beds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Garden_Beds_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_SeasonsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Seasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Seasons_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Garden_Seasons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Garden_Seasons_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Garden_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Garden_Seeds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Garden_Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_GardensArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


export type Subscription_RootUogorod_Gardens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


export type Subscription_RootUogorod_Gardens_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUogorod_Gardens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Gardens_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_CityArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_City_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_City_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Geo_City_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Geo_City_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_CountryArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Country_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_Country_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Country_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_Country_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Geo_Country_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Geo_Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_RegionArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


export type Subscription_RootUogorod_Geo_Region_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Geo_Region_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Geo_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


export type Subscription_RootUogorod_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Groups_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Category_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Category_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_Category_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Groups_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Groups_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Groups_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Groups_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Groups_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Groups_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Groups_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_LikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_Likes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Likes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_ManualArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};


export type Subscription_RootUogorod_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};


export type Subscription_RootUogorod_Manual_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Manual_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Manual_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};


export type Subscription_RootUogorod_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


export type Subscription_RootUogorod_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


export type Subscription_RootUogorod_Messages_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUogorod_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


export type Subscription_RootUogorod_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Notifications_Order_By>>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};


export type Subscription_RootUogorod_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Notifications_Order_By>>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};


export type Subscription_RootUogorod_Notifications_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Notifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};


export type Subscription_RootUogorod_OnboardingArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Onboarding_Order_By>>;
  where?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
};


export type Subscription_RootUogorod_Onboarding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Onboarding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Onboarding_Order_By>>;
  where?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
};


export type Subscription_RootUogorod_Onboarding_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Onboarding_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
};


export type Subscription_RootUogorod_PagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Pages_Order_By>>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};


export type Subscription_RootUogorod_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Pages_Order_By>>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};


export type Subscription_RootUogorod_Pages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Pages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Pages_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};


export type Subscription_RootUogorod_PostsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_Posts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Posts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reports_Order_By>>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};


export type Subscription_RootUogorod_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reports_Order_By>>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};


export type Subscription_RootUogorod_Reports_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};


export type Subscription_RootUogorod_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


export type Subscription_RootUogorod_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


export type Subscription_RootUogorod_Reviews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Categories_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUogorod_Seed_Categories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seed_Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Params_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Params_By_PkArgs = {
  name: Scalars['String']['input'];
  seed_id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seed_Params_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seed_Params_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_SimilarArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Similar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Similar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seed_Similar_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seed_Similar_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_SpecsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Specs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Specs_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Specs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Specs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Specs_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Specs_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Seed_Specs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seed_Specs_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_VotesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Votes_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Votes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Votes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Votes_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};


export type Subscription_RootUogorod_Seed_Votes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seed_Votes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seed_Votes_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};


export type Subscription_RootUogorod_SeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Brands_By_PkArgs = {
  brand_id: Scalars['bigint']['input'];
  seed_id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seeds_Brands_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seeds_Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seeds_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Images_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seeds_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seeds_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_Records_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Seeds_Records_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seeds_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


export type Subscription_RootUogorod_Seeds_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Seeds_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


export type Subscription_RootUogorod_SubscribesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


export type Subscription_RootUogorod_Subscribes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


export type Subscription_RootUogorod_Subscribes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Subscribes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Subscribes_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


export type Subscription_RootUogorod_Top_ReviewersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Top_Reviewers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Top_Reviewers_Order_By>>;
  where?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
};


export type Subscription_RootUogorod_Top_Reviewers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Top_Reviewers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Top_Reviewers_Order_By>>;
  where?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
};


export type Subscription_RootUogorod_Top_Reviewers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Top_Reviewers_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Comments_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Contacts_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_LikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Likes_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Likes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_PostsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Posts_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Posts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Posts_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seed_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seed_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seed_Actions_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Seed_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Seed_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seeds_StatusArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seeds_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Seeds_Status_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Seeds_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Seeds_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Type_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Type_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Type_Users_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootUogorod_Type_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Type_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_User_AchivmentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_User_Achivments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_User_Achivments_By_PkArgs = {
  achivment_id: Scalars['String']['input'];
  user_id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_User_Achivments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_User_Achivments_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


export type Subscription_RootUogorod_User_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_User_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_User_Contacts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_User_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_User_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


export type Subscription_RootUogorod_UsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Users_CalendarArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Calendar_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Calendar_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Calendar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Calendar_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Calendar_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Users_Calendar_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Users_Calendar_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Not_ActivatedArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Not_Activated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Not_Activated_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Not_Activated_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Not_Activated_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Not_Activated_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Not_Activated_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Users_Not_Activated_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Seed_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Seed_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_Seed_Actions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUogorod_Users_Seed_Actions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Users_Seed_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


export type Subscription_RootUogorod_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


export type Subscription_RootUogorod_View_ManualArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_View_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_View_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
};


export type Subscription_RootUogorod_View_Manual_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_View_Manual_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_View_Manual_Order_By>>;
  where?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
};


export type Subscription_RootUogorod_View_Manual_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uogorod_View_Manual_Stream_Cursor_Input>>;
  where?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Обновленные достижения */
export type Uogorod_Achivments = {
  __typename?: 'uogorod_achivments';
  description: Scalars['String']['output'];
  has_level: Scalars['Boolean']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.achivments" */
export type Uogorod_Achivments_Aggregate = {
  __typename?: 'uogorod_achivments_aggregate';
  aggregate?: Maybe<Uogorod_Achivments_Aggregate_Fields>;
  nodes: Array<Uogorod_Achivments>;
};

/** aggregate fields of "uogorod.achivments" */
export type Uogorod_Achivments_Aggregate_Fields = {
  __typename?: 'uogorod_achivments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Achivments_Max_Fields>;
  min?: Maybe<Uogorod_Achivments_Min_Fields>;
};


/** aggregate fields of "uogorod.achivments" */
export type Uogorod_Achivments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Achivments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.achivments". All fields are combined with a logical 'AND'. */
export type Uogorod_Achivments_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Achivments_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Achivments_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_level?: InputMaybe<Boolean_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.achivments" */
export enum Uogorod_Achivments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AchivmentsPkey = 'achivments_pkey'
}

/** input type for inserting data into table "uogorod.achivments" */
export type Uogorod_Achivments_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_level?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Achivments_Max_Fields = {
  __typename?: 'uogorod_achivments_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Achivments_Min_Fields = {
  __typename?: 'uogorod_achivments_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.achivments" */
export type Uogorod_Achivments_Mutation_Response = {
  __typename?: 'uogorod_achivments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Achivments>;
};

/** input type for inserting object relation for remote table "uogorod.achivments" */
export type Uogorod_Achivments_Obj_Rel_Insert_Input = {
  data: Uogorod_Achivments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Achivments_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.achivments" */
export type Uogorod_Achivments_On_Conflict = {
  constraint: Uogorod_Achivments_Constraint;
  update_columns?: Array<Uogorod_Achivments_Update_Column>;
  where?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.achivments". */
export type Uogorod_Achivments_Order_By = {
  description?: InputMaybe<Order_By>;
  has_level?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.achivments */
export type Uogorod_Achivments_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "uogorod.achivments" */
export enum Uogorod_Achivments_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  HasLevel = 'has_level',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "uogorod.achivments" */
export type Uogorod_Achivments_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_level?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_achivments" */
export type Uogorod_Achivments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Achivments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Achivments_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  has_level?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.achivments" */
export enum Uogorod_Achivments_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  HasLevel = 'has_level',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Uogorod_Achivments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Achivments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Achivments_Bool_Exp;
};

/** Производители */
export type Uogorod_Brands = {
  __typename?: 'uogorod_brands';
  /** An object relationship */
  author?: Maybe<Uogorod_Users>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  contacts: Array<Uogorod_Brands_Contacts>;
  /** An aggregate relationship */
  contacts_aggregate: Uogorod_Brands_Contacts_Aggregate;
  /** An object relationship */
  country?: Maybe<Uogorod_Geo_Country>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  foundation?: Maybe<Scalars['Int']['output']>;
  id: Scalars['bigint']['output'];
  image?: Maybe<Scalars['uuid']['output']>;
  rate: Scalars['numeric']['output'];
  /** An array relationship */
  reviews: Array<Uogorod_Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Uogorod_Reviews_Aggregate;
  /** An array relationship */
  seeds: Array<Uogorod_Seeds_Brands>;
  /** An aggregate relationship */
  seeds_aggregate: Uogorod_Seeds_Brands_Aggregate;
  status: Scalars['String']['output'];
  synonyms?: Maybe<Scalars['jsonb']['output']>;
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};


/** Производители */
export type Uogorod_BrandsContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Brands_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsReviewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsSeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


/** Производители */
export type Uogorod_BrandsSynonymsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.brands" */
export type Uogorod_Brands_Aggregate = {
  __typename?: 'uogorod_brands_aggregate';
  aggregate?: Maybe<Uogorod_Brands_Aggregate_Fields>;
  nodes: Array<Uogorod_Brands>;
};

/** aggregate fields of "uogorod.brands" */
export type Uogorod_Brands_Aggregate_Fields = {
  __typename?: 'uogorod_brands_aggregate_fields';
  avg?: Maybe<Uogorod_Brands_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Brands_Max_Fields>;
  min?: Maybe<Uogorod_Brands_Min_Fields>;
  stddev?: Maybe<Uogorod_Brands_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Brands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Brands_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Brands_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Brands_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Brands_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Brands_Variance_Fields>;
};


/** aggregate fields of "uogorod.brands" */
export type Uogorod_Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Brands_Append_Input = {
  synonyms?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Brands_Avg_Fields = {
  __typename?: 'uogorod_brands_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.brands". All fields are combined with a logical 'AND'. */
export type Uogorod_Brands_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Brands_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Brands_Bool_Exp>>;
  author?: InputMaybe<Uogorod_Users_Bool_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  contacts?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Uogorod_Brands_Contacts_Aggregate_Bool_Exp>;
  country?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
  country_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  foundation?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<Uuid_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  reviews?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Uogorod_Reviews_Aggregate_Bool_Exp>;
  seeds?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
  seeds_aggregate?: InputMaybe<Uogorod_Seeds_Brands_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  synonyms?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.brands" */
export enum Uogorod_Brands_Constraint {
  /** unique or primary key constraint on columns "image" */
  BrandsImageKey = 'brands_image_key',
  /** unique or primary key constraint on columns "id" */
  BrandsPkey = 'brands_pkey'
}

/** Контакты производителей (каскадное удаление) */
export type Uogorod_Brands_Contacts = {
  __typename?: 'uogorod_brands_contacts';
  brand_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Aggregate = {
  __typename?: 'uogorod_brands_contacts_aggregate';
  aggregate?: Maybe<Uogorod_Brands_Contacts_Aggregate_Fields>;
  nodes: Array<Uogorod_Brands_Contacts>;
};

export type Uogorod_Brands_Contacts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Brands_Contacts_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Brands_Contacts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Aggregate_Fields = {
  __typename?: 'uogorod_brands_contacts_aggregate_fields';
  avg?: Maybe<Uogorod_Brands_Contacts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Brands_Contacts_Max_Fields>;
  min?: Maybe<Uogorod_Brands_Contacts_Min_Fields>;
  stddev?: Maybe<Uogorod_Brands_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Brands_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Brands_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Brands_Contacts_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Brands_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Brands_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Brands_Contacts_Variance_Fields>;
};


/** aggregate fields of "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Brands_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Brands_Contacts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Brands_Contacts_Max_Order_By>;
  min?: InputMaybe<Uogorod_Brands_Contacts_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Brands_Contacts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Brands_Contacts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Brands_Contacts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Brands_Contacts_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Brands_Contacts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Brands_Contacts_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Brands_Contacts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Brands_Contacts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Brands_Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Brands_Contacts_Avg_Fields = {
  __typename?: 'uogorod_brands_contacts_avg_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.brands_contacts". All fields are combined with a logical 'AND'. */
export type Uogorod_Brands_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Brands_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Brands_Contacts_Bool_Exp>>;
  brand_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.brands_contacts" */
export enum Uogorod_Brands_Contacts_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandsContactsPkey = 'brands_contacts_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Inc_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Insert_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Brands_Contacts_Max_Fields = {
  __typename?: 'uogorod_brands_contacts_max_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Brands_Contacts_Min_Fields = {
  __typename?: 'uogorod_brands_contacts_min_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Mutation_Response = {
  __typename?: 'uogorod_brands_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Brands_Contacts>;
};

/** on_conflict condition type for table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_On_Conflict = {
  constraint: Uogorod_Brands_Contacts_Constraint;
  update_columns?: Array<Uogorod_Brands_Contacts_Update_Column>;
  where?: InputMaybe<Uogorod_Brands_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.brands_contacts". */
export type Uogorod_Brands_Contacts_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.brands_contacts */
export type Uogorod_Brands_Contacts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.brands_contacts" */
export enum Uogorod_Brands_Contacts_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Set_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Brands_Contacts_Stddev_Fields = {
  __typename?: 'uogorod_brands_contacts_stddev_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Brands_Contacts_Stddev_Pop_Fields = {
  __typename?: 'uogorod_brands_contacts_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Brands_Contacts_Stddev_Samp_Fields = {
  __typename?: 'uogorod_brands_contacts_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_brands_contacts" */
export type Uogorod_Brands_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Brands_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Brands_Contacts_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Brands_Contacts_Sum_Fields = {
  __typename?: 'uogorod_brands_contacts_sum_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.brands_contacts" */
export enum Uogorod_Brands_Contacts_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  Value = 'value'
}

export type Uogorod_Brands_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Brands_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Brands_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Brands_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Brands_Contacts_Var_Pop_Fields = {
  __typename?: 'uogorod_brands_contacts_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Brands_Contacts_Var_Samp_Fields = {
  __typename?: 'uogorod_brands_contacts_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Brands_Contacts_Variance_Fields = {
  __typename?: 'uogorod_brands_contacts_variance_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.brands_contacts" */
export type Uogorod_Brands_Contacts_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Brands_Delete_At_Path_Input = {
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Brands_Delete_Elem_Input = {
  synonyms?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Brands_Delete_Key_Input = {
  synonyms?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.brands" */
export type Uogorod_Brands_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  foundation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.brands" */
export type Uogorod_Brands_Insert_Input = {
  author?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  contacts?: InputMaybe<Uogorod_Brands_Contacts_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Uogorod_Geo_Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  reviews?: InputMaybe<Uogorod_Reviews_Arr_Rel_Insert_Input>;
  seeds?: InputMaybe<Uogorod_Seeds_Brands_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Brands_Max_Fields = {
  __typename?: 'uogorod_brands_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  foundation?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Brands_Min_Fields = {
  __typename?: 'uogorod_brands_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  foundation?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['uuid']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "uogorod.brands" */
export type Uogorod_Brands_Mutation_Response = {
  __typename?: 'uogorod_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Brands>;
};

/** input type for inserting object relation for remote table "uogorod.brands" */
export type Uogorod_Brands_Obj_Rel_Insert_Input = {
  data: Uogorod_Brands_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Brands_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.brands" */
export type Uogorod_Brands_On_Conflict = {
  constraint: Uogorod_Brands_Constraint;
  update_columns?: Array<Uogorod_Brands_Update_Column>;
  where?: InputMaybe<Uogorod_Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.brands". */
export type Uogorod_Brands_Order_By = {
  author?: InputMaybe<Uogorod_Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Uogorod_Brands_Contacts_Aggregate_Order_By>;
  country?: InputMaybe<Uogorod_Geo_Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  foundation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Uogorod_Reviews_Aggregate_Order_By>;
  seeds_aggregate?: InputMaybe<Uogorod_Seeds_Brands_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  synonyms?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.brands */
export type Uogorod_Brands_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Brands_Prepend_Input = {
  synonyms?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.brands" */
export enum Uogorod_Brands_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Foundation = 'foundation',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Rate = 'rate',
  /** column name */
  Status = 'status',
  /** column name */
  Synonyms = 'synonyms',
  /** column name */
  Title = 'title',
  /** column name */
  Views = 'views'
}

/** input type for updating data in table "uogorod.brands" */
export type Uogorod_Brands_Set_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Brands_Stddev_Fields = {
  __typename?: 'uogorod_brands_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Brands_Stddev_Pop_Fields = {
  __typename?: 'uogorod_brands_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Brands_Stddev_Samp_Fields = {
  __typename?: 'uogorod_brands_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_brands" */
export type Uogorod_Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Brands_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['uuid']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  synonyms?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Brands_Sum_Fields = {
  __typename?: 'uogorod_brands_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  foundation?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "uogorod.brands" */
export enum Uogorod_Brands_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Foundation = 'foundation',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Rate = 'rate',
  /** column name */
  Status = 'status',
  /** column name */
  Synonyms = 'synonyms',
  /** column name */
  Title = 'title',
  /** column name */
  Views = 'views'
}

export type Uogorod_Brands_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Brands_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Brands_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Brands_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Brands_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Brands_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Brands_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Brands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Brands_Var_Pop_Fields = {
  __typename?: 'uogorod_brands_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Brands_Var_Samp_Fields = {
  __typename?: 'uogorod_brands_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Brands_Variance_Fields = {
  __typename?: 'uogorod_brands_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  foundation?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.comments" */
export type Uogorod_Comments = {
  __typename?: 'uogorod_comments';
  /** An object relationship */
  author?: Maybe<Uogorod_Users>;
  created_at: Scalars['timestamptz']['output'];
  entity_id: Scalars['bigint']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  likes: Array<Uogorod_Likes>;
  /** An aggregate relationship */
  likes_aggregate: Uogorod_Likes_Aggregate;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  text: Scalars['String']['output'];
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.comments" */
export type Uogorod_CommentsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};


/** columns and relationships of "uogorod.comments" */
export type Uogorod_CommentsLikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


/** columns and relationships of "uogorod.comments" */
export type Uogorod_CommentsLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};

/** aggregated selection of "uogorod.comments" */
export type Uogorod_Comments_Aggregate = {
  __typename?: 'uogorod_comments_aggregate';
  aggregate?: Maybe<Uogorod_Comments_Aggregate_Fields>;
  nodes: Array<Uogorod_Comments>;
};

export type Uogorod_Comments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Comments_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Comments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Comments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.comments" */
export type Uogorod_Comments_Aggregate_Fields = {
  __typename?: 'uogorod_comments_aggregate_fields';
  avg?: Maybe<Uogorod_Comments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Comments_Max_Fields>;
  min?: Maybe<Uogorod_Comments_Min_Fields>;
  stddev?: Maybe<Uogorod_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Comments_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Comments_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Comments_Variance_Fields>;
};


/** aggregate fields of "uogorod.comments" */
export type Uogorod_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.comments" */
export type Uogorod_Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Comments_Max_Order_By>;
  min?: InputMaybe<Uogorod_Comments_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Comments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.comments" */
export type Uogorod_Comments_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Comments_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Comments_Avg_Fields = {
  __typename?: 'uogorod_comments_avg_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate avg on columns */
export type Uogorod_Comments_Avg_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by avg() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Avg_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.comments". All fields are combined with a logical 'AND'. */
export type Uogorod_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Comments_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Comments_Bool_Exp>>;
  author?: InputMaybe<Uogorod_Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  likes?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Bool_Exp>;
  parent_id?: InputMaybe<Bigint_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.comments" */
export enum Uogorod_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19068Primary = 'idx_19068_primary'
}

/** input type for incrementing numeric columns in table "uogorod.comments" */
export type Uogorod_Comments_Inc_Input = {
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.comments" */
export type Uogorod_Comments_Insert_Input = {
  author?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  likes?: InputMaybe<Uogorod_Likes_Arr_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Comments_Max_Fields = {
  __typename?: 'uogorod_comments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate max on columns */
export type Uogorod_Comments_Max_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by max() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Comments_Min_Fields = {
  __typename?: 'uogorod_comments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate min on columns */
export type Uogorod_Comments_Min_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by min() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.comments" */
export type Uogorod_Comments_Mutation_Response = {
  __typename?: 'uogorod_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Comments>;
};

/** on_conflict condition type for table "uogorod.comments" */
export type Uogorod_Comments_On_Conflict = {
  constraint: Uogorod_Comments_Constraint;
  update_columns?: Array<Uogorod_Comments_Update_Column>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.comments". */
export type Uogorod_Comments_Order_By = {
  author?: InputMaybe<Uogorod_Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.comments */
export type Uogorod_Comments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.comments" */
export enum Uogorod_Comments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.comments" */
export type Uogorod_Comments_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Comments_Stddev_Fields = {
  __typename?: 'uogorod_comments_stddev_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev on columns */
export type Uogorod_Comments_Stddev_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by stddev() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Stddev_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Comments_Stddev_Pop_Fields = {
  __typename?: 'uogorod_comments_stddev_pop_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_pop on columns */
export type Uogorod_Comments_Stddev_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by stddev_pop() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Stddev_Pop_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Comments_Stddev_Samp_Fields = {
  __typename?: 'uogorod_comments_stddev_samp_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_samp on columns */
export type Uogorod_Comments_Stddev_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by stddev_samp() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Stddev_Samp_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_comments" */
export type Uogorod_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Comments_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Comments_Sum_Fields = {
  __typename?: 'uogorod_comments_sum_fields';
  entity_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate sum on columns */
export type Uogorod_Comments_Sum_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by sum() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Sum_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.comments" */
export enum Uogorod_Comments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Comments_Var_Pop_Fields = {
  __typename?: 'uogorod_comments_var_pop_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_pop on columns */
export type Uogorod_Comments_Var_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by var_pop() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Var_Pop_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Comments_Var_Samp_Fields = {
  __typename?: 'uogorod_comments_var_samp_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_samp on columns */
export type Uogorod_Comments_Var_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by var_samp() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Var_Samp_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Comments_Variance_Fields = {
  __typename?: 'uogorod_comments_variance_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.comments_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate variance on columns */
export type Uogorod_Comments_Variance_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Comments_Args;
};

/** order by variance() on columns of table "uogorod.comments" */
export type Uogorod_Comments_Variance_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.emails" */
export type Uogorod_Emails = {
  __typename?: 'uogorod_emails';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "uogorod.emails" */
export type Uogorod_Emails_Aggregate = {
  __typename?: 'uogorod_emails_aggregate';
  aggregate?: Maybe<Uogorod_Emails_Aggregate_Fields>;
  nodes: Array<Uogorod_Emails>;
};

/** aggregate fields of "uogorod.emails" */
export type Uogorod_Emails_Aggregate_Fields = {
  __typename?: 'uogorod_emails_aggregate_fields';
  avg?: Maybe<Uogorod_Emails_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Emails_Max_Fields>;
  min?: Maybe<Uogorod_Emails_Min_Fields>;
  stddev?: Maybe<Uogorod_Emails_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Emails_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Emails_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Emails_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Emails_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Emails_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Emails_Variance_Fields>;
};


/** aggregate fields of "uogorod.emails" */
export type Uogorod_Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Emails_Avg_Fields = {
  __typename?: 'uogorod_emails_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.emails". All fields are combined with a logical 'AND'. */
export type Uogorod_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Emails_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Emails_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "uogorod.emails" */
export type Uogorod_Emails_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.emails" */
export type Uogorod_Emails_Insert_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Emails_Max_Fields = {
  __typename?: 'uogorod_emails_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Emails_Min_Fields = {
  __typename?: 'uogorod_emails_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.emails" */
export type Uogorod_Emails_Mutation_Response = {
  __typename?: 'uogorod_emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Emails>;
};

/** input type for inserting object relation for remote table "uogorod.emails" */
export type Uogorod_Emails_Obj_Rel_Insert_Input = {
  data: Uogorod_Emails_Insert_Input;
};

/** Ordering options when selecting data from "uogorod.emails". */
export type Uogorod_Emails_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.emails" */
export enum Uogorod_Emails_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "uogorod.emails" */
export type Uogorod_Emails_Set_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Emails_Stddev_Fields = {
  __typename?: 'uogorod_emails_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Emails_Stddev_Pop_Fields = {
  __typename?: 'uogorod_emails_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Emails_Stddev_Samp_Fields = {
  __typename?: 'uogorod_emails_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_emails" */
export type Uogorod_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Emails_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Emails_Sum_Fields = {
  __typename?: 'uogorod_emails_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

export type Uogorod_Emails_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Emails_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Emails_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Emails_Var_Pop_Fields = {
  __typename?: 'uogorod_emails_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Emails_Var_Samp_Fields = {
  __typename?: 'uogorod_emails_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Emails_Variance_Fields = {
  __typename?: 'uogorod_emails_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.experiments" */
export type Uogorod_Experiments = {
  __typename?: 'uogorod_experiments';
  closed: Scalars['bigint']['output'];
  created_at: Scalars['time']['output'];
  id: Scalars['bigint']['output'];
  image_id: Scalars['bigint']['output'];
  privatnost: Scalars['bigint']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  views: Scalars['bigint']['output'];
  vivod: Scalars['String']['output'];
  vivod_images: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.experiments" */
export type Uogorod_Experiments_Aggregate = {
  __typename?: 'uogorod_experiments_aggregate';
  aggregate?: Maybe<Uogorod_Experiments_Aggregate_Fields>;
  nodes: Array<Uogorod_Experiments>;
};

/** aggregate fields of "uogorod.experiments" */
export type Uogorod_Experiments_Aggregate_Fields = {
  __typename?: 'uogorod_experiments_aggregate_fields';
  avg?: Maybe<Uogorod_Experiments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Experiments_Max_Fields>;
  min?: Maybe<Uogorod_Experiments_Min_Fields>;
  stddev?: Maybe<Uogorod_Experiments_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Experiments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Experiments_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Experiments_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Experiments_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Experiments_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Experiments_Variance_Fields>;
};


/** aggregate fields of "uogorod.experiments" */
export type Uogorod_Experiments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Experiments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Experiments_Avg_Fields = {
  __typename?: 'uogorod_experiments_avg_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.experiments". All fields are combined with a logical 'AND'. */
export type Uogorod_Experiments_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Experiments_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Experiments_Bool_Exp>>;
  closed?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image_id?: InputMaybe<Bigint_Comparison_Exp>;
  privatnost?: InputMaybe<Bigint_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  views?: InputMaybe<Bigint_Comparison_Exp>;
  vivod?: InputMaybe<String_Comparison_Exp>;
  vivod_images?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.experiments" */
export enum Uogorod_Experiments_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18860Primary = 'idx_18860_primary'
}

/** input type for incrementing numeric columns in table "uogorod.experiments" */
export type Uogorod_Experiments_Inc_Input = {
  closed?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_id?: InputMaybe<Scalars['bigint']['input']>;
  privatnost?: InputMaybe<Scalars['bigint']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.experiments" */
export type Uogorod_Experiments_Insert_Input = {
  closed?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_id?: InputMaybe<Scalars['bigint']['input']>;
  privatnost?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
  vivod?: InputMaybe<Scalars['String']['input']>;
  vivod_images?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Experiments_Max_Fields = {
  __typename?: 'uogorod_experiments_max_fields';
  closed?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image_id?: Maybe<Scalars['bigint']['output']>;
  privatnost?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
  vivod?: Maybe<Scalars['String']['output']>;
  vivod_images?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Experiments_Min_Fields = {
  __typename?: 'uogorod_experiments_min_fields';
  closed?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image_id?: Maybe<Scalars['bigint']['output']>;
  privatnost?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
  vivod?: Maybe<Scalars['String']['output']>;
  vivod_images?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.experiments" */
export type Uogorod_Experiments_Mutation_Response = {
  __typename?: 'uogorod_experiments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Experiments>;
};

/** on_conflict condition type for table "uogorod.experiments" */
export type Uogorod_Experiments_On_Conflict = {
  constraint: Uogorod_Experiments_Constraint;
  update_columns?: Array<Uogorod_Experiments_Update_Column>;
  where?: InputMaybe<Uogorod_Experiments_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.experiments". */
export type Uogorod_Experiments_Order_By = {
  closed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  privatnost?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
  vivod?: InputMaybe<Order_By>;
  vivod_images?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.experiments */
export type Uogorod_Experiments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds = {
  __typename?: 'uogorod_experiments_seeds';
  experiment_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  seed_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Aggregate = {
  __typename?: 'uogorod_experiments_seeds_aggregate';
  aggregate?: Maybe<Uogorod_Experiments_Seeds_Aggregate_Fields>;
  nodes: Array<Uogorod_Experiments_Seeds>;
};

/** aggregate fields of "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Aggregate_Fields = {
  __typename?: 'uogorod_experiments_seeds_aggregate_fields';
  avg?: Maybe<Uogorod_Experiments_Seeds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Experiments_Seeds_Max_Fields>;
  min?: Maybe<Uogorod_Experiments_Seeds_Min_Fields>;
  stddev?: Maybe<Uogorod_Experiments_Seeds_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Experiments_Seeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Experiments_Seeds_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Experiments_Seeds_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Experiments_Seeds_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Experiments_Seeds_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Experiments_Seeds_Variance_Fields>;
};


/** aggregate fields of "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Experiments_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Experiments_Seeds_Avg_Fields = {
  __typename?: 'uogorod_experiments_seeds_avg_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.experiments_seeds". All fields are combined with a logical 'AND'. */
export type Uogorod_Experiments_Seeds_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Experiments_Seeds_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Experiments_Seeds_Bool_Exp>>;
  experiment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.experiments_seeds" */
export enum Uogorod_Experiments_Seeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18868Primary = 'idx_18868_primary'
}

/** input type for incrementing numeric columns in table "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Inc_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Insert_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Experiments_Seeds_Max_Fields = {
  __typename?: 'uogorod_experiments_seeds_max_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Experiments_Seeds_Min_Fields = {
  __typename?: 'uogorod_experiments_seeds_min_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Mutation_Response = {
  __typename?: 'uogorod_experiments_seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Experiments_Seeds>;
};

/** on_conflict condition type for table "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_On_Conflict = {
  constraint: Uogorod_Experiments_Seeds_Constraint;
  update_columns?: Array<Uogorod_Experiments_Seeds_Update_Column>;
  where?: InputMaybe<Uogorod_Experiments_Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.experiments_seeds". */
export type Uogorod_Experiments_Seeds_Order_By = {
  experiment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.experiments_seeds */
export type Uogorod_Experiments_Seeds_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.experiments_seeds" */
export enum Uogorod_Experiments_Seeds_Select_Column {
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id'
}

/** input type for updating data in table "uogorod.experiments_seeds" */
export type Uogorod_Experiments_Seeds_Set_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Experiments_Seeds_Stddev_Fields = {
  __typename?: 'uogorod_experiments_seeds_stddev_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Experiments_Seeds_Stddev_Pop_Fields = {
  __typename?: 'uogorod_experiments_seeds_stddev_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Experiments_Seeds_Stddev_Samp_Fields = {
  __typename?: 'uogorod_experiments_seeds_stddev_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_experiments_seeds" */
export type Uogorod_Experiments_Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Experiments_Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Experiments_Seeds_Stream_Cursor_Value_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Experiments_Seeds_Sum_Fields = {
  __typename?: 'uogorod_experiments_seeds_sum_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.experiments_seeds" */
export enum Uogorod_Experiments_Seeds_Update_Column {
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id'
}

export type Uogorod_Experiments_Seeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Experiments_Seeds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Experiments_Seeds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Experiments_Seeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Experiments_Seeds_Var_Pop_Fields = {
  __typename?: 'uogorod_experiments_seeds_var_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Experiments_Seeds_Var_Samp_Fields = {
  __typename?: 'uogorod_experiments_seeds_var_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Experiments_Seeds_Variance_Fields = {
  __typename?: 'uogorod_experiments_seeds_variance_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "uogorod.experiments" */
export enum Uogorod_Experiments_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Privatnost = 'privatnost',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views',
  /** column name */
  Vivod = 'vivod',
  /** column name */
  VivodImages = 'vivod_images'
}

/** input type for updating data in table "uogorod.experiments" */
export type Uogorod_Experiments_Set_Input = {
  closed?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_id?: InputMaybe<Scalars['bigint']['input']>;
  privatnost?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
  vivod?: InputMaybe<Scalars['String']['input']>;
  vivod_images?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Experiments_Stddev_Fields = {
  __typename?: 'uogorod_experiments_stddev_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Experiments_Stddev_Pop_Fields = {
  __typename?: 'uogorod_experiments_stddev_pop_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Experiments_Stddev_Samp_Fields = {
  __typename?: 'uogorod_experiments_stddev_samp_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps = {
  __typename?: 'uogorod_experiments_steps';
  date: Scalars['date']['output'];
  experiment_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  images_id: Scalars['String']['output'];
  step: Scalars['bigint']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Aggregate = {
  __typename?: 'uogorod_experiments_steps_aggregate';
  aggregate?: Maybe<Uogorod_Experiments_Steps_Aggregate_Fields>;
  nodes: Array<Uogorod_Experiments_Steps>;
};

/** aggregate fields of "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Aggregate_Fields = {
  __typename?: 'uogorod_experiments_steps_aggregate_fields';
  avg?: Maybe<Uogorod_Experiments_Steps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Experiments_Steps_Max_Fields>;
  min?: Maybe<Uogorod_Experiments_Steps_Min_Fields>;
  stddev?: Maybe<Uogorod_Experiments_Steps_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Experiments_Steps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Experiments_Steps_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Experiments_Steps_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Experiments_Steps_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Experiments_Steps_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Experiments_Steps_Variance_Fields>;
};


/** aggregate fields of "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Experiments_Steps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Experiments_Steps_Avg_Fields = {
  __typename?: 'uogorod_experiments_steps_avg_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.experiments_steps". All fields are combined with a logical 'AND'. */
export type Uogorod_Experiments_Steps_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Experiments_Steps_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Experiments_Steps_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  experiment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images_id?: InputMaybe<String_Comparison_Exp>;
  step?: InputMaybe<Bigint_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.experiments_steps" */
export enum Uogorod_Experiments_Steps_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18873Primary = 'idx_18873_primary'
}

/** input type for incrementing numeric columns in table "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Inc_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  step?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Insert_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images_id?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Experiments_Steps_Max_Fields = {
  __typename?: 'uogorod_experiments_steps_max_fields';
  date?: Maybe<Scalars['date']['output']>;
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  images_id?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Experiments_Steps_Min_Fields = {
  __typename?: 'uogorod_experiments_steps_min_fields';
  date?: Maybe<Scalars['date']['output']>;
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  images_id?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Mutation_Response = {
  __typename?: 'uogorod_experiments_steps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Experiments_Steps>;
};

/** on_conflict condition type for table "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_On_Conflict = {
  constraint: Uogorod_Experiments_Steps_Constraint;
  update_columns?: Array<Uogorod_Experiments_Steps_Update_Column>;
  where?: InputMaybe<Uogorod_Experiments_Steps_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.experiments_steps". */
export type Uogorod_Experiments_Steps_Order_By = {
  date?: InputMaybe<Order_By>;
  experiment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_id?: InputMaybe<Order_By>;
  step?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.experiments_steps */
export type Uogorod_Experiments_Steps_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.experiments_steps" */
export enum Uogorod_Experiments_Steps_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImagesId = 'images_id',
  /** column name */
  Step = 'step',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "uogorod.experiments_steps" */
export type Uogorod_Experiments_Steps_Set_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images_id?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Experiments_Steps_Stddev_Fields = {
  __typename?: 'uogorod_experiments_steps_stddev_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Experiments_Steps_Stddev_Pop_Fields = {
  __typename?: 'uogorod_experiments_steps_stddev_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Experiments_Steps_Stddev_Samp_Fields = {
  __typename?: 'uogorod_experiments_steps_stddev_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_experiments_steps" */
export type Uogorod_Experiments_Steps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Experiments_Steps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Experiments_Steps_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images_id?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Experiments_Steps_Sum_Fields = {
  __typename?: 'uogorod_experiments_steps_sum_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  step?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.experiments_steps" */
export enum Uogorod_Experiments_Steps_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImagesId = 'images_id',
  /** column name */
  Step = 'step',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title'
}

export type Uogorod_Experiments_Steps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Experiments_Steps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Experiments_Steps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Experiments_Steps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Experiments_Steps_Var_Pop_Fields = {
  __typename?: 'uogorod_experiments_steps_var_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Experiments_Steps_Var_Samp_Fields = {
  __typename?: 'uogorod_experiments_steps_var_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Experiments_Steps_Variance_Fields = {
  __typename?: 'uogorod_experiments_steps_variance_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_experiments" */
export type Uogorod_Experiments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Experiments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Experiments_Stream_Cursor_Value_Input = {
  closed?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image_id?: InputMaybe<Scalars['bigint']['input']>;
  privatnost?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
  vivod?: InputMaybe<Scalars['String']['input']>;
  vivod_images?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Experiments_Sum_Fields = {
  __typename?: 'uogorod_experiments_sum_fields';
  closed?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image_id?: Maybe<Scalars['bigint']['output']>;
  privatnost?: Maybe<Scalars['bigint']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.experiments" */
export enum Uogorod_Experiments_Update_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Privatnost = 'privatnost',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views',
  /** column name */
  Vivod = 'vivod',
  /** column name */
  VivodImages = 'vivod_images'
}

export type Uogorod_Experiments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Experiments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Experiments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Experiments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Experiments_Var_Pop_Fields = {
  __typename?: 'uogorod_experiments_var_pop_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Experiments_Var_Samp_Fields = {
  __typename?: 'uogorod_experiments_var_samp_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Experiments_Variance_Fields = {
  __typename?: 'uogorod_experiments_variance_fields';
  closed?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image_id?: Maybe<Scalars['Float']['output']>;
  privatnost?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.experiments_views" */
export type Uogorod_Experiments_Views = {
  __typename?: 'uogorod_experiments_views';
  created_at: Scalars['time']['output'];
  experiment_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Aggregate = {
  __typename?: 'uogorod_experiments_views_aggregate';
  aggregate?: Maybe<Uogorod_Experiments_Views_Aggregate_Fields>;
  nodes: Array<Uogorod_Experiments_Views>;
};

/** aggregate fields of "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Aggregate_Fields = {
  __typename?: 'uogorod_experiments_views_aggregate_fields';
  avg?: Maybe<Uogorod_Experiments_Views_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Experiments_Views_Max_Fields>;
  min?: Maybe<Uogorod_Experiments_Views_Min_Fields>;
  stddev?: Maybe<Uogorod_Experiments_Views_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Experiments_Views_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Experiments_Views_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Experiments_Views_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Experiments_Views_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Experiments_Views_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Experiments_Views_Variance_Fields>;
};


/** aggregate fields of "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Experiments_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Experiments_Views_Avg_Fields = {
  __typename?: 'uogorod_experiments_views_avg_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.experiments_views". All fields are combined with a logical 'AND'. */
export type Uogorod_Experiments_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Experiments_Views_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Experiments_Views_Bool_Exp>>;
  created_at?: InputMaybe<Time_Comparison_Exp>;
  experiment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.experiments_views" */
export enum Uogorod_Experiments_Views_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18880Primary = 'idx_18880_primary'
}

/** input type for incrementing numeric columns in table "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Inc_Input = {
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Insert_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Experiments_Views_Max_Fields = {
  __typename?: 'uogorod_experiments_views_max_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Experiments_Views_Min_Fields = {
  __typename?: 'uogorod_experiments_views_min_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Mutation_Response = {
  __typename?: 'uogorod_experiments_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Experiments_Views>;
};

/** on_conflict condition type for table "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_On_Conflict = {
  constraint: Uogorod_Experiments_Views_Constraint;
  update_columns?: Array<Uogorod_Experiments_Views_Update_Column>;
  where?: InputMaybe<Uogorod_Experiments_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.experiments_views". */
export type Uogorod_Experiments_Views_Order_By = {
  created_at?: InputMaybe<Order_By>;
  experiment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.experiments_views */
export type Uogorod_Experiments_Views_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.experiments_views" */
export enum Uogorod_Experiments_Views_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.experiments_views" */
export type Uogorod_Experiments_Views_Set_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Experiments_Views_Stddev_Fields = {
  __typename?: 'uogorod_experiments_views_stddev_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Experiments_Views_Stddev_Pop_Fields = {
  __typename?: 'uogorod_experiments_views_stddev_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Experiments_Views_Stddev_Samp_Fields = {
  __typename?: 'uogorod_experiments_views_stddev_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_experiments_views" */
export type Uogorod_Experiments_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Experiments_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Experiments_Views_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['time']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Experiments_Views_Sum_Fields = {
  __typename?: 'uogorod_experiments_views_sum_fields';
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.experiments_views" */
export enum Uogorod_Experiments_Views_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Experiments_Views_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Experiments_Views_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Experiments_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Experiments_Views_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Experiments_Views_Var_Pop_Fields = {
  __typename?: 'uogorod_experiments_views_var_pop_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Experiments_Views_Var_Samp_Fields = {
  __typename?: 'uogorod_experiments_views_var_samp_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Experiments_Views_Variance_Fields = {
  __typename?: 'uogorod_experiments_views_variance_fields';
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.garden_beds" */
export type Uogorod_Garden_Beds = {
  __typename?: 'uogorod_garden_beds';
  garden_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  season: Scalars['bigint']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Aggregate = {
  __typename?: 'uogorod_garden_beds_aggregate';
  aggregate?: Maybe<Uogorod_Garden_Beds_Aggregate_Fields>;
  nodes: Array<Uogorod_Garden_Beds>;
};

/** aggregate fields of "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Aggregate_Fields = {
  __typename?: 'uogorod_garden_beds_aggregate_fields';
  avg?: Maybe<Uogorod_Garden_Beds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Garden_Beds_Max_Fields>;
  min?: Maybe<Uogorod_Garden_Beds_Min_Fields>;
  stddev?: Maybe<Uogorod_Garden_Beds_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Garden_Beds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Garden_Beds_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Garden_Beds_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Garden_Beds_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Garden_Beds_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Garden_Beds_Variance_Fields>;
};


/** aggregate fields of "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Garden_Beds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Garden_Beds_Avg_Fields = {
  __typename?: 'uogorod_garden_beds_avg_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.garden_beds". All fields are combined with a logical 'AND'. */
export type Uogorod_Garden_Beds_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Garden_Beds_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Garden_Beds_Bool_Exp>>;
  garden_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  season?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.garden_beds" */
export enum Uogorod_Garden_Beds_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19098Primary = 'idx_19098_primary'
}

/** input type for incrementing numeric columns in table "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Inc_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Insert_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Garden_Beds_Max_Fields = {
  __typename?: 'uogorod_garden_beds_max_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Garden_Beds_Min_Fields = {
  __typename?: 'uogorod_garden_beds_min_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Mutation_Response = {
  __typename?: 'uogorod_garden_beds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Garden_Beds>;
};

/** on_conflict condition type for table "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_On_Conflict = {
  constraint: Uogorod_Garden_Beds_Constraint;
  update_columns?: Array<Uogorod_Garden_Beds_Update_Column>;
  where?: InputMaybe<Uogorod_Garden_Beds_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.garden_beds". */
export type Uogorod_Garden_Beds_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.garden_beds */
export type Uogorod_Garden_Beds_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds = {
  __typename?: 'uogorod_garden_beds_seeds';
  bed_id: Scalars['bigint']['output'];
  count: Scalars['bigint']['output'];
  garden_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  season: Scalars['bigint']['output'];
  seed_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Aggregate = {
  __typename?: 'uogorod_garden_beds_seeds_aggregate';
  aggregate?: Maybe<Uogorod_Garden_Beds_Seeds_Aggregate_Fields>;
  nodes: Array<Uogorod_Garden_Beds_Seeds>;
};

/** aggregate fields of "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Aggregate_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_aggregate_fields';
  avg?: Maybe<Uogorod_Garden_Beds_Seeds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Garden_Beds_Seeds_Max_Fields>;
  min?: Maybe<Uogorod_Garden_Beds_Seeds_Min_Fields>;
  stddev?: Maybe<Uogorod_Garden_Beds_Seeds_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Garden_Beds_Seeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Garden_Beds_Seeds_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Garden_Beds_Seeds_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Garden_Beds_Seeds_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Garden_Beds_Seeds_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Garden_Beds_Seeds_Variance_Fields>;
};


/** aggregate fields of "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Garden_Beds_Seeds_Avg_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_avg_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.garden_beds_seeds". All fields are combined with a logical 'AND'. */
export type Uogorod_Garden_Beds_Seeds_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Garden_Beds_Seeds_Bool_Exp>>;
  bed_id?: InputMaybe<Bigint_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  garden_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  season?: InputMaybe<Bigint_Comparison_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.garden_beds_seeds" */
export enum Uogorod_Garden_Beds_Seeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19103Primary = 'idx_19103_primary'
}

/** input type for incrementing numeric columns in table "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Inc_Input = {
  bed_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Insert_Input = {
  bed_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Garden_Beds_Seeds_Max_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_max_fields';
  bed_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Garden_Beds_Seeds_Min_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_min_fields';
  bed_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Mutation_Response = {
  __typename?: 'uogorod_garden_beds_seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Garden_Beds_Seeds>;
};

/** on_conflict condition type for table "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_On_Conflict = {
  constraint: Uogorod_Garden_Beds_Seeds_Constraint;
  update_columns?: Array<Uogorod_Garden_Beds_Seeds_Update_Column>;
  where?: InputMaybe<Uogorod_Garden_Beds_Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.garden_beds_seeds". */
export type Uogorod_Garden_Beds_Seeds_Order_By = {
  bed_id?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.garden_beds_seeds */
export type Uogorod_Garden_Beds_Seeds_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.garden_beds_seeds" */
export enum Uogorod_Garden_Beds_Seeds_Select_Column {
  /** column name */
  BedId = 'bed_id',
  /** column name */
  Count = 'count',
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Season = 'season',
  /** column name */
  SeedId = 'seed_id'
}

/** input type for updating data in table "uogorod.garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Set_Input = {
  bed_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Garden_Beds_Seeds_Stddev_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_stddev_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Garden_Beds_Seeds_Stddev_Pop_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_stddev_pop_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Garden_Beds_Seeds_Stddev_Samp_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_stddev_samp_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_garden_beds_seeds" */
export type Uogorod_Garden_Beds_Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Garden_Beds_Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Garden_Beds_Seeds_Stream_Cursor_Value_Input = {
  bed_id?: InputMaybe<Scalars['bigint']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Garden_Beds_Seeds_Sum_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_sum_fields';
  bed_id?: Maybe<Scalars['bigint']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.garden_beds_seeds" */
export enum Uogorod_Garden_Beds_Seeds_Update_Column {
  /** column name */
  BedId = 'bed_id',
  /** column name */
  Count = 'count',
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Season = 'season',
  /** column name */
  SeedId = 'seed_id'
}

export type Uogorod_Garden_Beds_Seeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Garden_Beds_Seeds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Garden_Beds_Seeds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Garden_Beds_Seeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Garden_Beds_Seeds_Var_Pop_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_var_pop_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Garden_Beds_Seeds_Var_Samp_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_var_samp_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Garden_Beds_Seeds_Variance_Fields = {
  __typename?: 'uogorod_garden_beds_seeds_variance_fields';
  bed_id?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "uogorod.garden_beds" */
export enum Uogorod_Garden_Beds_Select_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Season = 'season',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.garden_beds" */
export type Uogorod_Garden_Beds_Set_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Garden_Beds_Stddev_Fields = {
  __typename?: 'uogorod_garden_beds_stddev_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Garden_Beds_Stddev_Pop_Fields = {
  __typename?: 'uogorod_garden_beds_stddev_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Garden_Beds_Stddev_Samp_Fields = {
  __typename?: 'uogorod_garden_beds_stddev_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_garden_beds" */
export type Uogorod_Garden_Beds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Garden_Beds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Garden_Beds_Stream_Cursor_Value_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Garden_Beds_Sum_Fields = {
  __typename?: 'uogorod_garden_beds_sum_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.garden_beds" */
export enum Uogorod_Garden_Beds_Update_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Season = 'season',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Garden_Beds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Garden_Beds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Garden_Beds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Garden_Beds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Garden_Beds_Var_Pop_Fields = {
  __typename?: 'uogorod_garden_beds_var_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Garden_Beds_Var_Samp_Fields = {
  __typename?: 'uogorod_garden_beds_var_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Garden_Beds_Variance_Fields = {
  __typename?: 'uogorod_garden_beds_variance_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons = {
  __typename?: 'uogorod_garden_seasons';
  /** An object relationship */
  garden: Uogorod_Gardens;
  garden_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  season: Scalars['Int']['output'];
  /** An array relationship */
  seeds: Array<Uogorod_Garden_Seeds>;
  /** An aggregate relationship */
  seeds_aggregate: Uogorod_Garden_Seeds_Aggregate;
};


/** columns and relationships of "uogorod.garden_seasons" */
export type Uogorod_Garden_SeasonsSeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


/** columns and relationships of "uogorod.garden_seasons" */
export type Uogorod_Garden_SeasonsSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};

/** aggregated selection of "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Aggregate = {
  __typename?: 'uogorod_garden_seasons_aggregate';
  aggregate?: Maybe<Uogorod_Garden_Seasons_Aggregate_Fields>;
  nodes: Array<Uogorod_Garden_Seasons>;
};

export type Uogorod_Garden_Seasons_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Garden_Seasons_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Garden_Seasons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Aggregate_Fields = {
  __typename?: 'uogorod_garden_seasons_aggregate_fields';
  avg?: Maybe<Uogorod_Garden_Seasons_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Garden_Seasons_Max_Fields>;
  min?: Maybe<Uogorod_Garden_Seasons_Min_Fields>;
  stddev?: Maybe<Uogorod_Garden_Seasons_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Garden_Seasons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Garden_Seasons_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Garden_Seasons_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Garden_Seasons_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Garden_Seasons_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Garden_Seasons_Variance_Fields>;
};


/** aggregate fields of "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Garden_Seasons_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Garden_Seasons_Max_Order_By>;
  min?: InputMaybe<Uogorod_Garden_Seasons_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Garden_Seasons_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Garden_Seasons_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Garden_Seasons_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Garden_Seasons_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Garden_Seasons_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Garden_Seasons_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Garden_Seasons_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Garden_Seasons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Garden_Seasons_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Garden_Seasons_Avg_Fields = {
  __typename?: 'uogorod_garden_seasons_avg_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Avg_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.garden_seasons". All fields are combined with a logical 'AND'. */
export type Uogorod_Garden_Seasons_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Garden_Seasons_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Garden_Seasons_Bool_Exp>>;
  garden?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  garden_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  season?: InputMaybe<Int_Comparison_Exp>;
  seeds?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
  seeds_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uogorod.garden_seasons" */
export enum Uogorod_Garden_Seasons_Constraint {
  /** unique or primary key constraint on columns "garden_id", "season" */
  GardenSeasonsGardenIdSeasonKey = 'garden_seasons_garden_id_season_key',
  /** unique or primary key constraint on columns "id" */
  GardenSeasonsPkey = 'garden_seasons_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Inc_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Insert_Input = {
  garden?: InputMaybe<Uogorod_Gardens_Obj_Rel_Insert_Input>;
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Uogorod_Garden_Seeds_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uogorod_Garden_Seasons_Max_Fields = {
  __typename?: 'uogorod_garden_seasons_max_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Max_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Garden_Seasons_Min_Fields = {
  __typename?: 'uogorod_garden_seasons_min_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Min_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Mutation_Response = {
  __typename?: 'uogorod_garden_seasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Garden_Seasons>;
};

/** on_conflict condition type for table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_On_Conflict = {
  constraint: Uogorod_Garden_Seasons_Constraint;
  update_columns?: Array<Uogorod_Garden_Seasons_Update_Column>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.garden_seasons". */
export type Uogorod_Garden_Seasons_Order_By = {
  garden?: InputMaybe<Uogorod_Gardens_Order_By>;
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seeds_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Order_By>;
};

/** primary key columns input for table: uogorod.garden_seasons */
export type Uogorod_Garden_Seasons_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.garden_seasons" */
export enum Uogorod_Garden_Seasons_Select_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Season = 'season'
}

/** input type for updating data in table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Set_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Garden_Seasons_Stddev_Fields = {
  __typename?: 'uogorod_garden_seasons_stddev_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Stddev_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Garden_Seasons_Stddev_Pop_Fields = {
  __typename?: 'uogorod_garden_seasons_stddev_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Stddev_Pop_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Garden_Seasons_Stddev_Samp_Fields = {
  __typename?: 'uogorod_garden_seasons_stddev_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Stddev_Samp_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_garden_seasons" */
export type Uogorod_Garden_Seasons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Garden_Seasons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Garden_Seasons_Stream_Cursor_Value_Input = {
  garden_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Garden_Seasons_Sum_Fields = {
  __typename?: 'uogorod_garden_seasons_sum_fields';
  garden_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Sum_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.garden_seasons" */
export enum Uogorod_Garden_Seasons_Update_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Season = 'season'
}

export type Uogorod_Garden_Seasons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Garden_Seasons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Garden_Seasons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Garden_Seasons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Garden_Seasons_Var_Pop_Fields = {
  __typename?: 'uogorod_garden_seasons_var_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Var_Pop_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Garden_Seasons_Var_Samp_Fields = {
  __typename?: 'uogorod_garden_seasons_var_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Var_Samp_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Garden_Seasons_Variance_Fields = {
  __typename?: 'uogorod_garden_seasons_variance_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.garden_seasons" */
export type Uogorod_Garden_Seasons_Variance_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds = {
  __typename?: 'uogorod_garden_seeds';
  /** An object relationship */
  garden: Uogorod_Gardens;
  garden_id: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  journal: Scalars['jsonb']['output'];
  label?: Maybe<Scalars['String']['output']>;
  season: Scalars['Int']['output'];
  /** An object relationship */
  seed: Uogorod_Seeds;
  seed_id: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.garden_seeds" */
export type Uogorod_Garden_SeedsJournalArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Aggregate = {
  __typename?: 'uogorod_garden_seeds_aggregate';
  aggregate?: Maybe<Uogorod_Garden_Seeds_Aggregate_Fields>;
  nodes: Array<Uogorod_Garden_Seeds>;
};

export type Uogorod_Garden_Seeds_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Garden_Seeds_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Aggregate_Fields = {
  __typename?: 'uogorod_garden_seeds_aggregate_fields';
  avg?: Maybe<Uogorod_Garden_Seeds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Garden_Seeds_Max_Fields>;
  min?: Maybe<Uogorod_Garden_Seeds_Min_Fields>;
  stddev?: Maybe<Uogorod_Garden_Seeds_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Garden_Seeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Garden_Seeds_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Garden_Seeds_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Garden_Seeds_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Garden_Seeds_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Garden_Seeds_Variance_Fields>;
};


/** aggregate fields of "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Garden_Seeds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Garden_Seeds_Max_Order_By>;
  min?: InputMaybe<Uogorod_Garden_Seeds_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Garden_Seeds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Garden_Seeds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Garden_Seeds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Garden_Seeds_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Garden_Seeds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Garden_Seeds_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Garden_Seeds_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Garden_Seeds_Append_Input = {
  journal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Garden_Seeds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Garden_Seeds_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Garden_Seeds_Avg_Fields = {
  __typename?: 'uogorod_garden_seeds_avg_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Avg_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.garden_seeds". All fields are combined with a logical 'AND'. */
export type Uogorod_Garden_Seeds_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Garden_Seeds_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Garden_Seeds_Bool_Exp>>;
  garden?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  garden_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  journal?: InputMaybe<Jsonb_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  season?: InputMaybe<Int_Comparison_Exp>;
  seed?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.garden_seeds" */
export enum Uogorod_Garden_Seeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  GardenSeedsPkey = 'garden_seeds_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Garden_Seeds_Delete_At_Path_Input = {
  journal?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Garden_Seeds_Delete_Elem_Input = {
  journal?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Garden_Seeds_Delete_Key_Input = {
  journal?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Inc_Input = {
  garden_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Insert_Input = {
  garden?: InputMaybe<Uogorod_Gardens_Obj_Rel_Insert_Input>;
  garden_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  journal?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Garden_Seeds_Max_Fields = {
  __typename?: 'uogorod_garden_seeds_max_fields';
  garden_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Max_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Garden_Seeds_Min_Fields = {
  __typename?: 'uogorod_garden_seeds_min_fields';
  garden_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Min_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Mutation_Response = {
  __typename?: 'uogorod_garden_seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Garden_Seeds>;
};

/** on_conflict condition type for table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_On_Conflict = {
  constraint: Uogorod_Garden_Seeds_Constraint;
  update_columns?: Array<Uogorod_Garden_Seeds_Update_Column>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.garden_seeds". */
export type Uogorod_Garden_Seeds_Order_By = {
  garden?: InputMaybe<Uogorod_Gardens_Order_By>;
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  journal?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed?: InputMaybe<Uogorod_Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.garden_seeds */
export type Uogorod_Garden_Seeds_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Garden_Seeds_Prepend_Input = {
  journal?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.garden_seeds" */
export enum Uogorod_Garden_Seeds_Select_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Journal = 'journal',
  /** column name */
  Label = 'label',
  /** column name */
  Season = 'season',
  /** column name */
  SeedId = 'seed_id'
}

/** input type for updating data in table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Set_Input = {
  garden_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  journal?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Garden_Seeds_Stddev_Fields = {
  __typename?: 'uogorod_garden_seeds_stddev_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Stddev_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Garden_Seeds_Stddev_Pop_Fields = {
  __typename?: 'uogorod_garden_seeds_stddev_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Stddev_Pop_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Garden_Seeds_Stddev_Samp_Fields = {
  __typename?: 'uogorod_garden_seeds_stddev_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Stddev_Samp_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_garden_seeds" */
export type Uogorod_Garden_Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Garden_Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Garden_Seeds_Stream_Cursor_Value_Input = {
  garden_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  journal?: InputMaybe<Scalars['jsonb']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Garden_Seeds_Sum_Fields = {
  __typename?: 'uogorod_garden_seeds_sum_fields';
  garden_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  season?: Maybe<Scalars['Int']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Sum_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.garden_seeds" */
export enum Uogorod_Garden_Seeds_Update_Column {
  /** column name */
  GardenId = 'garden_id',
  /** column name */
  Id = 'id',
  /** column name */
  Journal = 'journal',
  /** column name */
  Label = 'label',
  /** column name */
  Season = 'season',
  /** column name */
  SeedId = 'seed_id'
}

export type Uogorod_Garden_Seeds_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Garden_Seeds_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Garden_Seeds_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Garden_Seeds_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Garden_Seeds_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Garden_Seeds_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Garden_Seeds_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Garden_Seeds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Garden_Seeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Garden_Seeds_Var_Pop_Fields = {
  __typename?: 'uogorod_garden_seeds_var_pop_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Var_Pop_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Garden_Seeds_Var_Samp_Fields = {
  __typename?: 'uogorod_garden_seeds_var_samp_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Var_Samp_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Garden_Seeds_Variance_Fields = {
  __typename?: 'uogorod_garden_seeds_variance_fields';
  garden_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.garden_seeds" */
export type Uogorod_Garden_Seeds_Variance_Order_By = {
  garden_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.gardens" */
export type Uogorod_Gardens = {
  __typename?: 'uogorod_gardens';
  about?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images: Scalars['jsonb']['output'];
  /** An array relationship */
  seasons: Array<Uogorod_Garden_Seasons>;
  /** An aggregate relationship */
  seasons_aggregate: Uogorod_Garden_Seasons_Aggregate;
  /** An array relationship */
  seeds: Array<Uogorod_Garden_Seeds>;
  /** An aggregate relationship */
  seeds_aggregate: Uogorod_Garden_Seeds_Aggregate;
  show_count: Scalars['Boolean']['output'];
  show_germination: Scalars['Boolean']['output'];
  show_ground: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Uogorod_Users;
  user_id: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};


/** columns and relationships of "uogorod.gardens" */
export type Uogorod_GardensImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.gardens" */
export type Uogorod_GardensSeasonsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


/** columns and relationships of "uogorod.gardens" */
export type Uogorod_GardensSeasons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seasons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seasons_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
};


/** columns and relationships of "uogorod.gardens" */
export type Uogorod_GardensSeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


/** columns and relationships of "uogorod.gardens" */
export type Uogorod_GardensSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};

/** aggregated selection of "uogorod.gardens" */
export type Uogorod_Gardens_Aggregate = {
  __typename?: 'uogorod_gardens_aggregate';
  aggregate?: Maybe<Uogorod_Gardens_Aggregate_Fields>;
  nodes: Array<Uogorod_Gardens>;
};

export type Uogorod_Gardens_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uogorod_Gardens_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uogorod_Gardens_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uogorod_Gardens_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Gardens_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uogorod_Gardens_Select_Column_Uogorod_Gardens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Gardens_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uogorod_Gardens_Select_Column_Uogorod_Gardens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Gardens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.gardens" */
export type Uogorod_Gardens_Aggregate_Fields = {
  __typename?: 'uogorod_gardens_aggregate_fields';
  avg?: Maybe<Uogorod_Gardens_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Gardens_Max_Fields>;
  min?: Maybe<Uogorod_Gardens_Min_Fields>;
  stddev?: Maybe<Uogorod_Gardens_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Gardens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Gardens_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Gardens_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Gardens_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Gardens_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Gardens_Variance_Fields>;
};


/** aggregate fields of "uogorod.gardens" */
export type Uogorod_Gardens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.gardens" */
export type Uogorod_Gardens_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Gardens_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Gardens_Max_Order_By>;
  min?: InputMaybe<Uogorod_Gardens_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Gardens_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Gardens_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Gardens_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Gardens_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Gardens_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Gardens_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Gardens_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Gardens_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.gardens" */
export type Uogorod_Gardens_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Gardens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Gardens_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Gardens_Avg_Fields = {
  __typename?: 'uogorod_gardens_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.gardens". All fields are combined with a logical 'AND'. */
export type Uogorod_Gardens_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Gardens_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Gardens_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  seasons?: InputMaybe<Uogorod_Garden_Seasons_Bool_Exp>;
  seasons_aggregate?: InputMaybe<Uogorod_Garden_Seasons_Aggregate_Bool_Exp>;
  seeds?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
  seeds_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Bool_Exp>;
  show_count?: InputMaybe<Boolean_Comparison_Exp>;
  show_germination?: InputMaybe<Boolean_Comparison_Exp>;
  show_ground?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
  views?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.gardens" */
export enum Uogorod_Gardens_Constraint {
  /** unique or primary key constraint on columns "id" */
  GardensPkey = 'gardens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Gardens_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Gardens_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Gardens_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.gardens" */
export type Uogorod_Gardens_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.gardens" */
export type Uogorod_Gardens_Insert_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  seasons?: InputMaybe<Uogorod_Garden_Seasons_Arr_Rel_Insert_Input>;
  seeds?: InputMaybe<Uogorod_Garden_Seeds_Arr_Rel_Insert_Input>;
  show_count?: InputMaybe<Scalars['Boolean']['input']>;
  show_germination?: InputMaybe<Scalars['Boolean']['input']>;
  show_ground?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Gardens_Max_Fields = {
  __typename?: 'uogorod_gardens_max_fields';
  about?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Gardens_Min_Fields = {
  __typename?: 'uogorod_gardens_min_fields';
  about?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.gardens" */
export type Uogorod_Gardens_Mutation_Response = {
  __typename?: 'uogorod_gardens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Gardens>;
};

/** input type for inserting object relation for remote table "uogorod.gardens" */
export type Uogorod_Gardens_Obj_Rel_Insert_Input = {
  data: Uogorod_Gardens_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Gardens_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.gardens" */
export type Uogorod_Gardens_On_Conflict = {
  constraint: Uogorod_Gardens_Constraint;
  update_columns?: Array<Uogorod_Gardens_Update_Column>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.gardens". */
export type Uogorod_Gardens_Order_By = {
  about?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  seasons_aggregate?: InputMaybe<Uogorod_Garden_Seasons_Aggregate_Order_By>;
  seeds_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Order_By>;
  show_count?: InputMaybe<Order_By>;
  show_germination?: InputMaybe<Order_By>;
  show_ground?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.gardens */
export type Uogorod_Gardens_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Gardens_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.gardens" */
export enum Uogorod_Gardens_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  ShowCount = 'show_count',
  /** column name */
  ShowGermination = 'show_germination',
  /** column name */
  ShowGround = 'show_ground',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views'
}

/** select "uogorod_gardens_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uogorod.gardens" */
export enum Uogorod_Gardens_Select_Column_Uogorod_Gardens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ShowCount = 'show_count',
  /** column name */
  ShowGermination = 'show_germination',
  /** column name */
  ShowGround = 'show_ground'
}

/** select "uogorod_gardens_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uogorod.gardens" */
export enum Uogorod_Gardens_Select_Column_Uogorod_Gardens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ShowCount = 'show_count',
  /** column name */
  ShowGermination = 'show_germination',
  /** column name */
  ShowGround = 'show_ground'
}

/** input type for updating data in table "uogorod.gardens" */
export type Uogorod_Gardens_Set_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  show_count?: InputMaybe<Scalars['Boolean']['input']>;
  show_germination?: InputMaybe<Scalars['Boolean']['input']>;
  show_ground?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Gardens_Stddev_Fields = {
  __typename?: 'uogorod_gardens_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Gardens_Stddev_Pop_Fields = {
  __typename?: 'uogorod_gardens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Gardens_Stddev_Samp_Fields = {
  __typename?: 'uogorod_gardens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_gardens" */
export type Uogorod_Gardens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Gardens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Gardens_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  show_count?: InputMaybe<Scalars['Boolean']['input']>;
  show_germination?: InputMaybe<Scalars['Boolean']['input']>;
  show_ground?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Gardens_Sum_Fields = {
  __typename?: 'uogorod_gardens_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.gardens" */
export enum Uogorod_Gardens_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  ShowCount = 'show_count',
  /** column name */
  ShowGermination = 'show_germination',
  /** column name */
  ShowGround = 'show_ground',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Views = 'views'
}

export type Uogorod_Gardens_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Gardens_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Gardens_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Gardens_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Gardens_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Gardens_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Gardens_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Gardens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Gardens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Gardens_Var_Pop_Fields = {
  __typename?: 'uogorod_gardens_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Gardens_Var_Samp_Fields = {
  __typename?: 'uogorod_gardens_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Gardens_Variance_Fields = {
  __typename?: 'uogorod_gardens_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.gardens" */
export type Uogorod_Gardens_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.geo_city" */
export type Uogorod_Geo_City = {
  __typename?: 'uogorod_geo_city';
  country_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  lat: Scalars['numeric']['output'];
  lng: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  region?: Maybe<Uogorod_Geo_Region>;
  region_id: Scalars['bigint']['output'];
  /** An array relationship */
  users: Array<Uogorod_Users>;
  /** An aggregate relationship */
  users_aggregate: Uogorod_Users_Aggregate;
};


/** columns and relationships of "uogorod.geo_city" */
export type Uogorod_Geo_CityUsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


/** columns and relationships of "uogorod.geo_city" */
export type Uogorod_Geo_CityUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};

/** aggregated selection of "uogorod.geo_city" */
export type Uogorod_Geo_City_Aggregate = {
  __typename?: 'uogorod_geo_city_aggregate';
  aggregate?: Maybe<Uogorod_Geo_City_Aggregate_Fields>;
  nodes: Array<Uogorod_Geo_City>;
};

export type Uogorod_Geo_City_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Geo_City_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Geo_City_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.geo_city" */
export type Uogorod_Geo_City_Aggregate_Fields = {
  __typename?: 'uogorod_geo_city_aggregate_fields';
  avg?: Maybe<Uogorod_Geo_City_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Geo_City_Max_Fields>;
  min?: Maybe<Uogorod_Geo_City_Min_Fields>;
  stddev?: Maybe<Uogorod_Geo_City_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Geo_City_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Geo_City_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Geo_City_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Geo_City_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Geo_City_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Geo_City_Variance_Fields>;
};


/** aggregate fields of "uogorod.geo_city" */
export type Uogorod_Geo_City_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Geo_City_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Geo_City_Max_Order_By>;
  min?: InputMaybe<Uogorod_Geo_City_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Geo_City_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Geo_City_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Geo_City_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Geo_City_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Geo_City_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Geo_City_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Geo_City_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.geo_city" */
export type Uogorod_Geo_City_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Geo_City_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Geo_City_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Geo_City_Avg_Fields = {
  __typename?: 'uogorod_geo_city_avg_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Avg_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.geo_city". All fields are combined with a logical 'AND'. */
export type Uogorod_Geo_City_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Geo_City_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Geo_City_Bool_Exp>>;
  country_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
  region_id?: InputMaybe<Bigint_Comparison_Exp>;
  users?: InputMaybe<Uogorod_Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Uogorod_Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uogorod.geo_city" */
export enum Uogorod_Geo_City_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18886Primary = 'idx_18886_primary'
}

/** input type for incrementing numeric columns in table "uogorod.geo_city" */
export type Uogorod_Geo_City_Inc_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  region_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.geo_city" */
export type Uogorod_Geo_City_Insert_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Uogorod_Geo_Region_Obj_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['bigint']['input']>;
  users?: InputMaybe<Uogorod_Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uogorod_Geo_City_Max_Fields = {
  __typename?: 'uogorod_geo_city_max_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Geo_City_Min_Fields = {
  __typename?: 'uogorod_geo_city_min_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.geo_city" */
export type Uogorod_Geo_City_Mutation_Response = {
  __typename?: 'uogorod_geo_city_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Geo_City>;
};

/** input type for inserting object relation for remote table "uogorod.geo_city" */
export type Uogorod_Geo_City_Obj_Rel_Insert_Input = {
  data: Uogorod_Geo_City_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Geo_City_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.geo_city" */
export type Uogorod_Geo_City_On_Conflict = {
  constraint: Uogorod_Geo_City_Constraint;
  update_columns?: Array<Uogorod_Geo_City_Update_Column>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.geo_city". */
export type Uogorod_Geo_City_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Uogorod_Geo_Region_Order_By>;
  region_id?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Uogorod_Users_Aggregate_Order_By>;
};

/** primary key columns input for table: uogorod.geo_city */
export type Uogorod_Geo_City_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.geo_city" */
export enum Uogorod_Geo_City_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Name = 'name',
  /** column name */
  RegionId = 'region_id'
}

/** input type for updating data in table "uogorod.geo_city" */
export type Uogorod_Geo_City_Set_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Geo_City_Stddev_Fields = {
  __typename?: 'uogorod_geo_city_stddev_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Stddev_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Geo_City_Stddev_Pop_Fields = {
  __typename?: 'uogorod_geo_city_stddev_pop_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Stddev_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Geo_City_Stddev_Samp_Fields = {
  __typename?: 'uogorod_geo_city_stddev_samp_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Stddev_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_geo_city" */
export type Uogorod_Geo_City_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Geo_City_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Geo_City_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Geo_City_Sum_Fields = {
  __typename?: 'uogorod_geo_city_sum_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  region_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Sum_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.geo_city" */
export enum Uogorod_Geo_City_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Name = 'name',
  /** column name */
  RegionId = 'region_id'
}

export type Uogorod_Geo_City_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Geo_City_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Geo_City_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Geo_City_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Geo_City_Var_Pop_Fields = {
  __typename?: 'uogorod_geo_city_var_pop_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Var_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Geo_City_Var_Samp_Fields = {
  __typename?: 'uogorod_geo_city_var_samp_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Var_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Geo_City_Variance_Fields = {
  __typename?: 'uogorod_geo_city_variance_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.geo_city" */
export type Uogorod_Geo_City_Variance_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.geo_country" */
export type Uogorod_Geo_Country = {
  __typename?: 'uogorod_geo_country';
  code: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An array relationship */
  regions: Array<Uogorod_Geo_Region>;
  /** An aggregate relationship */
  regions_aggregate: Uogorod_Geo_Region_Aggregate;
};


/** columns and relationships of "uogorod.geo_country" */
export type Uogorod_Geo_CountryRegionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};


/** columns and relationships of "uogorod.geo_country" */
export type Uogorod_Geo_CountryRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_Region_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};

/** aggregated selection of "uogorod.geo_country" */
export type Uogorod_Geo_Country_Aggregate = {
  __typename?: 'uogorod_geo_country_aggregate';
  aggregate?: Maybe<Uogorod_Geo_Country_Aggregate_Fields>;
  nodes: Array<Uogorod_Geo_Country>;
};

/** aggregate fields of "uogorod.geo_country" */
export type Uogorod_Geo_Country_Aggregate_Fields = {
  __typename?: 'uogorod_geo_country_aggregate_fields';
  avg?: Maybe<Uogorod_Geo_Country_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Geo_Country_Max_Fields>;
  min?: Maybe<Uogorod_Geo_Country_Min_Fields>;
  stddev?: Maybe<Uogorod_Geo_Country_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Geo_Country_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Geo_Country_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Geo_Country_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Geo_Country_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Geo_Country_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Geo_Country_Variance_Fields>;
};


/** aggregate fields of "uogorod.geo_country" */
export type Uogorod_Geo_Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Geo_Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Geo_Country_Avg_Fields = {
  __typename?: 'uogorod_geo_country_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.geo_country". All fields are combined with a logical 'AND'. */
export type Uogorod_Geo_Country_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Geo_Country_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Geo_Country_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  regions?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
  regions_aggregate?: InputMaybe<Uogorod_Geo_Region_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uogorod.geo_country" */
export enum Uogorod_Geo_Country_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18894Primary = 'idx_18894_primary'
}

/** input type for incrementing numeric columns in table "uogorod.geo_country" */
export type Uogorod_Geo_Country_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.geo_country" */
export type Uogorod_Geo_Country_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  regions?: InputMaybe<Uogorod_Geo_Region_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uogorod_Geo_Country_Max_Fields = {
  __typename?: 'uogorod_geo_country_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Geo_Country_Min_Fields = {
  __typename?: 'uogorod_geo_country_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "uogorod.geo_country" */
export type Uogorod_Geo_Country_Mutation_Response = {
  __typename?: 'uogorod_geo_country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Geo_Country>;
};

/** input type for inserting object relation for remote table "uogorod.geo_country" */
export type Uogorod_Geo_Country_Obj_Rel_Insert_Input = {
  data: Uogorod_Geo_Country_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Geo_Country_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.geo_country" */
export type Uogorod_Geo_Country_On_Conflict = {
  constraint: Uogorod_Geo_Country_Constraint;
  update_columns?: Array<Uogorod_Geo_Country_Update_Column>;
  where?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.geo_country". */
export type Uogorod_Geo_Country_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  regions_aggregate?: InputMaybe<Uogorod_Geo_Region_Aggregate_Order_By>;
};

/** primary key columns input for table: uogorod.geo_country */
export type Uogorod_Geo_Country_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.geo_country" */
export enum Uogorod_Geo_Country_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

/** input type for updating data in table "uogorod.geo_country" */
export type Uogorod_Geo_Country_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Geo_Country_Stddev_Fields = {
  __typename?: 'uogorod_geo_country_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Geo_Country_Stddev_Pop_Fields = {
  __typename?: 'uogorod_geo_country_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Geo_Country_Stddev_Samp_Fields = {
  __typename?: 'uogorod_geo_country_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_geo_country" */
export type Uogorod_Geo_Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Geo_Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Geo_Country_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Geo_Country_Sum_Fields = {
  __typename?: 'uogorod_geo_country_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "uogorod.geo_country" */
export enum Uogorod_Geo_Country_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

export type Uogorod_Geo_Country_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Geo_Country_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Geo_Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Geo_Country_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Geo_Country_Var_Pop_Fields = {
  __typename?: 'uogorod_geo_country_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Geo_Country_Var_Samp_Fields = {
  __typename?: 'uogorod_geo_country_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Geo_Country_Variance_Fields = {
  __typename?: 'uogorod_geo_country_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.geo_region" */
export type Uogorod_Geo_Region = {
  __typename?: 'uogorod_geo_region';
  /** An array relationship */
  cities: Array<Uogorod_Geo_City>;
  /** An aggregate relationship */
  cities_aggregate: Uogorod_Geo_City_Aggregate;
  /** An object relationship */
  country?: Maybe<Uogorod_Geo_Country>;
  country_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
};


/** columns and relationships of "uogorod.geo_region" */
export type Uogorod_Geo_RegionCitiesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};


/** columns and relationships of "uogorod.geo_region" */
export type Uogorod_Geo_RegionCities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Geo_City_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Geo_City_Order_By>>;
  where?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
};

/** aggregated selection of "uogorod.geo_region" */
export type Uogorod_Geo_Region_Aggregate = {
  __typename?: 'uogorod_geo_region_aggregate';
  aggregate?: Maybe<Uogorod_Geo_Region_Aggregate_Fields>;
  nodes: Array<Uogorod_Geo_Region>;
};

export type Uogorod_Geo_Region_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Geo_Region_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Geo_Region_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.geo_region" */
export type Uogorod_Geo_Region_Aggregate_Fields = {
  __typename?: 'uogorod_geo_region_aggregate_fields';
  avg?: Maybe<Uogorod_Geo_Region_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Geo_Region_Max_Fields>;
  min?: Maybe<Uogorod_Geo_Region_Min_Fields>;
  stddev?: Maybe<Uogorod_Geo_Region_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Geo_Region_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Geo_Region_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Geo_Region_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Geo_Region_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Geo_Region_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Geo_Region_Variance_Fields>;
};


/** aggregate fields of "uogorod.geo_region" */
export type Uogorod_Geo_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Geo_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Geo_Region_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Geo_Region_Max_Order_By>;
  min?: InputMaybe<Uogorod_Geo_Region_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Geo_Region_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Geo_Region_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Geo_Region_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Geo_Region_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Geo_Region_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Geo_Region_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Geo_Region_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Geo_Region_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Geo_Region_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Geo_Region_Avg_Fields = {
  __typename?: 'uogorod_geo_region_avg_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Avg_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.geo_region". All fields are combined with a logical 'AND'. */
export type Uogorod_Geo_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Geo_Region_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Geo_Region_Bool_Exp>>;
  cities?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
  cities_aggregate?: InputMaybe<Uogorod_Geo_City_Aggregate_Bool_Exp>;
  country?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
  country_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.geo_region" */
export enum Uogorod_Geo_Region_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18901Primary = 'idx_18901_primary'
}

/** input type for incrementing numeric columns in table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Inc_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Insert_Input = {
  cities?: InputMaybe<Uogorod_Geo_City_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Uogorod_Geo_Country_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Geo_Region_Max_Fields = {
  __typename?: 'uogorod_geo_region_max_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Max_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Geo_Region_Min_Fields = {
  __typename?: 'uogorod_geo_region_min_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Min_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Mutation_Response = {
  __typename?: 'uogorod_geo_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Geo_Region>;
};

/** input type for inserting object relation for remote table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Obj_Rel_Insert_Input = {
  data: Uogorod_Geo_Region_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Geo_Region_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.geo_region" */
export type Uogorod_Geo_Region_On_Conflict = {
  constraint: Uogorod_Geo_Region_Constraint;
  update_columns?: Array<Uogorod_Geo_Region_Update_Column>;
  where?: InputMaybe<Uogorod_Geo_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.geo_region". */
export type Uogorod_Geo_Region_Order_By = {
  cities_aggregate?: InputMaybe<Uogorod_Geo_City_Aggregate_Order_By>;
  country?: InputMaybe<Uogorod_Geo_Country_Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.geo_region */
export type Uogorod_Geo_Region_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.geo_region" */
export enum Uogorod_Geo_Region_Select_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Set_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Geo_Region_Stddev_Fields = {
  __typename?: 'uogorod_geo_region_stddev_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Stddev_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Geo_Region_Stddev_Pop_Fields = {
  __typename?: 'uogorod_geo_region_stddev_pop_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Stddev_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Geo_Region_Stddev_Samp_Fields = {
  __typename?: 'uogorod_geo_region_stddev_samp_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Stddev_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_geo_region" */
export type Uogorod_Geo_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Geo_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Geo_Region_Stream_Cursor_Value_Input = {
  country_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Geo_Region_Sum_Fields = {
  __typename?: 'uogorod_geo_region_sum_fields';
  country_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Sum_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.geo_region" */
export enum Uogorod_Geo_Region_Update_Column {
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Uogorod_Geo_Region_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Geo_Region_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Geo_Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Geo_Region_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Geo_Region_Var_Pop_Fields = {
  __typename?: 'uogorod_geo_region_var_pop_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Var_Pop_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Geo_Region_Var_Samp_Fields = {
  __typename?: 'uogorod_geo_region_var_samp_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Var_Samp_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Geo_Region_Variance_Fields = {
  __typename?: 'uogorod_geo_region_variance_fields';
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.geo_region" */
export type Uogorod_Geo_Region_Variance_Order_By = {
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.groups" */
export type Uogorod_Groups = {
  __typename?: 'uogorod_groups';
  category_id: Scalars['bigint']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  image: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.groups" */
export type Uogorod_Groups_Aggregate = {
  __typename?: 'uogorod_groups_aggregate';
  aggregate?: Maybe<Uogorod_Groups_Aggregate_Fields>;
  nodes: Array<Uogorod_Groups>;
};

/** aggregate fields of "uogorod.groups" */
export type Uogorod_Groups_Aggregate_Fields = {
  __typename?: 'uogorod_groups_aggregate_fields';
  avg?: Maybe<Uogorod_Groups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Groups_Max_Fields>;
  min?: Maybe<Uogorod_Groups_Min_Fields>;
  stddev?: Maybe<Uogorod_Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Groups_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Groups_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Groups_Variance_Fields>;
};


/** aggregate fields of "uogorod.groups" */
export type Uogorod_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Groups_Avg_Fields = {
  __typename?: 'uogorod_groups_avg_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.groups". All fields are combined with a logical 'AND'. */
export type Uogorod_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Groups_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Groups_Bool_Exp>>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "uogorod.groups_category" */
export type Uogorod_Groups_Category = {
  __typename?: 'uogorod_groups_category';
  default: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  parent_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.groups_category" */
export type Uogorod_Groups_Category_Aggregate = {
  __typename?: 'uogorod_groups_category_aggregate';
  aggregate?: Maybe<Uogorod_Groups_Category_Aggregate_Fields>;
  nodes: Array<Uogorod_Groups_Category>;
};

/** aggregate fields of "uogorod.groups_category" */
export type Uogorod_Groups_Category_Aggregate_Fields = {
  __typename?: 'uogorod_groups_category_aggregate_fields';
  avg?: Maybe<Uogorod_Groups_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Groups_Category_Max_Fields>;
  min?: Maybe<Uogorod_Groups_Category_Min_Fields>;
  stddev?: Maybe<Uogorod_Groups_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Groups_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Groups_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Groups_Category_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Groups_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Groups_Category_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Groups_Category_Variance_Fields>;
};


/** aggregate fields of "uogorod.groups_category" */
export type Uogorod_Groups_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Groups_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Groups_Category_Avg_Fields = {
  __typename?: 'uogorod_groups_category_avg_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.groups_category". All fields are combined with a logical 'AND'. */
export type Uogorod_Groups_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Groups_Category_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Groups_Category_Bool_Exp>>;
  default?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.groups_category" */
export enum Uogorod_Groups_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18919Primary = 'idx_18919_primary'
}

/** input type for incrementing numeric columns in table "uogorod.groups_category" */
export type Uogorod_Groups_Category_Inc_Input = {
  default?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.groups_category" */
export type Uogorod_Groups_Category_Insert_Input = {
  default?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Groups_Category_Max_Fields = {
  __typename?: 'uogorod_groups_category_max_fields';
  default?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Groups_Category_Min_Fields = {
  __typename?: 'uogorod_groups_category_min_fields';
  default?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.groups_category" */
export type Uogorod_Groups_Category_Mutation_Response = {
  __typename?: 'uogorod_groups_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Groups_Category>;
};

/** on_conflict condition type for table "uogorod.groups_category" */
export type Uogorod_Groups_Category_On_Conflict = {
  constraint: Uogorod_Groups_Category_Constraint;
  update_columns?: Array<Uogorod_Groups_Category_Update_Column>;
  where?: InputMaybe<Uogorod_Groups_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.groups_category". */
export type Uogorod_Groups_Category_Order_By = {
  default?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.groups_category */
export type Uogorod_Groups_Category_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.groups_category" */
export enum Uogorod_Groups_Category_Select_Column {
  /** column name */
  Default = 'default',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id'
}

/** input type for updating data in table "uogorod.groups_category" */
export type Uogorod_Groups_Category_Set_Input = {
  default?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Groups_Category_Stddev_Fields = {
  __typename?: 'uogorod_groups_category_stddev_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Groups_Category_Stddev_Pop_Fields = {
  __typename?: 'uogorod_groups_category_stddev_pop_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Groups_Category_Stddev_Samp_Fields = {
  __typename?: 'uogorod_groups_category_stddev_samp_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_groups_category" */
export type Uogorod_Groups_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Groups_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Groups_Category_Stream_Cursor_Value_Input = {
  default?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Groups_Category_Sum_Fields = {
  __typename?: 'uogorod_groups_category_sum_fields';
  default?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parent_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.groups_category" */
export enum Uogorod_Groups_Category_Update_Column {
  /** column name */
  Default = 'default',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id'
}

export type Uogorod_Groups_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Groups_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Groups_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Groups_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Groups_Category_Var_Pop_Fields = {
  __typename?: 'uogorod_groups_category_var_pop_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Groups_Category_Var_Samp_Fields = {
  __typename?: 'uogorod_groups_category_var_samp_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Groups_Category_Variance_Fields = {
  __typename?: 'uogorod_groups_category_variance_fields';
  default?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "uogorod.groups" */
export enum Uogorod_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18908Primary = 'idx_18908_primary'
}

/** input type for incrementing numeric columns in table "uogorod.groups" */
export type Uogorod_Groups_Inc_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.groups" */
export type Uogorod_Groups_Insert_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Groups_Max_Fields = {
  __typename?: 'uogorod_groups_max_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Groups_Min_Fields = {
  __typename?: 'uogorod_groups_min_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.groups" */
export type Uogorod_Groups_Mutation_Response = {
  __typename?: 'uogorod_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Groups>;
};

/** on_conflict condition type for table "uogorod.groups" */
export type Uogorod_Groups_On_Conflict = {
  constraint: Uogorod_Groups_Constraint;
  update_columns?: Array<Uogorod_Groups_Update_Column>;
  where?: InputMaybe<Uogorod_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.groups". */
export type Uogorod_Groups_Order_By = {
  category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.groups */
export type Uogorod_Groups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.groups" */
export enum Uogorod_Groups_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.groups" */
export type Uogorod_Groups_Set_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Groups_Stddev_Fields = {
  __typename?: 'uogorod_groups_stddev_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Groups_Stddev_Pop_Fields = {
  __typename?: 'uogorod_groups_stddev_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Groups_Stddev_Samp_Fields = {
  __typename?: 'uogorod_groups_stddev_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_groups" */
export type Uogorod_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Groups_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Groups_Sum_Fields = {
  __typename?: 'uogorod_groups_sum_fields';
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.groups" */
export enum Uogorod_Groups_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Groups_Bool_Exp;
};

/** columns and relationships of "uogorod.groups_users" */
export type Uogorod_Groups_Users = {
  __typename?: 'uogorod_groups_users';
  group_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  moderator: Scalars['Int']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.groups_users" */
export type Uogorod_Groups_Users_Aggregate = {
  __typename?: 'uogorod_groups_users_aggregate';
  aggregate?: Maybe<Uogorod_Groups_Users_Aggregate_Fields>;
  nodes: Array<Uogorod_Groups_Users>;
};

/** aggregate fields of "uogorod.groups_users" */
export type Uogorod_Groups_Users_Aggregate_Fields = {
  __typename?: 'uogorod_groups_users_aggregate_fields';
  avg?: Maybe<Uogorod_Groups_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Groups_Users_Max_Fields>;
  min?: Maybe<Uogorod_Groups_Users_Min_Fields>;
  stddev?: Maybe<Uogorod_Groups_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Groups_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Groups_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Groups_Users_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Groups_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Groups_Users_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Groups_Users_Variance_Fields>;
};


/** aggregate fields of "uogorod.groups_users" */
export type Uogorod_Groups_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Groups_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Groups_Users_Avg_Fields = {
  __typename?: 'uogorod_groups_users_avg_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.groups_users". All fields are combined with a logical 'AND'. */
export type Uogorod_Groups_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Groups_Users_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Groups_Users_Bool_Exp>>;
  group_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  moderator?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.groups_users" */
export enum Uogorod_Groups_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18924Primary = 'idx_18924_primary'
}

/** input type for incrementing numeric columns in table "uogorod.groups_users" */
export type Uogorod_Groups_Users_Inc_Input = {
  group_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  moderator?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.groups_users" */
export type Uogorod_Groups_Users_Insert_Input = {
  group_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  moderator?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Groups_Users_Max_Fields = {
  __typename?: 'uogorod_groups_users_max_fields';
  group_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  moderator?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Groups_Users_Min_Fields = {
  __typename?: 'uogorod_groups_users_min_fields';
  group_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  moderator?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.groups_users" */
export type Uogorod_Groups_Users_Mutation_Response = {
  __typename?: 'uogorod_groups_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Groups_Users>;
};

/** on_conflict condition type for table "uogorod.groups_users" */
export type Uogorod_Groups_Users_On_Conflict = {
  constraint: Uogorod_Groups_Users_Constraint;
  update_columns?: Array<Uogorod_Groups_Users_Update_Column>;
  where?: InputMaybe<Uogorod_Groups_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.groups_users". */
export type Uogorod_Groups_Users_Order_By = {
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderator?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.groups_users */
export type Uogorod_Groups_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.groups_users" */
export enum Uogorod_Groups_Users_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Moderator = 'moderator',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.groups_users" */
export type Uogorod_Groups_Users_Set_Input = {
  group_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  moderator?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Groups_Users_Stddev_Fields = {
  __typename?: 'uogorod_groups_users_stddev_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Groups_Users_Stddev_Pop_Fields = {
  __typename?: 'uogorod_groups_users_stddev_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Groups_Users_Stddev_Samp_Fields = {
  __typename?: 'uogorod_groups_users_stddev_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_groups_users" */
export type Uogorod_Groups_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Groups_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Groups_Users_Stream_Cursor_Value_Input = {
  group_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  moderator?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Groups_Users_Sum_Fields = {
  __typename?: 'uogorod_groups_users_sum_fields';
  group_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  moderator?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.groups_users" */
export enum Uogorod_Groups_Users_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Moderator = 'moderator',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Groups_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Groups_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Groups_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Groups_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Groups_Users_Var_Pop_Fields = {
  __typename?: 'uogorod_groups_users_var_pop_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Groups_Users_Var_Samp_Fields = {
  __typename?: 'uogorod_groups_users_var_samp_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Groups_Users_Variance_Fields = {
  __typename?: 'uogorod_groups_users_variance_fields';
  group_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  moderator?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Uogorod_Groups_Var_Pop_Fields = {
  __typename?: 'uogorod_groups_var_pop_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Groups_Var_Samp_Fields = {
  __typename?: 'uogorod_groups_var_samp_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Groups_Variance_Fields = {
  __typename?: 'uogorod_groups_variance_fields';
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.images" */
export type Uogorod_Images = {
  __typename?: 'uogorod_images';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['bigint']['output'];
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  likes: Array<Uogorod_Likes>;
  /** An aggregate relationship */
  likes_aggregate: Uogorod_Likes_Aggregate;
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Uogorod_Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "uogorod.images" */
export type Uogorod_ImagesIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};


/** columns and relationships of "uogorod.images" */
export type Uogorod_ImagesLikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


/** columns and relationships of "uogorod.images" */
export type Uogorod_ImagesLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};

/** aggregated selection of "uogorod.images" */
export type Uogorod_Images_Aggregate = {
  __typename?: 'uogorod_images_aggregate';
  aggregate?: Maybe<Uogorod_Images_Aggregate_Fields>;
  nodes: Array<Uogorod_Images>;
};

export type Uogorod_Images_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Images_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.images" */
export type Uogorod_Images_Aggregate_Fields = {
  __typename?: 'uogorod_images_aggregate_fields';
  avg?: Maybe<Uogorod_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Images_Max_Fields>;
  min?: Maybe<Uogorod_Images_Min_Fields>;
  stddev?: Maybe<Uogorod_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Images_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Images_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Images_Variance_Fields>;
};


/** aggregate fields of "uogorod.images" */
export type Uogorod_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.images" */
export type Uogorod_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Images_Max_Order_By>;
  min?: InputMaybe<Uogorod_Images_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.images" */
export type Uogorod_Images_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Images_Avg_Fields = {
  __typename?: 'uogorod_images_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate avg on columns */
export type Uogorod_Images_Avg_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by avg() on columns of table "uogorod.images" */
export type Uogorod_Images_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.images". All fields are combined with a logical 'AND'. */
export type Uogorod_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Images_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  likes?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Bool_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.images" */
export enum Uogorod_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18929Primary = 'idx_18929_primary',
  /** unique or primary key constraint on columns "uuid" */
  ImagesUuidKey = 'images_uuid_key'
}

/** input type for incrementing numeric columns in table "uogorod.images" */
export type Uogorod_Images_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.images" */
export type Uogorod_Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  likes?: InputMaybe<Uogorod_Likes_Arr_Rel_Insert_Input>;
  note?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Images_Max_Fields = {
  __typename?: 'uogorod_images_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};


/** aggregate max on columns */
export type Uogorod_Images_Max_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by max() on columns of table "uogorod.images" */
export type Uogorod_Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Images_Min_Fields = {
  __typename?: 'uogorod_images_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};


/** aggregate min on columns */
export type Uogorod_Images_Min_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by min() on columns of table "uogorod.images" */
export type Uogorod_Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.images" */
export type Uogorod_Images_Mutation_Response = {
  __typename?: 'uogorod_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Images>;
};

/** input type for inserting object relation for remote table "uogorod.images" */
export type Uogorod_Images_Obj_Rel_Insert_Input = {
  data: Uogorod_Images_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Images_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.images" */
export type Uogorod_Images_On_Conflict = {
  constraint: Uogorod_Images_Constraint;
  update_columns?: Array<Uogorod_Images_Update_Column>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.images". */
export type Uogorod_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Order_By>;
  note?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.images */
export type Uogorod_Images_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.images" */
export enum Uogorod_Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "uogorod.images" */
export type Uogorod_Images_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Images_Stddev_Fields = {
  __typename?: 'uogorod_images_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev on columns */
export type Uogorod_Images_Stddev_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by stddev() on columns of table "uogorod.images" */
export type Uogorod_Images_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Images_Stddev_Pop_Fields = {
  __typename?: 'uogorod_images_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_pop on columns */
export type Uogorod_Images_Stddev_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by stddev_pop() on columns of table "uogorod.images" */
export type Uogorod_Images_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Images_Stddev_Samp_Fields = {
  __typename?: 'uogorod_images_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_samp on columns */
export type Uogorod_Images_Stddev_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by stddev_samp() on columns of table "uogorod.images" */
export type Uogorod_Images_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_images" */
export type Uogorod_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Images_Sum_Fields = {
  __typename?: 'uogorod_images_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate sum on columns */
export type Uogorod_Images_Sum_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by sum() on columns of table "uogorod.images" */
export type Uogorod_Images_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.images" */
export enum Uogorod_Images_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Uuid = 'uuid'
}

export type Uogorod_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Images_Var_Pop_Fields = {
  __typename?: 'uogorod_images_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_pop on columns */
export type Uogorod_Images_Var_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by var_pop() on columns of table "uogorod.images" */
export type Uogorod_Images_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Images_Var_Samp_Fields = {
  __typename?: 'uogorod_images_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_samp on columns */
export type Uogorod_Images_Var_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by var_samp() on columns of table "uogorod.images" */
export type Uogorod_Images_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Images_Variance_Fields = {
  __typename?: 'uogorod_images_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.images_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate variance on columns */
export type Uogorod_Images_Variance_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Images_Args;
};

/** order by variance() on columns of table "uogorod.images" */
export type Uogorod_Images_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.likes" */
export type Uogorod_Likes = {
  __typename?: 'uogorod_likes';
  created_at: Scalars['timestamptz']['output'];
  entity_id: Scalars['bigint']['output'];
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  user: Uogorod_Users;
  user_id: Scalars['bigint']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "uogorod.likes" */
export type Uogorod_Likes_Aggregate = {
  __typename?: 'uogorod_likes_aggregate';
  aggregate?: Maybe<Uogorod_Likes_Aggregate_Fields>;
  nodes: Array<Uogorod_Likes>;
};

export type Uogorod_Likes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Likes_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Likes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.likes" */
export type Uogorod_Likes_Aggregate_Fields = {
  __typename?: 'uogorod_likes_aggregate_fields';
  avg?: Maybe<Uogorod_Likes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Likes_Max_Fields>;
  min?: Maybe<Uogorod_Likes_Min_Fields>;
  stddev?: Maybe<Uogorod_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Likes_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Likes_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Likes_Variance_Fields>;
};


/** aggregate fields of "uogorod.likes" */
export type Uogorod_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.likes" */
export type Uogorod_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Likes_Max_Order_By>;
  min?: InputMaybe<Uogorod_Likes_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Likes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.likes" */
export type Uogorod_Likes_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Likes_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Likes_Avg_Fields = {
  __typename?: 'uogorod_likes_avg_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Avg_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.likes". All fields are combined with a logical 'AND'. */
export type Uogorod_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Likes_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Likes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.likes" */
export enum Uogorod_Likes_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19082Primary = 'idx_19082_primary',
  /** unique or primary key constraint on columns "entity_type", "user_id", "entity_id" */
  LikesUserIdEntityIdEntityTypeKey = 'likes_user_id_entity_id_entity_type_key'
}

/** input type for incrementing numeric columns in table "uogorod.likes" */
export type Uogorod_Likes_Inc_Input = {
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.likes" */
export type Uogorod_Likes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Likes_Max_Fields = {
  __typename?: 'uogorod_likes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Likes_Min_Fields = {
  __typename?: 'uogorod_likes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.likes" */
export type Uogorod_Likes_Mutation_Response = {
  __typename?: 'uogorod_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Likes>;
};

/** input type for inserting object relation for remote table "uogorod.likes" */
export type Uogorod_Likes_Obj_Rel_Insert_Input = {
  data: Uogorod_Likes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Likes_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.likes" */
export type Uogorod_Likes_On_Conflict = {
  constraint: Uogorod_Likes_Constraint;
  update_columns?: Array<Uogorod_Likes_Update_Column>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.likes". */
export type Uogorod_Likes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.likes */
export type Uogorod_Likes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.likes" */
export enum Uogorod_Likes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "uogorod.likes" */
export type Uogorod_Likes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Likes_Stddev_Fields = {
  __typename?: 'uogorod_likes_stddev_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Stddev_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Likes_Stddev_Pop_Fields = {
  __typename?: 'uogorod_likes_stddev_pop_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Stddev_Pop_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Likes_Stddev_Samp_Fields = {
  __typename?: 'uogorod_likes_stddev_samp_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Stddev_Samp_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_likes" */
export type Uogorod_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Likes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-отзыв,2-топик(юзера или сообщества),3-фото */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Likes_Sum_Fields = {
  __typename?: 'uogorod_likes_sum_fields';
  entity_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Sum_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.likes" */
export enum Uogorod_Likes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Uogorod_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Likes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Likes_Var_Pop_Fields = {
  __typename?: 'uogorod_likes_var_pop_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Var_Pop_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Likes_Var_Samp_Fields = {
  __typename?: 'uogorod_likes_var_samp_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Var_Samp_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Likes_Variance_Fields = {
  __typename?: 'uogorod_likes_variance_fields';
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.likes" */
export type Uogorod_Likes_Variance_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.manual" */
export type Uogorod_Manual = {
  __typename?: 'uogorod_manual';
  ancestors_bad: Scalars['jsonb']['output'];
  ancestors_good: Scalars['jsonb']['output'];
  author_id?: Maybe<Scalars['bigint']['output']>;
  biology: Scalars['jsonb']['output'];
  /** An object relationship */
  category?: Maybe<Uogorod_Seed_Categories>;
  category_id: Scalars['bigint']['output'];
  content: Scalars['jsonb']['output'];
  id: Scalars['bigint']['output'];
  image?: Maybe<Scalars['String']['output']>;
  seedling: Scalars['jsonb']['output'];
};


/** columns and relationships of "uogorod.manual" */
export type Uogorod_ManualAncestors_BadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.manual" */
export type Uogorod_ManualAncestors_GoodArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.manual" */
export type Uogorod_ManualBiologyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.manual" */
export type Uogorod_ManualContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.manual" */
export type Uogorod_ManualSeedlingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.manual" */
export type Uogorod_Manual_Aggregate = {
  __typename?: 'uogorod_manual_aggregate';
  aggregate?: Maybe<Uogorod_Manual_Aggregate_Fields>;
  nodes: Array<Uogorod_Manual>;
};

/** aggregate fields of "uogorod.manual" */
export type Uogorod_Manual_Aggregate_Fields = {
  __typename?: 'uogorod_manual_aggregate_fields';
  avg?: Maybe<Uogorod_Manual_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Manual_Max_Fields>;
  min?: Maybe<Uogorod_Manual_Min_Fields>;
  stddev?: Maybe<Uogorod_Manual_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Manual_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Manual_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Manual_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Manual_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Manual_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Manual_Variance_Fields>;
};


/** aggregate fields of "uogorod.manual" */
export type Uogorod_Manual_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Manual_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Manual_Append_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Manual_Avg_Fields = {
  __typename?: 'uogorod_manual_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.manual". All fields are combined with a logical 'AND'. */
export type Uogorod_Manual_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Manual_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Manual_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Manual_Bool_Exp>>;
  ancestors_bad?: InputMaybe<Jsonb_Comparison_Exp>;
  ancestors_good?: InputMaybe<Jsonb_Comparison_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  biology?: InputMaybe<Jsonb_Comparison_Exp>;
  category?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  seedling?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.manual" */
export enum Uogorod_Manual_Constraint {
  /** unique or primary key constraint on columns "category_id" */
  Idx_18933CategoryId = 'idx_18933_category_id',
  /** unique or primary key constraint on columns "id" */
  ManualIdKey = 'manual_id_key',
  /** unique or primary key constraint on columns "id" */
  ManualPkey = 'manual_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Manual_Delete_At_Path_Input = {
  ancestors_bad?: InputMaybe<Array<Scalars['String']['input']>>;
  ancestors_good?: InputMaybe<Array<Scalars['String']['input']>>;
  biology?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  seedling?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Manual_Delete_Elem_Input = {
  ancestors_bad?: InputMaybe<Scalars['Int']['input']>;
  ancestors_good?: InputMaybe<Scalars['Int']['input']>;
  biology?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['Int']['input']>;
  seedling?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Manual_Delete_Key_Input = {
  ancestors_bad?: InputMaybe<Scalars['String']['input']>;
  ancestors_good?: InputMaybe<Scalars['String']['input']>;
  biology?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.manual" */
export type Uogorod_Manual_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.manual" */
export type Uogorod_Manual_Insert_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Uogorod_Seed_Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Manual_Max_Fields = {
  __typename?: 'uogorod_manual_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Manual_Min_Fields = {
  __typename?: 'uogorod_manual_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.manual" */
export type Uogorod_Manual_Mutation_Response = {
  __typename?: 'uogorod_manual_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Manual>;
};

/** input type for inserting object relation for remote table "uogorod.manual" */
export type Uogorod_Manual_Obj_Rel_Insert_Input = {
  data: Uogorod_Manual_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Manual_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.manual" */
export type Uogorod_Manual_On_Conflict = {
  constraint: Uogorod_Manual_Constraint;
  update_columns?: Array<Uogorod_Manual_Update_Column>;
  where?: InputMaybe<Uogorod_Manual_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.manual". */
export type Uogorod_Manual_Order_By = {
  ancestors_bad?: InputMaybe<Order_By>;
  ancestors_good?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  biology?: InputMaybe<Order_By>;
  category?: InputMaybe<Uogorod_Seed_Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  seedling?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.manual */
export type Uogorod_Manual_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Manual_Prepend_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.manual" */
export enum Uogorod_Manual_Select_Column {
  /** column name */
  AncestorsBad = 'ancestors_bad',
  /** column name */
  AncestorsGood = 'ancestors_good',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Biology = 'biology',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Seedling = 'seedling'
}

/** input type for updating data in table "uogorod.manual" */
export type Uogorod_Manual_Set_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Manual_Stddev_Fields = {
  __typename?: 'uogorod_manual_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Manual_Stddev_Pop_Fields = {
  __typename?: 'uogorod_manual_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Manual_Stddev_Samp_Fields = {
  __typename?: 'uogorod_manual_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_manual" */
export type Uogorod_Manual_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Manual_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Manual_Stream_Cursor_Value_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Manual_Sum_Fields = {
  __typename?: 'uogorod_manual_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.manual" */
export enum Uogorod_Manual_Update_Column {
  /** column name */
  AncestorsBad = 'ancestors_bad',
  /** column name */
  AncestorsGood = 'ancestors_good',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Biology = 'biology',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Seedling = 'seedling'
}

export type Uogorod_Manual_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Manual_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Manual_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Manual_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Manual_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Manual_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Manual_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Manual_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Manual_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Manual_Var_Pop_Fields = {
  __typename?: 'uogorod_manual_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Manual_Var_Samp_Fields = {
  __typename?: 'uogorod_manual_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Manual_Variance_Fields = {
  __typename?: 'uogorod_manual_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.messages" */
export type Uogorod_Messages = {
  __typename?: 'uogorod_messages';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  images?: Maybe<Scalars['jsonb']['output']>;
  is_readed: Scalars['Boolean']['output'];
  /** An object relationship */
  receiver: Uogorod_Users;
  receiver_id: Scalars['Int']['output'];
  /** An object relationship */
  sender: Uogorod_Users;
  sender_id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};


/** columns and relationships of "uogorod.messages" */
export type Uogorod_MessagesImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.messages" */
export type Uogorod_Messages_Aggregate = {
  __typename?: 'uogorod_messages_aggregate';
  aggregate?: Maybe<Uogorod_Messages_Aggregate_Fields>;
  nodes: Array<Uogorod_Messages>;
};

export type Uogorod_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uogorod_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uogorod_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uogorod_Messages_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uogorod_Messages_Select_Column_Uogorod_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uogorod_Messages_Select_Column_Uogorod_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.messages" */
export type Uogorod_Messages_Aggregate_Fields = {
  __typename?: 'uogorod_messages_aggregate_fields';
  avg?: Maybe<Uogorod_Messages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Messages_Max_Fields>;
  min?: Maybe<Uogorod_Messages_Min_Fields>;
  stddev?: Maybe<Uogorod_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Messages_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Messages_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Messages_Variance_Fields>;
};


/** aggregate fields of "uogorod.messages" */
export type Uogorod_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.messages" */
export type Uogorod_Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Messages_Max_Order_By>;
  min?: InputMaybe<Uogorod_Messages_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Messages_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Messages_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.messages" */
export type Uogorod_Messages_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Messages_Avg_Fields = {
  __typename?: 'uogorod_messages_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.messages". All fields are combined with a logical 'AND'. */
export type Uogorod_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Messages_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Messages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  is_readed?: InputMaybe<Boolean_Comparison_Exp>;
  receiver?: InputMaybe<Uogorod_Users_Bool_Exp>;
  receiver_id?: InputMaybe<Int_Comparison_Exp>;
  sender?: InputMaybe<Uogorod_Users_Bool_Exp>;
  sender_id?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.messages" */
export enum Uogorod_Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Messages_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Messages_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Messages_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.messages" */
export type Uogorod_Messages_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  receiver_id?: InputMaybe<Scalars['Int']['input']>;
  sender_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.messages" */
export type Uogorod_Messages_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  is_readed?: InputMaybe<Scalars['Boolean']['input']>;
  receiver?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  receiver_id?: InputMaybe<Scalars['Int']['input']>;
  sender?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  sender_id?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Messages_Max_Fields = {
  __typename?: 'uogorod_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  receiver_id?: Maybe<Scalars['Int']['output']>;
  sender_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Messages_Min_Fields = {
  __typename?: 'uogorod_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  receiver_id?: Maybe<Scalars['Int']['output']>;
  sender_id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.messages" */
export type Uogorod_Messages_Mutation_Response = {
  __typename?: 'uogorod_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Messages>;
};

/** on_conflict condition type for table "uogorod.messages" */
export type Uogorod_Messages_On_Conflict = {
  constraint: Uogorod_Messages_Constraint;
  update_columns?: Array<Uogorod_Messages_Update_Column>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.messages". */
export type Uogorod_Messages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  is_readed?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Uogorod_Users_Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender?: InputMaybe<Uogorod_Users_Order_By>;
  sender_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.messages */
export type Uogorod_Messages_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Messages_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.messages" */
export enum Uogorod_Messages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsReaded = 'is_readed',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  Text = 'text'
}

/** select "uogorod_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uogorod.messages" */
export enum Uogorod_Messages_Select_Column_Uogorod_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsReaded = 'is_readed'
}

/** select "uogorod_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uogorod.messages" */
export enum Uogorod_Messages_Select_Column_Uogorod_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsReaded = 'is_readed'
}

/** input type for updating data in table "uogorod.messages" */
export type Uogorod_Messages_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  is_readed?: InputMaybe<Scalars['Boolean']['input']>;
  receiver_id?: InputMaybe<Scalars['Int']['input']>;
  sender_id?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Messages_Stddev_Fields = {
  __typename?: 'uogorod_messages_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Messages_Stddev_Pop_Fields = {
  __typename?: 'uogorod_messages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Messages_Stddev_Samp_Fields = {
  __typename?: 'uogorod_messages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_messages" */
export type Uogorod_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Messages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  is_readed?: InputMaybe<Scalars['Boolean']['input']>;
  receiver_id?: InputMaybe<Scalars['Int']['input']>;
  sender_id?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Messages_Sum_Fields = {
  __typename?: 'uogorod_messages_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  receiver_id?: Maybe<Scalars['Int']['output']>;
  sender_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.messages" */
export enum Uogorod_Messages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  IsReaded = 'is_readed',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  Text = 'text'
}

export type Uogorod_Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Messages_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Messages_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Messages_Var_Pop_Fields = {
  __typename?: 'uogorod_messages_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Messages_Var_Samp_Fields = {
  __typename?: 'uogorod_messages_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Messages_Variance_Fields = {
  __typename?: 'uogorod_messages_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.messages" */
export type Uogorod_Messages_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.notifications" */
export type Uogorod_Notifications = {
  __typename?: 'uogorod_notifications';
  comment_id: Scalars['bigint']['output'];
  created_at: Scalars['timestamptz']['output'];
  experiment_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  ogorod_id: Scalars['bigint']['output'];
  page_name: Scalars['String']['output'];
  page_url: Scalars['String']['output'];
  post_id: Scalars['bigint']['output'];
  receiver_id: Scalars['bigint']['output'];
  review_id: Scalars['bigint']['output'];
  sender_id: Scalars['bigint']['output'];
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type: Scalars['Int']['output'];
  user_id: Scalars['bigint']['output'];
  view: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.notifications" */
export type Uogorod_Notifications_Aggregate = {
  __typename?: 'uogorod_notifications_aggregate';
  aggregate?: Maybe<Uogorod_Notifications_Aggregate_Fields>;
  nodes: Array<Uogorod_Notifications>;
};

/** aggregate fields of "uogorod.notifications" */
export type Uogorod_Notifications_Aggregate_Fields = {
  __typename?: 'uogorod_notifications_aggregate_fields';
  avg?: Maybe<Uogorod_Notifications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Notifications_Max_Fields>;
  min?: Maybe<Uogorod_Notifications_Min_Fields>;
  stddev?: Maybe<Uogorod_Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Notifications_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Notifications_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Notifications_Variance_Fields>;
};


/** aggregate fields of "uogorod.notifications" */
export type Uogorod_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Notifications_Avg_Fields = {
  __typename?: 'uogorod_notifications_avg_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.notifications". All fields are combined with a logical 'AND'. */
export type Uogorod_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Notifications_Bool_Exp>>;
  comment_id?: InputMaybe<Bigint_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  experiment_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  ogorod_id?: InputMaybe<Bigint_Comparison_Exp>;
  page_name?: InputMaybe<String_Comparison_Exp>;
  page_url?: InputMaybe<String_Comparison_Exp>;
  post_id?: InputMaybe<Bigint_Comparison_Exp>;
  receiver_id?: InputMaybe<Bigint_Comparison_Exp>;
  review_id?: InputMaybe<Bigint_Comparison_Exp>;
  sender_id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  view?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.notifications" */
export enum Uogorod_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18946Primary = 'idx_18946_primary'
}

/** input type for incrementing numeric columns in table "uogorod.notifications" */
export type Uogorod_Notifications_Inc_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  receiver_id?: InputMaybe<Scalars['bigint']['input']>;
  review_id?: InputMaybe<Scalars['bigint']['input']>;
  sender_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  view?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.notifications" */
export type Uogorod_Notifications_Insert_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  page_name?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  receiver_id?: InputMaybe<Scalars['bigint']['input']>;
  review_id?: InputMaybe<Scalars['bigint']['input']>;
  sender_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  view?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Notifications_Max_Fields = {
  __typename?: 'uogorod_notifications_max_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ogorod_id?: Maybe<Scalars['bigint']['output']>;
  page_name?: Maybe<Scalars['String']['output']>;
  page_url?: Maybe<Scalars['String']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  review_id?: Maybe<Scalars['bigint']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  view?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Notifications_Min_Fields = {
  __typename?: 'uogorod_notifications_min_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ogorod_id?: Maybe<Scalars['bigint']['output']>;
  page_name?: Maybe<Scalars['String']['output']>;
  page_url?: Maybe<Scalars['String']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  review_id?: Maybe<Scalars['bigint']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  view?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.notifications" */
export type Uogorod_Notifications_Mutation_Response = {
  __typename?: 'uogorod_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Notifications>;
};

/** on_conflict condition type for table "uogorod.notifications" */
export type Uogorod_Notifications_On_Conflict = {
  constraint: Uogorod_Notifications_Constraint;
  update_columns?: Array<Uogorod_Notifications_Update_Column>;
  where?: InputMaybe<Uogorod_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.notifications". */
export type Uogorod_Notifications_Order_By = {
  comment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experiment_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ogorod_id?: InputMaybe<Order_By>;
  page_name?: InputMaybe<Order_By>;
  page_url?: InputMaybe<Order_By>;
  post_id?: InputMaybe<Order_By>;
  receiver_id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  sender_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.notifications */
export type Uogorod_Notifications_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.notifications" */
export enum Uogorod_Notifications_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  OgorodId = 'ogorod_id',
  /** column name */
  PageName = 'page_name',
  /** column name */
  PageUrl = 'page_url',
  /** column name */
  PostId = 'post_id',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  View = 'view'
}

/** input type for updating data in table "uogorod.notifications" */
export type Uogorod_Notifications_Set_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  page_name?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  receiver_id?: InputMaybe<Scalars['bigint']['input']>;
  review_id?: InputMaybe<Scalars['bigint']['input']>;
  sender_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  view?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Notifications_Stddev_Fields = {
  __typename?: 'uogorod_notifications_stddev_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Notifications_Stddev_Pop_Fields = {
  __typename?: 'uogorod_notifications_stddev_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Notifications_Stddev_Samp_Fields = {
  __typename?: 'uogorod_notifications_stddev_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_notifications" */
export type Uogorod_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Notifications_Stream_Cursor_Value_Input = {
  comment_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  experiment_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  page_name?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['bigint']['input']>;
  receiver_id?: InputMaybe<Scalars['bigint']['input']>;
  review_id?: InputMaybe<Scalars['bigint']['input']>;
  sender_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  view?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Notifications_Sum_Fields = {
  __typename?: 'uogorod_notifications_sum_fields';
  comment_id?: Maybe<Scalars['bigint']['output']>;
  experiment_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ogorod_id?: Maybe<Scalars['bigint']['output']>;
  post_id?: Maybe<Scalars['bigint']['output']>;
  receiver_id?: Maybe<Scalars['bigint']['output']>;
  review_id?: Maybe<Scalars['bigint']['output']>;
  sender_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  view?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.notifications" */
export enum Uogorod_Notifications_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExperimentId = 'experiment_id',
  /** column name */
  Id = 'id',
  /** column name */
  OgorodId = 'ogorod_id',
  /** column name */
  PageName = 'page_name',
  /** column name */
  PageUrl = 'page_url',
  /** column name */
  PostId = 'post_id',
  /** column name */
  ReceiverId = 'receiver_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  View = 'view'
}

export type Uogorod_Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Notifications_Var_Pop_Fields = {
  __typename?: 'uogorod_notifications_var_pop_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Notifications_Var_Samp_Fields = {
  __typename?: 'uogorod_notifications_var_samp_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Notifications_Variance_Fields = {
  __typename?: 'uogorod_notifications_variance_fields';
  comment_id?: Maybe<Scalars['Float']['output']>;
  experiment_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ogorod_id?: Maybe<Scalars['Float']['output']>;
  post_id?: Maybe<Scalars['Float']['output']>;
  receiver_id?: Maybe<Scalars['Float']['output']>;
  review_id?: Maybe<Scalars['Float']['output']>;
  sender_id?: Maybe<Scalars['Float']['output']>;
  /** 1-лайк,2-комментарий,3-подписка,4-репост,5-день рождения,6-коммент коммента */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  view?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.onboarding" */
export type Uogorod_Onboarding = {
  __typename?: 'uogorod_onboarding';
  comments?: Maybe<Scalars['Int']['output']>;
  germination?: Maybe<Scalars['Int']['output']>;
  ground?: Maybe<Scalars['Int']['output']>;
  harvest?: Maybe<Scalars['Int']['output']>;
  plants?: Maybe<Scalars['bigint']['output']>;
  sowing?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "uogorod.onboarding" */
export type Uogorod_Onboarding_Aggregate = {
  __typename?: 'uogorod_onboarding_aggregate';
  aggregate?: Maybe<Uogorod_Onboarding_Aggregate_Fields>;
  nodes: Array<Uogorod_Onboarding>;
};

/** aggregate fields of "uogorod.onboarding" */
export type Uogorod_Onboarding_Aggregate_Fields = {
  __typename?: 'uogorod_onboarding_aggregate_fields';
  avg?: Maybe<Uogorod_Onboarding_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Onboarding_Max_Fields>;
  min?: Maybe<Uogorod_Onboarding_Min_Fields>;
  stddev?: Maybe<Uogorod_Onboarding_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Onboarding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Onboarding_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Onboarding_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Onboarding_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Onboarding_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Onboarding_Variance_Fields>;
};


/** aggregate fields of "uogorod.onboarding" */
export type Uogorod_Onboarding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Onboarding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Onboarding_Avg_Fields = {
  __typename?: 'uogorod_onboarding_avg_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.onboarding". All fields are combined with a logical 'AND'. */
export type Uogorod_Onboarding_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Onboarding_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Onboarding_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Onboarding_Bool_Exp>>;
  comments?: InputMaybe<Int_Comparison_Exp>;
  germination?: InputMaybe<Int_Comparison_Exp>;
  ground?: InputMaybe<Int_Comparison_Exp>;
  harvest?: InputMaybe<Int_Comparison_Exp>;
  plants?: InputMaybe<Bigint_Comparison_Exp>;
  sowing?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Uogorod_Onboarding_Max_Fields = {
  __typename?: 'uogorod_onboarding_max_fields';
  comments?: Maybe<Scalars['Int']['output']>;
  germination?: Maybe<Scalars['Int']['output']>;
  ground?: Maybe<Scalars['Int']['output']>;
  harvest?: Maybe<Scalars['Int']['output']>;
  plants?: Maybe<Scalars['bigint']['output']>;
  sowing?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Onboarding_Min_Fields = {
  __typename?: 'uogorod_onboarding_min_fields';
  comments?: Maybe<Scalars['Int']['output']>;
  germination?: Maybe<Scalars['Int']['output']>;
  ground?: Maybe<Scalars['Int']['output']>;
  harvest?: Maybe<Scalars['Int']['output']>;
  plants?: Maybe<Scalars['bigint']['output']>;
  sowing?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "uogorod.onboarding". */
export type Uogorod_Onboarding_Order_By = {
  comments?: InputMaybe<Order_By>;
  germination?: InputMaybe<Order_By>;
  ground?: InputMaybe<Order_By>;
  harvest?: InputMaybe<Order_By>;
  plants?: InputMaybe<Order_By>;
  sowing?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.onboarding" */
export enum Uogorod_Onboarding_Select_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  Germination = 'germination',
  /** column name */
  Ground = 'ground',
  /** column name */
  Harvest = 'harvest',
  /** column name */
  Plants = 'plants',
  /** column name */
  Sowing = 'sowing',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Uogorod_Onboarding_Stddev_Fields = {
  __typename?: 'uogorod_onboarding_stddev_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Onboarding_Stddev_Pop_Fields = {
  __typename?: 'uogorod_onboarding_stddev_pop_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Onboarding_Stddev_Samp_Fields = {
  __typename?: 'uogorod_onboarding_stddev_samp_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_onboarding" */
export type Uogorod_Onboarding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Onboarding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Onboarding_Stream_Cursor_Value_Input = {
  comments?: InputMaybe<Scalars['Int']['input']>;
  germination?: InputMaybe<Scalars['Int']['input']>;
  ground?: InputMaybe<Scalars['Int']['input']>;
  harvest?: InputMaybe<Scalars['Int']['input']>;
  plants?: InputMaybe<Scalars['bigint']['input']>;
  sowing?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Onboarding_Sum_Fields = {
  __typename?: 'uogorod_onboarding_sum_fields';
  comments?: Maybe<Scalars['Int']['output']>;
  germination?: Maybe<Scalars['Int']['output']>;
  ground?: Maybe<Scalars['Int']['output']>;
  harvest?: Maybe<Scalars['Int']['output']>;
  plants?: Maybe<Scalars['bigint']['output']>;
  sowing?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Uogorod_Onboarding_Var_Pop_Fields = {
  __typename?: 'uogorod_onboarding_var_pop_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Onboarding_Var_Samp_Fields = {
  __typename?: 'uogorod_onboarding_var_samp_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Onboarding_Variance_Fields = {
  __typename?: 'uogorod_onboarding_variance_fields';
  comments?: Maybe<Scalars['Float']['output']>;
  germination?: Maybe<Scalars['Float']['output']>;
  ground?: Maybe<Scalars['Float']['output']>;
  harvest?: Maybe<Scalars['Float']['output']>;
  plants?: Maybe<Scalars['Float']['output']>;
  sowing?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.pages" */
export type Uogorod_Pages = {
  __typename?: 'uogorod_pages';
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.pages" */
export type Uogorod_Pages_Aggregate = {
  __typename?: 'uogorod_pages_aggregate';
  aggregate?: Maybe<Uogorod_Pages_Aggregate_Fields>;
  nodes: Array<Uogorod_Pages>;
};

/** aggregate fields of "uogorod.pages" */
export type Uogorod_Pages_Aggregate_Fields = {
  __typename?: 'uogorod_pages_aggregate_fields';
  avg?: Maybe<Uogorod_Pages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Pages_Max_Fields>;
  min?: Maybe<Uogorod_Pages_Min_Fields>;
  stddev?: Maybe<Uogorod_Pages_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Pages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Pages_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Pages_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Pages_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Pages_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Pages_Variance_Fields>;
};


/** aggregate fields of "uogorod.pages" */
export type Uogorod_Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Pages_Avg_Fields = {
  __typename?: 'uogorod_pages_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.pages". All fields are combined with a logical 'AND'. */
export type Uogorod_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Pages_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Pages_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.pages" */
export enum Uogorod_Pages_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18954Primary = 'idx_18954_primary'
}

/** input type for incrementing numeric columns in table "uogorod.pages" */
export type Uogorod_Pages_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.pages" */
export type Uogorod_Pages_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Pages_Max_Fields = {
  __typename?: 'uogorod_pages_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Pages_Min_Fields = {
  __typename?: 'uogorod_pages_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.pages" */
export type Uogorod_Pages_Mutation_Response = {
  __typename?: 'uogorod_pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Pages>;
};

/** on_conflict condition type for table "uogorod.pages" */
export type Uogorod_Pages_On_Conflict = {
  constraint: Uogorod_Pages_Constraint;
  update_columns?: Array<Uogorod_Pages_Update_Column>;
  where?: InputMaybe<Uogorod_Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.pages". */
export type Uogorod_Pages_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.pages */
export type Uogorod_Pages_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.pages" */
export enum Uogorod_Pages_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Text = 'text',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "uogorod.pages" */
export type Uogorod_Pages_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Pages_Stddev_Fields = {
  __typename?: 'uogorod_pages_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Pages_Stddev_Pop_Fields = {
  __typename?: 'uogorod_pages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Pages_Stddev_Samp_Fields = {
  __typename?: 'uogorod_pages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_pages" */
export type Uogorod_Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Pages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Pages_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Pages_Sum_Fields = {
  __typename?: 'uogorod_pages_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.pages" */
export enum Uogorod_Pages_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Text = 'text',
  /** column name */
  Url = 'url'
}

export type Uogorod_Pages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Pages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Pages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Pages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Pages_Var_Pop_Fields = {
  __typename?: 'uogorod_pages_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Pages_Var_Samp_Fields = {
  __typename?: 'uogorod_pages_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Pages_Variance_Fields = {
  __typename?: 'uogorod_pages_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.posts" */
export type Uogorod_Posts = {
  __typename?: 'uogorod_posts';
  allow_comments: Scalars['Boolean']['output'];
  /** An object relationship */
  author?: Maybe<Uogorod_Users>;
  author_id: Scalars['bigint']['output'];
  /** An array relationship */
  comments: Array<Uogorod_Comments>;
  /** An aggregate relationship */
  comments_aggregate: Uogorod_Comments_Aggregate;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  images: Scalars['jsonb']['output'];
  in_feed: Scalars['Boolean']['output'];
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  likes: Array<Uogorod_Likes>;
  /** An aggregate relationship */
  likes_aggregate: Uogorod_Likes_Aggregate;
  /** Доступ только подписчикам? */
  privatnost: Scalars['Int']['output'];
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['bigint']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['bigint']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  views: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsLikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


/** columns and relationships of "uogorod.posts" */
export type Uogorod_PostsLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};

/** aggregated selection of "uogorod.posts" */
export type Uogorod_Posts_Aggregate = {
  __typename?: 'uogorod_posts_aggregate';
  aggregate?: Maybe<Uogorod_Posts_Aggregate_Fields>;
  nodes: Array<Uogorod_Posts>;
};

export type Uogorod_Posts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uogorod_Posts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uogorod_Posts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uogorod_Posts_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Posts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uogorod_Posts_Select_Column_Uogorod_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Posts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uogorod_Posts_Select_Column_Uogorod_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Posts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Posts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Posts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.posts" */
export type Uogorod_Posts_Aggregate_Fields = {
  __typename?: 'uogorod_posts_aggregate_fields';
  avg?: Maybe<Uogorod_Posts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Posts_Max_Fields>;
  min?: Maybe<Uogorod_Posts_Min_Fields>;
  stddev?: Maybe<Uogorod_Posts_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Posts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Posts_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Posts_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Posts_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Posts_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Posts_Variance_Fields>;
};


/** aggregate fields of "uogorod.posts" */
export type Uogorod_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.posts" */
export type Uogorod_Posts_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Posts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Posts_Max_Order_By>;
  min?: InputMaybe<Uogorod_Posts_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Posts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Posts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Posts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Posts_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Posts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Posts_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Posts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Posts_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.posts" */
export type Uogorod_Posts_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Posts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Posts_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Posts_Avg_Fields = {
  __typename?: 'uogorod_posts_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate avg on columns */
export type Uogorod_Posts_Avg_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by avg() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Avg_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.posts". All fields are combined with a logical 'AND'. */
export type Uogorod_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Posts_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Posts_Bool_Exp>>;
  allow_comments?: InputMaybe<Boolean_Comparison_Exp>;
  author?: InputMaybe<Uogorod_Users_Bool_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  comments?: InputMaybe<Uogorod_Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Uogorod_Comments_Aggregate_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  in_feed?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Bool_Exp>;
  privatnost?: InputMaybe<Int_Comparison_Exp>;
  repost_ogorod_id?: InputMaybe<Bigint_Comparison_Exp>;
  repost_post_id?: InputMaybe<Bigint_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.posts" */
export enum Uogorod_Posts_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18961Primary = 'idx_18961_primary'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Posts_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Posts_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Posts_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.posts" */
export type Uogorod_Posts_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Scalars['Int']['input']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.posts" */
export type Uogorod_Posts_Insert_Input = {
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  comments?: InputMaybe<Uogorod_Comments_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  in_feed?: InputMaybe<Scalars['Boolean']['input']>;
  likes?: InputMaybe<Uogorod_Likes_Arr_Rel_Insert_Input>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Scalars['Int']['input']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Posts_Max_Fields = {
  __typename?: 'uogorod_posts_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Int']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['bigint']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate max on columns */
export type Uogorod_Posts_Max_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by max() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Max_Order_By = {
  author_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Posts_Min_Fields = {
  __typename?: 'uogorod_posts_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Int']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['bigint']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['bigint']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate min on columns */
export type Uogorod_Posts_Min_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by min() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Min_Order_By = {
  author_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.posts" */
export type Uogorod_Posts_Mutation_Response = {
  __typename?: 'uogorod_posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Posts>;
};

/** on_conflict condition type for table "uogorod.posts" */
export type Uogorod_Posts_On_Conflict = {
  constraint: Uogorod_Posts_Constraint;
  update_columns?: Array<Uogorod_Posts_Update_Column>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.posts". */
export type Uogorod_Posts_Order_By = {
  allow_comments?: InputMaybe<Order_By>;
  author?: InputMaybe<Uogorod_Users_Order_By>;
  author_id?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Uogorod_Comments_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  in_feed?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Order_By>;
  privatnost?: InputMaybe<Order_By>;
  repost_ogorod_id?: InputMaybe<Order_By>;
  repost_post_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.posts */
export type Uogorod_Posts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Posts_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.posts" */
export enum Uogorod_Posts_Select_Column {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  InFeed = 'in_feed',
  /** column name */
  Privatnost = 'privatnost',
  /** column name */
  RepostOgorodId = 'repost_ogorod_id',
  /** column name */
  RepostPostId = 'repost_post_id',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  Views = 'views'
}

/** select "uogorod_posts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uogorod.posts" */
export enum Uogorod_Posts_Select_Column_Uogorod_Posts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  InFeed = 'in_feed'
}

/** select "uogorod_posts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uogorod.posts" */
export enum Uogorod_Posts_Select_Column_Uogorod_Posts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  InFeed = 'in_feed'
}

/** input type for updating data in table "uogorod.posts" */
export type Uogorod_Posts_Set_Input = {
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  in_feed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Scalars['Int']['input']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Posts_Stddev_Fields = {
  __typename?: 'uogorod_posts_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev on columns */
export type Uogorod_Posts_Stddev_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by stddev() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Stddev_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Posts_Stddev_Pop_Fields = {
  __typename?: 'uogorod_posts_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_pop on columns */
export type Uogorod_Posts_Stddev_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by stddev_pop() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Stddev_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Posts_Stddev_Samp_Fields = {
  __typename?: 'uogorod_posts_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_samp on columns */
export type Uogorod_Posts_Stddev_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by stddev_samp() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Stddev_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_posts" */
export type Uogorod_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Posts_Stream_Cursor_Value_Input = {
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Это пользовательский пост или пост группы, можно записать как group_id nullable */
  entity_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  in_feed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Scalars['Int']['input']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Scalars['bigint']['input']>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Scalars['bigint']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Posts_Sum_Fields = {
  __typename?: 'uogorod_posts_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Int']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['bigint']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['bigint']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate sum on columns */
export type Uogorod_Posts_Sum_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by sum() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Sum_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.posts" */
export enum Uogorod_Posts_Update_Column {
  /** column name */
  AllowComments = 'allow_comments',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  InFeed = 'in_feed',
  /** column name */
  Privatnost = 'privatnost',
  /** column name */
  RepostOgorodId = 'repost_ogorod_id',
  /** column name */
  RepostPostId = 'repost_post_id',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title',
  /** column name */
  Views = 'views'
}

export type Uogorod_Posts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Posts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Posts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Posts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Posts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Posts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Posts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Posts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Posts_Var_Pop_Fields = {
  __typename?: 'uogorod_posts_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_pop on columns */
export type Uogorod_Posts_Var_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by var_pop() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Var_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Posts_Var_Samp_Fields = {
  __typename?: 'uogorod_posts_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_samp on columns */
export type Uogorod_Posts_Var_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by var_samp() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Var_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Posts_Variance_Fields = {
  __typename?: 'uogorod_posts_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.posts_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** Доступ только подписчикам? */
  privatnost?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: Maybe<Scalars['Float']['output']>;
  /** Репосты, пока не понятно */
  repost_post_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};


/** aggregate variance on columns */
export type Uogorod_Posts_Variance_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Posts_Args;
};

/** order by variance() on columns of table "uogorod.posts" */
export type Uogorod_Posts_Variance_Order_By = {
  author_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Доступ только подписчикам? */
  privatnost?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_ogorod_id?: InputMaybe<Order_By>;
  /** Репосты, пока не понятно */
  repost_post_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.reports" */
export type Uogorod_Reports = {
  __typename?: 'uogorod_reports';
  author_id: Scalars['bigint']['output'];
  comment: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  entity_id: Scalars['bigint']['output'];
  /** 1-коммент,2-юзер,3-пост */
  entity_type: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  report_type: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.reports" */
export type Uogorod_Reports_Aggregate = {
  __typename?: 'uogorod_reports_aggregate';
  aggregate?: Maybe<Uogorod_Reports_Aggregate_Fields>;
  nodes: Array<Uogorod_Reports>;
};

/** aggregate fields of "uogorod.reports" */
export type Uogorod_Reports_Aggregate_Fields = {
  __typename?: 'uogorod_reports_aggregate_fields';
  avg?: Maybe<Uogorod_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Reports_Max_Fields>;
  min?: Maybe<Uogorod_Reports_Min_Fields>;
  stddev?: Maybe<Uogorod_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Reports_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Reports_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Reports_Variance_Fields>;
};


/** aggregate fields of "uogorod.reports" */
export type Uogorod_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Reports_Avg_Fields = {
  __typename?: 'uogorod_reports_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.reports". All fields are combined with a logical 'AND'. */
export type Uogorod_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Reports_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Reports_Bool_Exp>>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_id?: InputMaybe<Bigint_Comparison_Exp>;
  entity_type?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  report_type?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.reports" */
export enum Uogorod_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19130Primary = 'idx_19130_primary'
}

/** input type for incrementing numeric columns in table "uogorod.reports" */
export type Uogorod_Reports_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  report_type?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.reports" */
export type Uogorod_Reports_Insert_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  report_type?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Reports_Max_Fields = {
  __typename?: 'uogorod_reports_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  report_type?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Reports_Min_Fields = {
  __typename?: 'uogorod_reports_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  report_type?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.reports" */
export type Uogorod_Reports_Mutation_Response = {
  __typename?: 'uogorod_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Reports>;
};

/** on_conflict condition type for table "uogorod.reports" */
export type Uogorod_Reports_On_Conflict = {
  constraint: Uogorod_Reports_Constraint;
  update_columns?: Array<Uogorod_Reports_Update_Column>;
  where?: InputMaybe<Uogorod_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.reports". */
export type Uogorod_Reports_Order_By = {
  author_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  report_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.reports */
export type Uogorod_Reports_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.reports" */
export enum Uogorod_Reports_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  ReportType = 'report_type'
}

/** input type for updating data in table "uogorod.reports" */
export type Uogorod_Reports_Set_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  report_type?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Reports_Stddev_Fields = {
  __typename?: 'uogorod_reports_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Reports_Stddev_Pop_Fields = {
  __typename?: 'uogorod_reports_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Reports_Stddev_Samp_Fields = {
  __typename?: 'uogorod_reports_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_reports" */
export type Uogorod_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Reports_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entity_id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  report_type?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Reports_Sum_Fields = {
  __typename?: 'uogorod_reports_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  entity_id?: Maybe<Scalars['bigint']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  report_type?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.reports" */
export enum Uogorod_Reports_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  Id = 'id',
  /** column name */
  ReportType = 'report_type'
}

export type Uogorod_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Reports_Var_Pop_Fields = {
  __typename?: 'uogorod_reports_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Reports_Var_Samp_Fields = {
  __typename?: 'uogorod_reports_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Reports_Variance_Fields = {
  __typename?: 'uogorod_reports_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  entity_id?: Maybe<Scalars['Float']['output']>;
  /** 1-коммент,2-юзер,3-пост */
  entity_type?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  report_type?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.reviews" */
export type Uogorod_Reviews = {
  __typename?: 'uogorod_reviews';
  /** An object relationship */
  brand?: Maybe<Uogorod_Brands>;
  brand_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  comments: Array<Uogorod_Comments>;
  /** An aggregate relationship */
  comments_aggregate: Uogorod_Comments_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  images?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  likes: Array<Uogorod_Likes>;
  /** An aggregate relationship */
  likes_aggregate: Uogorod_Likes_Aggregate;
  minus?: Maybe<Scalars['String']['output']>;
  plus?: Maybe<Scalars['String']['output']>;
  rate: Scalars['numeric']['output'];
  recommended?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  seed?: Maybe<Uogorod_Seeds>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Uogorod_Users>;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Comments_Order_By>>;
  where?: InputMaybe<Uogorod_Comments_Bool_Exp>;
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsLikesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};


/** columns and relationships of "uogorod.reviews" */
export type Uogorod_ReviewsLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Likes_Order_By>>;
  where?: InputMaybe<Uogorod_Likes_Bool_Exp>;
};

/** aggregated selection of "uogorod.reviews" */
export type Uogorod_Reviews_Aggregate = {
  __typename?: 'uogorod_reviews_aggregate';
  aggregate?: Maybe<Uogorod_Reviews_Aggregate_Fields>;
  nodes: Array<Uogorod_Reviews>;
};

export type Uogorod_Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uogorod_Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uogorod_Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uogorod_Reviews_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uogorod_Reviews_Select_Column_Uogorod_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uogorod_Reviews_Select_Column_Uogorod_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.reviews" */
export type Uogorod_Reviews_Aggregate_Fields = {
  __typename?: 'uogorod_reviews_aggregate_fields';
  avg?: Maybe<Uogorod_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Reviews_Max_Fields>;
  min?: Maybe<Uogorod_Reviews_Min_Fields>;
  stddev?: Maybe<Uogorod_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Reviews_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Reviews_Variance_Fields>;
};


/** aggregate fields of "uogorod.reviews" */
export type Uogorod_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.reviews" */
export type Uogorod_Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Reviews_Max_Order_By>;
  min?: InputMaybe<Uogorod_Reviews_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Reviews_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Reviews_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.reviews" */
export type Uogorod_Reviews_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Reviews_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Reviews_Avg_Fields = {
  __typename?: 'uogorod_reviews_avg_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate avg on columns */
export type Uogorod_Reviews_Avg_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by avg() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.reviews". All fields are combined with a logical 'AND'. */
export type Uogorod_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Reviews_Bool_Exp>>;
  brand?: InputMaybe<Uogorod_Brands_Bool_Exp>;
  brand_id?: InputMaybe<Int_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Uogorod_Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Uogorod_Comments_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  likes?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Bool_Exp>;
  minus?: InputMaybe<String_Comparison_Exp>;
  plus?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  recommended?: InputMaybe<Boolean_Comparison_Exp>;
  seed?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.reviews" */
export enum Uogorod_Reviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey',
  /** unique or primary key constraint on columns "user_id", "seed_id" */
  ReviewsUserIdSeedIdKey = 'reviews_user_id_seed_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Reviews_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Reviews_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Reviews_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.reviews" */
export type Uogorod_Reviews_Inc_Input = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.reviews" */
export type Uogorod_Reviews_Insert_Input = {
  brand?: InputMaybe<Uogorod_Brands_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Uogorod_Comments_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  likes?: InputMaybe<Uogorod_Likes_Arr_Rel_Insert_Input>;
  minus?: InputMaybe<Scalars['String']['input']>;
  plus?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  seed?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Reviews_Max_Fields = {
  __typename?: 'uogorod_reviews_max_fields';
  brand_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  minus?: Maybe<Scalars['String']['output']>;
  plus?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate max on columns */
export type Uogorod_Reviews_Max_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by max() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minus?: InputMaybe<Order_By>;
  plus?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Reviews_Min_Fields = {
  __typename?: 'uogorod_reviews_min_fields';
  brand_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  minus?: Maybe<Scalars['String']['output']>;
  plus?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate min on columns */
export type Uogorod_Reviews_Min_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by min() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minus?: InputMaybe<Order_By>;
  plus?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.reviews" */
export type Uogorod_Reviews_Mutation_Response = {
  __typename?: 'uogorod_reviews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Reviews>;
};

/** on_conflict condition type for table "uogorod.reviews" */
export type Uogorod_Reviews_On_Conflict = {
  constraint: Uogorod_Reviews_Constraint;
  update_columns?: Array<Uogorod_Reviews_Update_Column>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.reviews". */
export type Uogorod_Reviews_Order_By = {
  brand?: InputMaybe<Uogorod_Brands_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Uogorod_Comments_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Uogorod_Likes_Aggregate_Order_By>;
  minus?: InputMaybe<Order_By>;
  plus?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  recommended?: InputMaybe<Order_By>;
  seed?: InputMaybe<Uogorod_Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.reviews */
export type Uogorod_Reviews_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Reviews_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.reviews" */
export enum Uogorod_Reviews_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Minus = 'minus',
  /** column name */
  Plus = 'plus',
  /** column name */
  Rate = 'rate',
  /** column name */
  Recommended = 'recommended',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "uogorod_reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uogorod.reviews" */
export enum Uogorod_Reviews_Select_Column_Uogorod_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Recommended = 'recommended'
}

/** select "uogorod_reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uogorod.reviews" */
export enum Uogorod_Reviews_Select_Column_Uogorod_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Recommended = 'recommended'
}

/** input type for updating data in table "uogorod.reviews" */
export type Uogorod_Reviews_Set_Input = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  minus?: InputMaybe<Scalars['String']['input']>;
  plus?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Reviews_Stddev_Fields = {
  __typename?: 'uogorod_reviews_stddev_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev on columns */
export type Uogorod_Reviews_Stddev_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by stddev() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Reviews_Stddev_Pop_Fields = {
  __typename?: 'uogorod_reviews_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_pop on columns */
export type Uogorod_Reviews_Stddev_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by stddev_pop() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Reviews_Stddev_Samp_Fields = {
  __typename?: 'uogorod_reviews_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate stddev_samp on columns */
export type Uogorod_Reviews_Stddev_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by stddev_samp() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_reviews" */
export type Uogorod_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Reviews_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  minus?: InputMaybe<Scalars['String']['input']>;
  plus?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Reviews_Sum_Fields = {
  __typename?: 'uogorod_reviews_sum_fields';
  brand_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};


/** aggregate sum on columns */
export type Uogorod_Reviews_Sum_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by sum() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.reviews" */
export enum Uogorod_Reviews_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Minus = 'minus',
  /** column name */
  Plus = 'plus',
  /** column name */
  Rate = 'rate',
  /** column name */
  Recommended = 'recommended',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Reviews_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Reviews_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Reviews_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Reviews_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Reviews_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Reviews_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Reviews_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Reviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Reviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Reviews_Var_Pop_Fields = {
  __typename?: 'uogorod_reviews_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_pop on columns */
export type Uogorod_Reviews_Var_Pop_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by var_pop() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Reviews_Var_Samp_Fields = {
  __typename?: 'uogorod_reviews_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate var_samp on columns */
export type Uogorod_Reviews_Var_Samp_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by var_samp() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Reviews_Variance_Fields = {
  __typename?: 'uogorod_reviews_variance_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "uogorod.reviews_is_liked" */
  is_liked?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};


/** aggregate variance on columns */
export type Uogorod_Reviews_Variance_FieldsIs_LikedArgs = {
  args: Is_Liked_Uogorod_Reviews_Args;
};

/** order by variance() on columns of table "uogorod.reviews" */
export type Uogorod_Reviews_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.seed_categories" */
export type Uogorod_Seed_Categories = {
  __typename?: 'uogorod_seed_categories';
  /** An array relationship */
  childrens: Array<Uogorod_Seed_Categories>;
  /** An aggregate relationship */
  childrens_aggregate: Uogorod_Seed_Categories_Aggregate;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  manual?: Maybe<Uogorod_Manual>;
  /** An object relationship */
  parent?: Maybe<Uogorod_Seed_Categories>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  seeds: Array<Uogorod_Seeds>;
  /** An aggregate relationship */
  seeds_aggregate: Uogorod_Seeds_Aggregate;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


/** columns and relationships of "uogorod.seed_categories" */
export type Uogorod_Seed_CategoriesChildrensArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


/** columns and relationships of "uogorod.seed_categories" */
export type Uogorod_Seed_CategoriesChildrens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Categories_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};


/** columns and relationships of "uogorod.seed_categories" */
export type Uogorod_Seed_CategoriesSeedsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};


/** columns and relationships of "uogorod.seed_categories" */
export type Uogorod_Seed_CategoriesSeeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};

/** aggregated selection of "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Aggregate = {
  __typename?: 'uogorod_seed_categories_aggregate';
  aggregate?: Maybe<Uogorod_Seed_Categories_Aggregate_Fields>;
  nodes: Array<Uogorod_Seed_Categories>;
};

export type Uogorod_Seed_Categories_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seed_Categories_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seed_Categories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Aggregate_Fields = {
  __typename?: 'uogorod_seed_categories_aggregate_fields';
  avg?: Maybe<Uogorod_Seed_Categories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seed_Categories_Max_Fields>;
  min?: Maybe<Uogorod_Seed_Categories_Min_Fields>;
  stddev?: Maybe<Uogorod_Seed_Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seed_Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seed_Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seed_Categories_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seed_Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seed_Categories_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seed_Categories_Variance_Fields>;
};


/** aggregate fields of "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seed_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seed_Categories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seed_Categories_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seed_Categories_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seed_Categories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seed_Categories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seed_Categories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seed_Categories_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seed_Categories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seed_Categories_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seed_Categories_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seed_Categories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seed_Categories_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seed_Categories_Avg_Fields = {
  __typename?: 'uogorod_seed_categories_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seed_categories". All fields are combined with a logical 'AND'. */
export type Uogorod_Seed_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seed_Categories_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seed_Categories_Bool_Exp>>;
  childrens?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  childrens_aggregate?: InputMaybe<Uogorod_Seed_Categories_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  manual?: InputMaybe<Uogorod_Manual_Bool_Exp>;
  parent?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  seeds?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seeds_aggregate?: InputMaybe<Uogorod_Seeds_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seed_categories" */
export enum Uogorod_Seed_Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeedCategoriesPkey = 'seed_categories_pkey',
  /** unique or primary key constraint on columns "slug" */
  SeedCategoriesSlugKey = 'seed_categories_slug_key'
}

/** input type for incrementing numeric columns in table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Insert_Input = {
  childrens?: InputMaybe<Uogorod_Seed_Categories_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  manual?: InputMaybe<Uogorod_Manual_Obj_Rel_Insert_Input>;
  parent?: InputMaybe<Uogorod_Seed_Categories_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Uogorod_Seeds_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seed_Categories_Max_Fields = {
  __typename?: 'uogorod_seed_categories_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seed_Categories_Min_Fields = {
  __typename?: 'uogorod_seed_categories_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Mutation_Response = {
  __typename?: 'uogorod_seed_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seed_Categories>;
};

/** input type for inserting object relation for remote table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Obj_Rel_Insert_Input = {
  data: Uogorod_Seed_Categories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seed_Categories_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_On_Conflict = {
  constraint: Uogorod_Seed_Categories_Constraint;
  update_columns?: Array<Uogorod_Seed_Categories_Update_Column>;
  where?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seed_categories". */
export type Uogorod_Seed_Categories_Order_By = {
  childrens_aggregate?: InputMaybe<Uogorod_Seed_Categories_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manual?: InputMaybe<Uogorod_Manual_Order_By>;
  parent?: InputMaybe<Uogorod_Seed_Categories_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  seeds_aggregate?: InputMaybe<Uogorod_Seeds_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seed_categories */
export type Uogorod_Seed_Categories_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "uogorod.seed_categories" */
export enum Uogorod_Seed_Categories_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seed_Categories_Stddev_Fields = {
  __typename?: 'uogorod_seed_categories_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seed_Categories_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seed_categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seed_Categories_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seed_categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seed_categories" */
export type Uogorod_Seed_Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seed_Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seed_Categories_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seed_Categories_Sum_Fields = {
  __typename?: 'uogorod_seed_categories_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seed_categories" */
export enum Uogorod_Seed_Categories_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title'
}

export type Uogorod_Seed_Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seed_Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seed_Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seed_Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seed_Categories_Var_Pop_Fields = {
  __typename?: 'uogorod_seed_categories_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seed_Categories_Var_Samp_Fields = {
  __typename?: 'uogorod_seed_categories_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seed_Categories_Variance_Fields = {
  __typename?: 'uogorod_seed_categories_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seed_categories" */
export type Uogorod_Seed_Categories_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.seed_params" */
export type Uogorod_Seed_Params = {
  __typename?: 'uogorod_seed_params';
  name: Scalars['String']['output'];
  /** An object relationship */
  seed: Uogorod_Seeds;
  seed_id: Scalars['bigint']['output'];
  /** An object relationship */
  seed_spec: Uogorod_Seed_Specs;
  values: Scalars['jsonb']['output'];
};


/** columns and relationships of "uogorod.seed_params" */
export type Uogorod_Seed_ParamsValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.seed_params" */
export type Uogorod_Seed_Params_Aggregate = {
  __typename?: 'uogorod_seed_params_aggregate';
  aggregate?: Maybe<Uogorod_Seed_Params_Aggregate_Fields>;
  nodes: Array<Uogorod_Seed_Params>;
};

export type Uogorod_Seed_Params_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seed_Params_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seed_Params_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seed_params" */
export type Uogorod_Seed_Params_Aggregate_Fields = {
  __typename?: 'uogorod_seed_params_aggregate_fields';
  avg?: Maybe<Uogorod_Seed_Params_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seed_Params_Max_Fields>;
  min?: Maybe<Uogorod_Seed_Params_Min_Fields>;
  stddev?: Maybe<Uogorod_Seed_Params_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seed_Params_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seed_Params_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seed_Params_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seed_Params_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seed_Params_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seed_Params_Variance_Fields>;
};


/** aggregate fields of "uogorod.seed_params" */
export type Uogorod_Seed_Params_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seed_Params_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seed_Params_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seed_Params_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seed_Params_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seed_Params_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seed_Params_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seed_Params_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seed_Params_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seed_Params_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seed_Params_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seed_Params_Append_Input = {
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seed_Params_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seed_Params_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seed_Params_Avg_Fields = {
  __typename?: 'uogorod_seed_params_avg_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Avg_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seed_params". All fields are combined with a logical 'AND'. */
export type Uogorod_Seed_Params_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seed_Params_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seed_Params_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  seed?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  seed_spec?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
  values?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seed_params" */
export enum Uogorod_Seed_Params_Constraint {
  /** unique or primary key constraint on columns "seed_id", "name" */
  SeedParamsPkey = 'seed_params_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Seed_Params_Delete_At_Path_Input = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Seed_Params_Delete_Elem_Input = {
  values?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Seed_Params_Delete_Key_Input = {
  values?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Inc_Input = {
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  seed_spec?: InputMaybe<Uogorod_Seed_Specs_Obj_Rel_Insert_Input>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seed_Params_Max_Fields = {
  __typename?: 'uogorod_seed_params_max_fields';
  name?: Maybe<Scalars['String']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seed_Params_Min_Fields = {
  __typename?: 'uogorod_seed_params_min_fields';
  name?: Maybe<Scalars['String']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Mutation_Response = {
  __typename?: 'uogorod_seed_params_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seed_Params>;
};

/** on_conflict condition type for table "uogorod.seed_params" */
export type Uogorod_Seed_Params_On_Conflict = {
  constraint: Uogorod_Seed_Params_Constraint;
  update_columns?: Array<Uogorod_Seed_Params_Update_Column>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seed_params". */
export type Uogorod_Seed_Params_Order_By = {
  name?: InputMaybe<Order_By>;
  seed?: InputMaybe<Uogorod_Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
  seed_spec?: InputMaybe<Uogorod_Seed_Specs_Order_By>;
  values?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seed_params */
export type Uogorod_Seed_Params_Pk_Columns_Input = {
  name: Scalars['String']['input'];
  seed_id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seed_Params_Prepend_Input = {
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.seed_params" */
export enum Uogorod_Seed_Params_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  Values = 'values'
}

/** input type for updating data in table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seed_Params_Stddev_Fields = {
  __typename?: 'uogorod_seed_params_stddev_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Stddev_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seed_Params_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seed_params_stddev_pop_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Stddev_Pop_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seed_Params_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seed_params_stddev_samp_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Stddev_Samp_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seed_params" */
export type Uogorod_Seed_Params_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seed_Params_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seed_Params_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seed_Params_Sum_Fields = {
  __typename?: 'uogorod_seed_params_sum_fields';
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Sum_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seed_params" */
export enum Uogorod_Seed_Params_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  Values = 'values'
}

export type Uogorod_Seed_Params_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Seed_Params_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Seed_Params_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Seed_Params_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Seed_Params_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seed_Params_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Seed_Params_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seed_Params_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seed_Params_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seed_Params_Var_Pop_Fields = {
  __typename?: 'uogorod_seed_params_var_pop_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Var_Pop_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seed_Params_Var_Samp_Fields = {
  __typename?: 'uogorod_seed_params_var_samp_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Var_Samp_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seed_Params_Variance_Fields = {
  __typename?: 'uogorod_seed_params_variance_fields';
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seed_params" */
export type Uogorod_Seed_Params_Variance_Order_By = {
  seed_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.seed_similar" */
export type Uogorod_Seed_Similar = {
  __typename?: 'uogorod_seed_similar';
  id: Scalars['bigint']['output'];
  seed_id: Scalars['bigint']['output'];
  /** An object relationship */
  similar?: Maybe<Uogorod_Seeds>;
  similar_seed_id: Scalars['bigint']['output'];
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Aggregate = {
  __typename?: 'uogorod_seed_similar_aggregate';
  aggregate?: Maybe<Uogorod_Seed_Similar_Aggregate_Fields>;
  nodes: Array<Uogorod_Seed_Similar>;
};

export type Uogorod_Seed_Similar_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seed_Similar_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seed_Similar_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Aggregate_Fields = {
  __typename?: 'uogorod_seed_similar_aggregate_fields';
  avg?: Maybe<Uogorod_Seed_Similar_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seed_Similar_Max_Fields>;
  min?: Maybe<Uogorod_Seed_Similar_Min_Fields>;
  stddev?: Maybe<Uogorod_Seed_Similar_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seed_Similar_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seed_Similar_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seed_Similar_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seed_Similar_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seed_Similar_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seed_Similar_Variance_Fields>;
};


/** aggregate fields of "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seed_Similar_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seed_Similar_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seed_Similar_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seed_Similar_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seed_Similar_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seed_Similar_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seed_Similar_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seed_Similar_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seed_Similar_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seed_Similar_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seed_Similar_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seed_Similar_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seed_Similar_Avg_Fields = {
  __typename?: 'uogorod_seed_similar_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seed_similar". All fields are combined with a logical 'AND'. */
export type Uogorod_Seed_Similar_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seed_Similar_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seed_Similar_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  similar?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  similar_seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seed_similar" */
export enum Uogorod_Seed_Similar_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18855Primary = 'idx_18855_primary',
  /** unique or primary key constraint on columns "seed_id", "similar_seed_id" */
  SeedSimilarSeedIdSimilarSeedIdKey = 'seed_similar_seed_id_similar_seed_id_key'
}

/** input type for incrementing numeric columns in table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  similar_seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  similar?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  similar_seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seed_Similar_Max_Fields = {
  __typename?: 'uogorod_seed_similar_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  similar_seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seed_Similar_Min_Fields = {
  __typename?: 'uogorod_seed_similar_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  similar_seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Mutation_Response = {
  __typename?: 'uogorod_seed_similar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seed_Similar>;
};

/** on_conflict condition type for table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_On_Conflict = {
  constraint: Uogorod_Seed_Similar_Constraint;
  update_columns?: Array<Uogorod_Seed_Similar_Update_Column>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seed_similar". */
export type Uogorod_Seed_Similar_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar?: InputMaybe<Uogorod_Seeds_Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seed_similar */
export type Uogorod_Seed_Similar_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.seed_similar" */
export enum Uogorod_Seed_Similar_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  SimilarSeedId = 'similar_seed_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  similar_seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seed_Similar_Stddev_Fields = {
  __typename?: 'uogorod_seed_similar_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seed_Similar_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seed_similar_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seed_Similar_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seed_similar_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seed_similar" */
export type Uogorod_Seed_Similar_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seed_Similar_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seed_Similar_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  similar_seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seed_Similar_Sum_Fields = {
  __typename?: 'uogorod_seed_similar_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  similar_seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seed_similar" */
export enum Uogorod_Seed_Similar_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  SimilarSeedId = 'similar_seed_id',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Seed_Similar_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seed_Similar_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seed_Similar_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seed_Similar_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seed_Similar_Var_Pop_Fields = {
  __typename?: 'uogorod_seed_similar_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seed_Similar_Var_Samp_Fields = {
  __typename?: 'uogorod_seed_similar_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seed_Similar_Variance_Fields = {
  __typename?: 'uogorod_seed_similar_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  similar_seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seed_similar" */
export type Uogorod_Seed_Similar_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  similar_seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Параметры растения, может быть множественным полем, если содержит values то значения выбираются из них */
export type Uogorod_Seed_Specs = {
  __typename?: 'uogorod_seed_specs';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  seed_params: Array<Uogorod_Seed_Params>;
  /** An aggregate relationship */
  seed_params_aggregate: Uogorod_Seed_Params_Aggregate;
  unit?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['jsonb']['output']>;
};


/** Параметры растения, может быть множественным полем, если содержит values то значения выбираются из них */
export type Uogorod_Seed_SpecsSeed_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


/** Параметры растения, может быть множественным полем, если содержит values то значения выбираются из них */
export type Uogorod_Seed_SpecsSeed_Params_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


/** Параметры растения, может быть множественным полем, если содержит values то значения выбираются из них */
export type Uogorod_Seed_SpecsValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Aggregate = {
  __typename?: 'uogorod_seed_specs_aggregate';
  aggregate?: Maybe<Uogorod_Seed_Specs_Aggregate_Fields>;
  nodes: Array<Uogorod_Seed_Specs>;
};

/** aggregate fields of "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Aggregate_Fields = {
  __typename?: 'uogorod_seed_specs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seed_Specs_Max_Fields>;
  min?: Maybe<Uogorod_Seed_Specs_Min_Fields>;
};


/** aggregate fields of "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seed_Specs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seed_Specs_Append_Input = {
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.seed_specs". All fields are combined with a logical 'AND'. */
export type Uogorod_Seed_Specs_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seed_Specs_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seed_Specs_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  multiple?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  seed_params?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
  seed_params_aggregate?: InputMaybe<Uogorod_Seed_Params_Aggregate_Bool_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  values?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seed_specs" */
export enum Uogorod_Seed_Specs_Constraint {
  /** unique or primary key constraint on columns "name" */
  SeedSpecsPkey = 'seed_specs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Seed_Specs_Delete_At_Path_Input = {
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Seed_Specs_Delete_Elem_Input = {
  values?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Seed_Specs_Delete_Key_Input = {
  values?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seed_params?: InputMaybe<Uogorod_Seed_Params_Arr_Rel_Insert_Input>;
  unit?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seed_Specs_Max_Fields = {
  __typename?: 'uogorod_seed_specs_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Seed_Specs_Min_Fields = {
  __typename?: 'uogorod_seed_specs_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Mutation_Response = {
  __typename?: 'uogorod_seed_specs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seed_Specs>;
};

/** input type for inserting object relation for remote table "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Obj_Rel_Insert_Input = {
  data: Uogorod_Seed_Specs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seed_Specs_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_On_Conflict = {
  constraint: Uogorod_Seed_Specs_Constraint;
  update_columns?: Array<Uogorod_Seed_Specs_Update_Column>;
  where?: InputMaybe<Uogorod_Seed_Specs_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seed_specs". */
export type Uogorod_Seed_Specs_Order_By = {
  description?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  multiple?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  seed_params_aggregate?: InputMaybe<Uogorod_Seed_Params_Aggregate_Order_By>;
  unit?: InputMaybe<Order_By>;
  values?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seed_specs */
export type Uogorod_Seed_Specs_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seed_Specs_Prepend_Input = {
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.seed_specs" */
export enum Uogorod_Seed_Specs_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Label = 'label',
  /** column name */
  Multiple = 'multiple',
  /** column name */
  Name = 'name',
  /** column name */
  Unit = 'unit',
  /** column name */
  Values = 'values'
}

/** input type for updating data in table "uogorod.seed_specs" */
export type Uogorod_Seed_Specs_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "uogorod_seed_specs" */
export type Uogorod_Seed_Specs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seed_Specs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seed_Specs_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "uogorod.seed_specs" */
export enum Uogorod_Seed_Specs_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Label = 'label',
  /** column name */
  Multiple = 'multiple',
  /** column name */
  Name = 'name',
  /** column name */
  Unit = 'unit',
  /** column name */
  Values = 'values'
}

export type Uogorod_Seed_Specs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Seed_Specs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Seed_Specs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Seed_Specs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Seed_Specs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Seed_Specs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seed_Specs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seed_Specs_Bool_Exp;
};

/** columns and relationships of "uogorod.seed_votes" */
export type Uogorod_Seed_Votes = {
  __typename?: 'uogorod_seed_votes';
  date: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  seed_id: Scalars['bigint']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Aggregate = {
  __typename?: 'uogorod_seed_votes_aggregate';
  aggregate?: Maybe<Uogorod_Seed_Votes_Aggregate_Fields>;
  nodes: Array<Uogorod_Seed_Votes>;
};

/** aggregate fields of "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Aggregate_Fields = {
  __typename?: 'uogorod_seed_votes_aggregate_fields';
  avg?: Maybe<Uogorod_Seed_Votes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seed_Votes_Max_Fields>;
  min?: Maybe<Uogorod_Seed_Votes_Min_Fields>;
  stddev?: Maybe<Uogorod_Seed_Votes_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seed_Votes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seed_Votes_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seed_Votes_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seed_Votes_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seed_Votes_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seed_Votes_Variance_Fields>;
};


/** aggregate fields of "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seed_Votes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Seed_Votes_Avg_Fields = {
  __typename?: 'uogorod_seed_votes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.seed_votes". All fields are combined with a logical 'AND'. */
export type Uogorod_Seed_Votes_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seed_Votes_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seed_Votes_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seed_votes" */
export enum Uogorod_Seed_Votes_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18997Primary = 'idx_18997_primary'
}

/** input type for incrementing numeric columns in table "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seed_Votes_Max_Fields = {
  __typename?: 'uogorod_seed_votes_max_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Seed_Votes_Min_Fields = {
  __typename?: 'uogorod_seed_votes_min_fields';
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Mutation_Response = {
  __typename?: 'uogorod_seed_votes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seed_Votes>;
};

/** on_conflict condition type for table "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_On_Conflict = {
  constraint: Uogorod_Seed_Votes_Constraint;
  update_columns?: Array<Uogorod_Seed_Votes_Update_Column>;
  where?: InputMaybe<Uogorod_Seed_Votes_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seed_votes". */
export type Uogorod_Seed_Votes_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seed_votes */
export type Uogorod_Seed_Votes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.seed_votes" */
export enum Uogorod_Seed_Votes_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.seed_votes" */
export type Uogorod_Seed_Votes_Set_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seed_Votes_Stddev_Fields = {
  __typename?: 'uogorod_seed_votes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seed_Votes_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seed_votes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seed_Votes_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seed_votes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_seed_votes" */
export type Uogorod_Seed_Votes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seed_Votes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seed_Votes_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seed_Votes_Sum_Fields = {
  __typename?: 'uogorod_seed_votes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.seed_votes" */
export enum Uogorod_Seed_Votes_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Seed_Votes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seed_Votes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seed_Votes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seed_Votes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seed_Votes_Var_Pop_Fields = {
  __typename?: 'uogorod_seed_votes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seed_Votes_Var_Samp_Fields = {
  __typename?: 'uogorod_seed_votes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Seed_Votes_Variance_Fields = {
  __typename?: 'uogorod_seed_votes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.seeds" */
export type Uogorod_Seeds = {
  __typename?: 'uogorod_seeds';
  /** An object relationship */
  Country?: Maybe<Uogorod_Geo_Country>;
  /** An array relationship */
  actions: Array<Uogorod_Users_Seed_Actions>;
  /** An aggregate relationship */
  actions_aggregate: Uogorod_Users_Seed_Actions_Aggregate;
  agrotech?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  brands: Array<Uogorod_Seeds_Brands>;
  /** An aggregate relationship */
  brands_aggregate: Uogorod_Seeds_Brands_Aggregate;
  /** An object relationship */
  category?: Maybe<Uogorod_Seed_Categories>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  images: Array<Uogorod_Seeds_Images>;
  /** An aggregate relationship */
  images_aggregate: Uogorod_Seeds_Images_Aggregate;
  /** An object relationship */
  manual?: Maybe<Uogorod_View_Manual>;
  originator_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  params: Array<Uogorod_Seed_Params>;
  /** An aggregate relationship */
  params_aggregate: Uogorod_Seed_Params_Aggregate;
  /** An array relationship */
  planted: Array<Uogorod_Garden_Seeds>;
  /** An aggregate relationship */
  planted_aggregate: Uogorod_Garden_Seeds_Aggregate;
  rate: Scalars['numeric']['output'];
  /** An array relationship */
  records: Array<Uogorod_Seeds_Records>;
  /** An aggregate relationship */
  records_aggregate: Uogorod_Seeds_Records_Aggregate;
  /** An array relationship */
  reviews: Array<Uogorod_Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Uogorod_Reviews_Aggregate;
  seed_category_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  similars: Array<Uogorod_Seed_Similar>;
  /** An aggregate relationship */
  similars_aggregate: Uogorod_Seed_Similar_Aggregate;
  status: Uogorod_Type_Seeds_Status_Enum;
  title: Scalars['String']['output'];
  title_en?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Uogorod_Users>;
  views: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsActionsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsBrandsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Brands_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsParamsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsParams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Params_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsPlantedArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsPlanted_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Garden_Seeds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Garden_Seeds_Order_By>>;
  where?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsRecordsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsRecords_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Records_Order_By>>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsReviewsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Reviews_Order_By>>;
  where?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsSimilarsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};


/** columns and relationships of "uogorod.seeds" */
export type Uogorod_SeedsSimilars_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Seed_Similar_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seed_Similar_Order_By>>;
  where?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
};

/** aggregated selection of "uogorod.seeds" */
export type Uogorod_Seeds_Aggregate = {
  __typename?: 'uogorod_seeds_aggregate';
  aggregate?: Maybe<Uogorod_Seeds_Aggregate_Fields>;
  nodes: Array<Uogorod_Seeds>;
};

export type Uogorod_Seeds_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seeds_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seeds_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seeds" */
export type Uogorod_Seeds_Aggregate_Fields = {
  __typename?: 'uogorod_seeds_aggregate_fields';
  avg?: Maybe<Uogorod_Seeds_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seeds_Max_Fields>;
  min?: Maybe<Uogorod_Seeds_Min_Fields>;
  stddev?: Maybe<Uogorod_Seeds_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seeds_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seeds_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seeds_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seeds_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seeds_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seeds_Variance_Fields>;
};


/** aggregate fields of "uogorod.seeds" */
export type Uogorod_Seeds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seeds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seeds" */
export type Uogorod_Seeds_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seeds_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seeds_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seeds_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seeds_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seeds_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seeds_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seeds_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seeds_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seeds_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seeds_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.seeds" */
export type Uogorod_Seeds_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seeds_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seeds_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seeds_Avg_Fields = {
  __typename?: 'uogorod_seeds_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Avg_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seeds". All fields are combined with a logical 'AND'. */
export type Uogorod_Seeds_Bool_Exp = {
  Country?: InputMaybe<Uogorod_Geo_Country_Bool_Exp>;
  _and?: InputMaybe<Array<Uogorod_Seeds_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seeds_Bool_Exp>>;
  actions?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
  actions_aggregate?: InputMaybe<Uogorod_Users_Seed_Actions_Aggregate_Bool_Exp>;
  agrotech?: InputMaybe<String_Comparison_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  brands?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
  brands_aggregate?: InputMaybe<Uogorod_Seeds_Brands_Aggregate_Bool_Exp>;
  category?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  country_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
  images_aggregate?: InputMaybe<Uogorod_Seeds_Images_Aggregate_Bool_Exp>;
  manual?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
  originator_id?: InputMaybe<Bigint_Comparison_Exp>;
  params?: InputMaybe<Uogorod_Seed_Params_Bool_Exp>;
  params_aggregate?: InputMaybe<Uogorod_Seed_Params_Aggregate_Bool_Exp>;
  planted?: InputMaybe<Uogorod_Garden_Seeds_Bool_Exp>;
  planted_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Bool_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  records?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
  records_aggregate?: InputMaybe<Uogorod_Seeds_Records_Aggregate_Bool_Exp>;
  reviews?: InputMaybe<Uogorod_Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Uogorod_Reviews_Aggregate_Bool_Exp>;
  seed_category_id?: InputMaybe<Int_Comparison_Exp>;
  similars?: InputMaybe<Uogorod_Seed_Similar_Bool_Exp>;
  similars_aggregate?: InputMaybe<Uogorod_Seed_Similar_Aggregate_Bool_Exp>;
  status?: InputMaybe<Uogorod_Type_Seeds_Status_Enum_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  title_en?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands = {
  __typename?: 'uogorod_seeds_brands';
  /** An object relationship */
  brand?: Maybe<Uogorod_Brands>;
  brand_id: Scalars['bigint']['output'];
  /** An object relationship */
  seed?: Maybe<Uogorod_Seeds>;
  seed_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Aggregate = {
  __typename?: 'uogorod_seeds_brands_aggregate';
  aggregate?: Maybe<Uogorod_Seeds_Brands_Aggregate_Fields>;
  nodes: Array<Uogorod_Seeds_Brands>;
};

export type Uogorod_Seeds_Brands_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seeds_Brands_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seeds_Brands_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Aggregate_Fields = {
  __typename?: 'uogorod_seeds_brands_aggregate_fields';
  avg?: Maybe<Uogorod_Seeds_Brands_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seeds_Brands_Max_Fields>;
  min?: Maybe<Uogorod_Seeds_Brands_Min_Fields>;
  stddev?: Maybe<Uogorod_Seeds_Brands_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seeds_Brands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seeds_Brands_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seeds_Brands_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seeds_Brands_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seeds_Brands_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seeds_Brands_Variance_Fields>;
};


/** aggregate fields of "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seeds_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seeds_Brands_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seeds_Brands_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seeds_Brands_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seeds_Brands_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seeds_Brands_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seeds_Brands_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seeds_Brands_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seeds_Brands_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seeds_Brands_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seeds_Brands_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seeds_Brands_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seeds_Brands_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seeds_Brands_Avg_Fields = {
  __typename?: 'uogorod_seeds_brands_avg_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Avg_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seeds_brands". All fields are combined with a logical 'AND'. */
export type Uogorod_Seeds_Brands_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seeds_Brands_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seeds_Brands_Bool_Exp>>;
  brand?: InputMaybe<Uogorod_Brands_Bool_Exp>;
  brand_id?: InputMaybe<Bigint_Comparison_Exp>;
  seed?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seeds_brands" */
export enum Uogorod_Seeds_Brands_Constraint {
  /** unique or primary key constraint on columns "brand_id", "seed_id" */
  SeedsBrandsPkey = 'seeds_brands_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Inc_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Insert_Input = {
  brand?: InputMaybe<Uogorod_Brands_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  seed?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seeds_Brands_Max_Fields = {
  __typename?: 'uogorod_seeds_brands_max_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seeds_Brands_Min_Fields = {
  __typename?: 'uogorod_seeds_brands_min_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Mutation_Response = {
  __typename?: 'uogorod_seeds_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seeds_Brands>;
};

/** on_conflict condition type for table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_On_Conflict = {
  constraint: Uogorod_Seeds_Brands_Constraint;
  update_columns?: Array<Uogorod_Seeds_Brands_Update_Column>;
  where?: InputMaybe<Uogorod_Seeds_Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seeds_brands". */
export type Uogorod_Seeds_Brands_Order_By = {
  brand?: InputMaybe<Uogorod_Brands_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  seed?: InputMaybe<Uogorod_Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seeds_brands */
export type Uogorod_Seeds_Brands_Pk_Columns_Input = {
  brand_id: Scalars['bigint']['input'];
  seed_id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.seeds_brands" */
export enum Uogorod_Seeds_Brands_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  SeedId = 'seed_id'
}

/** input type for updating data in table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Set_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seeds_Brands_Stddev_Fields = {
  __typename?: 'uogorod_seeds_brands_stddev_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Stddev_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seeds_Brands_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seeds_brands_stddev_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Stddev_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seeds_Brands_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seeds_brands_stddev_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Stddev_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seeds_brands" */
export type Uogorod_Seeds_Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seeds_Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seeds_Brands_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seeds_Brands_Sum_Fields = {
  __typename?: 'uogorod_seeds_brands_sum_fields';
  brand_id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Sum_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seeds_brands" */
export enum Uogorod_Seeds_Brands_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  SeedId = 'seed_id'
}

export type Uogorod_Seeds_Brands_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seeds_Brands_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seeds_Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seeds_Brands_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seeds_Brands_Var_Pop_Fields = {
  __typename?: 'uogorod_seeds_brands_var_pop_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Var_Pop_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seeds_Brands_Var_Samp_Fields = {
  __typename?: 'uogorod_seeds_brands_var_samp_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Var_Samp_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seeds_Brands_Variance_Fields = {
  __typename?: 'uogorod_seeds_brands_variance_fields';
  brand_id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seeds_brands" */
export type Uogorod_Seeds_Brands_Variance_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "uogorod.seeds" */
export enum Uogorod_Seeds_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeedsPkey = 'seeds_pkey'
}

/** columns and relationships of "uogorod.seeds_images" */
export type Uogorod_Seeds_Images = {
  __typename?: 'uogorod_seeds_images';
  id: Scalars['bigint']['output'];
  /** An object relationship */
  image?: Maybe<Uogorod_Images>;
  seed_id: Scalars['bigint']['output'];
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Aggregate = {
  __typename?: 'uogorod_seeds_images_aggregate';
  aggregate?: Maybe<Uogorod_Seeds_Images_Aggregate_Fields>;
  nodes: Array<Uogorod_Seeds_Images>;
};

export type Uogorod_Seeds_Images_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seeds_Images_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seeds_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Aggregate_Fields = {
  __typename?: 'uogorod_seeds_images_aggregate_fields';
  avg?: Maybe<Uogorod_Seeds_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seeds_Images_Max_Fields>;
  min?: Maybe<Uogorod_Seeds_Images_Min_Fields>;
  stddev?: Maybe<Uogorod_Seeds_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seeds_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seeds_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seeds_Images_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seeds_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seeds_Images_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seeds_Images_Variance_Fields>;
};


/** aggregate fields of "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seeds_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seeds_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seeds_Images_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seeds_Images_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seeds_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seeds_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seeds_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seeds_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seeds_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seeds_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seeds_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seeds_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seeds_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seeds_Images_Avg_Fields = {
  __typename?: 'uogorod_seeds_images_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seeds_images". All fields are combined with a logical 'AND'. */
export type Uogorod_Seeds_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seeds_Images_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seeds_Images_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<Uogorod_Images_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  uuid?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seeds_images" */
export enum Uogorod_Seeds_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  SeedsImagesPkey = 'seeds_images_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Uogorod_Images_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seeds_Images_Max_Fields = {
  __typename?: 'uogorod_seeds_images_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seeds_Images_Min_Fields = {
  __typename?: 'uogorod_seeds_images_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Mutation_Response = {
  __typename?: 'uogorod_seeds_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seeds_Images>;
};

/** on_conflict condition type for table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_On_Conflict = {
  constraint: Uogorod_Seeds_Images_Constraint;
  update_columns?: Array<Uogorod_Seeds_Images_Update_Column>;
  where?: InputMaybe<Uogorod_Seeds_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seeds_images". */
export type Uogorod_Seeds_Images_Order_By = {
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Uogorod_Images_Order_By>;
  seed_id?: InputMaybe<Order_By>;
  uuid?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seeds_images */
export type Uogorod_Seeds_Images_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.seeds_images" */
export enum Uogorod_Seeds_Images_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  Uuid = 'uuid'
}

/** input type for updating data in table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seeds_Images_Stddev_Fields = {
  __typename?: 'uogorod_seeds_images_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seeds_Images_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seeds_images_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seeds_Images_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seeds_images_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seeds_images" */
export type Uogorod_Seeds_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seeds_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seeds_Images_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seeds_Images_Sum_Fields = {
  __typename?: 'uogorod_seeds_images_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seeds_images" */
export enum Uogorod_Seeds_Images_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  Uuid = 'uuid'
}

export type Uogorod_Seeds_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seeds_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seeds_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seeds_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seeds_Images_Var_Pop_Fields = {
  __typename?: 'uogorod_seeds_images_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seeds_Images_Var_Samp_Fields = {
  __typename?: 'uogorod_seeds_images_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seeds_Images_Variance_Fields = {
  __typename?: 'uogorod_seeds_images_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seeds_images" */
export type Uogorod_Seeds_Images_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "uogorod.seeds" */
export type Uogorod_Seeds_Inc_Input = {
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  originator_id?: InputMaybe<Scalars['bigint']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  seed_category_id?: InputMaybe<Scalars['Int']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seeds" */
export type Uogorod_Seeds_Insert_Input = {
  Country?: InputMaybe<Uogorod_Geo_Country_Obj_Rel_Insert_Input>;
  actions?: InputMaybe<Uogorod_Users_Seed_Actions_Arr_Rel_Insert_Input>;
  agrotech?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  brands?: InputMaybe<Uogorod_Seeds_Brands_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Uogorod_Seed_Categories_Obj_Rel_Insert_Input>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Uogorod_Seeds_Images_Arr_Rel_Insert_Input>;
  manual?: InputMaybe<Uogorod_View_Manual_Obj_Rel_Insert_Input>;
  originator_id?: InputMaybe<Scalars['bigint']['input']>;
  params?: InputMaybe<Uogorod_Seed_Params_Arr_Rel_Insert_Input>;
  planted?: InputMaybe<Uogorod_Garden_Seeds_Arr_Rel_Insert_Input>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  records?: InputMaybe<Uogorod_Seeds_Records_Arr_Rel_Insert_Input>;
  reviews?: InputMaybe<Uogorod_Reviews_Arr_Rel_Insert_Input>;
  seed_category_id?: InputMaybe<Scalars['Int']['input']>;
  similars?: InputMaybe<Uogorod_Seed_Similar_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Uogorod_Type_Seeds_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seeds_Max_Fields = {
  __typename?: 'uogorod_seeds_max_fields';
  agrotech?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  originator_id?: Maybe<Scalars['bigint']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_category_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Max_Order_By = {
  agrotech?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  title_en?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seeds_Min_Fields = {
  __typename?: 'uogorod_seeds_min_fields';
  agrotech?: Maybe<Scalars['String']['output']>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  originator_id?: Maybe<Scalars['bigint']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_category_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Min_Order_By = {
  agrotech?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  title_en?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seeds" */
export type Uogorod_Seeds_Mutation_Response = {
  __typename?: 'uogorod_seeds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seeds>;
};

/** input type for inserting object relation for remote table "uogorod.seeds" */
export type Uogorod_Seeds_Obj_Rel_Insert_Input = {
  data: Uogorod_Seeds_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seeds_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.seeds" */
export type Uogorod_Seeds_On_Conflict = {
  constraint: Uogorod_Seeds_Constraint;
  update_columns?: Array<Uogorod_Seeds_Update_Column>;
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seeds". */
export type Uogorod_Seeds_Order_By = {
  Country?: InputMaybe<Uogorod_Geo_Country_Order_By>;
  actions_aggregate?: InputMaybe<Uogorod_Users_Seed_Actions_Aggregate_Order_By>;
  agrotech?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  brands_aggregate?: InputMaybe<Uogorod_Seeds_Brands_Aggregate_Order_By>;
  category?: InputMaybe<Uogorod_Seed_Categories_Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Uogorod_Seeds_Images_Aggregate_Order_By>;
  manual?: InputMaybe<Uogorod_View_Manual_Order_By>;
  originator_id?: InputMaybe<Order_By>;
  params_aggregate?: InputMaybe<Uogorod_Seed_Params_Aggregate_Order_By>;
  planted_aggregate?: InputMaybe<Uogorod_Garden_Seeds_Aggregate_Order_By>;
  rate?: InputMaybe<Order_By>;
  records_aggregate?: InputMaybe<Uogorod_Seeds_Records_Aggregate_Order_By>;
  reviews_aggregate?: InputMaybe<Uogorod_Reviews_Aggregate_Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  similars_aggregate?: InputMaybe<Uogorod_Seed_Similar_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  title_en?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seeds */
export type Uogorod_Seeds_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "uogorod.seeds_records" */
export type Uogorod_Seeds_Records = {
  __typename?: 'uogorod_seeds_records';
  id: Scalars['bigint']['output'];
  images: Scalars['jsonb']['output'];
  record: Scalars['numeric']['output'];
  seed_id: Scalars['bigint']['output'];
  /** An object relationship */
  user?: Maybe<Uogorod_Users>;
  user_id: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.seeds_records" */
export type Uogorod_Seeds_RecordsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Aggregate = {
  __typename?: 'uogorod_seeds_records_aggregate';
  aggregate?: Maybe<Uogorod_Seeds_Records_Aggregate_Fields>;
  nodes: Array<Uogorod_Seeds_Records>;
};

export type Uogorod_Seeds_Records_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Seeds_Records_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Seeds_Records_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Aggregate_Fields = {
  __typename?: 'uogorod_seeds_records_aggregate_fields';
  avg?: Maybe<Uogorod_Seeds_Records_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Seeds_Records_Max_Fields>;
  min?: Maybe<Uogorod_Seeds_Records_Min_Fields>;
  stddev?: Maybe<Uogorod_Seeds_Records_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Seeds_Records_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Seeds_Records_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Seeds_Records_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Seeds_Records_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Seeds_Records_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Seeds_Records_Variance_Fields>;
};


/** aggregate fields of "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Seeds_Records_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Seeds_Records_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Seeds_Records_Max_Order_By>;
  min?: InputMaybe<Uogorod_Seeds_Records_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Seeds_Records_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Seeds_Records_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Seeds_Records_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Seeds_Records_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Seeds_Records_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Seeds_Records_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Seeds_Records_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seeds_Records_Append_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Seeds_Records_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Seeds_Records_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Seeds_Records_Avg_Fields = {
  __typename?: 'uogorod_seeds_records_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.seeds_records". All fields are combined with a logical 'AND'. */
export type Uogorod_Seeds_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Seeds_Records_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Seeds_Records_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  record?: InputMaybe<Numeric_Comparison_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.seeds_records" */
export enum Uogorod_Seeds_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_18824Primary = 'idx_18824_primary',
  /** unique or primary key constraint on columns "user_id", "seed_id" */
  SeedsRecordsSeedIdUserIdKey = 'seeds_records_seed_id_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Seeds_Records_Delete_At_Path_Input = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Seeds_Records_Delete_Elem_Input = {
  images?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Seeds_Records_Delete_Key_Input = {
  images?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  record?: InputMaybe<Scalars['numeric']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  record?: InputMaybe<Scalars['numeric']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Uogorod_Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Seeds_Records_Max_Fields = {
  __typename?: 'uogorod_seeds_records_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  record?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Seeds_Records_Min_Fields = {
  __typename?: 'uogorod_seeds_records_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  record?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Mutation_Response = {
  __typename?: 'uogorod_seeds_records_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Seeds_Records>;
};

/** on_conflict condition type for table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_On_Conflict = {
  constraint: Uogorod_Seeds_Records_Constraint;
  update_columns?: Array<Uogorod_Seeds_Records_Update_Column>;
  where?: InputMaybe<Uogorod_Seeds_Records_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.seeds_records". */
export type Uogorod_Seeds_Records_Order_By = {
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.seeds_records */
export type Uogorod_Seeds_Records_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Seeds_Records_Prepend_Input = {
  images?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "uogorod.seeds_records" */
export enum Uogorod_Seeds_Records_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Record = 'record',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  record?: InputMaybe<Scalars['numeric']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seeds_Records_Stddev_Fields = {
  __typename?: 'uogorod_seeds_records_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seeds_Records_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seeds_records_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seeds_Records_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seeds_records_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seeds_records" */
export type Uogorod_Seeds_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seeds_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seeds_Records_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
  record?: InputMaybe<Scalars['numeric']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seeds_Records_Sum_Fields = {
  __typename?: 'uogorod_seeds_records_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  record?: Maybe<Scalars['numeric']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seeds_records" */
export enum Uogorod_Seeds_Records_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  Record = 'record',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Seeds_Records_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Seeds_Records_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Seeds_Records_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Seeds_Records_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Seeds_Records_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seeds_Records_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Seeds_Records_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seeds_Records_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seeds_Records_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seeds_Records_Var_Pop_Fields = {
  __typename?: 'uogorod_seeds_records_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seeds_Records_Var_Samp_Fields = {
  __typename?: 'uogorod_seeds_records_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seeds_Records_Variance_Fields = {
  __typename?: 'uogorod_seeds_records_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seeds_records" */
export type Uogorod_Seeds_Records_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.seeds" */
export enum Uogorod_Seeds_Select_Column {
  /** column name */
  Agrotech = 'agrotech',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  OriginatorId = 'originator_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  SeedCategoryId = 'seed_category_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  Views = 'views'
}

/** input type for updating data in table "uogorod.seeds" */
export type Uogorod_Seeds_Set_Input = {
  agrotech?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  originator_id?: InputMaybe<Scalars['bigint']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  seed_category_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Uogorod_Type_Seeds_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Seeds_Stddev_Fields = {
  __typename?: 'uogorod_seeds_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Stddev_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Seeds_Stddev_Pop_Fields = {
  __typename?: 'uogorod_seeds_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Stddev_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Seeds_Stddev_Samp_Fields = {
  __typename?: 'uogorod_seeds_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Stddev_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_seeds" */
export type Uogorod_Seeds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Seeds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Seeds_Stream_Cursor_Value_Input = {
  agrotech?: InputMaybe<Scalars['String']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  originator_id?: InputMaybe<Scalars['bigint']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  seed_category_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Uogorod_Type_Seeds_Status_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Seeds_Sum_Fields = {
  __typename?: 'uogorod_seeds_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  originator_id?: Maybe<Scalars['bigint']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  seed_category_id?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Sum_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.seeds" */
export enum Uogorod_Seeds_Update_Column {
  /** column name */
  Agrotech = 'agrotech',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  OriginatorId = 'originator_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  SeedCategoryId = 'seed_category_id',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  TitleEn = 'title_en',
  /** column name */
  Views = 'views'
}

export type Uogorod_Seeds_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Seeds_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Seeds_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Seeds_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Seeds_Var_Pop_Fields = {
  __typename?: 'uogorod_seeds_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Var_Pop_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Seeds_Var_Samp_Fields = {
  __typename?: 'uogorod_seeds_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Var_Samp_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Seeds_Variance_Fields = {
  __typename?: 'uogorod_seeds_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  country_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  originator_id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  seed_category_id?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.seeds" */
export type Uogorod_Seeds_Variance_Order_By = {
  author_id?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  seed_category_id?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.subscribes" */
export type Uogorod_Subscribes = {
  __typename?: 'uogorod_subscribes';
  created_at: Scalars['timestamptz']['output'];
  element_id: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** 1-юзер,2-соощество */
  type: Scalars['Int']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.subscribes" */
export type Uogorod_Subscribes_Aggregate = {
  __typename?: 'uogorod_subscribes_aggregate';
  aggregate?: Maybe<Uogorod_Subscribes_Aggregate_Fields>;
  nodes: Array<Uogorod_Subscribes>;
};

export type Uogorod_Subscribes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Subscribes_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Subscribes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.subscribes" */
export type Uogorod_Subscribes_Aggregate_Fields = {
  __typename?: 'uogorod_subscribes_aggregate_fields';
  avg?: Maybe<Uogorod_Subscribes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Subscribes_Max_Fields>;
  min?: Maybe<Uogorod_Subscribes_Min_Fields>;
  stddev?: Maybe<Uogorod_Subscribes_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Subscribes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Subscribes_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Subscribes_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Subscribes_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Subscribes_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Subscribes_Variance_Fields>;
};


/** aggregate fields of "uogorod.subscribes" */
export type Uogorod_Subscribes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Subscribes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Subscribes_Max_Order_By>;
  min?: InputMaybe<Uogorod_Subscribes_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Subscribes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Subscribes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Subscribes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Subscribes_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Subscribes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Subscribes_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Subscribes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.subscribes" */
export type Uogorod_Subscribes_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Subscribes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Subscribes_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Subscribes_Avg_Fields = {
  __typename?: 'uogorod_subscribes_avg_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Avg_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.subscribes". All fields are combined with a logical 'AND'. */
export type Uogorod_Subscribes_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Subscribes_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Subscribes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  element_id?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.subscribes" */
export enum Uogorod_Subscribes_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19015Primary = 'idx_19015_primary'
}

/** input type for incrementing numeric columns in table "uogorod.subscribes" */
export type Uogorod_Subscribes_Inc_Input = {
  element_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.subscribes" */
export type Uogorod_Subscribes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  element_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Subscribes_Max_Fields = {
  __typename?: 'uogorod_subscribes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  element_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Subscribes_Min_Fields = {
  __typename?: 'uogorod_subscribes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  element_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.subscribes" */
export type Uogorod_Subscribes_Mutation_Response = {
  __typename?: 'uogorod_subscribes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Subscribes>;
};

/** on_conflict condition type for table "uogorod.subscribes" */
export type Uogorod_Subscribes_On_Conflict = {
  constraint: Uogorod_Subscribes_Constraint;
  update_columns?: Array<Uogorod_Subscribes_Update_Column>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.subscribes". */
export type Uogorod_Subscribes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.subscribes */
export type Uogorod_Subscribes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.subscribes" */
export enum Uogorod_Subscribes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ElementId = 'element_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.subscribes" */
export type Uogorod_Subscribes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  element_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Subscribes_Stddev_Fields = {
  __typename?: 'uogorod_subscribes_stddev_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Stddev_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Subscribes_Stddev_Pop_Fields = {
  __typename?: 'uogorod_subscribes_stddev_pop_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Stddev_Pop_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Subscribes_Stddev_Samp_Fields = {
  __typename?: 'uogorod_subscribes_stddev_samp_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Stddev_Samp_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_subscribes" */
export type Uogorod_Subscribes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Subscribes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Subscribes_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  element_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Subscribes_Sum_Fields = {
  __typename?: 'uogorod_subscribes_sum_fields';
  element_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Sum_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.subscribes" */
export enum Uogorod_Subscribes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ElementId = 'element_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Subscribes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Subscribes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Subscribes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Subscribes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Subscribes_Var_Pop_Fields = {
  __typename?: 'uogorod_subscribes_var_pop_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Var_Pop_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Subscribes_Var_Samp_Fields = {
  __typename?: 'uogorod_subscribes_var_samp_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Var_Samp_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Subscribes_Variance_Fields = {
  __typename?: 'uogorod_subscribes_variance_fields';
  element_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** 1-юзер,2-соощество */
  type?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.subscribes" */
export type Uogorod_Subscribes_Variance_Order_By = {
  element_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** 1-юзер,2-соощество */
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.top_reviewers" */
export type Uogorod_Top_Reviewers = {
  __typename?: 'uogorod_top_reviewers';
  count?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<Uogorod_Users>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "uogorod.top_reviewers" */
export type Uogorod_Top_Reviewers_Aggregate = {
  __typename?: 'uogorod_top_reviewers_aggregate';
  aggregate?: Maybe<Uogorod_Top_Reviewers_Aggregate_Fields>;
  nodes: Array<Uogorod_Top_Reviewers>;
};

/** aggregate fields of "uogorod.top_reviewers" */
export type Uogorod_Top_Reviewers_Aggregate_Fields = {
  __typename?: 'uogorod_top_reviewers_aggregate_fields';
  avg?: Maybe<Uogorod_Top_Reviewers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Top_Reviewers_Max_Fields>;
  min?: Maybe<Uogorod_Top_Reviewers_Min_Fields>;
  stddev?: Maybe<Uogorod_Top_Reviewers_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Top_Reviewers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Top_Reviewers_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Top_Reviewers_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Top_Reviewers_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Top_Reviewers_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Top_Reviewers_Variance_Fields>;
};


/** aggregate fields of "uogorod.top_reviewers" */
export type Uogorod_Top_Reviewers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Top_Reviewers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Top_Reviewers_Avg_Fields = {
  __typename?: 'uogorod_top_reviewers_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.top_reviewers". All fields are combined with a logical 'AND'. */
export type Uogorod_Top_Reviewers_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Top_Reviewers_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Top_Reviewers_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Top_Reviewers_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Uogorod_Users_Bool_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Uogorod_Top_Reviewers_Max_Fields = {
  __typename?: 'uogorod_top_reviewers_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Top_Reviewers_Min_Fields = {
  __typename?: 'uogorod_top_reviewers_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "uogorod.top_reviewers". */
export type Uogorod_Top_Reviewers_Order_By = {
  count?: InputMaybe<Order_By>;
  user?: InputMaybe<Uogorod_Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.top_reviewers" */
export enum Uogorod_Top_Reviewers_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Uogorod_Top_Reviewers_Stddev_Fields = {
  __typename?: 'uogorod_top_reviewers_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Top_Reviewers_Stddev_Pop_Fields = {
  __typename?: 'uogorod_top_reviewers_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Top_Reviewers_Stddev_Samp_Fields = {
  __typename?: 'uogorod_top_reviewers_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_top_reviewers" */
export type Uogorod_Top_Reviewers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Top_Reviewers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Top_Reviewers_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Top_Reviewers_Sum_Fields = {
  __typename?: 'uogorod_top_reviewers_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Uogorod_Top_Reviewers_Var_Pop_Fields = {
  __typename?: 'uogorod_top_reviewers_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Top_Reviewers_Var_Samp_Fields = {
  __typename?: 'uogorod_top_reviewers_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Top_Reviewers_Variance_Fields = {
  __typename?: 'uogorod_top_reviewers_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "uogorod.type_comments" */
export type Uogorod_Type_Comments = {
  __typename?: 'uogorod_type_comments';
  type: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.type_comments" */
export type Uogorod_Type_Comments_Aggregate = {
  __typename?: 'uogorod_type_comments_aggregate';
  aggregate?: Maybe<Uogorod_Type_Comments_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Comments>;
};

/** aggregate fields of "uogorod.type_comments" */
export type Uogorod_Type_Comments_Aggregate_Fields = {
  __typename?: 'uogorod_type_comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Comments_Max_Fields>;
  min?: Maybe<Uogorod_Type_Comments_Min_Fields>;
};


/** aggregate fields of "uogorod.type_comments" */
export type Uogorod_Type_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_comments". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Comments_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Comments_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_comments" */
export enum Uogorod_Type_Comments_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypeCommentsPkey = 'type_comments_pkey'
}

/** input type for inserting data into table "uogorod.type_comments" */
export type Uogorod_Type_Comments_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Type_Comments_Max_Fields = {
  __typename?: 'uogorod_type_comments_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Comments_Min_Fields = {
  __typename?: 'uogorod_type_comments_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_comments" */
export type Uogorod_Type_Comments_Mutation_Response = {
  __typename?: 'uogorod_type_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Comments>;
};

/** on_conflict condition type for table "uogorod.type_comments" */
export type Uogorod_Type_Comments_On_Conflict = {
  constraint: Uogorod_Type_Comments_Constraint;
  update_columns?: Array<Uogorod_Type_Comments_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_comments". */
export type Uogorod_Type_Comments_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.type_comments */
export type Uogorod_Type_Comments_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_comments" */
export enum Uogorod_Type_Comments_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_comments" */
export type Uogorod_Type_Comments_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_comments" */
export type Uogorod_Type_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Comments_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_comments" */
export enum Uogorod_Type_Comments_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Comments_Bool_Exp;
};

/** Типы контактов */
export type Uogorod_Type_Contacts = {
  __typename?: 'uogorod_type_contacts';
  type: Scalars['String']['output'];
  /** An array relationship */
  user_contacts: Array<Uogorod_User_Contacts>;
  /** An aggregate relationship */
  user_contacts_aggregate: Uogorod_User_Contacts_Aggregate;
};


/** Типы контактов */
export type Uogorod_Type_ContactsUser_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


/** Типы контактов */
export type Uogorod_Type_ContactsUser_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};

/** aggregated selection of "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Aggregate = {
  __typename?: 'uogorod_type_contacts_aggregate';
  aggregate?: Maybe<Uogorod_Type_Contacts_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Contacts>;
};

/** aggregate fields of "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Aggregate_Fields = {
  __typename?: 'uogorod_type_contacts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Contacts_Max_Fields>;
  min?: Maybe<Uogorod_Type_Contacts_Min_Fields>;
};


/** aggregate fields of "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_contacts". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Contacts_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_contacts?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
  user_contacts_aggregate?: InputMaybe<Uogorod_User_Contacts_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_contacts" */
export enum Uogorod_Type_Contacts_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypeContactsPkey = 'type_contacts_pkey'
}

/** input type for inserting data into table "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
  user_contacts?: InputMaybe<Uogorod_User_Contacts_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uogorod_Type_Contacts_Max_Fields = {
  __typename?: 'uogorod_type_contacts_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Contacts_Min_Fields = {
  __typename?: 'uogorod_type_contacts_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Mutation_Response = {
  __typename?: 'uogorod_type_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Contacts>;
};

/** on_conflict condition type for table "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_On_Conflict = {
  constraint: Uogorod_Type_Contacts_Constraint;
  update_columns?: Array<Uogorod_Type_Contacts_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_contacts". */
export type Uogorod_Type_Contacts_Order_By = {
  type?: InputMaybe<Order_By>;
  user_contacts_aggregate?: InputMaybe<Uogorod_User_Contacts_Aggregate_Order_By>;
};

/** primary key columns input for table: uogorod.type_contacts */
export type Uogorod_Type_Contacts_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_contacts" */
export enum Uogorod_Type_Contacts_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_contacts" */
export type Uogorod_Type_Contacts_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_contacts" */
export type Uogorod_Type_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Contacts_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_contacts" */
export enum Uogorod_Type_Contacts_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Contacts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Contacts_Bool_Exp;
};

/** columns and relationships of "uogorod.type_likes" */
export type Uogorod_Type_Likes = {
  __typename?: 'uogorod_type_likes';
  type: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.type_likes" */
export type Uogorod_Type_Likes_Aggregate = {
  __typename?: 'uogorod_type_likes_aggregate';
  aggregate?: Maybe<Uogorod_Type_Likes_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Likes>;
};

/** aggregate fields of "uogorod.type_likes" */
export type Uogorod_Type_Likes_Aggregate_Fields = {
  __typename?: 'uogorod_type_likes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Likes_Max_Fields>;
  min?: Maybe<Uogorod_Type_Likes_Min_Fields>;
};


/** aggregate fields of "uogorod.type_likes" */
export type Uogorod_Type_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_likes". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Likes_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Likes_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_likes" */
export enum Uogorod_Type_Likes_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypeLikesPkey = 'type_likes_pkey'
}

/** input type for inserting data into table "uogorod.type_likes" */
export type Uogorod_Type_Likes_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Type_Likes_Max_Fields = {
  __typename?: 'uogorod_type_likes_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Likes_Min_Fields = {
  __typename?: 'uogorod_type_likes_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_likes" */
export type Uogorod_Type_Likes_Mutation_Response = {
  __typename?: 'uogorod_type_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Likes>;
};

/** on_conflict condition type for table "uogorod.type_likes" */
export type Uogorod_Type_Likes_On_Conflict = {
  constraint: Uogorod_Type_Likes_Constraint;
  update_columns?: Array<Uogorod_Type_Likes_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_likes". */
export type Uogorod_Type_Likes_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.type_likes */
export type Uogorod_Type_Likes_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_likes" */
export enum Uogorod_Type_Likes_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_likes" */
export type Uogorod_Type_Likes_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_likes" */
export type Uogorod_Type_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Likes_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_likes" */
export enum Uogorod_Type_Likes_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Likes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Likes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Likes_Bool_Exp;
};

/** Типы постов */
export type Uogorod_Type_Posts = {
  __typename?: 'uogorod_type_posts';
  type: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.type_posts" */
export type Uogorod_Type_Posts_Aggregate = {
  __typename?: 'uogorod_type_posts_aggregate';
  aggregate?: Maybe<Uogorod_Type_Posts_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Posts>;
};

/** aggregate fields of "uogorod.type_posts" */
export type Uogorod_Type_Posts_Aggregate_Fields = {
  __typename?: 'uogorod_type_posts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Posts_Max_Fields>;
  min?: Maybe<Uogorod_Type_Posts_Min_Fields>;
};


/** aggregate fields of "uogorod.type_posts" */
export type Uogorod_Type_Posts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Posts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_posts". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Posts_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Posts_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Posts_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_posts" */
export enum Uogorod_Type_Posts_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypePostsPkey = 'type_posts_pkey'
}

/** input type for inserting data into table "uogorod.type_posts" */
export type Uogorod_Type_Posts_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Type_Posts_Max_Fields = {
  __typename?: 'uogorod_type_posts_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Posts_Min_Fields = {
  __typename?: 'uogorod_type_posts_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_posts" */
export type Uogorod_Type_Posts_Mutation_Response = {
  __typename?: 'uogorod_type_posts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Posts>;
};

/** on_conflict condition type for table "uogorod.type_posts" */
export type Uogorod_Type_Posts_On_Conflict = {
  constraint: Uogorod_Type_Posts_Constraint;
  update_columns?: Array<Uogorod_Type_Posts_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Posts_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_posts". */
export type Uogorod_Type_Posts_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.type_posts */
export type Uogorod_Type_Posts_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_posts" */
export enum Uogorod_Type_Posts_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_posts" */
export type Uogorod_Type_Posts_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_posts" */
export type Uogorod_Type_Posts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Posts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Posts_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_posts" */
export enum Uogorod_Type_Posts_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Posts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Posts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Posts_Bool_Exp;
};

/** columns and relationships of "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions = {
  __typename?: 'uogorod_type_seed_actions';
  type: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Aggregate = {
  __typename?: 'uogorod_type_seed_actions_aggregate';
  aggregate?: Maybe<Uogorod_Type_Seed_Actions_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Seed_Actions>;
};

/** aggregate fields of "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Aggregate_Fields = {
  __typename?: 'uogorod_type_seed_actions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Seed_Actions_Max_Fields>;
  min?: Maybe<Uogorod_Type_Seed_Actions_Min_Fields>;
};


/** aggregate fields of "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_seed_actions". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Seed_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Seed_Actions_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_seed_actions" */
export enum Uogorod_Type_Seed_Actions_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypeSeedActionsPkey = 'type_seed_actions_pkey'
}

/** input type for inserting data into table "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Type_Seed_Actions_Max_Fields = {
  __typename?: 'uogorod_type_seed_actions_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Seed_Actions_Min_Fields = {
  __typename?: 'uogorod_type_seed_actions_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Mutation_Response = {
  __typename?: 'uogorod_type_seed_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Seed_Actions>;
};

/** on_conflict condition type for table "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_On_Conflict = {
  constraint: Uogorod_Type_Seed_Actions_Constraint;
  update_columns?: Array<Uogorod_Type_Seed_Actions_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Seed_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_seed_actions". */
export type Uogorod_Type_Seed_Actions_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.type_seed_actions */
export type Uogorod_Type_Seed_Actions_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_seed_actions" */
export enum Uogorod_Type_Seed_Actions_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_seed_actions" */
export type Uogorod_Type_Seed_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Seed_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Seed_Actions_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_seed_actions" */
export enum Uogorod_Type_Seed_Actions_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Seed_Actions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Seed_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Seed_Actions_Bool_Exp;
};

/** columns and relationships of "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status = {
  __typename?: 'uogorod_type_seeds_status';
  status: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Aggregate = {
  __typename?: 'uogorod_type_seeds_status_aggregate';
  aggregate?: Maybe<Uogorod_Type_Seeds_Status_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Seeds_Status>;
};

/** aggregate fields of "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Aggregate_Fields = {
  __typename?: 'uogorod_type_seeds_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Seeds_Status_Max_Fields>;
  min?: Maybe<Uogorod_Type_Seeds_Status_Min_Fields>;
};


/** aggregate fields of "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_seeds_status". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Seeds_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Bool_Exp>>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_seeds_status" */
export enum Uogorod_Type_Seeds_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  TypeSeedsStatusPkey = 'type_seeds_status_pkey'
}

export enum Uogorod_Type_Seeds_Status_Enum {
  Active = 'active',
  Moderate = 'moderate',
  Noname = 'noname'
}

/** Boolean expression to compare columns of type "uogorod_type_seeds_status_enum". All fields are combined with logical 'AND'. */
export type Uogorod_Type_Seeds_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Uogorod_Type_Seeds_Status_Enum>;
  _in?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Uogorod_Type_Seeds_Status_Enum>;
  _nin?: InputMaybe<Array<Uogorod_Type_Seeds_Status_Enum>>;
};

/** input type for inserting data into table "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Insert_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Type_Seeds_Status_Max_Fields = {
  __typename?: 'uogorod_type_seeds_status_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Seeds_Status_Min_Fields = {
  __typename?: 'uogorod_type_seeds_status_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Mutation_Response = {
  __typename?: 'uogorod_type_seeds_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Seeds_Status>;
};

/** on_conflict condition type for table "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_On_Conflict = {
  constraint: Uogorod_Type_Seeds_Status_Constraint;
  update_columns?: Array<Uogorod_Type_Seeds_Status_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Seeds_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_seeds_status". */
export type Uogorod_Type_Seeds_Status_Order_By = {
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.type_seeds_status */
export type Uogorod_Type_Seeds_Status_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_seeds_status" */
export enum Uogorod_Type_Seeds_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "uogorod.type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_seeds_status" */
export type Uogorod_Type_Seeds_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Seeds_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Seeds_Status_Stream_Cursor_Value_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_seeds_status" */
export enum Uogorod_Type_Seeds_Status_Update_Column {
  /** column name */
  Status = 'status'
}

export type Uogorod_Type_Seeds_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Seeds_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Seeds_Status_Bool_Exp;
};

/** Типы пользователей */
export type Uogorod_Type_Users = {
  __typename?: 'uogorod_type_users';
  type: Scalars['String']['output'];
  /** An array relationship */
  users: Array<Uogorod_Users>;
  /** An aggregate relationship */
  users_aggregate: Uogorod_Users_Aggregate;
};


/** Типы пользователей */
export type Uogorod_Type_UsersUsersArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};


/** Типы пользователей */
export type Uogorod_Type_UsersUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By>>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};

/** aggregated selection of "uogorod.type_users" */
export type Uogorod_Type_Users_Aggregate = {
  __typename?: 'uogorod_type_users_aggregate';
  aggregate?: Maybe<Uogorod_Type_Users_Aggregate_Fields>;
  nodes: Array<Uogorod_Type_Users>;
};

/** aggregate fields of "uogorod.type_users" */
export type Uogorod_Type_Users_Aggregate_Fields = {
  __typename?: 'uogorod_type_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Type_Users_Max_Fields>;
  min?: Maybe<Uogorod_Type_Users_Min_Fields>;
};


/** aggregate fields of "uogorod.type_users" */
export type Uogorod_Type_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Type_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "uogorod.type_users". All fields are combined with a logical 'AND'. */
export type Uogorod_Type_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Type_Users_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Type_Users_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Uogorod_Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Uogorod_Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uogorod.type_users" */
export enum Uogorod_Type_Users_Constraint {
  /** unique or primary key constraint on columns "type" */
  TypeUsersPkey = 'type_users_pkey'
}

export enum Uogorod_Type_Users_Enum {
  Admin = 'admin',
  Designer = 'designer',
  Farmer = 'farmer',
  Gardener = 'gardener',
  Manufacturer = 'manufacturer',
  Moderator = 'moderator'
}

/** Boolean expression to compare columns of type "uogorod_type_users_enum". All fields are combined with logical 'AND'. */
export type Uogorod_Type_Users_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Uogorod_Type_Users_Enum>;
  _in?: InputMaybe<Array<Uogorod_Type_Users_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Uogorod_Type_Users_Enum>;
  _nin?: InputMaybe<Array<Uogorod_Type_Users_Enum>>;
};

/** input type for inserting data into table "uogorod.type_users" */
export type Uogorod_Type_Users_Insert_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Uogorod_Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uogorod_Type_Users_Max_Fields = {
  __typename?: 'uogorod_type_users_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Type_Users_Min_Fields = {
  __typename?: 'uogorod_type_users_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.type_users" */
export type Uogorod_Type_Users_Mutation_Response = {
  __typename?: 'uogorod_type_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Type_Users>;
};

/** input type for inserting object relation for remote table "uogorod.type_users" */
export type Uogorod_Type_Users_Obj_Rel_Insert_Input = {
  data: Uogorod_Type_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Type_Users_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.type_users" */
export type Uogorod_Type_Users_On_Conflict = {
  constraint: Uogorod_Type_Users_Constraint;
  update_columns?: Array<Uogorod_Type_Users_Update_Column>;
  where?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.type_users". */
export type Uogorod_Type_Users_Order_By = {
  type?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Uogorod_Users_Aggregate_Order_By>;
};

/** primary key columns input for table: uogorod.type_users */
export type Uogorod_Type_Users_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "uogorod.type_users" */
export enum Uogorod_Type_Users_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.type_users" */
export type Uogorod_Type_Users_Set_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "uogorod_type_users" */
export type Uogorod_Type_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Type_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Type_Users_Stream_Cursor_Value_Input = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "uogorod.type_users" */
export enum Uogorod_Type_Users_Update_Column {
  /** column name */
  Type = 'type'
}

export type Uogorod_Type_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Type_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Type_Users_Bool_Exp;
};

/** columns and relationships of "uogorod.user_achivments" */
export type Uogorod_User_Achivments = {
  __typename?: 'uogorod_user_achivments';
  /** An object relationship */
  achivment: Uogorod_Achivments;
  achivment_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Aggregate = {
  __typename?: 'uogorod_user_achivments_aggregate';
  aggregate?: Maybe<Uogorod_User_Achivments_Aggregate_Fields>;
  nodes: Array<Uogorod_User_Achivments>;
};

export type Uogorod_User_Achivments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_User_Achivments_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_User_Achivments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Aggregate_Fields = {
  __typename?: 'uogorod_user_achivments_aggregate_fields';
  avg?: Maybe<Uogorod_User_Achivments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_User_Achivments_Max_Fields>;
  min?: Maybe<Uogorod_User_Achivments_Min_Fields>;
  stddev?: Maybe<Uogorod_User_Achivments_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_User_Achivments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_User_Achivments_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_User_Achivments_Sum_Fields>;
  var_pop?: Maybe<Uogorod_User_Achivments_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_User_Achivments_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_User_Achivments_Variance_Fields>;
};


/** aggregate fields of "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_User_Achivments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_User_Achivments_Max_Order_By>;
  min?: InputMaybe<Uogorod_User_Achivments_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_User_Achivments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_User_Achivments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_User_Achivments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_User_Achivments_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_User_Achivments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_User_Achivments_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_User_Achivments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_User_Achivments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_User_Achivments_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_User_Achivments_Avg_Fields = {
  __typename?: 'uogorod_user_achivments_avg_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Avg_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.user_achivments". All fields are combined with a logical 'AND'. */
export type Uogorod_User_Achivments_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_User_Achivments_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_User_Achivments_Bool_Exp>>;
  achivment?: InputMaybe<Uogorod_Achivments_Bool_Exp>;
  achivment_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  points?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.user_achivments" */
export enum Uogorod_User_Achivments_Constraint {
  /** unique or primary key constraint on columns "user_id", "achivment_id" */
  UserAchivmentsPkey = 'user_achivments_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Inc_Input = {
  points?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Insert_Input = {
  achivment?: InputMaybe<Uogorod_Achivments_Obj_Rel_Insert_Input>;
  achivment_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_User_Achivments_Max_Fields = {
  __typename?: 'uogorod_user_achivments_max_fields';
  achivment_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Max_Order_By = {
  achivment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_User_Achivments_Min_Fields = {
  __typename?: 'uogorod_user_achivments_min_fields';
  achivment_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Min_Order_By = {
  achivment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Mutation_Response = {
  __typename?: 'uogorod_user_achivments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_User_Achivments>;
};

/** on_conflict condition type for table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_On_Conflict = {
  constraint: Uogorod_User_Achivments_Constraint;
  update_columns?: Array<Uogorod_User_Achivments_Update_Column>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.user_achivments". */
export type Uogorod_User_Achivments_Order_By = {
  achivment?: InputMaybe<Uogorod_Achivments_Order_By>;
  achivment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.user_achivments */
export type Uogorod_User_Achivments_Pk_Columns_Input = {
  achivment_id: Scalars['String']['input'];
  user_id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.user_achivments" */
export enum Uogorod_User_Achivments_Select_Column {
  /** column name */
  AchivmentId = 'achivment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Points = 'points',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Set_Input = {
  achivment_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_User_Achivments_Stddev_Fields = {
  __typename?: 'uogorod_user_achivments_stddev_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Stddev_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_User_Achivments_Stddev_Pop_Fields = {
  __typename?: 'uogorod_user_achivments_stddev_pop_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Stddev_Pop_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_User_Achivments_Stddev_Samp_Fields = {
  __typename?: 'uogorod_user_achivments_stddev_samp_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Stddev_Samp_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_user_achivments" */
export type Uogorod_User_Achivments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_User_Achivments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_User_Achivments_Stream_Cursor_Value_Input = {
  achivment_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_User_Achivments_Sum_Fields = {
  __typename?: 'uogorod_user_achivments_sum_fields';
  points?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Sum_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.user_achivments" */
export enum Uogorod_User_Achivments_Update_Column {
  /** column name */
  AchivmentId = 'achivment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Points = 'points',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_User_Achivments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_User_Achivments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_User_Achivments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_User_Achivments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_User_Achivments_Var_Pop_Fields = {
  __typename?: 'uogorod_user_achivments_var_pop_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Var_Pop_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_User_Achivments_Var_Samp_Fields = {
  __typename?: 'uogorod_user_achivments_var_samp_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Var_Samp_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_User_Achivments_Variance_Fields = {
  __typename?: 'uogorod_user_achivments_variance_fields';
  points?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.user_achivments" */
export type Uogorod_User_Achivments_Variance_Order_By = {
  points?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.user_contacts" */
export type Uogorod_User_Contacts = {
  __typename?: 'uogorod_user_contacts';
  id: Scalars['bigint']['output'];
  type: Scalars['String']['output'];
  user_id: Scalars['bigint']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Aggregate = {
  __typename?: 'uogorod_user_contacts_aggregate';
  aggregate?: Maybe<Uogorod_User_Contacts_Aggregate_Fields>;
  nodes: Array<Uogorod_User_Contacts>;
};

export type Uogorod_User_Contacts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_User_Contacts_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_User_Contacts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Aggregate_Fields = {
  __typename?: 'uogorod_user_contacts_aggregate_fields';
  avg?: Maybe<Uogorod_User_Contacts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_User_Contacts_Max_Fields>;
  min?: Maybe<Uogorod_User_Contacts_Min_Fields>;
  stddev?: Maybe<Uogorod_User_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_User_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_User_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_User_Contacts_Sum_Fields>;
  var_pop?: Maybe<Uogorod_User_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_User_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_User_Contacts_Variance_Fields>;
};


/** aggregate fields of "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_User_Contacts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_User_Contacts_Max_Order_By>;
  min?: InputMaybe<Uogorod_User_Contacts_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_User_Contacts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_User_Contacts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_User_Contacts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_User_Contacts_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_User_Contacts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_User_Contacts_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_User_Contacts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_User_Contacts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_User_Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_User_Contacts_Avg_Fields = {
  __typename?: 'uogorod_user_contacts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.user_contacts". All fields are combined with a logical 'AND'. */
export type Uogorod_User_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_User_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_User_Contacts_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.user_contacts" */
export enum Uogorod_User_Contacts_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserContactsPkey = 'user_contacts_pkey'
}

/** input type for incrementing numeric columns in table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_User_Contacts_Max_Fields = {
  __typename?: 'uogorod_user_contacts_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_User_Contacts_Min_Fields = {
  __typename?: 'uogorod_user_contacts_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Mutation_Response = {
  __typename?: 'uogorod_user_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_User_Contacts>;
};

/** on_conflict condition type for table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_On_Conflict = {
  constraint: Uogorod_User_Contacts_Constraint;
  update_columns?: Array<Uogorod_User_Contacts_Update_Column>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.user_contacts". */
export type Uogorod_User_Contacts_Order_By = {
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.user_contacts */
export type Uogorod_User_Contacts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.user_contacts" */
export enum Uogorod_User_Contacts_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Set_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_User_Contacts_Stddev_Fields = {
  __typename?: 'uogorod_user_contacts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_User_Contacts_Stddev_Pop_Fields = {
  __typename?: 'uogorod_user_contacts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_User_Contacts_Stddev_Samp_Fields = {
  __typename?: 'uogorod_user_contacts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_user_contacts" */
export type Uogorod_User_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_User_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_User_Contacts_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_User_Contacts_Sum_Fields = {
  __typename?: 'uogorod_user_contacts_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.user_contacts" */
export enum Uogorod_User_Contacts_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Uogorod_User_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_User_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_User_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_User_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_User_Contacts_Var_Pop_Fields = {
  __typename?: 'uogorod_user_contacts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_User_Contacts_Var_Samp_Fields = {
  __typename?: 'uogorod_user_contacts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_User_Contacts_Variance_Fields = {
  __typename?: 'uogorod_user_contacts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.user_contacts" */
export type Uogorod_User_Contacts_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.users" */
export type Uogorod_Users = {
  __typename?: 'uogorod_users';
  about?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  achivments: Array<Uogorod_User_Achivments>;
  /** An aggregate relationship */
  achivments_aggregate: Uogorod_User_Achivments_Aggregate;
  birthday?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  city?: Maybe<Uogorod_Geo_City>;
  city_id?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  contacts: Array<Uogorod_User_Contacts>;
  /** An aggregate relationship */
  contacts_aggregate: Uogorod_User_Contacts_Aggregate;
  created_at?: Maybe<Scalars['date']['output']>;
  email: Scalars['String']['output'];
  experience?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  gardens: Array<Uogorod_Gardens>;
  /** An aggregate relationship */
  gardens_aggregate: Uogorod_Gardens_Aggregate;
  /** false - Муржской, true - Женский */
  gender: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  images: Array<Uogorod_Images>;
  /** An aggregate relationship */
  images_aggregate: Uogorod_Images_Aggregate;
  is_private_birthday: Scalars['Boolean']['output'];
  /** An object relationship */
  likes?: Maybe<Uogorod_Likes>;
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  notification_sended_at?: Maybe<Scalars['timestamptz']['output']>;
  password: Scalars['String']['output'];
  /** An array relationship */
  posts: Array<Uogorod_Posts>;
  /** An aggregate relationship */
  posts_aggregate: Uogorod_Posts_Aggregate;
  /** An object relationship */
  private?: Maybe<Uogorod_Emails>;
  rating: Scalars['numeric']['output'];
  /** An array relationship */
  received_messages: Array<Uogorod_Messages>;
  /** An aggregate relationship */
  received_messages_aggregate: Uogorod_Messages_Aggregate;
  settings: Scalars['jsonb']['output'];
  /** An array relationship */
  subcribes: Array<Uogorod_Subscribes>;
  /** An aggregate relationship */
  subcribes_aggregate: Uogorod_Subscribes_Aggregate;
  type?: Maybe<Uogorod_Type_Users_Enum>;
  /** An object relationship */
  type_user?: Maybe<Uogorod_Type_Users>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views: Scalars['bigint']['output'];
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersAchivmentsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersAchivments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Achivments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Achivments_Order_By>>;
  where?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersContactsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_User_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_User_Contacts_Order_By>>;
  where?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersGardensArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersGardens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Gardens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Gardens_Order_By>>;
  where?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersImagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Images_Order_By>>;
  where?: InputMaybe<Uogorod_Images_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersPostsArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersPosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Posts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By>>;
  where?: InputMaybe<Uogorod_Posts_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersReceived_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersReceived_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Messages_Order_By>>;
  where?: InputMaybe<Uogorod_Messages_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersSettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersSubcribesArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};


/** columns and relationships of "uogorod.users" */
export type Uogorod_UsersSubcribes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uogorod_Subscribes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Subscribes_Order_By>>;
  where?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
};

/** aggregated selection of "uogorod.users" */
export type Uogorod_Users_Aggregate = {
  __typename?: 'uogorod_users_aggregate';
  aggregate?: Maybe<Uogorod_Users_Aggregate_Fields>;
  nodes: Array<Uogorod_Users>;
};

export type Uogorod_Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uogorod_Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uogorod_Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uogorod_Users_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uogorod_Users_Select_Column_Uogorod_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uogorod_Users_Select_Column_Uogorod_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uogorod_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.users" */
export type Uogorod_Users_Aggregate_Fields = {
  __typename?: 'uogorod_users_aggregate_fields';
  avg?: Maybe<Uogorod_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Users_Max_Fields>;
  min?: Maybe<Uogorod_Users_Min_Fields>;
  stddev?: Maybe<Uogorod_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Users_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Users_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Users_Variance_Fields>;
};


/** aggregate fields of "uogorod.users" */
export type Uogorod_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.users" */
export type Uogorod_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Users_Max_Order_By>;
  min?: InputMaybe<Uogorod_Users_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Users_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "uogorod.users" */
export type Uogorod_Users_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Users_Avg_Fields = {
  __typename?: 'uogorod_users_avg_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.users" */
export type Uogorod_Users_Avg_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.users". All fields are combined with a logical 'AND'. */
export type Uogorod_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Users_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Users_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  achivments?: InputMaybe<Uogorod_User_Achivments_Bool_Exp>;
  achivments_aggregate?: InputMaybe<Uogorod_User_Achivments_Aggregate_Bool_Exp>;
  birthday?: InputMaybe<Date_Comparison_Exp>;
  city?: InputMaybe<Uogorod_Geo_City_Bool_Exp>;
  city_id?: InputMaybe<Bigint_Comparison_Exp>;
  contacts?: InputMaybe<Uogorod_User_Contacts_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Uogorod_User_Contacts_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Date_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  experience?: InputMaybe<Date_Comparison_Exp>;
  gardens?: InputMaybe<Uogorod_Gardens_Bool_Exp>;
  gardens_aggregate?: InputMaybe<Uogorod_Gardens_Aggregate_Bool_Exp>;
  gender?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  images?: InputMaybe<Uogorod_Images_Bool_Exp>;
  images_aggregate?: InputMaybe<Uogorod_Images_Aggregate_Bool_Exp>;
  is_private_birthday?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Uogorod_Likes_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nickname?: InputMaybe<String_Comparison_Exp>;
  notification_sended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  posts?: InputMaybe<Uogorod_Posts_Bool_Exp>;
  posts_aggregate?: InputMaybe<Uogorod_Posts_Aggregate_Bool_Exp>;
  private?: InputMaybe<Uogorod_Emails_Bool_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  received_messages?: InputMaybe<Uogorod_Messages_Bool_Exp>;
  received_messages_aggregate?: InputMaybe<Uogorod_Messages_Aggregate_Bool_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  subcribes?: InputMaybe<Uogorod_Subscribes_Bool_Exp>;
  subcribes_aggregate?: InputMaybe<Uogorod_Subscribes_Aggregate_Bool_Exp>;
  type?: InputMaybe<Uogorod_Type_Users_Enum_Comparison_Exp>;
  type_user?: InputMaybe<Uogorod_Type_Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  views?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "uogorod.users_calendar" */
export type Uogorod_Users_Calendar = {
  __typename?: 'uogorod_users_calendar';
  date: Scalars['date']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  sended: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Aggregate = {
  __typename?: 'uogorod_users_calendar_aggregate';
  aggregate?: Maybe<Uogorod_Users_Calendar_Aggregate_Fields>;
  nodes: Array<Uogorod_Users_Calendar>;
};

/** aggregate fields of "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Aggregate_Fields = {
  __typename?: 'uogorod_users_calendar_aggregate_fields';
  avg?: Maybe<Uogorod_Users_Calendar_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Users_Calendar_Max_Fields>;
  min?: Maybe<Uogorod_Users_Calendar_Min_Fields>;
  stddev?: Maybe<Uogorod_Users_Calendar_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Users_Calendar_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Users_Calendar_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Users_Calendar_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Users_Calendar_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Users_Calendar_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Users_Calendar_Variance_Fields>;
};


/** aggregate fields of "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Users_Calendar_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Users_Calendar_Avg_Fields = {
  __typename?: 'uogorod_users_calendar_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.users_calendar". All fields are combined with a logical 'AND'. */
export type Uogorod_Users_Calendar_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Users_Calendar_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Users_Calendar_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sended?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.users_calendar" */
export enum Uogorod_Users_Calendar_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19050Primary = 'idx_19050_primary'
}

/** input type for incrementing numeric columns in table "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  sended?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Insert_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sended?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Users_Calendar_Max_Fields = {
  __typename?: 'uogorod_users_calendar_max_fields';
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sended?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Users_Calendar_Min_Fields = {
  __typename?: 'uogorod_users_calendar_min_fields';
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sended?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Mutation_Response = {
  __typename?: 'uogorod_users_calendar_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Users_Calendar>;
};

/** on_conflict condition type for table "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_On_Conflict = {
  constraint: Uogorod_Users_Calendar_Constraint;
  update_columns?: Array<Uogorod_Users_Calendar_Update_Column>;
  where?: InputMaybe<Uogorod_Users_Calendar_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.users_calendar". */
export type Uogorod_Users_Calendar_Order_By = {
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sended?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.users_calendar */
export type Uogorod_Users_Calendar_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.users_calendar" */
export enum Uogorod_Users_Calendar_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Sended = 'sended',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.users_calendar" */
export type Uogorod_Users_Calendar_Set_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sended?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Users_Calendar_Stddev_Fields = {
  __typename?: 'uogorod_users_calendar_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Users_Calendar_Stddev_Pop_Fields = {
  __typename?: 'uogorod_users_calendar_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Users_Calendar_Stddev_Samp_Fields = {
  __typename?: 'uogorod_users_calendar_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_users_calendar" */
export type Uogorod_Users_Calendar_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Users_Calendar_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Users_Calendar_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sended?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Users_Calendar_Sum_Fields = {
  __typename?: 'uogorod_users_calendar_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  sended?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "uogorod.users_calendar" */
export enum Uogorod_Users_Calendar_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Sended = 'sended',
  /** column name */
  Text = 'text',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Users_Calendar_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Users_Calendar_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Users_Calendar_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Users_Calendar_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Users_Calendar_Var_Pop_Fields = {
  __typename?: 'uogorod_users_calendar_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Users_Calendar_Var_Samp_Fields = {
  __typename?: 'uogorod_users_calendar_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Users_Calendar_Variance_Fields = {
  __typename?: 'uogorod_users_calendar_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  sended?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** unique or primary key constraints on table "uogorod.users" */
export enum Uogorod_Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  Email = 'email',
  /** unique or primary key constraint on columns "id" */
  Idx_19041Primary = 'idx_19041_primary',
  /** unique or primary key constraint on columns "nickname" */
  Nickname = 'nickname'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Uogorod_Users_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Uogorod_Users_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Uogorod_Users_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "uogorod.users" */
export type Uogorod_Users_Inc_Input = {
  city_id?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.users" */
export type Uogorod_Users_Insert_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  achivments?: InputMaybe<Uogorod_User_Achivments_Arr_Rel_Insert_Input>;
  birthday?: InputMaybe<Scalars['date']['input']>;
  city?: InputMaybe<Uogorod_Geo_City_Obj_Rel_Insert_Input>;
  city_id?: InputMaybe<Scalars['bigint']['input']>;
  contacts?: InputMaybe<Uogorod_User_Contacts_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['date']['input']>;
  gardens?: InputMaybe<Uogorod_Gardens_Arr_Rel_Insert_Input>;
  /** false - Муржской, true - Женский */
  gender?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Uogorod_Images_Arr_Rel_Insert_Input>;
  is_private_birthday?: InputMaybe<Scalars['Boolean']['input']>;
  likes?: InputMaybe<Uogorod_Likes_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notification_sended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Uogorod_Posts_Arr_Rel_Insert_Input>;
  private?: InputMaybe<Uogorod_Emails_Obj_Rel_Insert_Input>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  received_messages?: InputMaybe<Uogorod_Messages_Arr_Rel_Insert_Input>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  subcribes?: InputMaybe<Uogorod_Subscribes_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Uogorod_Type_Users_Enum>;
  type_user?: InputMaybe<Uogorod_Type_Users_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Users_Max_Fields = {
  __typename?: 'uogorod_users_max_fields';
  about?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['date']['output']>;
  city_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notification_sended_at?: Maybe<Scalars['timestamptz']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.users" */
export type Uogorod_Users_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  notification_sended_at?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Users_Min_Fields = {
  __typename?: 'uogorod_users_min_fields';
  about?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['date']['output']>;
  city_id?: Maybe<Scalars['bigint']['output']>;
  created_at?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notification_sended_at?: Maybe<Scalars['timestamptz']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.users" */
export type Uogorod_Users_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  notification_sended_at?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.users" */
export type Uogorod_Users_Mutation_Response = {
  __typename?: 'uogorod_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Users>;
};

/** columns and relationships of "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated = {
  __typename?: 'uogorod_users_not_activated';
  created_at?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Aggregate = {
  __typename?: 'uogorod_users_not_activated_aggregate';
  aggregate?: Maybe<Uogorod_Users_Not_Activated_Aggregate_Fields>;
  nodes: Array<Uogorod_Users_Not_Activated>;
};

/** aggregate fields of "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Aggregate_Fields = {
  __typename?: 'uogorod_users_not_activated_aggregate_fields';
  avg?: Maybe<Uogorod_Users_Not_Activated_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Users_Not_Activated_Max_Fields>;
  min?: Maybe<Uogorod_Users_Not_Activated_Min_Fields>;
  stddev?: Maybe<Uogorod_Users_Not_Activated_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Users_Not_Activated_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Users_Not_Activated_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Users_Not_Activated_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Users_Not_Activated_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Users_Not_Activated_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Users_Not_Activated_Variance_Fields>;
};


/** aggregate fields of "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Users_Not_Activated_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_Users_Not_Activated_Avg_Fields = {
  __typename?: 'uogorod_users_not_activated_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.users_not_activated". All fields are combined with a logical 'AND'. */
export type Uogorod_Users_Not_Activated_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Users_Not_Activated_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Users_Not_Activated_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Users_Not_Activated_Bool_Exp>>;
  created_at?: InputMaybe<Date_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Insert_Input = {
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Users_Not_Activated_Max_Fields = {
  __typename?: 'uogorod_users_not_activated_max_fields';
  created_at?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_Users_Not_Activated_Min_Fields = {
  __typename?: 'uogorod_users_not_activated_min_fields';
  created_at?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Mutation_Response = {
  __typename?: 'uogorod_users_not_activated_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Users_Not_Activated>;
};

/** Ordering options when selecting data from "uogorod.users_not_activated". */
export type Uogorod_Users_Not_Activated_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.users_not_activated" */
export enum Uogorod_Users_Not_Activated_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "uogorod.users_not_activated" */
export type Uogorod_Users_Not_Activated_Set_Input = {
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Users_Not_Activated_Stddev_Fields = {
  __typename?: 'uogorod_users_not_activated_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Users_Not_Activated_Stddev_Pop_Fields = {
  __typename?: 'uogorod_users_not_activated_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Users_Not_Activated_Stddev_Samp_Fields = {
  __typename?: 'uogorod_users_not_activated_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_users_not_activated" */
export type Uogorod_Users_Not_Activated_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Users_Not_Activated_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Users_Not_Activated_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Users_Not_Activated_Sum_Fields = {
  __typename?: 'uogorod_users_not_activated_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

export type Uogorod_Users_Not_Activated_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Users_Not_Activated_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Users_Not_Activated_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Users_Not_Activated_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Users_Not_Activated_Var_Pop_Fields = {
  __typename?: 'uogorod_users_not_activated_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_Users_Not_Activated_Var_Samp_Fields = {
  __typename?: 'uogorod_users_not_activated_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_Users_Not_Activated_Variance_Fields = {
  __typename?: 'uogorod_users_not_activated_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** input type for inserting object relation for remote table "uogorod.users" */
export type Uogorod_Users_Obj_Rel_Insert_Input = {
  data: Uogorod_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Users_On_Conflict>;
};

/** on_conflict condition type for table "uogorod.users" */
export type Uogorod_Users_On_Conflict = {
  constraint: Uogorod_Users_Constraint;
  update_columns?: Array<Uogorod_Users_Update_Column>;
  where?: InputMaybe<Uogorod_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.users". */
export type Uogorod_Users_Order_By = {
  about?: InputMaybe<Order_By>;
  achivments_aggregate?: InputMaybe<Uogorod_User_Achivments_Aggregate_Order_By>;
  birthday?: InputMaybe<Order_By>;
  city?: InputMaybe<Uogorod_Geo_City_Order_By>;
  city_id?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Uogorod_User_Contacts_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  gardens_aggregate?: InputMaybe<Uogorod_Gardens_Aggregate_Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Uogorod_Images_Aggregate_Order_By>;
  is_private_birthday?: InputMaybe<Order_By>;
  likes?: InputMaybe<Uogorod_Likes_Order_By>;
  name?: InputMaybe<Order_By>;
  nickname?: InputMaybe<Order_By>;
  notification_sended_at?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  posts_aggregate?: InputMaybe<Uogorod_Posts_Aggregate_Order_By>;
  private?: InputMaybe<Uogorod_Emails_Order_By>;
  rating?: InputMaybe<Order_By>;
  received_messages_aggregate?: InputMaybe<Uogorod_Messages_Aggregate_Order_By>;
  settings?: InputMaybe<Order_By>;
  subcribes_aggregate?: InputMaybe<Uogorod_Subscribes_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  type_user?: InputMaybe<Uogorod_Type_Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.users */
export type Uogorod_Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Uogorod_Users_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions = {
  __typename?: 'uogorod_users_seed_actions';
  /** 1-отложено,2-выращен,3-избранное */
  action: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  seed: Uogorod_Seeds;
  seed_id: Scalars['bigint']['output'];
  user_id: Scalars['bigint']['output'];
};

/** aggregated selection of "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Aggregate = {
  __typename?: 'uogorod_users_seed_actions_aggregate';
  aggregate?: Maybe<Uogorod_Users_Seed_Actions_Aggregate_Fields>;
  nodes: Array<Uogorod_Users_Seed_Actions>;
};

export type Uogorod_Users_Seed_Actions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uogorod_Users_Seed_Actions_Aggregate_Bool_Exp_Count>;
};

export type Uogorod_Users_Seed_Actions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Aggregate_Fields = {
  __typename?: 'uogorod_users_seed_actions_aggregate_fields';
  avg?: Maybe<Uogorod_Users_Seed_Actions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_Users_Seed_Actions_Max_Fields>;
  min?: Maybe<Uogorod_Users_Seed_Actions_Min_Fields>;
  stddev?: Maybe<Uogorod_Users_Seed_Actions_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_Users_Seed_Actions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_Users_Seed_Actions_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_Users_Seed_Actions_Sum_Fields>;
  var_pop?: Maybe<Uogorod_Users_Seed_Actions_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_Users_Seed_Actions_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_Users_Seed_Actions_Variance_Fields>;
};


/** aggregate fields of "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Aggregate_Order_By = {
  avg?: InputMaybe<Uogorod_Users_Seed_Actions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uogorod_Users_Seed_Actions_Max_Order_By>;
  min?: InputMaybe<Uogorod_Users_Seed_Actions_Min_Order_By>;
  stddev?: InputMaybe<Uogorod_Users_Seed_Actions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uogorod_Users_Seed_Actions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uogorod_Users_Seed_Actions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uogorod_Users_Seed_Actions_Sum_Order_By>;
  var_pop?: InputMaybe<Uogorod_Users_Seed_Actions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uogorod_Users_Seed_Actions_Var_Samp_Order_By>;
  variance?: InputMaybe<Uogorod_Users_Seed_Actions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Arr_Rel_Insert_Input = {
  data: Array<Uogorod_Users_Seed_Actions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uogorod_Users_Seed_Actions_On_Conflict>;
};

/** aggregate avg on columns */
export type Uogorod_Users_Seed_Actions_Avg_Fields = {
  __typename?: 'uogorod_users_seed_actions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uogorod.users_seed_actions". All fields are combined with a logical 'AND'. */
export type Uogorod_Users_Seed_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_Users_Seed_Actions_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seed?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  seed_id?: InputMaybe<Bigint_Comparison_Exp>;
  user_id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uogorod.users_seed_actions" */
export enum Uogorod_Users_Seed_Actions_Constraint {
  /** unique or primary key constraint on columns "id" */
  Idx_19058Primary = 'idx_19058_primary',
  /** unique or primary key constraint on columns "action", "user_id", "seed_id" */
  UsersSeedActionsUserIdSeedIdActionKey = 'users_seed_actions_user_id_seed_id_action_key'
}

/** input type for incrementing numeric columns in table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Insert_Input = {
  /** 1-отложено,2-выращен,3-избранное */
  action?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed?: InputMaybe<Uogorod_Seeds_Obj_Rel_Insert_Input>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Uogorod_Users_Seed_Actions_Max_Fields = {
  __typename?: 'uogorod_users_seed_actions_max_fields';
  /** 1-отложено,2-выращен,3-избранное */
  action?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Max_Order_By = {
  /** 1-отложено,2-выращен,3-избранное */
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uogorod_Users_Seed_Actions_Min_Fields = {
  __typename?: 'uogorod_users_seed_actions_min_fields';
  /** 1-отложено,2-выращен,3-избранное */
  action?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Min_Order_By = {
  /** 1-отложено,2-выращен,3-избранное */
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Mutation_Response = {
  __typename?: 'uogorod_users_seed_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uogorod_Users_Seed_Actions>;
};

/** on_conflict condition type for table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_On_Conflict = {
  constraint: Uogorod_Users_Seed_Actions_Constraint;
  update_columns?: Array<Uogorod_Users_Seed_Actions_Update_Column>;
  where?: InputMaybe<Uogorod_Users_Seed_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "uogorod.users_seed_actions". */
export type Uogorod_Users_Seed_Actions_Order_By = {
  action?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seed?: InputMaybe<Uogorod_Seeds_Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uogorod.users_seed_actions */
export type Uogorod_Users_Seed_Actions_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uogorod.users_seed_actions" */
export enum Uogorod_Users_Seed_Actions_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Set_Input = {
  /** 1-отложено,2-выращен,3-избранное */
  action?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Users_Seed_Actions_Stddev_Fields = {
  __typename?: 'uogorod_users_seed_actions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Users_Seed_Actions_Stddev_Pop_Fields = {
  __typename?: 'uogorod_users_seed_actions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Users_Seed_Actions_Stddev_Samp_Fields = {
  __typename?: 'uogorod_users_seed_actions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Users_Seed_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Users_Seed_Actions_Stream_Cursor_Value_Input = {
  /** 1-отложено,2-выращен,3-избранное */
  action?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  user_id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Users_Seed_Actions_Sum_Fields = {
  __typename?: 'uogorod_users_seed_actions_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  seed_id?: Maybe<Scalars['bigint']['output']>;
  user_id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.users_seed_actions" */
export enum Uogorod_Users_Seed_Actions_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  Id = 'id',
  /** column name */
  SeedId = 'seed_id',
  /** column name */
  UserId = 'user_id'
}

export type Uogorod_Users_Seed_Actions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Users_Seed_Actions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Users_Seed_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Users_Seed_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Users_Seed_Actions_Var_Pop_Fields = {
  __typename?: 'uogorod_users_seed_actions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Users_Seed_Actions_Var_Samp_Fields = {
  __typename?: 'uogorod_users_seed_actions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Users_Seed_Actions_Variance_Fields = {
  __typename?: 'uogorod_users_seed_actions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  seed_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.users_seed_actions" */
export type Uogorod_Users_Seed_Actions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  seed_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.users" */
export enum Uogorod_Users_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Experience = 'experience',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrivateBirthday = 'is_private_birthday',
  /** column name */
  Name = 'name',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  NotificationSendedAt = 'notification_sended_at',
  /** column name */
  Password = 'password',
  /** column name */
  Rating = 'rating',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views'
}

/** select "uogorod_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uogorod.users" */
export enum Uogorod_Users_Select_Column_Uogorod_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Gender = 'gender',
  /** column name */
  IsPrivateBirthday = 'is_private_birthday'
}

/** select "uogorod_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uogorod.users" */
export enum Uogorod_Users_Select_Column_Uogorod_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Gender = 'gender',
  /** column name */
  IsPrivateBirthday = 'is_private_birthday'
}

/** input type for updating data in table "uogorod.users" */
export type Uogorod_Users_Set_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['date']['input']>;
  city_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['date']['input']>;
  /** false - Муржской, true - Женский */
  gender?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_private_birthday?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notification_sended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Uogorod_Type_Users_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Uogorod_Users_Stddev_Fields = {
  __typename?: 'uogorod_users_stddev_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uogorod.users" */
export type Uogorod_Users_Stddev_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_Users_Stddev_Pop_Fields = {
  __typename?: 'uogorod_users_stddev_pop_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uogorod.users" */
export type Uogorod_Users_Stddev_Pop_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_Users_Stddev_Samp_Fields = {
  __typename?: 'uogorod_users_stddev_samp_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uogorod.users" */
export type Uogorod_Users_Stddev_Samp_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uogorod_users" */
export type Uogorod_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_Users_Stream_Cursor_Value_Input = {
  about?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['date']['input']>;
  city_id?: InputMaybe<Scalars['bigint']['input']>;
  created_at?: InputMaybe<Scalars['date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['date']['input']>;
  /** false - Муржской, true - Женский */
  gender?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_private_birthday?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  notification_sended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Uogorod_Type_Users_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  views?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_Users_Sum_Fields = {
  __typename?: 'uogorod_users_sum_fields';
  city_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  views?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uogorod.users" */
export type Uogorod_Users_Sum_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** update columns of table "uogorod.users" */
export enum Uogorod_Users_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Experience = 'experience',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrivateBirthday = 'is_private_birthday',
  /** column name */
  Name = 'name',
  /** column name */
  Nickname = 'nickname',
  /** column name */
  NotificationSendedAt = 'notification_sended_at',
  /** column name */
  Password = 'password',
  /** column name */
  Rating = 'rating',
  /** column name */
  Settings = 'settings',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Views = 'views'
}

export type Uogorod_Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Uogorod_Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Uogorod_Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Uogorod_Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Uogorod_Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uogorod_Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Uogorod_Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uogorod_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uogorod_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uogorod_Users_Var_Pop_Fields = {
  __typename?: 'uogorod_users_var_pop_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uogorod.users" */
export type Uogorod_Users_Var_Pop_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uogorod_Users_Var_Samp_Fields = {
  __typename?: 'uogorod_users_var_samp_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uogorod.users" */
export type Uogorod_Users_Var_Samp_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uogorod_Users_Variance_Fields = {
  __typename?: 'uogorod_users_variance_fields';
  city_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uogorod.users" */
export type Uogorod_Users_Variance_Order_By = {
  city_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  views?: InputMaybe<Order_By>;
};

/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_Manual = {
  __typename?: 'uogorod_view_manual';
  ancestors_bad?: Maybe<Scalars['jsonb']['output']>;
  ancestors_good?: Maybe<Scalars['jsonb']['output']>;
  author_id?: Maybe<Scalars['bigint']['output']>;
  bad?: Maybe<Scalars['jsonb']['output']>;
  biology?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  category?: Maybe<Uogorod_Seed_Categories>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  content?: Maybe<Scalars['jsonb']['output']>;
  good?: Maybe<Scalars['jsonb']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  seedling?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualAncestors_BadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualAncestors_GoodArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualBadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualBiologyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualGoodArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "uogorod.view_manual" */
export type Uogorod_View_ManualSeedlingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "uogorod.view_manual" */
export type Uogorod_View_Manual_Aggregate = {
  __typename?: 'uogorod_view_manual_aggregate';
  aggregate?: Maybe<Uogorod_View_Manual_Aggregate_Fields>;
  nodes: Array<Uogorod_View_Manual>;
};

/** aggregate fields of "uogorod.view_manual" */
export type Uogorod_View_Manual_Aggregate_Fields = {
  __typename?: 'uogorod_view_manual_aggregate_fields';
  avg?: Maybe<Uogorod_View_Manual_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uogorod_View_Manual_Max_Fields>;
  min?: Maybe<Uogorod_View_Manual_Min_Fields>;
  stddev?: Maybe<Uogorod_View_Manual_Stddev_Fields>;
  stddev_pop?: Maybe<Uogorod_View_Manual_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uogorod_View_Manual_Stddev_Samp_Fields>;
  sum?: Maybe<Uogorod_View_Manual_Sum_Fields>;
  var_pop?: Maybe<Uogorod_View_Manual_Var_Pop_Fields>;
  var_samp?: Maybe<Uogorod_View_Manual_Var_Samp_Fields>;
  variance?: Maybe<Uogorod_View_Manual_Variance_Fields>;
};


/** aggregate fields of "uogorod.view_manual" */
export type Uogorod_View_Manual_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uogorod_View_Manual_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Uogorod_View_Manual_Avg_Fields = {
  __typename?: 'uogorod_view_manual_avg_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "uogorod.view_manual". All fields are combined with a logical 'AND'. */
export type Uogorod_View_Manual_Bool_Exp = {
  _and?: InputMaybe<Array<Uogorod_View_Manual_Bool_Exp>>;
  _not?: InputMaybe<Uogorod_View_Manual_Bool_Exp>;
  _or?: InputMaybe<Array<Uogorod_View_Manual_Bool_Exp>>;
  ancestors_bad?: InputMaybe<Jsonb_Comparison_Exp>;
  ancestors_good?: InputMaybe<Jsonb_Comparison_Exp>;
  author_id?: InputMaybe<Bigint_Comparison_Exp>;
  bad?: InputMaybe<Jsonb_Comparison_Exp>;
  biology?: InputMaybe<Jsonb_Comparison_Exp>;
  category?: InputMaybe<Uogorod_Seed_Categories_Bool_Exp>;
  category_id?: InputMaybe<Bigint_Comparison_Exp>;
  content?: InputMaybe<Jsonb_Comparison_Exp>;
  good?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  seedling?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** input type for inserting data into table "uogorod.view_manual" */
export type Uogorod_View_Manual_Insert_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  bad?: InputMaybe<Scalars['jsonb']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  category?: InputMaybe<Uogorod_Seed_Categories_Obj_Rel_Insert_Input>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  good?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Uogorod_View_Manual_Max_Fields = {
  __typename?: 'uogorod_view_manual_max_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Uogorod_View_Manual_Min_Fields = {
  __typename?: 'uogorod_view_manual_min_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  image?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "uogorod.view_manual" */
export type Uogorod_View_Manual_Obj_Rel_Insert_Input = {
  data: Uogorod_View_Manual_Insert_Input;
};

/** Ordering options when selecting data from "uogorod.view_manual". */
export type Uogorod_View_Manual_Order_By = {
  ancestors_bad?: InputMaybe<Order_By>;
  ancestors_good?: InputMaybe<Order_By>;
  author_id?: InputMaybe<Order_By>;
  bad?: InputMaybe<Order_By>;
  biology?: InputMaybe<Order_By>;
  category?: InputMaybe<Uogorod_Seed_Categories_Order_By>;
  category_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  good?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  seedling?: InputMaybe<Order_By>;
};

/** select columns of table "uogorod.view_manual" */
export enum Uogorod_View_Manual_Select_Column {
  /** column name */
  AncestorsBad = 'ancestors_bad',
  /** column name */
  AncestorsGood = 'ancestors_good',
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  Bad = 'bad',
  /** column name */
  Biology = 'biology',
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Content = 'content',
  /** column name */
  Good = 'good',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Seedling = 'seedling'
}

/** aggregate stddev on columns */
export type Uogorod_View_Manual_Stddev_Fields = {
  __typename?: 'uogorod_view_manual_stddev_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Uogorod_View_Manual_Stddev_Pop_Fields = {
  __typename?: 'uogorod_view_manual_stddev_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Uogorod_View_Manual_Stddev_Samp_Fields = {
  __typename?: 'uogorod_view_manual_stddev_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "uogorod_view_manual" */
export type Uogorod_View_Manual_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uogorod_View_Manual_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uogorod_View_Manual_Stream_Cursor_Value_Input = {
  ancestors_bad?: InputMaybe<Scalars['jsonb']['input']>;
  ancestors_good?: InputMaybe<Scalars['jsonb']['input']>;
  author_id?: InputMaybe<Scalars['bigint']['input']>;
  bad?: InputMaybe<Scalars['jsonb']['input']>;
  biology?: InputMaybe<Scalars['jsonb']['input']>;
  category_id?: InputMaybe<Scalars['bigint']['input']>;
  content?: InputMaybe<Scalars['jsonb']['input']>;
  good?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  seedling?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Uogorod_View_Manual_Sum_Fields = {
  __typename?: 'uogorod_view_manual_sum_fields';
  author_id?: Maybe<Scalars['bigint']['output']>;
  category_id?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Uogorod_View_Manual_Var_Pop_Fields = {
  __typename?: 'uogorod_view_manual_var_pop_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Uogorod_View_Manual_Var_Samp_Fields = {
  __typename?: 'uogorod_view_manual_var_samp_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Uogorod_View_Manual_Variance_Fields = {
  __typename?: 'uogorod_view_manual_variance_fields';
  author_id?: Maybe<Scalars['Float']['output']>;
  category_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  email: Scalars['String']['output'];
  /** An array relationship */
  followers: Array<Followers>;
  /** An array relationship */
  followersByFollowerId: Array<Followers>;
  /** An aggregate relationship */
  followersByFollowerId_aggregate: Followers_Aggregate;
  /** An aggregate relationship */
  followers_aggregate: Followers_Aggregate;
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};


/** columns and relationships of "users" */
export type UsersCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowersArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowersByFollowerIdArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowersByFollowerId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFollowers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Followers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Followers_Order_By>>;
  where?: InputMaybe<Followers_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  followers?: InputMaybe<Followers_Bool_Exp>;
  followersByFollowerId?: InputMaybe<Followers_Bool_Exp>;
  followersByFollowerId_aggregate?: InputMaybe<Followers_Aggregate_Bool_Exp>;
  followers_aggregate?: InputMaybe<Followers_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  followersByFollowerId_aggregate?: InputMaybe<Followers_Aggregate_Order_By>;
  followers_aggregate?: InputMaybe<Followers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Username = 'username'
}

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type GetCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCategoryQuery = { __typename?: 'query_root', uogorod_seed_categories_by_pk?: { __typename?: 'uogorod_seed_categories', id: number, title: string, description?: string | null, parent_id?: number | null, color?: string | null, childrens: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string }> } | null };

export type DeleteSeedMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteSeedMutation = { __typename?: 'mutation_root', delete_uogorod_seeds_by_pk?: { __typename?: 'uogorod_seeds', id: number } | null };

export type UpdateSeedMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  brands_ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  set: Uogorod_Seeds_Set_Input;
  brands: Array<Uogorod_Seeds_Brands_Insert_Input> | Uogorod_Seeds_Brands_Insert_Input;
  params: Array<Uogorod_Seed_Params_Insert_Input> | Uogorod_Seed_Params_Insert_Input;
}>;


export type UpdateSeedMutation = { __typename?: 'mutation_root', update_uogorod_seeds_by_pk?: { __typename?: 'uogorod_seeds', id: number, title: string, title_en?: string | null, originator_id?: number | null, country_id?: number | null, seed_category_id?: number | null, status: Uogorod_Type_Seeds_Status_Enum, description?: string | null, agrotech?: string | null } | null, delete_uogorod_seeds_brands?: { __typename?: 'uogorod_seeds_brands_mutation_response', affected_rows: number } | null, insert_uogorod_seeds_brands?: { __typename?: 'uogorod_seeds_brands_mutation_response', returning: Array<{ __typename?: 'uogorod_seeds_brands', brand_id: number }> } | null, insert_uogorod_seed_params?: { __typename?: 'uogorod_seed_params_mutation_response', returning: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }> } | null };

export type UpdateBrandMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  set: Uogorod_Brands_Set_Input;
  contacts_ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  contacts: Array<Uogorod_Brands_Contacts_Insert_Input> | Uogorod_Brands_Contacts_Insert_Input;
}>;


export type UpdateBrandMutation = { __typename?: 'mutation_root', update_uogorod_brands_by_pk?: { __typename?: 'uogorod_brands', id: number } | null, delete_uogorod_brands_contacts?: { __typename?: 'uogorod_brands_contacts_mutation_response', affected_rows: number } | null, insert_uogorod_brands_contacts?: { __typename?: 'uogorod_brands_contacts_mutation_response', returning: Array<{ __typename?: 'uogorod_brands_contacts', id: number }> } | null };

export type InsertBrandMutationVariables = Exact<{
  object: Uogorod_Brands_Insert_Input;
}>;


export type InsertBrandMutation = { __typename?: 'mutation_root', insert_uogorod_brands_one?: { __typename?: 'uogorod_brands', id: number } | null };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'mutation_root', delete_uogorod_brands_by_pk?: { __typename?: 'uogorod_brands', id: number } | null };

export type ChangeRelationMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  newid: Scalars['bigint']['input'];
}>;


export type ChangeRelationMutation = { __typename?: 'mutation_root', update_uogorod_garden_seeds?: { __typename?: 'uogorod_garden_seeds_mutation_response', returning: Array<{ __typename?: 'uogorod_garden_seeds', id: number }> } | null, update_uogorod_seeds_records?: { __typename?: 'uogorod_seeds_records_mutation_response', returning: Array<{ __typename?: 'uogorod_seeds_records', id: number }> } | null, update_uogorod_reviews?: { __typename?: 'uogorod_reviews_mutation_response', returning: Array<{ __typename?: 'uogorod_reviews', id: number }> } | null, update_uogorod_seeds_images?: { __typename?: 'uogorod_seeds_images_mutation_response', returning: Array<{ __typename?: 'uogorod_seeds_images', id: number }> } | null, update_uogorod_seed_similar?: { __typename?: 'uogorod_seed_similar_mutation_response', returning: Array<{ __typename?: 'uogorod_seed_similar', id: number }> } | null, update_uogorod_users_seed_actions?: { __typename?: 'uogorod_users_seed_actions_mutation_response', returning: Array<{ __typename?: 'uogorod_users_seed_actions', id: number }> } | null };

export type BrandsCommonFieldsFragment = { __typename?: 'uogorod_brands', id: number, title: string };

export type NewBrandMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type NewBrandMutation = { __typename?: 'mutation_root', insert_uogorod_brands_one?: { __typename?: 'uogorod_brands', id: number, title: string } | null };

export type GetBrandsForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsForSelectQuery = { __typename?: 'query_root', uogorod_brands: Array<{ __typename?: 'uogorod_brands', id: number, title: string, synonyms?: any | null }> };

export type BrandInfoFragment = { __typename?: 'uogorod_brands', image?: any | null, created_at: any, id: number, title: string, contacts: Array<{ __typename?: 'uogorod_brands_contacts', id: number, type: string, value: string }>, seeds_aggregate: { __typename?: 'uogorod_seeds_brands_aggregate', aggregate?: { __typename?: 'uogorod_seeds_brands_aggregate_fields', count: number } | null }, reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number, avg?: { __typename?: 'uogorod_reviews_avg_fields', rate?: number | null } | null } | null } };

export type GetBrandQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetBrandQuery = { __typename?: 'query_root', uogorod_brands_by_pk?: { __typename?: 'uogorod_brands', country_id?: number | null, synonyms?: any | null, description?: string | null, foundation?: number | null, image?: any | null, created_at: any, id: number, title: string, contacts: Array<{ __typename?: 'uogorod_brands_contacts', id: number, type: string, value: string }>, seeds_aggregate: { __typename?: 'uogorod_seeds_brands_aggregate', aggregate?: { __typename?: 'uogorod_seeds_brands_aggregate_fields', count: number } | null }, reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number, avg?: { __typename?: 'uogorod_reviews_avg_fields', rate?: number | null } | null } | null } } | null };

export type GetBrandsQueryVariables = Exact<{
  like?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetBrandsQuery = { __typename?: 'query_root', uogorod_brands: Array<{ __typename?: 'uogorod_brands', image?: any | null, created_at: any, id: number, title: string, contacts: Array<{ __typename?: 'uogorod_brands_contacts', id: number, type: string, value: string }>, seeds_aggregate: { __typename?: 'uogorod_seeds_brands_aggregate', aggregate?: { __typename?: 'uogorod_seeds_brands_aggregate_fields', count: number } | null }, reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number, avg?: { __typename?: 'uogorod_reviews_avg_fields', rate?: number | null } | null } | null } }>, uogorod_brands_aggregate: { __typename?: 'uogorod_brands_aggregate', aggregate?: { __typename?: 'uogorod_brands_aggregate_fields', count: number } | null } };

export type GetBrandReviewsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  isBrandReview: Scalars['Boolean']['input'];
}>;


export type GetBrandReviewsQuery = { __typename?: 'query_root', uogorod_reviews: Array<{ __typename?: 'uogorod_reviews', id: number, rate: any, comment?: string | null, created_at: any, recommended?: boolean | null, images?: any | null, is_liked?: number | null, seed?: { __typename?: 'uogorod_seeds', id: number, title: string, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> }>, uogorod_reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number, avg?: { __typename?: 'uogorod_reviews_avg_fields', rate?: number | null } | null } | null } };

export type CategoryBaseFieldsFragment = { __typename?: 'uogorod_seed_categories', id: number, title: string, description?: string | null, slug?: string | null, seeds?: Array<{ __typename?: 'uogorod_seeds', rate: any, created_at: any, id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }>, brands: Array<{ __typename?: 'uogorod_seeds_brands', brand_id: number }>, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, seeds_aggregate?: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null } };

export type GetRootCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRootCategoriesQuery = { __typename?: 'query_root', uogorod_seed_categories: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null, childrens: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null }> }> };

export type GetCategoryFiltersQueryVariables = Exact<{
  where: Uogorod_Seeds_Bool_Exp;
}>;


export type GetCategoryFiltersQuery = { __typename?: 'query_root', uogorod_seed_params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }>, uogorod_seed_specs: Array<{ __typename?: 'uogorod_seed_specs', label: string, name: string, values?: any | null }>, uogorod_brands: Array<{ __typename?: 'uogorod_brands', id: number, title: string }> };

export type GetCategoriesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  where: Uogorod_Seeds_Bool_Exp;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  categoryOffset?: InputMaybe<Scalars['Int']['input']>;
  categoryLimit?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uogorod_Seeds_Order_By> | Uogorod_Seeds_Order_By>;
  parentId: Scalars['Boolean']['input'];
  includeSeeds: Scalars['Boolean']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'query_root', uogorod_seed_categories: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string, description?: string | null, slug?: string | null, parent?: { __typename?: 'uogorod_seed_categories', slug?: string | null, title: string } | null, childrens?: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string, description?: string | null, slug?: string | null, seeds?: Array<{ __typename?: 'uogorod_seeds', rate: any, created_at: any, id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }>, brands: Array<{ __typename?: 'uogorod_seeds_brands', brand_id: number }>, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, seeds_aggregate?: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null } }>, childrens_aggregate?: { __typename?: 'uogorod_seed_categories_aggregate', aggregate?: { __typename?: 'uogorod_seed_categories_aggregate_fields', count: number } | null }, seeds?: Array<{ __typename?: 'uogorod_seeds', rate: any, created_at: any, id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }>, brands: Array<{ __typename?: 'uogorod_seeds_brands', brand_id: number }>, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, seeds_aggregate?: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null } }> };

export type SearchCategoryQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchCategoryQuery = { __typename?: 'query_root', uogorod_seed_categories: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string }> };

export type AuthorBaseFieldsFragment = { __typename?: 'uogorod_users', id: number, name: string, nickname: string };

export type CommentBaseFieldsFragment = { __typename?: 'uogorod_comments', id: number, text: string, parent_id?: number | null, created_at: any, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null };

export type ReviewCommentsFragment = { __typename?: 'uogorod_reviews', comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> };

export type InsertCommentMutationVariables = Exact<{
  entity_id: Scalars['bigint']['input'];
  entity_type: Scalars['String']['input'];
  parent_id?: InputMaybe<Scalars['bigint']['input']>;
  text: Scalars['String']['input'];
}>;


export type InsertCommentMutation = { __typename?: 'mutation_root', insert_uogorod_comments_one?: { __typename?: 'uogorod_comments', id: number, text: string, parent_id?: number | null, created_at: any, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null } | null };

export type GetCommentsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetCommentsQuery = { __typename?: 'query_root', uogorod_comments: Array<{ __typename?: 'uogorod_comments', entity_id: number, entity_type: string, id: number, text: string, parent_id?: number | null, created_at: any, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'mutation_root', delete_uogorod_comments_by_pk?: { __typename?: 'uogorod_comments', id: number } | null };

export type GetGardenQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetGardenQuery = { __typename?: 'query_root', uogorod_gardens_by_pk?: { __typename?: 'uogorod_gardens', title?: string | null } | null };

export type GetGardensQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGardensQuery = { __typename?: 'query_root', uogorod_gardens: Array<{ __typename?: 'uogorod_gardens', id: number, title?: string | null, about?: string | null, show_count: boolean, show_germination: boolean, show_ground: boolean, views: number, images: any, seasons: Array<{ __typename?: 'uogorod_garden_seasons', season: number }>, user: { __typename?: 'uogorod_users', city?: { __typename?: 'uogorod_geo_city', name: string, region?: { __typename?: 'uogorod_geo_region', name: string } | null } | null } }>, uogorod_gardens_aggregate: { __typename?: 'uogorod_gardens_aggregate', aggregate?: { __typename?: 'uogorod_gardens_aggregate_fields', count: number } | null } };

export type GardenBaseFieldsFragment = { __typename?: 'uogorod_gardens', id: number, title?: string | null, about?: string | null, images: any, show_count: boolean, show_ground: boolean, show_germination: boolean };

export type GardensQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GardensQuery = { __typename?: 'query_root', uogorod_gardens: Array<{ __typename?: 'uogorod_gardens', id: number, title?: string | null, about?: string | null, images: any, show_count: boolean, show_ground: boolean, show_germination: boolean, seasons: Array<{ __typename?: 'uogorod_garden_seasons', season: number }>, seeds: Array<{ __typename?: 'uogorod_garden_seeds', season: number }>, seeds_aggregate: { __typename?: 'uogorod_garden_seeds_aggregate', aggregate?: { __typename?: 'uogorod_garden_seeds_aggregate_fields', count: number } | null } }> };

export type CreateGardenMutationVariables = Exact<{
  object: Uogorod_Gardens_Insert_Input;
}>;


export type CreateGardenMutation = { __typename?: 'mutation_root', insert_uogorod_gardens_one?: { __typename?: 'uogorod_gardens', id: number, title?: string | null, about?: string | null, images: any, show_count: boolean, show_ground: boolean, show_germination: boolean, seasons: Array<{ __typename?: 'uogorod_garden_seasons', season: number }> } | null };

export type UpdateGardenMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  set: Uogorod_Gardens_Set_Input;
}>;


export type UpdateGardenMutation = { __typename?: 'mutation_root', update_uogorod_gardens_by_pk?: { __typename?: 'uogorod_gardens', id: number, title?: string | null, about?: string | null, images: any, show_count: boolean, show_ground: boolean, show_germination: boolean } | null };

export type DeleteGardenMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteGardenMutation = { __typename?: 'mutation_root', delete_uogorod_gardens_by_pk?: { __typename?: 'uogorod_gardens', id: number } | null };

export type InsertPlantMutationVariables = Exact<{
  objects: Array<Uogorod_Garden_Seeds_Insert_Input> | Uogorod_Garden_Seeds_Insert_Input;
}>;


export type InsertPlantMutation = { __typename?: 'mutation_root', insert_uogorod_garden_seeds?: { __typename?: 'uogorod_garden_seeds_mutation_response', returning: Array<{ __typename?: 'uogorod_garden_seeds', id: number, label?: string | null, season: number, journal: any, seed: { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, category?: { __typename?: 'uogorod_seed_categories', id: number, title: string } | null, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } }> } | null };

export type UpdateGardenSeedMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  set: Uogorod_Garden_Seeds_Set_Input;
  append: Uogorod_Garden_Seeds_Append_Input;
  delete: Uogorod_Garden_Seeds_Delete_Elem_Input;
}>;


export type UpdateGardenSeedMutation = { __typename?: 'mutation_root', update_uogorod_garden_seeds_by_pk?: { __typename?: 'uogorod_garden_seeds', id: number, journal: any } | null };

export type DeleteGardenSeedMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteGardenSeedMutation = { __typename?: 'mutation_root', delete_uogorod_garden_seeds_by_pk?: { __typename?: 'uogorod_garden_seeds', id: number } | null };

export type GardenSeedsQueryVariables = Exact<{
  where: Uogorod_Garden_Seeds_Bool_Exp;
}>;


export type GardenSeedsQuery = { __typename?: 'query_root', uogorod_garden_seeds: Array<{ __typename?: 'uogorod_garden_seeds', id: number, label?: string | null, season: number, journal: any, garden_id: number, seed_id: number, seed: { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any, seed_spec: { __typename?: 'uogorod_seed_specs', values?: any | null } }>, manual?: { __typename?: 'uogorod_view_manual', id?: number | null } | null, category?: { __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null, color?: string | null, parent_id?: number | null } | null, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } }> };

export type RemoveImageMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type RemoveImageMutation = { __typename?: 'mutation_root', delete_uogorod_images_by_pk?: { __typename?: 'uogorod_images', id: number } | null };

export type InsertFavoriteMutationVariables = Exact<{
  seed_id: Scalars['bigint']['input'];
}>;


export type InsertFavoriteMutation = { __typename?: 'mutation_root', insert_uogorod_users_seed_actions_one?: { __typename?: 'uogorod_users_seed_actions', id: number, user_id: number, action: string, seed_id: number } | null };

export type RemoveFavoriteMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type RemoveFavoriteMutation = { __typename?: 'mutation_root', delete_uogorod_users_seed_actions_by_pk?: { __typename?: 'uogorod_users_seed_actions', id: number } | null };

export type ImagesQueryVariables = Exact<{
  uuids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type ImagesQuery = { __typename?: 'query_root', uogorod_images: Array<{ __typename?: 'uogorod_images', id: number, user_id?: number | null, uuid: any, note?: string | null }> };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  note: Scalars['String']['input'];
}>;


export type UpdateNoteMutation = { __typename?: 'mutation_root', update_uogorod_images_by_pk?: { __typename?: 'uogorod_images', id: number, user_id?: number | null, uuid: any, note?: string | null } | null };

export type CreateSeasonMutationVariables = Exact<{
  object: Uogorod_Garden_Seasons_Insert_Input;
}>;


export type CreateSeasonMutation = { __typename?: 'mutation_root', insert_uogorod_garden_seasons_one?: { __typename?: 'uogorod_garden_seasons', id: number, season: number } | null };

export type GetCountriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCountriesQuery = { __typename?: 'query_root', uogorod_geo_country: Array<{ __typename?: 'uogorod_geo_country', id: number, title: string }> };

export type InsertLikeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['Int']['input'];
}>;


export type InsertLikeMutation = { __typename?: 'mutation_root', insert_uogorod_likes_one?: { __typename?: 'uogorod_likes', id: number, value?: number | null } | null };

export type UpdateLikeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateLikeMutation = { __typename?: 'mutation_root', update_uogorod_likes?: { __typename?: 'uogorod_likes_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'uogorod_likes', id: number, value?: number | null }> } | null };

export type RemoveLikeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['bigint']['input']>;
  type: Scalars['String']['input'];
}>;


export type RemoveLikeMutation = { __typename?: 'mutation_root', delete_uogorod_likes?: { __typename?: 'uogorod_likes_mutation_response', affected_rows: number } | null };

export type ManualCommonFieldFragment = { __typename?: 'uogorod_view_manual', id?: number | null, image?: string | null, category?: { __typename?: 'uogorod_seed_categories', title: string, slug?: string | null } | null };

export type ManualInfoFieldFragment = { __typename?: 'uogorod_view_manual', content?: any | null, biology?: any | null, seedling?: any | null, good?: any | null, bad?: any | null };

export type GetManualQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetManualQuery = { __typename?: 'query_root', uogorod_view_manual: Array<{ __typename?: 'uogorod_view_manual', author_id?: number | null, id?: number | null, image?: string | null, content?: any | null, biology?: any | null, seedling?: any | null, good?: any | null, bad?: any | null, category?: { __typename?: 'uogorod_seed_categories', title: string, slug?: string | null } | null }> };

export type GetManualsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManualsQuery = { __typename?: 'query_root', uogorod_view_manual: Array<{ __typename?: 'uogorod_view_manual', id?: number | null, image?: string | null, category?: { __typename?: 'uogorod_seed_categories', title: string, slug?: string | null } | null }> };

export type MessagesSubscriptionVariables = Exact<{
  profile_id: Scalars['Int']['input'];
}>;


export type MessagesSubscription = { __typename?: 'subscription_root', uogorod_messages: Array<{ __typename?: 'uogorod_messages', id: number, text: string, is_readed: boolean, sender_id: number, receiver_id: number, created_at: any, images?: any | null }> };

export type DialogsSubscriptionVariables = Exact<{
  client_id: Scalars['Int']['input'];
}>;


export type DialogsSubscription = { __typename?: 'subscription_root', dialogs: Array<{ __typename?: 'dialog', user?: any | null, is_new?: boolean | null, text?: string | null, created_at?: any | null }> };

export type AddMessageMutationVariables = Exact<{
  receiver_id: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  images?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type AddMessageMutation = { __typename?: 'mutation_root', insert_uogorod_messages_one?: { __typename?: 'uogorod_messages', id: number, text: string, sender_id: number, receiver_id: number, created_at: any, images?: any | null } | null };

export type MarkAsReadMutationVariables = Exact<{
  profile_id: Scalars['Int']['input'];
}>;


export type MarkAsReadMutation = { __typename?: 'mutation_root', update_uogorod_messages?: { __typename?: 'uogorod_messages_mutation_response', affected_rows: number } | null };

export type PostFieldsFragment = { __typename?: 'uogorod_posts', entity_type?: string | null, views: number, created_at: any, is_liked?: number | null, in_feed: boolean, id: number, title: string, text: string, content?: string | null, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null } };

export type PostBaseFieldsFragment = { __typename?: 'uogorod_posts', id: number, title: string, text: string, content?: string | null };

export type PostCommentsCountFragment = { __typename?: 'uogorod_posts', comments_aggregate: { __typename?: 'uogorod_comments_aggregate', aggregate?: { __typename?: 'uogorod_comments_aggregate_fields', count: number } | null } };

export type LikesCountFragment = { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null };

export type GetPostQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetPostQuery = { __typename?: 'query_root', uogorod_posts_by_pk?: { __typename?: 'uogorod_posts', entity_type?: string | null, views: number, created_at: any, is_liked?: number | null, in_feed: boolean, id: number, title: string, text: string, content?: string | null, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null } } | null, uogorod_comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> };

export type InsertPostMutationVariables = Exact<{
  title: Scalars['String']['input'];
  text: Scalars['String']['input'];
  in_feed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertPostMutation = { __typename?: 'mutation_root', insert_uogorod_posts_one?: { __typename?: 'uogorod_posts', id: number, title: string, text: string, content?: string | null } | null };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  title: Scalars['String']['input'];
  text: Scalars['String']['input'];
  in_feed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePostMutation = { __typename?: 'mutation_root', update_uogorod_posts_by_pk?: { __typename?: 'uogorod_posts', id: number, title: string, text: string, content?: string | null } | null };

export type RemovePostMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type RemovePostMutation = { __typename?: 'mutation_root', delete_uogorod_posts_by_pk?: { __typename?: 'uogorod_posts', id: number } | null };

export type GetPostsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Uogorod_Posts_Order_By> | Uogorod_Posts_Order_By>;
  where: Uogorod_Posts_Bool_Exp;
}>;


export type GetPostsQuery = { __typename?: 'query_root', uogorod_posts: Array<{ __typename?: 'uogorod_posts', entity_type?: string | null, views: number, created_at: any, is_liked?: number | null, in_feed: boolean, id: number, title: string, text: string, content?: string | null, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, comments_aggregate: { __typename?: 'uogorod_comments_aggregate', aggregate?: { __typename?: 'uogorod_comments_aggregate_fields', count: number } | null } }>, uogorod_posts_aggregate: { __typename?: 'uogorod_posts_aggregate', aggregate?: { __typename?: 'uogorod_posts_aggregate_fields', count: number } | null } };

export type SeedCommonFieldsFragment = { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> };

export type ReviewsBaseFieldsFragment = { __typename?: 'uogorod_reviews', id: number, rate: any, comment?: string | null, created_at: any, recommended?: boolean | null, images?: any | null, is_liked?: number | null, seed?: { __typename?: 'uogorod_seeds', id: number, title: string, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> };

export type GetCatalogQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCatalogQuery = { __typename?: 'query_root', uogorod_seed_categories: Array<{ __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null }>, uogorod_seeds: Array<{ __typename?: 'uogorod_seeds', rate: any, id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, uogorod_top_reviewers: Array<{ __typename?: 'uogorod_top_reviewers', count?: number | null, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }>, uogorod_reviews: Array<{ __typename?: 'uogorod_reviews', id: number, rate: any, comment?: string | null, created_at: any, recommended?: boolean | null, images?: any | null, is_liked?: number | null, brand?: { __typename?: 'uogorod_brands', id: number, title: string } | null, seed?: { __typename?: 'uogorod_seeds', id: number, title: string, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> }>, uogorod_seeds_records: Array<{ __typename?: 'uogorod_seeds_records', record: any, images: any, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> };

export type InsertUogorodSeedMutationVariables = Exact<{
  object: Uogorod_Seeds_Insert_Input;
}>;


export type InsertUogorodSeedMutation = { __typename?: 'mutation_root', insert_uogorod_seeds_one?: { __typename?: 'uogorod_seeds', id: number } | null };

export type InsertSeedRecordMutationVariables = Exact<{
  seed_id: Scalars['bigint']['input'];
  record: Scalars['numeric']['input'];
  images: Scalars['jsonb']['input'];
}>;


export type InsertSeedRecordMutation = { __typename?: 'mutation_root', insert_uogorod_seeds_records_one?: { __typename?: 'uogorod_seeds_records', record: any, images: any, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null } | null };

export type InsertSeedImagesMutationVariables = Exact<{
  objects: Array<Uogorod_Seeds_Images_Insert_Input> | Uogorod_Seeds_Images_Insert_Input;
}>;


export type InsertSeedImagesMutation = { __typename?: 'mutation_root', insert_uogorod_seeds_images?: { __typename?: 'uogorod_seeds_images_mutation_response', returning: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null, image?: { __typename?: 'uogorod_images', created_at?: any | null } | null }> } | null };

export type GetSeedsForSelectQueryVariables = Exact<{
  where: Uogorod_Seeds_Bool_Exp;
}>;


export type GetSeedsForSelectQuery = { __typename?: 'query_root', uogorod_seeds: Array<{ __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }> };

export type InsertSeedSimilarMutationVariables = Exact<{
  seed_id: Scalars['bigint']['input'];
  similar_seed_id: Scalars['bigint']['input'];
}>;


export type InsertSeedSimilarMutation = { __typename?: 'mutation_root', insert_uogorod_seed_similar_one?: { __typename?: 'uogorod_seed_similar', similar?: { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } | null } | null };

export type GetBrandSeedsQueryVariables = Exact<{
  where?: InputMaybe<Uogorod_Seeds_Bool_Exp>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  user: Scalars['Boolean']['input'];
}>;


export type GetBrandSeedsQuery = { __typename?: 'query_root', uogorod_seeds: Array<{ __typename?: 'uogorod_seeds', rate: any, created_at: any, id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, user?: { __typename?: 'uogorod_users', id: number, nickname: string } | null, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, uogorod_seeds_aggregate: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null } };

export type GetSeedSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeedSpecsQuery = { __typename?: 'query_root', uogorod_seed_specs: Array<{ __typename?: 'uogorod_seed_specs', multiple: boolean, values?: any | null, description?: string | null, label: string, name: string, unit?: string | null }> };

export type GetSeedQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  user_id?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetSeedQuery = { __typename?: 'query_root', uogorod_garden_seeds: Array<{ __typename?: 'uogorod_garden_seeds', season: number }>, uogorod_users_seed_actions_aggregate: { __typename?: 'uogorod_users_seed_actions_aggregate', aggregate?: { __typename?: 'uogorod_users_seed_actions_aggregate_fields', count: number } | null }, uogorod_seeds_by_pk?: { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, title_en?: string | null, originator_id?: number | null, seed_category_id?: number | null, rate: any, views: number, created_at: any, description?: string | null, agrotech?: string | null, Country?: { __typename?: 'uogorod_geo_country', name: string } | null, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null, image?: { __typename?: 'uogorod_images', id: number, uuid: any, created_at?: any | null, is_liked?: number | null, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null } } | null }>, params: Array<{ __typename?: 'uogorod_seed_params', name: string, values: any }>, records: Array<{ __typename?: 'uogorod_seeds_records', id: number, record: any, images: any, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }>, actions: Array<{ __typename?: 'uogorod_users_seed_actions', id: number, user_id: number }>, reviews: Array<{ __typename?: 'uogorod_reviews', id: number, user_id: number, brand_id?: number | null, rate: any, comment?: string | null, recommended?: boolean | null }>, reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number, avg?: { __typename?: 'uogorod_reviews_avg_fields', rate?: number | null, seed_id?: number | null } | null } | null, nodes: Array<{ __typename?: 'uogorod_reviews', id: number, rate: any, comment?: string | null, created_at: any, recommended?: boolean | null, images?: any | null, is_liked?: number | null, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, user?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null, brand?: { __typename?: 'uogorod_brands', id: number, title: string } | null, comments: Array<{ __typename?: 'uogorod_comments', is_liked?: number | null, id: number, text: string, parent_id?: number | null, created_at: any, likes_aggregate: { __typename?: 'uogorod_likes_aggregate', aggregate?: { __typename?: 'uogorod_likes_aggregate_fields', count: number, sum?: { __typename?: 'uogorod_likes_sum_fields', value?: number | null } | null } | null }, author?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string } | null }> }> }, category?: { __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null, parent?: { __typename?: 'uogorod_seed_categories', id: number, title: string, slug?: string | null } | null } | null, similars: Array<{ __typename?: 'uogorod_seed_similar', id: number, user_id?: number | null, similar?: { __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> } | null }>, brands: Array<{ __typename?: 'uogorod_seeds_brands', brand?: { __typename?: 'uogorod_brands', id: number, title: string } | null }>, manual?: { __typename?: 'uogorod_view_manual', content?: any | null, biology?: any | null, seedling?: any | null, good?: any | null, bad?: any | null } | null } | null };

export type SendReviewMutationVariables = Exact<{
  rate: Scalars['numeric']['input'];
  plus?: InputMaybe<Scalars['String']['input']>;
  minus?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  recommended: Scalars['Boolean']['input'];
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  seed_id?: InputMaybe<Scalars['bigint']['input']>;
  images?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type SendReviewMutation = { __typename?: 'mutation_root', insert_uogorod_reviews_one?: { __typename?: 'uogorod_reviews', id: number } | null };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  set: Uogorod_Reviews_Set_Input;
}>;


export type UpdateReviewMutation = { __typename?: 'mutation_root', update_uogorod_reviews_by_pk?: { __typename?: 'uogorod_reviews', id: number } | null };

export type RemoveSimilarMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type RemoveSimilarMutation = { __typename?: 'mutation_root', delete_uogorod_seed_similar_by_pk?: { __typename?: 'uogorod_seed_similar', id: number } | null };

export type RemoveRecordMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type RemoveRecordMutation = { __typename?: 'mutation_root', delete_uogorod_seeds_records_by_pk?: { __typename?: 'uogorod_seeds_records', id: number } | null };

export type UserAchivmentsSubscriptionVariables = Exact<{
  id: Scalars['bigint']['input'];
  created_at: Scalars['timestamptz']['input'];
}>;


export type UserAchivmentsSubscription = { __typename?: 'subscription_root', uogorod_user_achivments: Array<{ __typename?: 'uogorod_user_achivments', points?: number | null, created_at: any, achivment: { __typename?: 'uogorod_achivments', id: string, name: string, description: string, icon: string } }> };

export type GeoCitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GeoCitiesQuery = { __typename?: 'query_root', uogorod_geo_city: Array<{ __typename?: 'uogorod_geo_city', id: number, name: string, region?: { __typename?: 'uogorod_geo_region', name: string, country?: { __typename?: 'uogorod_geo_country', name: string } | null } | null }> };

export type GetProfileSettingsQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetProfileSettingsQuery = { __typename?: 'query_root', uogorod_users_by_pk?: { __typename?: 'uogorod_users', id: number, settings: any } | null };

export type GetProfileQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  isOwner: Scalars['Boolean']['input'];
}>;


export type GetProfileQuery = { __typename?: 'query_root', uogorod_users_by_pk?: { __typename?: 'uogorod_users', id: number, name: string, nickname: string, updated_at?: any | null, created_at?: any | null, experience?: any | null, about?: string | null, gender: boolean, birthday?: any | null, city_id?: number | null, settings: any, private?: { __typename?: 'uogorod_emails', email?: string | null } | null, achivments: Array<{ __typename?: 'uogorod_user_achivments', points?: number | null, created_at: any, achivment: { __typename?: 'uogorod_achivments', id: string, name: string, description: string, icon: string } }>, city?: { __typename?: 'uogorod_geo_city', id: number, name: string, region?: { __typename?: 'uogorod_geo_region', name: string } | null } | null, gardens_aggregate?: { __typename?: 'uogorod_gardens_aggregate', aggregate?: { __typename?: 'uogorod_gardens_aggregate_fields', count: number } | null }, subcribes_aggregate: { __typename?: 'uogorod_subscribes_aggregate', aggregate?: { __typename?: 'uogorod_subscribes_aggregate_fields', count: number } | null } } | null, uogorod_subscribes_aggregate: { __typename?: 'uogorod_subscribes_aggregate', aggregate?: { __typename?: 'uogorod_subscribes_aggregate_fields', count: number } | null } };

export type GetProfileStatsQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetProfileStatsQuery = { __typename?: 'query_root', uogorod_seed_categories: Array<{ __typename?: 'uogorod_seed_categories', title: string, seeds_aggregate: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'uogorod_seeds', title: string, reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number } | null } }> } }>, uogorod_reviews_aggregate: { __typename?: 'uogorod_reviews_aggregate', aggregate?: { __typename?: 'uogorod_reviews_aggregate_fields', count: number } | null } };

export type GetProfilesQueryVariables = Exact<{
  where: Uogorod_Users_Bool_Exp;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Uogorod_Users_Order_By> | Uogorod_Users_Order_By>;
}>;


export type GetProfilesQuery = { __typename?: 'query_root', uogorod_users: Array<{ __typename?: 'uogorod_users', id: number, name: string, nickname: string, gender: boolean, city?: { __typename?: 'uogorod_geo_city', name: string, region?: { __typename?: 'uogorod_geo_region', name: string, country?: { __typename?: 'uogorod_geo_country', name: string } | null } | null } | null }>, uogorod_users_aggregate: { __typename?: 'uogorod_users_aggregate', aggregate?: { __typename?: 'uogorod_users_aggregate_fields', count: number } | null }, maleCount: { __typename?: 'uogorod_users_aggregate', aggregate?: { __typename?: 'uogorod_users_aggregate_fields', count: number } | null }, femaleCount: { __typename?: 'uogorod_users_aggregate', aggregate?: { __typename?: 'uogorod_users_aggregate_fields', count: number } | null }, uogorod_geo_city: Array<{ __typename?: 'uogorod_geo_city', id: number, name: string, region?: { __typename?: 'uogorod_geo_region', country?: { __typename?: 'uogorod_geo_country', id: number, name: string } | null } | null, users_aggregate: { __typename?: 'uogorod_users_aggregate', aggregate?: { __typename?: 'uogorod_users_aggregate_fields', count: number } | null } }> };

export type UpdateProfileMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  append: Uogorod_Users_Append_Input;
  set?: InputMaybe<Uogorod_Users_Set_Input>;
}>;


export type UpdateProfileMutation = { __typename?: 'mutation_root', update_uogorod_users_by_pk?: { __typename?: 'uogorod_users', updated_at?: any | null } | null };

export type UserActionsQueryVariables = Exact<{
  user_id: Scalars['bigint']['input'];
  type: Scalars['String']['input'];
}>;


export type UserActionsQuery = { __typename?: 'query_root', uogorod_seeds: Array<{ __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }> };

export type UserRecordsQueryVariables = Exact<{
  user_id: Scalars['bigint']['input'];
  limit: Scalars['Int']['input'];
}>;


export type UserRecordsQuery = { __typename?: 'query_root', uogorod_seeds: Array<{ __typename?: 'uogorod_seeds', id: number, title: string, status: Uogorod_Type_Seeds_Status_Enum, records: Array<{ __typename?: 'uogorod_seeds_records', record: any }>, images: Array<{ __typename?: 'uogorod_seeds_images', uuid?: any | null }> }>, uogorod_seeds_aggregate: { __typename?: 'uogorod_seeds_aggregate', aggregate?: { __typename?: 'uogorod_seeds_aggregate_fields', count: number } | null } };

export const BrandsCommonFieldsFragmentDoc = gql`
    fragment BrandsCommonFields on uogorod_brands {
  id
  title
}
    `;
export const BrandInfoFragmentDoc = gql`
    fragment BrandInfo on uogorod_brands {
  ...BrandsCommonFields
  image
  created_at
  contacts {
    id
    type
    value
  }
  seeds_aggregate {
    aggregate {
      count
    }
  }
  reviews_aggregate(where: {seed_id: {_is_null: false}}) {
    aggregate {
      avg {
        rate
      }
      count
    }
  }
}
    ${BrandsCommonFieldsFragmentDoc}`;
export const SeedCommonFieldsFragmentDoc = gql`
    fragment SeedCommonFields on uogorod_seeds {
  id
  title
  status
  images: ranked_images {
    uuid
  }
}
    `;
export const CategoryBaseFieldsFragmentDoc = gql`
    fragment CategoryBaseFields on uogorod_seed_categories {
  id
  title
  description
  slug
  seeds(where: $where, offset: $offset, limit: $limit, order_by: $order_by) @include(if: $includeSeeds) {
    ...SeedCommonFields
    rate
    created_at
    params {
      name
      values
    }
    brands {
      brand_id
    }
  }
  seeds_aggregate(where: $where) @include(if: $includeSeeds) {
    aggregate {
      count
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;
export const GardenBaseFieldsFragmentDoc = gql`
    fragment GardenBaseFields on uogorod_gardens {
  id
  title
  about
  images
  show_count
  show_ground
  show_germination
}
    `;
export const ManualCommonFieldFragmentDoc = gql`
    fragment ManualCommonField on uogorod_view_manual {
  id
  image
  category {
    title
    slug
  }
}
    `;
export const ManualInfoFieldFragmentDoc = gql`
    fragment ManualInfoField on uogorod_view_manual {
  content
  biology
  seedling
  good
  bad
}
    `;
export const PostBaseFieldsFragmentDoc = gql`
    fragment PostBaseFields on uogorod_posts {
  id
  title
  text
  content
}
    `;
export const AuthorBaseFieldsFragmentDoc = gql`
    fragment AuthorBaseFields on uogorod_users {
  id
  name
  nickname
}
    `;
export const LikesCountFragmentDoc = gql`
    fragment LikesCount on uogorod_likes_aggregate {
  aggregate {
    count
    sum {
      value
    }
  }
}
    `;
export const PostFieldsFragmentDoc = gql`
    fragment PostFields on uogorod_posts {
    entity_type
  ...PostBaseFields
  views
  created_at
  author {
    ...AuthorBaseFields
  }
  is_liked(args: {entity: "Post"})
  likes_aggregate(where: {entity_type: {_eq: "Post"}}) {
    ...LikesCount
  }
  in_feed
}
    ${PostBaseFieldsFragmentDoc}
${AuthorBaseFieldsFragmentDoc}
${LikesCountFragmentDoc}`;
export const PostCommentsCountFragmentDoc = gql`
    fragment PostCommentsCount on uogorod_posts {
  comments_aggregate(where: {entity_type: {_eq: "Post"}}) {
    aggregate {
      count
    }
  }
}
    `;
export const CommentBaseFieldsFragmentDoc = gql`
    fragment CommentBaseFields on uogorod_comments {
  id
  text
  parent_id
  created_at
  author {
    ...AuthorBaseFields
  }
}
    ${AuthorBaseFieldsFragmentDoc}`;
export const ReviewCommentsFragmentDoc = gql`
    fragment ReviewComments on uogorod_reviews {
  comments(where: {entity_type: {_eq: "Review"}}) {
    ...CommentBaseFields
    is_liked(args: {entity: "Comment"})
    likes_aggregate(where: {entity_type: {_eq: "Comment"}}) {
      aggregate {
        count
        sum {
          value
        }
      }
    }
  }
}
    ${CommentBaseFieldsFragmentDoc}`;
export const ReviewsBaseFieldsFragmentDoc = gql`
    fragment ReviewsBaseFields on uogorod_reviews {
  id
  rate
  comment
  plus
  minus
  reviewed_at
  created_at
  recommended
  images
  seed {
    id
    title
    images: ranked_images {
      uuid
    }
  }
  is_liked(args: {entity: "Review"})
  likes_aggregate(where: {entity_type: {_eq: "Review"}}) {
    aggregate {
      count
      sum {
        value
      }
    }
  }
  ...ReviewComments
  user {
    ...AuthorBaseFields
  }
}
    ${ReviewCommentsFragmentDoc}
${AuthorBaseFieldsFragmentDoc}`;
export const GetCategoryDocument = gql`
    query GetCategory($id: Int!) {
  uogorod_seed_categories_by_pk(id: $id) {
    id
    title
    description
    parent_id
    color
    childrens {
      id
      title
    }
  }
}
    `;

export function useGetCategoryQuery(options?: Omit<Urql.UseQueryArgs<never, GetCategoryQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCategoryQuery, GetCategoryQueryVariables | undefined>({ query: GetCategoryDocument, variables: undefined, ...options });
};
export const DeleteSeedDocument = gql`
    mutation DeleteSeed($id: bigint!) {
  delete_uogorod_seeds_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteSeedMutation() {
  return Urql.useMutation<DeleteSeedMutation, DeleteSeedMutationVariables>(DeleteSeedDocument);
};
export const UpdateSeedDocument = gql`
    mutation UpdateSeed($id: bigint!, $brands_ids: [bigint!]!, $set: uogorod_seeds_set_input!, $brands: [uogorod_seeds_brands_insert_input!]!, $params: [uogorod_seed_params_insert_input!]!) {
  update_uogorod_seeds_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    title
    title_en
    originator_id
    country_id
    seed_category_id
    status
    description
    agrotech
  }
  delete_uogorod_seeds_brands(
    where: {seed_id: {_eq: $id}, brand_id: {_nin: $brands_ids}}
  ) {
    affected_rows
  }
  insert_uogorod_seeds_brands(
    objects: $brands
    on_conflict: {constraint: seeds_brands_pkey, update_columns: brand_id}
  ) {
    returning {
      brand_id
    }
  }
  insert_uogorod_seed_params(
    objects: $params
    on_conflict: {constraint: seed_params_pkey, update_columns: values}
  ) {
    returning {
      name
      values
    }
  }
}
    `;

export function useUpdateSeedMutation() {
  return Urql.useMutation<UpdateSeedMutation, UpdateSeedMutationVariables>(UpdateSeedDocument);
};
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($id: bigint!, $set: uogorod_brands_set_input!, $contacts_ids: [bigint!]!, $contacts: [uogorod_brands_contacts_insert_input!]!) {
  update_uogorod_brands_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
  delete_uogorod_brands_contacts(
    where: {brand_id: {_eq: $id}, id: {_nin: $contacts_ids}}
  ) {
    affected_rows
  }
  insert_uogorod_brands_contacts(
    objects: $contacts
    on_conflict: {constraint: brands_contacts_pkey, update_columns: [type, value]}
  ) {
    returning {
      id
    }
  }
}
    `;

export function useUpdateBrandMutation() {
  return Urql.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument);
};
export const InsertBrandDocument = gql`
    mutation InsertBrand($object: uogorod_brands_insert_input!) {
  insert_uogorod_brands_one(object: $object) {
    id
  }
}
    `;

export function useInsertBrandMutation() {
  return Urql.useMutation<InsertBrandMutation, InsertBrandMutationVariables>(InsertBrandDocument);
};
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: bigint!) {
  delete_uogorod_brands_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteBrandMutation() {
  return Urql.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument);
};
export const ChangeRelationDocument = gql`
    mutation ChangeRelation($id: bigint!, $newid: bigint!) {
  update_uogorod_garden_seeds(
    where: {seed_id: {_eq: $id}}
    _set: {seed_id: $newid}
  ) {
    returning {
      id
    }
  }
  update_uogorod_seeds_records(
    where: {seed_id: {_eq: $id}}
    _set: {seed_id: $newid}
  ) {
    returning {
      id
    }
  }
  update_uogorod_reviews(where: {seed_id: {_eq: $id}}, _set: {seed_id: $newid}) {
    returning {
      id
    }
  }
  update_uogorod_seeds_images(
    where: {seed_id: {_eq: $id}}
    _set: {seed_id: $newid}
  ) {
    returning {
      id
    }
  }
  update_uogorod_seed_similar(
    where: {seed_id: {_eq: $id}}
    _set: {seed_id: $newid}
  ) {
    returning {
      id
    }
  }
  update_uogorod_users_seed_actions(
    where: {seed_id: {_eq: $id}}
    _set: {seed_id: $newid}
  ) {
    returning {
      id
    }
  }
}
    `;

export function useChangeRelationMutation() {
  return Urql.useMutation<ChangeRelationMutation, ChangeRelationMutationVariables>(ChangeRelationDocument);
};
export const NewBrandDocument = gql`
    mutation NewBrand($title: String!) {
  insert_uogorod_brands_one(object: {title: $title}) {
    id
    title
  }
}
    `;

export function useNewBrandMutation() {
  return Urql.useMutation<NewBrandMutation, NewBrandMutationVariables>(NewBrandDocument);
};
export const GetBrandsForSelectDocument = gql`
    query GetBrandsForSelect {
  uogorod_brands(order_by: {title: asc}) {
    ...BrandsCommonFields
    synonyms
  }
}
    ${BrandsCommonFieldsFragmentDoc}`;

export function useGetBrandsForSelectQuery(options?: Omit<Urql.UseQueryArgs<never, GetBrandsForSelectQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetBrandsForSelectQuery, GetBrandsForSelectQueryVariables | undefined>({ query: GetBrandsForSelectDocument, variables: undefined, ...options });
};
export const GetBrandDocument = gql`
    query GetBrand($id: bigint!) {
  uogorod_brands_by_pk(id: $id) {
    ...BrandInfo
    country_id
    synonyms
    description
    foundation
  }
}
    ${BrandInfoFragmentDoc}`;

export function useGetBrandQuery(options?: Omit<Urql.UseQueryArgs<never, GetBrandQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetBrandQuery, GetBrandQueryVariables | undefined>({ query: GetBrandDocument, variables: undefined, ...options });
};
export const GetBrandsDocument = gql`
    query GetBrands($like: String, $offset: Int!, $limit: Int!) {
  uogorod_brands(
    where: {title: {_ilike: $like}}
    order_by: {title: asc}
    offset: $offset
    limit: $limit
  ) {
    ...BrandInfo
  }
  uogorod_brands_aggregate(where: {title: {_ilike: $like}}) {
    aggregate {
      count
    }
  }
}
    ${BrandInfoFragmentDoc}`;

export function useGetBrandsQuery(options?: Omit<Urql.UseQueryArgs<never, GetBrandsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetBrandsQuery, GetBrandsQueryVariables | undefined>({ query: GetBrandsDocument, variables: undefined, ...options });
};
export const GetBrandReviewsDocument = gql`
    query GetBrandReviews($id: Int!, $offset: Int!, $limit: Int!, $isBrandReview: Boolean!) {
  uogorod_reviews(
    where: {brand_id: {_eq: $id}, seed_id: {_is_null: $isBrandReview}}
    offset: $offset
    limit: $limit
  ) {
    ...ReviewsBaseFields
  }
  uogorod_reviews_aggregate(
    where: {brand_id: {_eq: $id}, seed_id: {_is_null: $isBrandReview}}
  ) {
    aggregate {
      avg {
        rate
      }
      count
    }
  }
}
    ${ReviewsBaseFieldsFragmentDoc}`;

export function useGetBrandReviewsQuery(options?: Omit<Urql.UseQueryArgs<never, GetBrandReviewsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetBrandReviewsQuery, GetBrandReviewsQueryVariables | undefined>({ query: GetBrandReviewsDocument, variables: undefined, ...options });
};
export const GetRootCategoriesDocument = gql`
    query GetRootCategories {
  uogorod_seed_categories(
    where: {parent_id: {_is_null: true}}
    order_by: {title: asc}
  ) {
    id
    title
    slug
    childrens(order_by: {title: asc}) {
      id
      title
      slug
    }
  }
}
    `;

export function useGetRootCategoriesQuery(options?: Omit<Urql.UseQueryArgs<never, GetRootCategoriesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetRootCategoriesQuery, GetRootCategoriesQueryVariables | undefined>({ query: GetRootCategoriesDocument, variables: undefined, ...options });
};
export const GetCategoryFiltersDocument = gql`
    query GetCategoryFilters($where: uogorod_seeds_bool_exp!) {
  uogorod_seed_params(
    where: {seed: $where, values: {_neq: "null"}, name: {_nin: ["blooming_time", "color", "fruiting_time", "facts"]}}
    distinct_on: name
  ) {
    name
    values
  }
  uogorod_seed_specs(
    where: {seed_params: {seed: $where, name: {_nin: ["blooming_time", "color", "fruiting_time", "facts"]}}, values: {_neq: "null"}}
    distinct_on: name
  ) {
    label
    name
    values
  }
  uogorod_brands(where: {seeds: {seed: $where}}, distinct_on: id) {
    ...BrandsCommonFields
  }
}
    ${BrandsCommonFieldsFragmentDoc}`;

export function useGetCategoryFiltersQuery(options?: Omit<Urql.UseQueryArgs<never, GetCategoryFiltersQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCategoryFiltersQuery, GetCategoryFiltersQueryVariables | undefined>({ query: GetCategoryFiltersDocument, variables: undefined, ...options });
};
export const GetCategoriesDocument = gql`
    query GetCategories($slug: String!, $where: uogorod_seeds_bool_exp!, $offset: Int!, $limit: Int!, $categoryOffset: Int, $categoryLimit: Int, $order_by: [uogorod_seeds_order_by!], $parentId: Boolean!, $includeSeeds: Boolean!) {
  uogorod_seed_categories(
    where: {slug: {_eq: $slug}, parent_id: {_is_null: $parentId}}
    limit: 1
  ) {
    ...CategoryBaseFields
    parent @skip(if: $parentId) {
      slug
      title
    }
    childrens(
      where: {seeds: $where}
      order_by: {title: asc}
      offset: $categoryOffset
      limit: $categoryLimit
    ) @include(if: $parentId) {
      ...CategoryBaseFields
    }
    childrens_aggregate(where: {seeds: $where}) @include(if: $parentId) {
      aggregate {
        count
      }
    }
  }
}
    ${CategoryBaseFieldsFragmentDoc}`;

export function useGetCategoriesQuery(options?: Omit<Urql.UseQueryArgs<never, GetCategoriesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables | undefined>({ query: GetCategoriesDocument, variables: undefined, ...options });
};
export const SearchCategoryDocument = gql`
    query SearchCategory($search: String!) {
  uogorod_seed_categories(
    where: {title: {_ilike: $search}, parent_id: {_is_null: false}}
  ) {
    id
    title
  }
}
    `;

export function useSearchCategoryQuery(options?: Omit<Urql.UseQueryArgs<never, SearchCategoryQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SearchCategoryQuery, SearchCategoryQueryVariables | undefined>({ query: SearchCategoryDocument, variables: undefined, ...options });
};
export const InsertCommentDocument = gql`
    mutation InsertComment($entity_id: bigint!, $entity_type: String!, $parent_id: bigint, $text: String!) {
  insert_uogorod_comments_one(
    object: {entity_id: $entity_id, entity_type: $entity_type, parent_id: $parent_id, text: $text}
  ) {
    ...CommentBaseFields
  }
}
    ${CommentBaseFieldsFragmentDoc}`;

export function useInsertCommentMutation() {
  return Urql.useMutation<InsertCommentMutation, InsertCommentMutationVariables>(InsertCommentDocument);
};
export const GetCommentsDocument = gql`
    query GetComments($limit: Int!) {
  uogorod_comments(limit: $limit, order_by: {created_at: desc}) {
    ...CommentBaseFields
    entity_id
    entity_type
  }
}
    ${CommentBaseFieldsFragmentDoc}`;

export function useGetCommentsQuery(options?: Omit<Urql.UseQueryArgs<never, GetCommentsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCommentsQuery, GetCommentsQueryVariables | undefined>({ query: GetCommentsDocument, variables: undefined, ...options });
};
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: bigint!) {
  delete_uogorod_comments_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteCommentMutation() {
  return Urql.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument);
};
export const GetGardenDocument = gql`
    query GetGarden($id: Int!) {
  uogorod_gardens_by_pk(id: $id) {
    title
  }
}
    `;

export function useGetGardenQuery(options?: Omit<Urql.UseQueryArgs<never, GetGardenQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetGardenQuery, GetGardenQueryVariables | undefined>({ query: GetGardenDocument, variables: undefined, ...options });
};
export const GetGardensDocument = gql`
    query GetGardens($offset: Int!, $limit: Int!) {
  uogorod_gardens(offset: $offset, limit: $limit) {
    id
    title
    seasons {
      season
    }
    user {
      city {
        name
        region {
          name
        }
      }
    }
    about
    show_count
    show_germination
    show_ground
    views
    images
  }
  uogorod_gardens_aggregate {
    aggregate {
      count
    }
  }
}
    `;

export function useGetGardensQuery(options?: Omit<Urql.UseQueryArgs<never, GetGardensQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetGardensQuery, GetGardensQueryVariables | undefined>({ query: GetGardensDocument, variables: undefined, ...options });
};
export const GardensDocument = gql`
    query Gardens($id: Int!) {
  uogorod_gardens(where: {user_id: {_eq: $id}}) {
    ...GardenBaseFields
    seasons(order_by: {season: desc}) {
      season
    }
    seeds(distinct_on: season, order_by: {season: desc}) {
      season
    }
    seeds_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ${GardenBaseFieldsFragmentDoc}`;

export function useGardensQuery(options?: Omit<Urql.UseQueryArgs<never, GardensQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GardensQuery, GardensQueryVariables | undefined>({ query: GardensDocument, variables: undefined, ...options });
};
export const CreateGardenDocument = gql`
    mutation CreateGarden($object: uogorod_gardens_insert_input!) {
  insert_uogorod_gardens_one(object: $object) {
    ...GardenBaseFields
    seasons {
      season
    }
  }
}
    ${GardenBaseFieldsFragmentDoc}`;

export function useCreateGardenMutation() {
  return Urql.useMutation<CreateGardenMutation, CreateGardenMutationVariables>(CreateGardenDocument);
};
export const UpdateGardenDocument = gql`
    mutation UpdateGarden($id: Int!, $set: uogorod_gardens_set_input!) {
  update_uogorod_gardens_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...GardenBaseFields
  }
}
    ${GardenBaseFieldsFragmentDoc}`;

export function useUpdateGardenMutation() {
  return Urql.useMutation<UpdateGardenMutation, UpdateGardenMutationVariables>(UpdateGardenDocument);
};
export const DeleteGardenDocument = gql`
    mutation DeleteGarden($id: Int!) {
  delete_uogorod_gardens_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteGardenMutation() {
  return Urql.useMutation<DeleteGardenMutation, DeleteGardenMutationVariables>(DeleteGardenDocument);
};
export const InsertPlantDocument = gql`
    mutation InsertPlant($objects: [uogorod_garden_seeds_insert_input!]!) {
  insert_uogorod_garden_seeds(objects: $objects) {
    returning {
      id
      label
      season
      journal
      seed {
        ...SeedCommonFields
        category {
          id
          title
        }
      }
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useInsertPlantMutation() {
  return Urql.useMutation<InsertPlantMutation, InsertPlantMutationVariables>(InsertPlantDocument);
};
export const UpdateGardenSeedDocument = gql`
    mutation UpdateGardenSeed($id: bigint!, $set: uogorod_garden_seeds_set_input!, $append: uogorod_garden_seeds_append_input!, $delete: uogorod_garden_seeds_delete_elem_input!) {
  update_uogorod_garden_seeds_by_pk(
    pk_columns: {id: $id}
    _set: $set
    _append: $append
    _delete_elem: $delete
  ) {
    id
    journal
  }
}
    `;

export function useUpdateGardenSeedMutation() {
  return Urql.useMutation<UpdateGardenSeedMutation, UpdateGardenSeedMutationVariables>(UpdateGardenSeedDocument);
};
export const DeleteGardenSeedDocument = gql`
    mutation DeleteGardenSeed($id: bigint!) {
  delete_uogorod_garden_seeds_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteGardenSeedMutation() {
  return Urql.useMutation<DeleteGardenSeedMutation, DeleteGardenSeedMutationVariables>(DeleteGardenSeedDocument);
};
export const GardenSeedsDocument = gql`
    query GardenSeeds($where: uogorod_garden_seeds_bool_exp!) {
  uogorod_garden_seeds(where: $where, order_by: {seed: {title: asc}}) {
    id
    label
    season
    journal
    garden_id
    seed_id
    seed {
      ...SeedCommonFields
      params(where: {name: {_in: ["ripening_time", "growth_time", "growth_type"]}}) {
        name
        values
        seed_spec {
          values
        }
      }
      manual {
        id
      }
      category {
        id
        title
        slug
        color
        parent_id
      }
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useGardenSeedsQuery(options?: Omit<Urql.UseQueryArgs<never, GardenSeedsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GardenSeedsQuery, GardenSeedsQueryVariables | undefined>({ query: GardenSeedsDocument, variables: undefined, ...options });
};
export const RemoveImageDocument = gql`
    mutation RemoveImage($id: bigint!) {
  delete_uogorod_images_by_pk(id: $id) {
    id
  }
}
    `;

export function useRemoveImageMutation() {
  return Urql.useMutation<RemoveImageMutation, RemoveImageMutationVariables>(RemoveImageDocument);
};
export const InsertFavoriteDocument = gql`
    mutation InsertFavorite($seed_id: bigint!) {
  insert_uogorod_users_seed_actions_one(
    object: {action: "Favorites", seed_id: $seed_id}
  ) {
    id
    user_id
    action
    seed_id
  }
}
    `;

export function useInsertFavoriteMutation() {
  return Urql.useMutation<InsertFavoriteMutation, InsertFavoriteMutationVariables>(InsertFavoriteDocument);
};
export const RemoveFavoriteDocument = gql`
    mutation RemoveFavorite($id: bigint!) {
  delete_uogorod_users_seed_actions_by_pk(id: $id) {
    id
  }
}
    `;

export function useRemoveFavoriteMutation() {
  return Urql.useMutation<RemoveFavoriteMutation, RemoveFavoriteMutationVariables>(RemoveFavoriteDocument);
};
export const ImagesDocument = gql`
    query Images($uuids: [uuid!]) {
  uogorod_images(where: {uuid: {_in: $uuids}}) {
    id
    user_id
    uuid
    note
  }
}
    `;

export function useImagesQuery(options?: Omit<Urql.UseQueryArgs<never, ImagesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<ImagesQuery, ImagesQueryVariables | undefined>({ query: ImagesDocument, variables: undefined, ...options });
};
export const UpdateNoteDocument = gql`
    mutation UpdateNote($id: bigint!, $note: String!) {
  update_uogorod_images_by_pk(pk_columns: {id: $id}, _set: {note: $note}) {
    id
    user_id
    uuid
    note
  }
}
    `;

export function useUpdateNoteMutation() {
  return Urql.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument);
};
export const CreateSeasonDocument = gql`
    mutation CreateSeason($object: uogorod_garden_seasons_insert_input!) {
  insert_uogorod_garden_seasons_one(
    object: $object
    on_conflict: {constraint: garden_seasons_garden_id_season_key, update_columns: []}
  ) {
    id
    season
  }
}
    `;

export function useCreateSeasonMutation() {
  return Urql.useMutation<CreateSeasonMutation, CreateSeasonMutationVariables>(CreateSeasonDocument);
};
export const GetCountriesDocument = gql`
    query GetCountries($search: String) {
  uogorod_geo_country(where: {name: {_ilike: $search}}) {
    id
    title: name
  }
}
    `;

export function useGetCountriesQuery(options?: Omit<Urql.UseQueryArgs<never, GetCountriesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCountriesQuery, GetCountriesQueryVariables | undefined>({ query: GetCountriesDocument, variables: undefined, ...options });
};
export const InsertLikeDocument = gql`
    mutation InsertLike($id: bigint, $type: String!, $value: Int!) {
  insert_uogorod_likes_one(
    object: {entity_id: $id, entity_type: $type, value: $value}
    on_conflict: {constraint: likes_user_id_entity_id_entity_type_key, update_columns: [value]}
  ) {
    id
    value
  }
}
    `;

export function useInsertLikeMutation() {
  return Urql.useMutation<InsertLikeMutation, InsertLikeMutationVariables>(InsertLikeDocument);
};
export const UpdateLikeDocument = gql`
    mutation UpdateLike($id: bigint, $type: String!, $value: Int) {
  update_uogorod_likes(
    where: {entity_id: {_eq: $id}, entity_type: {_eq: $type}}
    _set: {value: $value}
  ) {
    affected_rows
    returning {
      id
      value
    }
  }
}
    `;

export function useUpdateLikeMutation() {
  return Urql.useMutation<UpdateLikeMutation, UpdateLikeMutationVariables>(UpdateLikeDocument);
};
export const RemoveLikeDocument = gql`
    mutation RemoveLike($id: bigint, $type: String!) {
  delete_uogorod_likes(where: {entity_id: {_eq: $id}, entity_type: {_eq: $type}}) {
    affected_rows
  }
}
    `;

export function useRemoveLikeMutation() {
  return Urql.useMutation<RemoveLikeMutation, RemoveLikeMutationVariables>(RemoveLikeDocument);
};
export const GetManualDocument = gql`
    query GetManual($slug: String!) {
  uogorod_view_manual(where: {category: {slug: {_eq: $slug}}}, limit: 1) {
    ...ManualCommonField
    ...ManualInfoField
    author_id
  }
}
    ${ManualCommonFieldFragmentDoc}
${ManualInfoFieldFragmentDoc}`;

export function useGetManualQuery(options?: Omit<Urql.UseQueryArgs<never, GetManualQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetManualQuery, GetManualQueryVariables | undefined>({ query: GetManualDocument, variables: undefined, ...options });
};
export const GetManualsDocument = gql`
    query GetManuals {
  uogorod_view_manual {
    ...ManualCommonField
  }
}
    ${ManualCommonFieldFragmentDoc}`;

export function useGetManualsQuery(options?: Omit<Urql.UseQueryArgs<never, GetManualsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetManualsQuery, GetManualsQueryVariables | undefined>({ query: GetManualsDocument, variables: undefined, ...options });
};
export const MessagesDocument = gql`
    subscription Messages($profile_id: Int!) {
  uogorod_messages(
    where: {_or: [{receiver_id: {_eq: $profile_id}}, {sender_id: {_eq: $profile_id}}]}
    order_by: {created_at: asc}
  ) {
    id
    text
    is_readed
    sender_id
    receiver_id
    created_at
    images
  }
}
    `;

export function useMessagesSubscription<R = MessagesSubscription>(options?: Omit<Urql.UseSubscriptionArgs<never, MessagesSubscriptionVariables | undefined>, 'query'>, handler?: Urql.SubscriptionHandlerArg<MessagesSubscription, R>) {
  return Urql.useSubscription<MessagesSubscription, R, MessagesSubscriptionVariables | undefined>({ query: MessagesDocument, variables: undefined, ...options }, handler);
};
export const DialogsDocument = gql`
    subscription Dialogs($client_id: Int!) {
  dialogs(args: {owner_id: $client_id}, order_by: {created_at: desc}) {
    user
    is_new
    text
    created_at
  }
}
    `;

export function useDialogsSubscription<R = DialogsSubscription>(options?: Omit<Urql.UseSubscriptionArgs<never, DialogsSubscriptionVariables | undefined>, 'query'>, handler?: Urql.SubscriptionHandlerArg<DialogsSubscription, R>) {
  return Urql.useSubscription<DialogsSubscription, R, DialogsSubscriptionVariables | undefined>({ query: DialogsDocument, variables: undefined, ...options }, handler);
};
export const AddMessageDocument = gql`
    mutation AddMessage($receiver_id: Int!, $text: String!, $images: jsonb) {
  insert_uogorod_messages_one(
    object: {receiver_id: $receiver_id, text: $text, images: $images}
  ) {
    id
    text
    sender_id
    receiver_id
    created_at
    images
  }
}
    `;

export function useAddMessageMutation() {
  return Urql.useMutation<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument);
};
export const MarkAsReadDocument = gql`
    mutation MarkAsRead($profile_id: Int!) {
  update_uogorod_messages(
    where: {sender_id: {_eq: $profile_id}, is_readed: {_eq: false}}
  ) {
    affected_rows
  }
}
    `;

export function useMarkAsReadMutation() {
  return Urql.useMutation<MarkAsReadMutation, MarkAsReadMutationVariables>(MarkAsReadDocument);
};
export const GetPostDocument = gql`
    query GetPost($id: bigint!) {
  uogorod_posts_by_pk(id: $id) {
    ...PostFields
  }
  uogorod_comments(where: {entity_id: {_eq: $id}, entity_type: {_eq: "Post"}}) {
    ...CommentBaseFields
    is_liked(args: {entity: "Comment"})
    likes_aggregate(where: {entity_type: {_eq: "Comment"}}) {
      ...LikesCount
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentBaseFieldsFragmentDoc}
${LikesCountFragmentDoc}`;

export function useGetPostQuery(options?: Omit<Urql.UseQueryArgs<never, GetPostQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetPostQuery, GetPostQueryVariables | undefined>({ query: GetPostDocument, variables: undefined, ...options });
};
export const InsertPostDocument = gql`
    mutation InsertPost($title: String!, $text: String!, $in_feed: Boolean) {
  insert_uogorod_posts_one(
    object: {title: $title, text: $text, in_feed: $in_feed}
  ) {
    ...PostBaseFields
  }
}
    ${PostBaseFieldsFragmentDoc}`;

export function useInsertPostMutation() {
  return Urql.useMutation<InsertPostMutation, InsertPostMutationVariables>(InsertPostDocument);
};
export const UpdatePostDocument = gql`
    mutation UpdatePost($id: bigint!, $title: String!, $text: String!, $in_feed: Boolean) {
  update_uogorod_posts_by_pk(
    pk_columns: {id: $id}
    _set: {title: $title, text: $text, in_feed: $in_feed}
  ) {
    ...PostBaseFields
  }
}
    ${PostBaseFieldsFragmentDoc}`;

export function useUpdatePostMutation() {
  return Urql.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument);
};
export const RemovePostDocument = gql`
    mutation RemovePost($id: bigint!) {
  delete_uogorod_posts_by_pk(id: $id) {
    id
  }
}
    `;

export function useRemovePostMutation() {
  return Urql.useMutation<RemovePostMutation, RemovePostMutationVariables>(RemovePostDocument);
};
export const GetPostsDocument = gql`
    query GetPosts($limit: Int!, $offset: Int!, $order_by: [uogorod_posts_order_by!], $where: uogorod_posts_bool_exp!) {
  uogorod_posts(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...PostFields
    ...PostCommentsCount
  }
  uogorod_posts_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${PostFieldsFragmentDoc}
${PostCommentsCountFragmentDoc}`;

export function useGetPostsQuery(options?: Omit<Urql.UseQueryArgs<never, GetPostsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetPostsQuery, GetPostsQueryVariables | undefined>({ query: GetPostsDocument, variables: undefined, ...options });
};
export const GetCatalogDocument = gql`
    query GetCatalog($offset: Int!, $limit: Int!) {
  uogorod_seed_categories(
    where: {parent_id: {_is_null: true}}
    order_by: {title: asc}
  ) {
    id
    title
    slug
  }
  uogorod_seeds(limit: 12, order_by: {created_at: desc}) {
    ...SeedCommonFields
    rate
  }
  uogorod_top_reviewers(limit: 10) {
    count
    user {
      ...AuthorBaseFields
    }
  }
  uogorod_reviews(offset: $offset, limit: $limit, order_by: {created_at: desc}) {
    ...ReviewsBaseFields
    brand {
      ...BrandsCommonFields
    }
  }
  uogorod_seeds_records(limit: 12) {
    record
    images
    user {
      ...AuthorBaseFields
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}
${AuthorBaseFieldsFragmentDoc}
${ReviewsBaseFieldsFragmentDoc}
${BrandsCommonFieldsFragmentDoc}`;

export function useGetCatalogQuery(options?: Omit<Urql.UseQueryArgs<never, GetCatalogQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetCatalogQuery, GetCatalogQueryVariables | undefined>({ query: GetCatalogDocument, variables: undefined, ...options });
};
export const InsertUogorodSeedDocument = gql`
    mutation InsertUogorodSeed($object: uogorod_seeds_insert_input!) {
  insert_uogorod_seeds_one(object: $object) {
    id
  }
}
    `;

export function useInsertUogorodSeedMutation() {
  return Urql.useMutation<InsertUogorodSeedMutation, InsertUogorodSeedMutationVariables>(InsertUogorodSeedDocument);
};
export const InsertSeedRecordDocument = gql`
    mutation InsertSeedRecord($seed_id: bigint!, $record: numeric!, $images: jsonb!) {
  insert_uogorod_seeds_records_one(
    object: {seed_id: $seed_id, record: $record, images: $images}
  ) {
    record
    images
    user {
      ...AuthorBaseFields
    }
  }
}
    ${AuthorBaseFieldsFragmentDoc}`;

export function useInsertSeedRecordMutation() {
  return Urql.useMutation<InsertSeedRecordMutation, InsertSeedRecordMutationVariables>(InsertSeedRecordDocument);
};
export const InsertSeedImagesDocument = gql`
    mutation InsertSeedImages($objects: [uogorod_seeds_images_insert_input!]!) {
  insert_uogorod_seeds_images(objects: $objects) {
    returning {
      uuid
      image {
        created_at
      }
    }
  }
}
    `;

export function useInsertSeedImagesMutation() {
  return Urql.useMutation<InsertSeedImagesMutation, InsertSeedImagesMutationVariables>(InsertSeedImagesDocument);
};
export const GetSeedsForSelectDocument = gql`
    query GetSeedsForSelect($where: uogorod_seeds_bool_exp!) {
  uogorod_seeds(where: $where) {
    ...SeedCommonFields
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useGetSeedsForSelectQuery(options?: Omit<Urql.UseQueryArgs<never, GetSeedsForSelectQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetSeedsForSelectQuery, GetSeedsForSelectQueryVariables | undefined>({ query: GetSeedsForSelectDocument, variables: undefined, ...options });
};
export const InsertSeedSimilarDocument = gql`
    mutation InsertSeedSimilar($seed_id: bigint!, $similar_seed_id: bigint!) {
  insert_uogorod_seed_similar_one(
    object: {seed_id: $seed_id, similar_seed_id: $similar_seed_id}
  ) {
    similar {
      ...SeedCommonFields
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useInsertSeedSimilarMutation() {
  return Urql.useMutation<InsertSeedSimilarMutation, InsertSeedSimilarMutationVariables>(InsertSeedSimilarDocument);
};
export const GetBrandSeedsDocument = gql`
    query GetBrandSeeds($where: uogorod_seeds_bool_exp, $offset: Int!, $limit: Int!, $user: Boolean!) {
  uogorod_seeds(
    where: $where
    order_by: {created_at: desc}
    offset: $offset
    limit: $limit
  ) {
    ...SeedCommonFields
    rate
    created_at
    user @include(if: $user) {
      id
      nickname
    }
  }
  uogorod_seeds_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useGetBrandSeedsQuery(options?: Omit<Urql.UseQueryArgs<never, GetBrandSeedsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetBrandSeedsQuery, GetBrandSeedsQueryVariables | undefined>({ query: GetBrandSeedsDocument, variables: undefined, ...options });
};
export const GetSeedSpecsDocument = gql`
    query GetSeedSpecs {
  uogorod_seed_specs {
    multiple
    values
    description
    label
    name
    unit
  }
}
    `;

export function useGetSeedSpecsQuery(options?: Omit<Urql.UseQueryArgs<never, GetSeedSpecsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetSeedSpecsQuery, GetSeedSpecsQueryVariables | undefined>({ query: GetSeedSpecsDocument, variables: undefined, ...options });
};
export const GetSeedDocument = gql`
    query GetSeed($id: bigint!, $user_id: bigint) {
  uogorod_garden_seeds(where: {seed_id: {_eq: $id}}, distinct_on: garden_id) {
    season
  }
  uogorod_users_seed_actions_aggregate(
    where: {seed_id: {_eq: $id}, action: {_eq: "Favorites"}}
  ) {
    aggregate {
      count
    }
  }
  uogorod_seeds_by_pk(id: $id) {
    id
    title
    status
    title_en
    originator_id
    seed_category_id
    rate
    views
    created_at
    Country {
      name
    }
    images: ranked_images {
      uuid
      image {
        id
        uuid
        user {
          ...AuthorBaseFields
        }
        created_at
        is_liked(args: {entity: "Image"})
        likes_aggregate(where: {entity_type: {_eq: "Image"}}) {
          aggregate {
            count
            sum {
              value
            }
          }
        }
      }
    }
    params {
      name
      values
    }
    description
    agrotech
    records {
      id
      record
      images
      user {
        ...AuthorBaseFields
      }
    }
    actions(where: {user_id: {_eq: $user_id}}, limit: 1) {
      id
      user_id
    }
    reviews(where: {user_id: {_eq: $user_id}}, limit: 1) {
      id
      user_id
      brand_id
      rate
      comment
      plus
      minus
      reviewed_at
      recommended
    }
    reviews_aggregate(order_by: {created_at: desc}) {
      aggregate {
        count
        avg {
          rate
          seed_id
        }
      }
      nodes {
        id
        rate
        comment
        plus
        minus
        reviewed_at
        created_at
        recommended
        images
        is_liked(args: {entity: "Review"})
        likes_aggregate(where: {entity_type: {_eq: "Review"}}) {
          aggregate {
            count
            sum {
              value
            }
          }
        }
        ...ReviewComments
        user {
          ...AuthorBaseFields
        }
        brand {
          ...BrandsCommonFields
        }
      }
    }
    category {
      id
      title
      slug
      parent {
        id
        title
        slug
      }
    }
    similars {
      id
      user_id
      similar {
        ...SeedCommonFields
      }
    }
    brands {
      brand {
        ...BrandsCommonFields
      }
    }
    manual {
      ...ManualInfoField
    }
  }
}
    ${AuthorBaseFieldsFragmentDoc}
${ReviewCommentsFragmentDoc}
${BrandsCommonFieldsFragmentDoc}
${SeedCommonFieldsFragmentDoc}
${ManualInfoFieldFragmentDoc}`;

export function useGetSeedQuery(options?: Omit<Urql.UseQueryArgs<never, GetSeedQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetSeedQuery, GetSeedQueryVariables | undefined>({ query: GetSeedDocument, variables: undefined, ...options });
};
export const SendReviewDocument = gql`
    mutation SendReview($rate: numeric!, $plus: String, $minus: String, $comment: String!, $recommended: Boolean!, $brand_id: Int, $seed_id: bigint, $images: jsonb) {
  insert_uogorod_reviews_one(
    object: {rate: $rate, plus: $plus, minus: $minus, comment: $comment, recommended: $recommended, brand_id: $brand_id, seed_id: $seed_id, images: $images}
  ) {
    id
  }
}
    `;

export function useSendReviewMutation() {
  return Urql.useMutation<SendReviewMutation, SendReviewMutationVariables>(SendReviewDocument);
};
export const UpdateReviewDocument = gql`
    mutation UpdateReview($id: bigint!, $set: uogorod_reviews_set_input!) {
  update_uogorod_reviews_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;

export function useUpdateReviewMutation() {
  return Urql.useMutation<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument);
};
export const RemoveSimilarDocument = gql`
    mutation RemoveSimilar($id: bigint!) {
  delete_uogorod_seed_similar_by_pk(id: $id) {
    id
  }
}
    `;

export function useRemoveSimilarMutation() {
  return Urql.useMutation<RemoveSimilarMutation, RemoveSimilarMutationVariables>(RemoveSimilarDocument);
};
export const RemoveRecordDocument = gql`
    mutation RemoveRecord($id: bigint!) {
  delete_uogorod_seeds_records_by_pk(id: $id) {
    id
  }
}
    `;

export function useRemoveRecordMutation() {
  return Urql.useMutation<RemoveRecordMutation, RemoveRecordMutationVariables>(RemoveRecordDocument);
};
export const UserAchivmentsDocument = gql`
    subscription UserAchivments($id: bigint!, $created_at: timestamptz!) {
  uogorod_user_achivments(
    where: {user_id: {_eq: $id}, created_at: {_gte: $created_at}}
    order_by: {created_at: desc}
  ) {
    achivment {
      id
      name
      description
      icon
    }
    points
    created_at
  }
}
    `;

export function useUserAchivmentsSubscription<R = UserAchivmentsSubscription>(options?: Omit<Urql.UseSubscriptionArgs<never, UserAchivmentsSubscriptionVariables | undefined>, 'query'>, handler?: Urql.SubscriptionHandlerArg<UserAchivmentsSubscription, R>) {
  return Urql.useSubscription<UserAchivmentsSubscription, R, UserAchivmentsSubscriptionVariables | undefined>({ query: UserAchivmentsDocument, variables: undefined, ...options }, handler);
};
export const GeoCitiesDocument = gql`
    query GeoCities($search: String) {
  uogorod_geo_city(where: {name: {_ilike: $search}}) {
    id
    name
    region {
      name
      country {
        name
      }
    }
  }
}
    `;

export function useGeoCitiesQuery(options?: Omit<Urql.UseQueryArgs<never, GeoCitiesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GeoCitiesQuery, GeoCitiesQueryVariables | undefined>({ query: GeoCitiesDocument, variables: undefined, ...options });
};
export const GetProfileSettingsDocument = gql`
    query GetProfileSettings($id: bigint!) {
  uogorod_users_by_pk(id: $id) {
    id
    settings
  }
}
    `;

export function useGetProfileSettingsQuery(options?: Omit<Urql.UseQueryArgs<never, GetProfileSettingsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetProfileSettingsQuery, GetProfileSettingsQueryVariables | undefined>({ query: GetProfileSettingsDocument, variables: undefined, ...options });
};
export const GetProfileDocument = gql`
    query GetProfile($id: bigint!, $isOwner: Boolean!) {
  uogorod_users_by_pk(id: $id) {
    id
    name
    nickname
    updated_at
    created_at
    experience
    about
    gender
    birthday
    city_id
    settings
    private @include(if: $isOwner) {
      email
    }
    achivments {
      points
      created_at
      achivment {
        id
        name
        description
        icon
      }
    }
    city {
      id
      name
      region {
        name
      }
    }
    gardens_aggregate @include(if: $isOwner) {
      aggregate {
        count
      }
    }
    subcribes_aggregate {
      aggregate {
        count
      }
    }
  }
  uogorod_subscribes_aggregate(where: {element_id: {_eq: $id}, type: {_eq: 1}}) {
    aggregate {
      count
    }
  }
}
    `;

export function useGetProfileQuery(options?: Omit<Urql.UseQueryArgs<never, GetProfileQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetProfileQuery, GetProfileQueryVariables | undefined>({ query: GetProfileDocument, variables: undefined, ...options });
};
export const GetProfileStatsDocument = gql`
    query GetProfileStats($id: bigint!) {
  uogorod_seed_categories(
    where: {seeds: {reviews: {user_id: {_eq: $id}}}}
    order_by: {seeds_aggregate: {count: desc}}
  ) {
    title
    seeds_aggregate(where: {reviews: {user_id: {_eq: $id}}}) {
      aggregate {
        count
      }
      nodes {
        title
        reviews_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
  uogorod_reviews_aggregate(where: {user_id: {_eq: $id}}) {
    aggregate {
      count(distinct: true, columns: seed_id)
    }
  }
}
    `;

export function useGetProfileStatsQuery(options?: Omit<Urql.UseQueryArgs<never, GetProfileStatsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetProfileStatsQuery, GetProfileStatsQueryVariables | undefined>({ query: GetProfileStatsDocument, variables: undefined, ...options });
};
export const GetProfilesDocument = gql`
    query GetProfiles($where: uogorod_users_bool_exp!, $offset: Int!, $limit: Int!, $order_by: [uogorod_users_order_by!]) {
  uogorod_users(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    id
    name
    nickname
    gender
    city {
      name
      region {
        name
        country {
          name
        }
      }
    }
  }
  uogorod_users_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  maleCount: uogorod_users_aggregate(where: {gender: {_eq: false}}) {
    aggregate {
      count
    }
  }
  femaleCount: uogorod_users_aggregate(where: {gender: {_eq: true}}) {
    aggregate {
      count
    }
  }
  uogorod_geo_city(
    where: {users: {id: {_is_null: false}}}
    order_by: {users_aggregate: {count: desc, sum: {}}}
  ) {
    id
    name
    region {
      country {
        id
        name
      }
    }
    users_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

export function useGetProfilesQuery(options?: Omit<Urql.UseQueryArgs<never, GetProfilesQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<GetProfilesQuery, GetProfilesQueryVariables | undefined>({ query: GetProfilesDocument, variables: undefined, ...options });
};
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($id: bigint!, $append: uogorod_users_append_input!, $set: uogorod_users_set_input) {
  update_uogorod_users_by_pk(pk_columns: {id: $id}, _append: $append, _set: $set) {
    updated_at
  }
}
    `;

export function useUpdateProfileMutation() {
  return Urql.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument);
};
export const UserActionsDocument = gql`
    query UserActions($user_id: bigint!, $type: String!) {
  uogorod_seeds(
    where: {actions: {user_id: {_eq: $user_id}, action: {_eq: $type}}}
  ) {
    ...SeedCommonFields
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useUserActionsQuery(options?: Omit<Urql.UseQueryArgs<never, UserActionsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<UserActionsQuery, UserActionsQueryVariables | undefined>({ query: UserActionsDocument, variables: undefined, ...options });
};
export const UserRecordsDocument = gql`
    query UserRecords($user_id: bigint!, $limit: Int!) {
  uogorod_seeds(where: {records: {user_id: {_eq: $user_id}}}, limit: $limit) {
    ...SeedCommonFields
    records {
      record
    }
  }
  uogorod_seeds_aggregate(where: {records: {user_id: {_eq: $user_id}}}) {
    aggregate {
      count
    }
  }
}
    ${SeedCommonFieldsFragmentDoc}`;

export function useUserRecordsQuery(options?: Omit<Urql.UseQueryArgs<never, UserRecordsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<UserRecordsQuery, UserRecordsQueryVariables | undefined>({ query: UserRecordsDocument, variables: undefined, ...options });
};